
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9c4f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9c4f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.5";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.5" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.5"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.5",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.5"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.5";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.5";

});



parcelRegister("goMib", function(module, exports) {
module.exports = import("49aT6").then(()=>parcelRequire('apVnu'));

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));





var $acw62 = parcelRequire("acw62");

function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$1c5a554c78c0cd12 = "@scope";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(z += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $298fb931ed4fbf8b$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $298fb931ed4fbf8b$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($298fb931ed4fbf8b$export$9e1725a4cfeada27(b || 1) == 5 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e() || 1) == 5) && $298fb931ed4fbf8b$export$36776f635604f274(z) && $298fb931ed4fbf8b$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($298fb931ed4fbf8b$export$36776f635604f274(z) - l || h === 0 && b === 47)) $298fb931ed4fbf8b$export$10d8903dec122b9d(v > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, c && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $298fb931ed4fbf8b$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) z += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    p = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(k = z += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $298fb931ed4fbf8b$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; k < h; ++k)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? b[k] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, b[k]))) f[g++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, c, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, c), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(c, n, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(c, n)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c + (s = s[n].value), "span", 0) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span", 0) ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(c) - 1 - n > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c, "stretch", 0) ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, $298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$6aad947bda0f3f46:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                c.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (c.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $f8dbcd8598db1f0b$var$r, $f8dbcd8598db1f0b$var$i;
const $f8dbcd8598db1f0b$var$a = "data-styled", $f8dbcd8598db1f0b$var$c = "active", $f8dbcd8598db1f0b$var$l = "data-styled-version", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.4.0", $f8dbcd8598db1f0b$var$d = "/*!sc*/\n", $f8dbcd8598db1f0b$var$h = "undefined" != typeof window && "undefined" != typeof document;
function $f8dbcd8598db1f0b$var$p(e) {}
const $f8dbcd8598db1f0b$var$f = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : null !== ($f8dbcd8598db1f0b$var$i = null !== ($f8dbcd8598db1f0b$var$r = $f8dbcd8598db1f0b$var$p("REACT_APP_SC_DISABLE_SPEEDY")) && void 0 !== $f8dbcd8598db1f0b$var$r ? $f8dbcd8598db1f0b$var$r : $f8dbcd8598db1f0b$var$p("SC_DISABLE_SPEEDY")) && void 0 !== $f8dbcd8598db1f0b$var$i ? $f8dbcd8598db1f0b$var$i : true), $f8dbcd8598db1f0b$var$m = "sc-keyframes-", $f8dbcd8598db1f0b$var$y = {}, $f8dbcd8598db1f0b$var$g = {};
function $f8dbcd8598db1f0b$var$v(e, ...t) {
    return new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${e} for more information.${t.length > 0 ? ` Args: ${t.join(", ")}` : ""}`);
}
const $f8dbcd8598db1f0b$var$S = 1073741824;
let $f8dbcd8598db1f0b$var$w = new Map, $f8dbcd8598db1f0b$var$b = new Map, $f8dbcd8598db1f0b$var$N = 1;
const $f8dbcd8598db1f0b$var$C = (e)=>{
    if ($f8dbcd8598db1f0b$var$w.has(e)) return $f8dbcd8598db1f0b$var$w.get(e);
    for(; $f8dbcd8598db1f0b$var$b.has($f8dbcd8598db1f0b$var$N);)$f8dbcd8598db1f0b$var$N++;
    const t = $f8dbcd8598db1f0b$var$N++;
    return $f8dbcd8598db1f0b$var$w.set(e, t), $f8dbcd8598db1f0b$var$b.set(t, e), t;
}, $f8dbcd8598db1f0b$var$O = (e)=>$f8dbcd8598db1f0b$var$b.get(e), $f8dbcd8598db1f0b$var$E = (e, t)=>{
    $f8dbcd8598db1f0b$var$N = t + 1, $f8dbcd8598db1f0b$var$w.set(e, t), $f8dbcd8598db1f0b$var$b.set(t, e);
}, $f8dbcd8598db1f0b$var$P = /invalid hook call/i, $f8dbcd8598db1f0b$var$A = new Set, $f8dbcd8598db1f0b$var$_ = (e, n)=>{
    var t, n1, e1;
}, $f8dbcd8598db1f0b$var$I = Object.freeze([]), $f8dbcd8598db1f0b$var$$ = Object.freeze({});
function $f8dbcd8598db1f0b$var$R(e, t, n = $f8dbcd8598db1f0b$var$$) {
    return e.theme !== n.theme && e.theme || t || n.theme;
}
const $f8dbcd8598db1f0b$var$j = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$x = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$k(e) {
    return e.replace($f8dbcd8598db1f0b$var$j, "-").replace($f8dbcd8598db1f0b$var$x, "");
}
const $f8dbcd8598db1f0b$var$D = /(a)(d)/gi, $f8dbcd8598db1f0b$var$T = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97));
function $f8dbcd8598db1f0b$var$V(e) {
    let t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$T(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$T(t % 52) + n).replace($f8dbcd8598db1f0b$var$D, "$1-$2");
}
const $f8dbcd8598db1f0b$var$M = 5381, $f8dbcd8598db1f0b$var$G = (e, t)=>{
    let n = t.length;
    for(; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$F = (e)=>$f8dbcd8598db1f0b$var$G($f8dbcd8598db1f0b$var$M, e);
function $f8dbcd8598db1f0b$var$z(e) {
    return $f8dbcd8598db1f0b$var$V($f8dbcd8598db1f0b$var$F(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$W(e) {
    return e.displayName || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$L(e) {
    return "string" == typeof e && true;
}
function $f8dbcd8598db1f0b$var$B(e) {
    return $f8dbcd8598db1f0b$var$L(e) ? `styled.${e}` : `Styled(${$f8dbcd8598db1f0b$var$W(e)})`;
}
const $f8dbcd8598db1f0b$var$q = Symbol.for("react.memo"), $f8dbcd8598db1f0b$var$H = Symbol.for("react.forward_ref"), $f8dbcd8598db1f0b$var$Y = {
    contextType: !0,
    defaultProps: !0,
    displayName: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$J = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$X = {
    [$f8dbcd8598db1f0b$var$H]: {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
    },
    [$f8dbcd8598db1f0b$var$q]: $f8dbcd8598db1f0b$var$J
};
function $f8dbcd8598db1f0b$var$Z(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$q ? $f8dbcd8598db1f0b$var$J : "$$typeof" in e ? $f8dbcd8598db1f0b$var$X[e.$$typeof] : $f8dbcd8598db1f0b$var$Y;
}
const $f8dbcd8598db1f0b$var$K = Object.defineProperty, $f8dbcd8598db1f0b$var$Q = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$ee = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$te = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$ne = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$oe = Object.prototype;
function $f8dbcd8598db1f0b$var$se(e, t, n) {
    if ("string" != typeof t) {
        const o = $f8dbcd8598db1f0b$var$ne(t);
        o && o !== $f8dbcd8598db1f0b$var$oe && $f8dbcd8598db1f0b$var$se(e, o, n);
        const s = $f8dbcd8598db1f0b$var$Q(t).concat($f8dbcd8598db1f0b$var$ee(t)), r = $f8dbcd8598db1f0b$var$Z(e), i = $f8dbcd8598db1f0b$var$Z(t);
        for(let o = 0; o < s.length; ++o){
            const a = s[o];
            if (!(a in $f8dbcd8598db1f0b$var$U || n && n[a] || i && a in i || r && a in r)) {
                const n = $f8dbcd8598db1f0b$var$te(t, a);
                try {
                    $f8dbcd8598db1f0b$var$K(e, a, n);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$re(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$ae(e, t) {
    return e && t ? e + " " + t : e || t || "";
}
function $f8dbcd8598db1f0b$var$ce(e, t) {
    return e.join(t || "");
}
function $f8dbcd8598db1f0b$var$le(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$ue(e, t, n = !1) {
    if (!n && !$f8dbcd8598db1f0b$var$le(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(let n = 0; n < t.length; n++)e[n] = $f8dbcd8598db1f0b$var$ue(e[n], t[n]);
    else if ($f8dbcd8598db1f0b$var$le(t)) for(const n in t)e[n] = $f8dbcd8598db1f0b$var$ue(e[n], t[n]);
    return e;
}
function $f8dbcd8598db1f0b$var$de(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
const $f8dbcd8598db1f0b$var$he = class {
    constructor(e){
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
    }
    indexOfGroup(e) {
        if (e === this._cGroup) return this._cIndex;
        let t = this._cIndex;
        if (e > this._cGroup) for(let n = this._cGroup; n < e; n++)t += this.groupSizes[n];
        else for(let n = this._cGroup - 1; n >= e; n--)t -= this.groupSizes[n];
        return this._cGroup = e, this._cIndex = t, t;
    }
    insertRules(e, t) {
        if (e >= this.groupSizes.length) {
            const t = this.groupSizes, n = t.length;
            let o = n;
            for(; e >= o;)if (o <<= 1, o < 0) throw $f8dbcd8598db1f0b$var$v(16, `${e}`);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(t), this.length = o;
            for(let e = n; e < o; e++)this.groupSizes[e] = 0;
        }
        let n = this.indexOfGroup(e + 1), o = 0;
        for(let s = 0, r = t.length; s < r; s++)this.tag.insertRule(n, t[s]) && (this.groupSizes[e]++, n++, o++);
        o > 0 && this._cGroup > e && (this._cIndex += o);
    }
    clearGroup(e) {
        if (e < this.length) {
            const t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(let e = n; e < o; e++)this.tag.deleteRule(n);
            t > 0 && this._cGroup > e && (this._cIndex -= t);
        }
    }
    getGroup(e) {
        let t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        const n = this.groupSizes[e], o = this.indexOfGroup(e), s = o + n;
        for(let e = o; e < s; e++)t += this.tag.getRule(e) + $f8dbcd8598db1f0b$var$d;
        return t;
    }
}, $f8dbcd8598db1f0b$var$pe = `style[${$f8dbcd8598db1f0b$var$a}][${$f8dbcd8598db1f0b$var$l}="${$f8dbcd8598db1f0b$export$83d89fbfd8236492}"]`, $f8dbcd8598db1f0b$var$fe = new RegExp(`^${$f8dbcd8598db1f0b$var$a}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), $f8dbcd8598db1f0b$var$me = (e)=>"undefined" != typeof ShadowRoot && e instanceof ShadowRoot || "host" in e && 11 === e.nodeType, $f8dbcd8598db1f0b$var$ye = (e)=>{
    if (!e) return document;
    if ($f8dbcd8598db1f0b$var$me(e)) return e;
    if ("getRootNode" in e) {
        const t = e.getRootNode();
        if ($f8dbcd8598db1f0b$var$me(t)) return t;
    }
    return document;
}, $f8dbcd8598db1f0b$var$ge = (e, t, n)=>{
    const o = n.split(",");
    let s;
    for(let n = 0, r = o.length; n < r; n++)(s = o[n]) && e.registerName(t, s);
}, $f8dbcd8598db1f0b$var$ve = (e, t)=>{
    var n;
    const o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f8dbcd8598db1f0b$var$d), s = [];
    for(let t = 0, n = o.length; t < n; t++){
        const n = o[t].trim();
        if (!n) continue;
        const r = n.match($f8dbcd8598db1f0b$var$fe);
        if (r) {
            const t = 0 | parseInt(r[1], 10), n = r[2];
            0 !== t && ($f8dbcd8598db1f0b$var$E(n, t), $f8dbcd8598db1f0b$var$ge(e, n, r[3]), e.getTag().insertRules(t, s)), s.length = 0;
        } else s.push(n);
    }
}, $f8dbcd8598db1f0b$var$Se = (e)=>{
    const t = $f8dbcd8598db1f0b$var$ye(e.options.target).querySelectorAll($f8dbcd8598db1f0b$var$pe);
    for(let n = 0, o = t.length; n < o; n++){
        const o = t[n];
        o && o.getAttribute($f8dbcd8598db1f0b$var$a) !== $f8dbcd8598db1f0b$var$c && ($f8dbcd8598db1f0b$var$ve(e, o), o.parentNode && o.parentNode.removeChild(o));
    }
};
let $f8dbcd8598db1f0b$var$we = !1;
function $f8dbcd8598db1f0b$var$be() {
    if (!1 !== $f8dbcd8598db1f0b$var$we) return $f8dbcd8598db1f0b$var$we;
    if ("undefined" != typeof document) {
        const e = document.head.querySelector('meta[property="csp-nonce"]');
        if (e) return $f8dbcd8598db1f0b$var$we = e.nonce || e.getAttribute("content") || void 0;
        const t = document.head.querySelector('meta[name="sc-nonce"]');
        if (t) return $f8dbcd8598db1f0b$var$we = t.getAttribute("content") || void 0;
    }
    return $f8dbcd8598db1f0b$var$we = "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0;
}
const $f8dbcd8598db1f0b$var$Ne = (e, t)=>{
    const n = document.head, o = e || n, s = document.createElement("style"), r = ((e)=>{
        const t = Array.from(e.querySelectorAll(`style[${$f8dbcd8598db1f0b$var$a}]`));
        return t[t.length - 1];
    })(o), i = void 0 !== r ? r.nextSibling : null;
    s.setAttribute($f8dbcd8598db1f0b$var$a, $f8dbcd8598db1f0b$var$c), s.setAttribute($f8dbcd8598db1f0b$var$l, $f8dbcd8598db1f0b$export$83d89fbfd8236492);
    const d = t || $f8dbcd8598db1f0b$var$be();
    return d && s.setAttribute("nonce", d), o.insertBefore(s, i), s;
}, $f8dbcd8598db1f0b$var$Ce = class {
    constructor(e, t){
        this.element = $f8dbcd8598db1f0b$var$Ne(e, t), this.element.appendChild(document.createTextNode("")), this.sheet = ((e)=>{
            var t;
            if (e.sheet) return e.sheet;
            const n = null !== (t = e.getRootNode().styleSheets) && void 0 !== t ? t : document.styleSheets;
            for(let t = 0, o = n.length; t < o; t++){
                const o = n[t];
                if (o.ownerNode === e) return o;
            }
            throw $f8dbcd8598db1f0b$var$v(17);
        })(this.element), this.length = 0;
    }
    insertRule(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }
    deleteRule(e) {
        this.sheet.deleteRule(e), this.length--;
    }
    getRule(e) {
        const t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }
}, $f8dbcd8598db1f0b$var$Oe = class {
    constructor(e, t){
        this.element = $f8dbcd8598db1f0b$var$Ne(e, t), this.nodes = this.element.childNodes, this.length = 0;
    }
    insertRule(e, t) {
        if (e <= this.length && e >= 0) {
            const n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }
    deleteRule(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }
    getRule(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }
};
let $f8dbcd8598db1f0b$var$Ee = $f8dbcd8598db1f0b$var$h;
const $f8dbcd8598db1f0b$var$Pe = {
    isServer: !$f8dbcd8598db1f0b$var$h,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$f
};
class $f8dbcd8598db1f0b$var$Ae {
    static registerId(e) {
        return $f8dbcd8598db1f0b$var$C(e);
    }
    constructor(e = $f8dbcd8598db1f0b$var$$, t = {}, n){
        this.options = Object.assign(Object.assign({}, $f8dbcd8598db1f0b$var$Pe), e), this.gs = t, this.keyframeIds = new Set, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$h && $f8dbcd8598db1f0b$var$Ee && ($f8dbcd8598db1f0b$var$Ee = !1, $f8dbcd8598db1f0b$var$Se(this)), $f8dbcd8598db1f0b$var$de(this, ()=>((e)=>{
                const t = e.getTag(), { length: n } = t;
                let o = "";
                for(let s = 0; s < n; s++){
                    const n = $f8dbcd8598db1f0b$var$O(s);
                    if (void 0 === n) continue;
                    const r = e.names.get(n);
                    if (void 0 === r || !r.size) continue;
                    const i = t.getGroup(s);
                    if (0 === i.length) continue;
                    const c = $f8dbcd8598db1f0b$var$a + ".g" + s + '[id="' + n + '"]';
                    let l = "";
                    for (const e of r)e.length > 0 && (l += e + ",");
                    o += i + c + '{content:"' + l + '"}' + $f8dbcd8598db1f0b$var$d;
                }
                return o;
            })(this));
    }
    rehydrate() {
        !this.server && $f8dbcd8598db1f0b$var$h && $f8dbcd8598db1f0b$var$Se(this);
    }
    reconstructWithOptions(e, t = !0) {
        const n = new $f8dbcd8598db1f0b$var$Ae(Object.assign(Object.assign({}, this.options), e), this.gs, t && this.names || void 0);
        return n.keyframeIds = new Set(this.keyframeIds), !this.server && $f8dbcd8598db1f0b$var$h && e.target !== this.options.target && $f8dbcd8598db1f0b$var$ye(this.options.target) !== $f8dbcd8598db1f0b$var$ye(e.target) && $f8dbcd8598db1f0b$var$Se(n), n;
    }
    allocateGSInstance(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }
    getTag() {
        var e;
        return this.tag || (this.tag = (e = (({ useCSSOMInjection: e, target: t, nonce: n })=>e ? new $f8dbcd8598db1f0b$var$Ce(t, n) : new $f8dbcd8598db1f0b$var$Oe(t, n))(this.options), new $f8dbcd8598db1f0b$var$he(e)));
    }
    hasNameForId(e, t) {
        var n, o;
        return null !== (o = null === (n = this.names.get(e)) || void 0 === n ? void 0 : n.has(t)) && void 0 !== o && o;
    }
    registerName(e, t) {
        $f8dbcd8598db1f0b$var$C(e), e.startsWith($f8dbcd8598db1f0b$var$m) && this.keyframeIds.add(e);
        const n = this.names.get(e);
        n ? n.add(t) : this.names.set(e, new Set([
            t
        ]));
    }
    insertRules(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$C(e), n);
    }
    clearNames(e) {
        this.names.has(e) && this.names.get(e).clear();
    }
    clearRules(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$C(e)), this.clearNames(e);
    }
    clearTag() {
        this.tag = void 0;
    }
}
const $f8dbcd8598db1f0b$var$_e = new WeakSet, $f8dbcd8598db1f0b$var$Ie = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
function $f8dbcd8598db1f0b$var$$e(e, t) {
    return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in $f8dbcd8598db1f0b$var$Ie || e.startsWith("--") ? String(t).trim() : t + "px";
}
const $f8dbcd8598db1f0b$var$Re = (e)=>e >= "A" && e <= "Z";
function $f8dbcd8598db1f0b$var$je(e) {
    let t = "";
    for(let n = 0; n < e.length; n++){
        const o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$Re(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
const $f8dbcd8598db1f0b$var$xe = Symbol.for("sc-keyframes");
function $f8dbcd8598db1f0b$var$ke(e) {
    return "object" == typeof e && null !== e && $f8dbcd8598db1f0b$var$xe in e;
}
function $f8dbcd8598db1f0b$var$De(e) {
    return $f8dbcd8598db1f0b$var$re(e) && !(e.prototype && e.prototype.isReactComponent);
}
const $f8dbcd8598db1f0b$var$Te = (e)=>null == e || !1 === e || "" === e, $f8dbcd8598db1f0b$var$Ve = Symbol.for("react.client.reference");
function $f8dbcd8598db1f0b$var$Me(e) {
    return e.$$typeof === $f8dbcd8598db1f0b$var$Ve;
}
function $f8dbcd8598db1f0b$var$Ge(e) {
    const t = e.$$id, n = (t && t.includes("#") ? t.split("#").pop() : t) || e.name || "unknown";
    console.warn(`Interpolating a client component (${n}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
const $f8dbcd8598db1f0b$var$Fe = (e)=>{
    const t = [];
    for(const n in e){
        const o = e[n];
        e.hasOwnProperty(n) && !$f8dbcd8598db1f0b$var$Te(o) && (Array.isArray(o) && $f8dbcd8598db1f0b$var$_e.has(o) || $f8dbcd8598db1f0b$var$re(o) ? t.push($f8dbcd8598db1f0b$var$je(n) + ":", o, ";") : $f8dbcd8598db1f0b$var$le(o) ? t.push(n + " {", ...$f8dbcd8598db1f0b$var$Fe(o), "}") : t.push($f8dbcd8598db1f0b$var$je(n) + ": " + $f8dbcd8598db1f0b$var$$e(n, o) + ";"));
    }
    return t;
};
function $f8dbcd8598db1f0b$var$ze(e, t, n, o, s = []) {
    if ($f8dbcd8598db1f0b$var$Te(e)) return s;
    const r = typeof e;
    if ("string" === r) return s.push(e), s;
    if ("function" === r) {
        if ($f8dbcd8598db1f0b$var$Me(e)) return s;
        if ($f8dbcd8598db1f0b$var$De(e) && t) {
            const r = e(t);
            return $f8dbcd8598db1f0b$var$ze(r, t, n, o, s);
        }
        return s.push(e), s;
    }
    if (Array.isArray(e)) {
        for(let r = 0; r < e.length; r++)$f8dbcd8598db1f0b$var$ze(e[r], t, n, o, s);
        return s;
    }
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return s.push(`.${e.styledComponentId}`), s;
    if ($f8dbcd8598db1f0b$var$ke(e)) return n ? (e.inject(n, o), s.push(e.getName(o))) : s.push(e), s;
    if ($f8dbcd8598db1f0b$var$Me(e)) return s;
    if ($f8dbcd8598db1f0b$var$le(e)) {
        const t = $f8dbcd8598db1f0b$var$Fe(e);
        for(let e = 0; e < t.length; e++)s.push(t[e]);
        return s;
    }
    return s.push(e.toString()), s;
}
const $f8dbcd8598db1f0b$var$We = $f8dbcd8598db1f0b$var$F($f8dbcd8598db1f0b$export$83d89fbfd8236492);
class $f8dbcd8598db1f0b$var$Le {
    constructor(e, t, n){
        this.rules = e, this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$G($f8dbcd8598db1f0b$var$We, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Ae.registerId(t);
    }
    generateAndInjectStyles(e, t, n) {
        let o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        {
            let s = "";
            for(let o = 0; o < this.rules.length; o++){
                const r = this.rules[o];
                if ("string" == typeof r) s += r;
                else if (r) {
                    if ($f8dbcd8598db1f0b$var$De(r)) {
                        const o = r(e);
                        "string" == typeof o ? s += o : null != o && !1 !== o && (s += $f8dbcd8598db1f0b$var$ce($f8dbcd8598db1f0b$var$ze(o, e, t, n)));
                    } else s += $f8dbcd8598db1f0b$var$ce($f8dbcd8598db1f0b$var$ze(r, e, t, n));
                }
            }
            if (s) {
                this.dynamicNameCache || (this.dynamicNameCache = new Map);
                const e = n.hash ? n.hash + s : s;
                let r = this.dynamicNameCache.get(e);
                if (!r) {
                    if (r = $f8dbcd8598db1f0b$var$V($f8dbcd8598db1f0b$var$G($f8dbcd8598db1f0b$var$G(this.baseHash, n.hash), s) >>> 0), this.dynamicNameCache.size >= 200) {
                        const e = this.dynamicNameCache.keys().next().value;
                        void 0 !== e && this.dynamicNameCache.delete(e);
                    }
                    this.dynamicNameCache.set(e, r);
                }
                if (!t.hasNameForId(this.componentId, r)) {
                    const e = n(s, "." + r, void 0, this.componentId);
                    t.insertRules(this.componentId, r, e);
                }
                o = $f8dbcd8598db1f0b$var$ae(o, r);
            }
        }
        return o;
    }
}
const $f8dbcd8598db1f0b$var$Be = /&/g, $f8dbcd8598db1f0b$var$qe = 47;
function $f8dbcd8598db1f0b$var$He(e, t) {
    let n = 0;
    for(; --t >= 0 && 92 === e.charCodeAt(t);)n++;
    return !(1 & ~n);
}
function $f8dbcd8598db1f0b$var$Ye(e) {
    const t = e.length;
    let n = "", o = 0, s = 0, r = 0, i = !1, a = !1;
    for(let c = 0; c < t; c++){
        const l = e.charCodeAt(c);
        if (0 !== r || i || l !== $f8dbcd8598db1f0b$var$qe || 42 !== e.charCodeAt(c + 1)) {
            if (i) 42 === l && e.charCodeAt(c + 1) === $f8dbcd8598db1f0b$var$qe && (i = !1, c++);
            else if (34 !== l && 39 !== l || $f8dbcd8598db1f0b$var$He(e, c)) {
                if (0 === r) {
                    if (123 === l) s++;
                    else if (125 === l) {
                        if (s--, s < 0) {
                            a = !0;
                            let n = c + 1;
                            for(; n < t;){
                                const t = e.charCodeAt(n);
                                if (59 === t || 10 === t) break;
                                n++;
                            }
                            n < t && 59 === e.charCodeAt(n) && n++, s = 0, c = n - 1, o = n;
                            continue;
                        }
                        0 === s && (n += e.substring(o, c + 1), o = c + 1);
                    } else 59 === l && 0 === s && (n += e.substring(o, c + 1), o = c + 1);
                }
            } else 0 === r ? r = l : r === l && (r = 0);
        } else i = !0, c++;
    }
    return a || 0 !== s || 0 !== r ? (o < t && 0 === s && 0 === r && (n += e.substring(o)), n) : e;
}
function $f8dbcd8598db1f0b$var$Ue(e, t) {
    for(let n = 0; n < e.length; n++){
        const o = e[n];
        if ("rule" === o.type) {
            o.value = t + " " + o.value, o.value = o.value.replaceAll(",", "," + t + " ");
            const e = o.props, n = [];
            for(let o = 0; o < e.length; o++)n[o] = t + " " + e[o];
            o.props = n;
        }
        Array.isArray(o.children) && "@keyframes" !== o.type && (o.children = $f8dbcd8598db1f0b$var$Ue(o.children, t));
    }
    return e;
}
function $f8dbcd8598db1f0b$var$Je({ options: e = $f8dbcd8598db1f0b$var$$, plugins: t = $f8dbcd8598db1f0b$var$I } = $f8dbcd8598db1f0b$var$$) {
    let n, s, r;
    const i = (e, t, o)=>o.startsWith(s) && o.endsWith(s) && o.replaceAll(s, "").length > 0 ? `.${n}` : e, a = t.slice();
    a.push((e)=>{
        e.type === $298fb931ed4fbf8b$export$aa3a2e812ca8570d && e.value.includes("&") && (r || (r = new RegExp(`\\${s}\\b`, "g")), e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$Be, s).replace(r, i));
    }), e.prefix && a.push($298fb931ed4fbf8b$export$e08c7d021b829b7a), a.push($298fb931ed4fbf8b$export$fac44ee5b035f737);
    let c = [];
    const l = $298fb931ed4fbf8b$export$5a7767152ae0305f(a.concat($298fb931ed4fbf8b$export$38bcb760f1d4871c((e)=>c.push(e)))), u = (t, i = "", a = "", u = "&")=>{
        n = u, s = i, r = void 0;
        const d = function(e) {
            const t = -1 !== e.indexOf("//"), n = -1 !== e.indexOf("}");
            if (!t && !n) return e;
            if (!t) return $f8dbcd8598db1f0b$var$Ye(e);
            const o = e.length;
            let s = "", r = 0, i = 0, a = 0, c = 0, l = 0, u = !1;
            for(; i < o;){
                const t = e.charCodeAt(i);
                if (34 !== t && 39 !== t || $f8dbcd8598db1f0b$var$He(e, i)) {
                    if (0 === a) {
                        if (t === $f8dbcd8598db1f0b$var$qe && i + 1 < o && 42 === e.charCodeAt(i + 1)) {
                            for(i += 2; i + 1 < o && (42 !== e.charCodeAt(i) || e.charCodeAt(i + 1) !== $f8dbcd8598db1f0b$var$qe);)i++;
                            i += 2;
                        } else if (40 !== t) {
                            if (41 !== t) {
                                if (c > 0) i++;
                                else if (42 === t && i + 1 < o && e.charCodeAt(i + 1) === $f8dbcd8598db1f0b$var$qe) s += e.substring(r, i), i += 2, r = i, u = !0;
                                else if (t === $f8dbcd8598db1f0b$var$qe && i + 1 < o && e.charCodeAt(i + 1) === $f8dbcd8598db1f0b$var$qe) {
                                    for(s += e.substring(r, i); i < o && 10 !== e.charCodeAt(i);)i++;
                                    r = i, u = !0;
                                } else 123 === t ? l++ : 125 === t && l--, i++;
                            } else c > 0 && c--, i++;
                        } else c++, i++;
                    } else i++;
                } else 0 === a ? a = t : a === t && (a = 0), i++;
            }
            return u ? (r < o && (s += e.substring(r)), 0 === l ? s : $f8dbcd8598db1f0b$var$Ye(s)) : 0 === l ? e : $f8dbcd8598db1f0b$var$Ye(e);
        }(t);
        let h = $298fb931ed4fbf8b$export$ef7acd7185315e22(a || i ? a + " " + i + " { " + d + " }" : d);
        return e.namespace && (h = $f8dbcd8598db1f0b$var$Ue(h, e.namespace)), c = [], $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(h, l), c;
    }, d = e;
    let h = $f8dbcd8598db1f0b$var$M;
    for(let e = 0; e < t.length; e++)t[e].name || $f8dbcd8598db1f0b$var$v(15), h = $f8dbcd8598db1f0b$var$G(h, t[e].name);
    return (null == d ? void 0 : d.namespace) && (h = $f8dbcd8598db1f0b$var$G(h, d.namespace)), (null == d ? void 0 : d.prefix) && (h = $f8dbcd8598db1f0b$var$G(h, "p")), u.hash = h !== $f8dbcd8598db1f0b$var$M ? h.toString() : "", u;
}
const $f8dbcd8598db1f0b$var$Xe = new $f8dbcd8598db1f0b$var$Ae, $f8dbcd8598db1f0b$var$Ze = $f8dbcd8598db1f0b$var$Je(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Xe,
    stylis: $f8dbcd8598db1f0b$var$Ze,
    stylisPlugins: void 0
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer;
function $f8dbcd8598db1f0b$var$et() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var n;
    const o = $f8dbcd8598db1f0b$var$et(), { styleSheet: s } = o, r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        let t = s;
        return e.sheet ? t = e.sheet : e.target ? t = t.reconstructWithOptions(void 0 !== e.nonce ? {
            target: e.target,
            nonce: e.nonce
        } : {
            target: e.target
        }, !1) : void 0 !== e.nonce && (t = t.reconstructWithOptions({
            nonce: e.nonce
        })), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.nonce,
        e.sheet,
        e.target,
        s
    ]), i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        var t;
        return void 0 === e.stylisPlugins && void 0 === e.namespace && void 0 === e.enableVendorPrefixes ? o.stylis : $f8dbcd8598db1f0b$var$Je({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: null !== (t = e.stylisPlugins) && void 0 !== t ? t : o.stylisPlugins
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        e.stylisPlugins,
        o.stylis,
        o.stylisPlugins
    ]), a = "shouldForwardProp" in e ? e.shouldForwardProp : o.shouldForwardProp, c = null !== (n = e.stylisPlugins) && void 0 !== n ? n : o.stylisPlugins, l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            shouldForwardProp: a,
            styleSheet: r,
            stylis: i,
            stylisPlugins: c
        }), [
        a,
        r,
        i,
        c
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: l
    }, e.children);
}
const $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    const e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$v(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), o = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(function(e, t) {
            if (!e) throw $f8dbcd8598db1f0b$var$v(14);
            if ($f8dbcd8598db1f0b$var$re(e)) {
                const n = e(t);
                return n;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$v(8);
            return t ? Object.assign(Object.assign({}, t), e) : e;
        })(e.theme, n), [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: o
    }, e.children) : null;
}
const $f8dbcd8598db1f0b$var$it = Object.prototype.hasOwnProperty, $f8dbcd8598db1f0b$var$at = {};
function $f8dbcd8598db1f0b$var$ct(e, t) {
    const n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$k(e);
    $f8dbcd8598db1f0b$var$at[n] = ($f8dbcd8598db1f0b$var$at[n] || 0) + 1;
    const o = n + "-" + $f8dbcd8598db1f0b$var$z($f8dbcd8598db1f0b$export$83d89fbfd8236492 + n + $f8dbcd8598db1f0b$var$at[n]);
    return t ? t + "-" + o : o;
}
let $f8dbcd8598db1f0b$var$lt;
function $f8dbcd8598db1f0b$var$ut(o, s, r) {
    const i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(o), a = o, c = !$f8dbcd8598db1f0b$var$L(o), { attrs: l = $f8dbcd8598db1f0b$var$I, componentId: u = $f8dbcd8598db1f0b$var$ct(s.displayName, s.parentComponentId), displayName: d = $f8dbcd8598db1f0b$var$B(o) } = s, h = s.displayName && s.componentId ? $f8dbcd8598db1f0b$var$k(s.displayName) + "-" + s.componentId : s.componentId || u, p = i && a.attrs ? a.attrs.concat(l).filter(Boolean) : l;
    let { shouldForwardProp: f } = s;
    if (i && a.shouldForwardProp) {
        const e = a.shouldForwardProp;
        if (s.shouldForwardProp) {
            const t = s.shouldForwardProp;
            f = (n, o)=>e(n, o) && t(n, o);
        } else f = e;
    }
    const m = new $f8dbcd8598db1f0b$var$Le(r, h, i ? a.componentStyle : void 0);
    function y(o, s) {
        return function(o, s, r) {
            const { attrs: i, componentStyle: a, defaultProps: c, foldedComponentIds: l, styledComponentId: u, target: d } = o, h = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), p = $f8dbcd8598db1f0b$var$et(), f = o.shouldForwardProp || p.shouldForwardProp;
            const m = $f8dbcd8598db1f0b$var$R(s, h, c) || $f8dbcd8598db1f0b$var$$;
            let y, g;
            {
                const e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), n = e.current;
                if (null !== n && n[1] === m && n[2] === p.styleSheet && n[3] === p.stylis && n[7] === a && function(e, t, n) {
                    const o = e, s = t;
                    let r = 0;
                    for(const e in s)if ($f8dbcd8598db1f0b$var$it.call(s, e) && (r++, o[e] !== s[e])) return !1;
                    return r === n;
                }(n[0], s, n[4])) y = n[5], g = n[6];
                else {
                    y = function(e, t, n) {
                        const o = Object.assign(Object.assign({}, t), {
                            className: void 0,
                            theme: n
                        }), s = e.length > 1;
                        for(let n = 0; n < e.length; n++){
                            const r = e[n], i = $f8dbcd8598db1f0b$var$re(r) ? r(s ? Object.assign({}, o) : o) : r;
                            for(const e in i)"className" === e ? o.className = $f8dbcd8598db1f0b$var$ae(o.className, i[e]) : "style" === e ? o.style = Object.assign(Object.assign({}, o.style), i[e]) : e in t && void 0 === t[e] || (o[e] = i[e]);
                        }
                        return "className" in t && "string" == typeof t.className && (o.className = $f8dbcd8598db1f0b$var$ae(o.className, t.className)), o;
                    }(i, s, m), g = function(e, n, o, s) {
                        const r = e.generateAndInjectStyles(n, o, s);
                        return r;
                    }(a, y, p.styleSheet, p.stylis);
                    let n = 0;
                    for(const e in s)$f8dbcd8598db1f0b$var$it.call(s, e) && n++;
                    e.current = [
                        s,
                        m,
                        p.styleSheet,
                        p.stylis,
                        n,
                        y,
                        g,
                        a
                    ];
                }
            }
            const v = y.as || d, S = function(t, n, o, s) {
                const r = {};
                for(const i in t)void 0 === t[i] || "$" === i[0] || "as" === i || "theme" === i && t.theme === o || ("forwardedAs" === i ? r.as = t.forwardedAs : s && !s(i, n) || (r[i] = t[i], s));
                return r;
            }(y, v, m, f);
            let w = $f8dbcd8598db1f0b$var$ae(l, u);
            return g && (w += " " + g), y.className && (w += " " + y.className), S[$f8dbcd8598db1f0b$var$L(v) && v.includes("-") ? "class" : "className"] = w, r && (S.ref = r), (0, $acw62.createElement)(v, S);
        }(g, o, s);
    }
    y.displayName = d;
    let g = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(y);
    return g.attrs = p, g.componentStyle = m, g.displayName = d, g.shouldForwardProp = f, g.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$ae(a.foldedComponentIds, a.styledComponentId) : "", g.styledComponentId = h, g.target = i ? a.target : o, Object.defineProperty(g, "defaultProps", {
        get () {
            return this._foldedDefaultProps;
        },
        set (e) {
            this._foldedDefaultProps = i ? function(e, ...t) {
                for (const n of t)$f8dbcd8598db1f0b$var$ue(e, n, !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$de(g, ()=>`.${g.styledComponentId}`), c && $f8dbcd8598db1f0b$var$se(g, o, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), g;
}
var $f8dbcd8598db1f0b$var$dt = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "button",
    "br",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "menu",
    "meter",
    "nav",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use"
]);
function $f8dbcd8598db1f0b$var$ht(e, t) {
    const n = [
        e[0]
    ];
    for(let o = 0, s = t.length; o < s; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
const $f8dbcd8598db1f0b$var$pt = (e)=>($f8dbcd8598db1f0b$var$_e.add(e), e);
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e, ...t) {
    if ($f8dbcd8598db1f0b$var$re(e) || $f8dbcd8598db1f0b$var$le(e)) return $f8dbcd8598db1f0b$var$pt($f8dbcd8598db1f0b$var$ze($f8dbcd8598db1f0b$var$ht($f8dbcd8598db1f0b$var$I, [
        e,
        ...t
    ])));
    const n = e;
    return 0 === t.length && 1 === n.length && "string" == typeof n[0] ? $f8dbcd8598db1f0b$var$ze(n) : $f8dbcd8598db1f0b$var$pt($f8dbcd8598db1f0b$var$ze($f8dbcd8598db1f0b$var$ht(n, t)));
}
function $f8dbcd8598db1f0b$var$mt(e, t, n = $f8dbcd8598db1f0b$var$$) {
    if (!t) throw $f8dbcd8598db1f0b$var$v(1, t);
    const o = (o, ...s)=>e(t, n, $f8dbcd8598db1f0b$export$dbf350e5966cf602(o, ...s));
    return o.attrs = (o)=>$f8dbcd8598db1f0b$var$mt(e, t, Object.assign(Object.assign({}, n), {
            attrs: Array.prototype.concat(n.attrs, o).filter(Boolean)
        })), o.withConfig = (o)=>$f8dbcd8598db1f0b$var$mt(e, t, Object.assign(Object.assign({}, n), o)), o;
}
const $f8dbcd8598db1f0b$var$yt = (e)=>$f8dbcd8598db1f0b$var$mt($f8dbcd8598db1f0b$var$ut, e), $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$yt;
$f8dbcd8598db1f0b$var$dt.forEach((e)=>{
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$yt(e);
});
class $f8dbcd8598db1f0b$var$vt {
    constructor(e, t){
        this.instanceRules = new Map, this.rules = e, this.componentId = t, this.isStatic = function(e) {
            for(let t = 0; t < e.length; t += 1){
                const n = e[t];
                if ($f8dbcd8598db1f0b$var$re(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
            }
            return !0;
        }(e), $f8dbcd8598db1f0b$var$Ae.registerId(this.componentId);
    }
    removeStyles(e, t) {
        this.instanceRules.delete(e), this.rebuildGroup(t);
    }
    renderStyles(e, t, n, o) {
        const s = this.componentId;
        if (this.isStatic) {
            if (n.hasNameForId(s, s + e)) this.instanceRules.has(e) || this.computeRules(e, t, n, o);
            else {
                const r = this.computeRules(e, t, n, o);
                n.insertRules(s, r.name, r.rules);
            }
            return;
        }
        const r = this.instanceRules.get(e);
        if (this.computeRules(e, t, n, o), !n.server && r) {
            const t = r.rules, n = this.instanceRules.get(e).rules;
            if (t.length === n.length) {
                let e = !0;
                for(let o = 0; o < t.length; o++)if (t[o] !== n[o]) {
                    e = !1;
                    break;
                }
                if (e) return;
            }
        }
        this.rebuildGroup(n);
    }
    computeRules(e, t, n, o) {
        const s = $f8dbcd8598db1f0b$var$ce($f8dbcd8598db1f0b$var$ze(this.rules, t, n, o)), r = {
            name: this.componentId + e,
            rules: o(s, "")
        };
        return this.instanceRules.set(e, r), r;
    }
    rebuildGroup(e) {
        const t = this.componentId;
        e.clearRules(t);
        for (const n of this.instanceRules.values())e.insertRules(t, n.name, n.rules);
    }
}
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e, ...n) {
    const o = $f8dbcd8598db1f0b$export$dbf350e5966cf602(e, ...n), s = `sc-global-${$f8dbcd8598db1f0b$var$z(JSON.stringify(o))}`, r = new $f8dbcd8598db1f0b$var$vt(o, s);
    const i = (e)=>{
        const n = $f8dbcd8598db1f0b$var$et(), i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6);
        let c;
        {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
            null === e.current && (e.current = n.styleSheet.allocateGSInstance(s)), c = e.current;
        }
        n.styleSheet.server && a(c, e, n.styleSheet, i, n.stylis);
        {
            const o = r.isStatic ? [
                c,
                n.styleSheet,
                r
            ] : [
                c,
                e,
                n.styleSheet,
                i,
                n.stylis,
                r
            ], l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(r);
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>(n.styleSheet.server || (l.current !== r && (n.styleSheet.clearRules(s), l.current = r), a(c, e, n.styleSheet, i, n.stylis)), ()=>{
                    r.removeStyles(c, n.styleSheet);
                }), o);
        }
        return n.styleSheet.server && r.instanceRules.delete(c), null;
    };
    function a(e, t, n, o, s) {
        if (r.isStatic) r.renderStyles(e, $f8dbcd8598db1f0b$var$y, n, s);
        else {
            const a = Object.assign(Object.assign({}, t), {
                theme: $f8dbcd8598db1f0b$var$R(t, o, i.defaultProps)
            });
            r.renderStyles(e, a, n, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(i);
}
function $f8dbcd8598db1f0b$var$wt(e, t, n, o, s) {
    for(const r in e){
        const i = e[r], a = s ? s + "-" + r : r;
        if ("object" == typeof i && null !== i) {
            const e = {};
            $f8dbcd8598db1f0b$var$wt(i, t, e, o, a), n[r] = e;
        } else n[r] = o(a, i, r);
    }
}
function $f8dbcd8598db1f0b$var$bt(e, t, n, o) {
    let s = "";
    for(const r in e){
        const i = e[r], a = t[r], c = o ? o + "-" + r : r;
        "object" == typeof i && null !== i ? "object" == typeof a && null !== a && (s += $f8dbcd8598db1f0b$var$bt(i, a, n, c)) : void 0 !== a && "function" != typeof a && (s += "--" + n + c + ":" + a + ";");
    }
    return s;
}
function $f8dbcd8598db1f0b$export$25d302a5b900a763(e, t) {
    var n, o;
    const s = (null !== (n = null == t ? void 0 : t.prefix) && void 0 !== n ? n : "sc") + "-", r = null !== (o = null == t ? void 0 : t.selector) && void 0 !== o ? o : ":root", i = function(e, t) {
        const n = {};
        return $f8dbcd8598db1f0b$var$wt(e, t, n, (e)=>"--" + t + e), n;
    }(e, s), a = function(e, t) {
        const n = {};
        return $f8dbcd8598db1f0b$var$wt(e, t, n, (e, n)=>{
            return "var(--" + t + e + ", " + n + ")";
        }), n;
    }(e, s), c = $f8dbcd8598db1f0b$export$f0f03736edb61697`
    ${r} {
      ${(t)=>$f8dbcd8598db1f0b$var$bt(e, t.theme, s)}
    }
  `;
    return Object.assign(a, {
        GlobalStyle: c,
        raw: e,
        vars: i,
        resolve (t) {
            if (!$f8dbcd8598db1f0b$var$h) throw new Error("createTheme.resolve() is client-only");
            const n = null != t ? t : document.documentElement;
            return function(e, t, n) {
                const o = {};
                return $f8dbcd8598db1f0b$var$wt(e, t, o, (e, o)=>n.getPropertyValue("--" + t + e).trim() || o), o;
            }(e, s, getComputedStyle(n));
        }
    });
}
var $f8dbcd8598db1f0b$var$Ct;
class $f8dbcd8598db1f0b$var$Ot {
    constructor(e, t){
        this[$f8dbcd8598db1f0b$var$Ct] = !0, this.inject = (e, t = $f8dbcd8598db1f0b$var$Ze)=>{
            const n = this.getName(t);
            if (!e.hasNameForId(this.id, n)) {
                const o = t(this.rules, n, "@keyframes");
                e.insertRules(this.id, n, o);
            }
        }, this.name = e, this.id = $f8dbcd8598db1f0b$var$m + e, this.rules = t, $f8dbcd8598db1f0b$var$C(this.id), $f8dbcd8598db1f0b$var$de(this, ()=>{
            throw $f8dbcd8598db1f0b$var$v(12, String(this.name));
        });
    }
    getName(e = $f8dbcd8598db1f0b$var$Ze) {
        return e.hash ? this.name + $f8dbcd8598db1f0b$var$V(+e.hash >>> 0) : this.name;
    }
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e, ...t) {
    const n = $f8dbcd8598db1f0b$var$ce($f8dbcd8598db1f0b$export$dbf350e5966cf602(e, ...t)), o = $f8dbcd8598db1f0b$var$z(n);
    return new $f8dbcd8598db1f0b$var$Ot(o, n);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((n, o)=>{
        const s = $f8dbcd8598db1f0b$var$R(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, Object.assign(Object.assign({}, n), {
            theme: s,
            ref: o
        }));
    });
    return n.displayName = `WithTheme(${$f8dbcd8598db1f0b$var$W(e)})`, $f8dbcd8598db1f0b$var$se(n, e);
}
$f8dbcd8598db1f0b$var$Ct = $f8dbcd8598db1f0b$var$xe;
class $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 {
    constructor({ nonce: e } = {}){
        this._emitSheetCSS = ()=>{
            const e = this.instance.toString();
            if (!e) return "";
            const t = this.instance.options.nonce || $f8dbcd8598db1f0b$var$be();
            return `<style ${$f8dbcd8598db1f0b$var$ce([
                t && `nonce="${t}"`,
                `${$f8dbcd8598db1f0b$var$a}="true"`,
                `${$f8dbcd8598db1f0b$var$l}="${$f8dbcd8598db1f0b$export$83d89fbfd8236492}"`
            ].filter(Boolean), " ")}>${e}</style>`;
        }, this.getStyleTags = ()=>{
            if (this.sealed) throw $f8dbcd8598db1f0b$var$v(2);
            return this._emitSheetCSS();
        }, this.getStyleElement = ()=>{
            if (this.sealed) throw $f8dbcd8598db1f0b$var$v(2);
            const e = this.instance.toString();
            if (!e) return [];
            const n = {
                [$f8dbcd8598db1f0b$var$a]: "",
                [$f8dbcd8598db1f0b$var$l]: $f8dbcd8598db1f0b$export$83d89fbfd8236492,
                dangerouslySetInnerHTML: {
                    __html: e
                }
            }, o = this.instance.options.nonce || $f8dbcd8598db1f0b$var$be();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", Object.assign({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = ()=>{
            this.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Ae({
            isServer: !0,
            nonce: e
        }), this.sealed = !1;
    }
    collectStyles(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$v(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }
    interleaveWithNodeStream(e) {
        throw $f8dbcd8598db1f0b$var$v(3);
    }
}
const $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Ae,
    mainSheet: $f8dbcd8598db1f0b$var$Xe
};
const $f8dbcd8598db1f0b$var$It = `__sc-${$f8dbcd8598db1f0b$var$a}__`;
const $f8dbcd8598db1f0b$var$$t = /:(?:(first)-child|(last)-child|(only)-child|(nth-child)\(([^()]+)\)|(nth-last-child)\(([^()]+)\))/g, $f8dbcd8598db1f0b$var$Rt = `:not(style[${$f8dbcd8598db1f0b$var$a}])`, $f8dbcd8598db1f0b$var$jt = `style[${$f8dbcd8598db1f0b$var$a}]`;
function $f8dbcd8598db1f0b$var$xt(e) {
    return -1 === e.indexOf("-child") ? e : ($f8dbcd8598db1f0b$var$$t.lastIndex = 0, e.replace($f8dbcd8598db1f0b$var$$t, (e, t, n, o, s, r, i, a)=>t ? `:nth-child(1 of ${$f8dbcd8598db1f0b$var$Rt})` : n ? `:nth-last-child(1 of ${$f8dbcd8598db1f0b$var$Rt})` : o ? `:nth-child(1 of ${$f8dbcd8598db1f0b$var$Rt}):nth-last-child(1 of ${$f8dbcd8598db1f0b$var$Rt})` : s ? -1 !== r.indexOf(" of ") ? e : `:nth-child(${r} of ${$f8dbcd8598db1f0b$var$Rt})` : -1 !== a.indexOf(" of ") ? e : `:nth-last-child(${a} of ${$f8dbcd8598db1f0b$var$Rt})`));
}
function $f8dbcd8598db1f0b$var$kt(e, t) {
    if (-1 === e.indexOf("+")) return;
    let n = 0, o = 0;
    for(let s = 0; s < e.length; s++){
        const r = e.charCodeAt(s);
        if (40 === r) n++;
        else if (41 === r) n--;
        else if (91 === r) o++;
        else if (93 === r) o--;
        else if (43 === r && 0 === n && 0 === o && !$f8dbcd8598db1f0b$var$He(e, s)) {
            const n = e.substring(0, s), o = e.substring(s + 1);
            t.push(n + "+" + $f8dbcd8598db1f0b$var$jt + "+" + o), t.push(n + "+" + $f8dbcd8598db1f0b$var$jt + "+" + $f8dbcd8598db1f0b$var$jt + "+" + o);
        }
    }
}
function $f8dbcd8598db1f0b$export$337461d98bd2ad54(e) {
    if (e.type === (0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d)) {
        const t = e.props, n = [];
        for(let e = 0; e < t.length; e++){
            const o = $f8dbcd8598db1f0b$var$xt(t[e]);
            n.push(o), $f8dbcd8598db1f0b$var$kt(o, n);
        }
        e.props = n;
    }
}




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");


const $68869157a003f4ce$var$CONTROL_LABELS = {
    minimize: "Minimize",
    maximize: "Maximize",
    restore: "Restore",
    help: "Help",
    close: "Close"
};
const $68869157a003f4ce$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  /* Status-bar text ("Cards: 12 / 52") is chrome, not copy. */
  & > .status-bar {
    -webkit-user-select: none;
    user-select: none;
  }
`;
const $68869157a003f4ce$var$Body = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1 1 auto;
  min-height: 0;
`;
// The grab cursor only where grabbing WORKS: draggable containers
// (PositionedWindow, TouchDragBox) stamp data-draggable, and only
// their title bars advertise dragging.
const $68869157a003f4ce$var$TitleBar = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  cursor: default;

  [data-draggable] & {
    cursor: grab;
  }
  [data-draggable] &:active {
    cursor: grabbing;
  }

  /* A programmatic press (the spectated close ritual) needs the same
     inset bevel as a real pointer-held 98.css button. */
  & .title-bar-controls button[data-pressed="true"]:not(:disabled) {
    box-shadow:
      inset -1px -1px #fff,
      inset 1px 1px #0a0a0a,
      inset -2px -2px #dfdfdf,
      inset 2px 2px grey;
  }
`;
const $68869157a003f4ce$var$TitleText = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  white-space: nowrap;
`;
function $68869157a003f4ce$var$Window({ title: title, icon: // Optional 16px icon node rendered at the left of the title bar,
// like real Win95 windows. Pass a <PixelIcon size={16} />.
icon, controls: controls, disabledControls: disabledControls, pressedControls: pressedControls, onControlClick: onControlClick, inactive: inactive = false, statusFields: statusFields, children: children, className: className, bodyStyle: bodyStyle, ...delegated }) {
    const hasControls = Array.isArray(controls) && controls.length > 0;
    const hasStatus = Array.isArray(statusFields) && statusFields.length > 0;
    const rootClassName = [
        "window",
        className
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($68869157a003f4ce$var$Wrapper, {
        className: rootClassName,
        ...delegated,
        children: [
            title !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($68869157a003f4ce$var$TitleBar, {
                className: inactive ? "title-bar inactive" : "title-bar",
                "data-drag-handle": true,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($68869157a003f4ce$var$TitleText, {
                        className: "title-bar-text",
                        children: [
                            icon,
                            title
                        ]
                    }),
                    hasControls && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "title-bar-controls",
                        children: controls.map((control)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                "aria-label": $68869157a003f4ce$var$CONTROL_LABELS[control] ?? control,
                                disabled: disabledControls?.includes(control),
                                "data-pressed": pressedControls?.includes(control) ? "true" : undefined,
                                onClick: onControlClick ? ()=>onControlClick(control) : undefined
                            }, control))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($68869157a003f4ce$var$Body, {
                className: "window-body",
                style: bodyStyle,
                children: children
            }),
            hasStatus && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "status-bar",
                children: statusFields.map((field, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "status-bar-field",
                        children: field
                    }, i))
            })
        ]
    });
}
var $68869157a003f4ce$export$2e2bcd8739ae039 = $68869157a003f4ce$var$Window;





parcelRequire("acw62");

var $0eeb772b8ab814c1$exports = {};
$0eeb772b8ab814c1$exports = import.meta.resolve("avxrW");


var $109c87bcc2d1a812$exports = {};
$109c87bcc2d1a812$exports = import.meta.resolve("dwrZg");


var $4bd3e62f109b461f$exports = {};
$4bd3e62f109b461f$exports = import.meta.resolve("6Glel");


var $4733d53c5ca7b229$exports = {};
$4733d53c5ca7b229$exports = import.meta.resolve("Wr5Oj");


var $9ae9442fae2a6c23$exports = {};
$9ae9442fae2a6c23$exports = import.meta.resolve("ZAW3f");


var $89c2ec9ed18618a5$exports = {};
$89c2ec9ed18618a5$exports = import.meta.resolve("fWT4Y");


var $ea7ce9fd03524b69$exports = {};
$ea7ce9fd03524b69$exports = import.meta.resolve("c0APM");


var $91292f1f5ba37ed4$exports = {};
$91292f1f5ba37ed4$exports = import.meta.resolve("ktpRF");


var $2f44f0632e394eb8$exports = {};
$2f44f0632e394eb8$exports = import.meta.resolve("7c0yk");


var $7add5cf334a18f12$exports = {};
$7add5cf334a18f12$exports = import.meta.resolve("i6QDM");


var $b964cc82fe3789e7$exports = {};
$b964cc82fe3789e7$exports = import.meta.resolve("dfJeO");


var $08d4017f46dc0890$exports = {};
$08d4017f46dc0890$exports = import.meta.resolve("fW4Vy");


var $457d48a8c3ace38b$exports = {};
$457d48a8c3ace38b$exports = import.meta.resolve("jHg0P");


var $1eaf024914584560$exports = {};
$1eaf024914584560$exports = import.meta.resolve("d363a");



var $cb11801f44328d80$exports = {};
$cb11801f44328d80$exports = import.meta.resolve("fX1DN");


var $62924f4f7d826ec8$exports = {};
$62924f4f7d826ec8$exports = import.meta.resolve("lUlg1");


var $6b768cd396e8e746$exports = {};
$6b768cd396e8e746$exports = import.meta.resolve("lHkuS");


var $22eed918e36e5614$exports = {};
$22eed918e36e5614$exports = import.meta.resolve("t2iiM");


var $97bfc673b4213ac6$exports = {};
$97bfc673b4213ac6$exports = import.meta.resolve("3bcHq");


var $1ea8eb3fc83525f9$exports = {};
$1ea8eb3fc83525f9$exports = import.meta.resolve("cBdwm");


var $1b5628fd3d79632d$exports = {};
$1b5628fd3d79632d$exports = import.meta.resolve("d1AZU");


var $7beb4fbe7930c90b$exports = {};
$7beb4fbe7930c90b$exports = import.meta.resolve("6yhbd");


var $9a5c3170aea1aafd$exports = {};
$9a5c3170aea1aafd$exports = import.meta.resolve("kUs3i");


var $cc7eb1810790de57$exports = {};
$cc7eb1810790de57$exports = import.meta.resolve("8rFdQ");


var $12c954d2f07a16ef$exports = {};
$12c954d2f07a16ef$exports = import.meta.resolve("l6UMP");


var $4bd60bb086946a20$exports = {};
$4bd60bb086946a20$exports = import.meta.resolve("9UmGN");


var $f2e992d324369992$exports = {};
$f2e992d324369992$exports = import.meta.resolve("j7DmC");


var $3edd897ed395415a$exports = {};
$3edd897ed395415a$exports = import.meta.resolve("61v76");


var $55e81fd03e0c7dec$exports = {};
$55e81fd03e0c7dec$exports = import.meta.resolve("kujVj");


var $d95394ce6143dbbc$exports = {};
$d95394ce6143dbbc$exports = import.meta.resolve("6UhGx");


// One manifest for the piece's period icon set. Keeping every use
// behind this component makes a future replacement an asset-only swap.
// Use size 16 for menus/title bars and 32 for desktop icons.
const $c9b9905cc1d7b9d6$var$PNGS = {
    solitaire: {
        16: new URL($0eeb772b8ab814c1$exports),
        32: new URL($109c87bcc2d1a812$exports)
    },
    folder: {
        16: new URL($4bd3e62f109b461f$exports),
        32: new URL($4733d53c5ca7b229$exports)
    },
    "recycle-bin-empty": {
        16: new URL($9ae9442fae2a6c23$exports),
        32: new URL($89c2ec9ed18618a5$exports)
    },
    "recycle-bin-full": {
        16: new URL($ea7ce9fd03524b69$exports),
        32: new URL($91292f1f5ba37ed4$exports)
    },
    "all-games": {
        16: new URL($2f44f0632e394eb8$exports),
        32: new URL($7add5cf334a18f12$exports)
    },
    settings: {
        16: new URL($b964cc82fe3789e7$exports),
        32: new URL($08d4017f46dc0890$exports)
    },
    shutdown: {
        16: new URL($457d48a8c3ace38b$exports),
        32: new URL($1eaf024914584560$exports)
    },
    // MsgIcon resolves `message-${kind}` — same art, dialog-sized.
    "message-shutdown": {
        32: new URL($1eaf024914584560$exports)
    },
    "text-file": {
        16: new URL($cb11801f44328d80$exports),
        32: new URL($62924f4f7d826ec8$exports)
    },
    notepad: {
        16: new URL($6b768cd396e8e746$exports),
        32: new URL($22eed918e36e5614$exports)
    },
    speaker: {
        16: new URL($97bfc673b4213ac6$exports),
        32: new URL($1ea8eb3fc83525f9$exports)
    },
    "speaker-loud": {
        16: new URL($1b5628fd3d79632d$exports),
        32: new URL($7beb4fbe7930c90b$exports)
    },
    key: {
        16: new URL($9a5c3170aea1aafd$exports),
        32: new URL($cc7eb1810790de57$exports)
    },
    information: {
        16: new URL($12c954d2f07a16ef$exports),
        32: new URL($4bd60bb086946a20$exports)
    },
    "message-question": {
        16: new URL($f2e992d324369992$exports),
        32: new URL($3edd897ed395415a$exports)
    },
    "message-warning": {
        16: new URL($55e81fd03e0c7dec$exports),
        32: new URL($d95394ce6143dbbc$exports)
    }
};
function $c9b9905cc1d7b9d6$var$PixelIcon({ name: name, size: size = 16, className: className }) {
    const set = $c9b9905cc1d7b9d6$var$PNGS[name];
    if (!set) return null;
    const variant = size <= 16 ? set[16] : set[32];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9b9905cc1d7b9d6$var$Img, {
        src: variant.href ?? String(variant),
        width: size,
        height: size,
        alt: "",
        "aria-hidden": "true",
        className: className,
        // Never let the browser start a native image drag — it fires
        // pointercancel and kills our own drag handling.
        draggable: false
    });
}
const $c9b9905cc1d7b9d6$var$Img = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img`
  image-rendering: pixelated;
  display: inline-block;
  flex-shrink: 0;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  user-select: none;
`;
var $c9b9905cc1d7b9d6$export$2e2bcd8739ae039 = $c9b9905cc1d7b9d6$var$PixelIcon;






var $acw62 = parcelRequire("acw62");

// Window menu bar. Items are { label, items: [{ label, shortcut, onClick,
// disabled, checked }] } for a real dropdown, { label, disabled: true }
// for an honestly-greyed menu, or a plain string — which ALSO renders
// disabled: affordance honesty means nothing looks clickable unless it
// does something. One menu open at a time; clicking elsewhere closes it
// via the transparent backdrop.
function $1171fabab2f3639c$var$MenuBar({ items: items, className: className, ...delegated }) {
    const [openLabel, setOpenLabel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Close on any press outside this menubar. A fixed-position backdrop
    // would be clipped by PositionedWindow's transform (fixed scopes to
    // a transformed ancestor); a document listener sidesteps that.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (openLabel == null) return undefined;
        const onDocDown = (e)=>{
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpenLabel(null);
        };
        document.addEventListener("mousedown", onDocDown);
        return ()=>document.removeEventListener("mousedown", onDocDown);
    }, [
        openLabel
    ]);
    const labelOf = (item)=>typeof item === "string" ? item : item.label;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1171fabab2f3639c$var$Wrapper, {
        role: "menubar",
        className: className,
        ref: wrapperRef,
        ...delegated,
        children: items.map((item)=>{
            const label = labelOf(item);
            const hasMenu = typeof item !== "string" && Array.isArray(item.items);
            const disabled = !hasMenu || item.disabled === true;
            const open = hasMenu && !disabled && openLabel === label;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($1171fabab2f3639c$var$ItemWrap, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($1171fabab2f3639c$var$Item, {
                        type: "button",
                        role: "menuitem",
                        disabled: disabled,
                        "data-open": open ? "true" : undefined,
                        "data-scene-target": typeof item === "string" ? undefined : item.sceneTarget,
                        onClick: ()=>hasMenu && setOpenLabel(open ? null : label),
                        // Win95 menu mode: once any menu is open, sliding along
                        // the bar opens siblings without a click.
                        onMouseEnter: ()=>{
                            if (openLabel != null && hasMenu && !disabled) setOpenLabel(label);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1171fabab2f3639c$var$FirstChar, {
                                children: label[0]
                            }),
                            label.slice(1)
                        ]
                    }),
                    open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1171fabab2f3639c$var$Dropdown, {
                        className: "window",
                        children: item.items.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($1171fabab2f3639c$var$DropdownItem, {
                                type: "button",
                                role: "menuitem",
                                disabled: entry.disabled,
                                "data-scene-target": entry.sceneTarget,
                                onClick: ()=>{
                                    setOpenLabel(null);
                                    if (entry.onClick) entry.onClick();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1171fabab2f3639c$var$Check, {
                                        "aria-hidden": "true",
                                        children: entry.checked ? "\u2022" : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1171fabab2f3639c$var$Label, {
                                        children: entry.label
                                    }),
                                    entry.shortcut && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1171fabab2f3639c$var$Shortcut, {
                                        children: entry.shortcut
                                    })
                                ]
                            }, entry.label))
                    })
                ]
            }, label);
        })
    });
}
const $1171fabab2f3639c$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  margin: 1px 0;
  width: 100%;
`;
const $1171fabab2f3639c$var$ItemWrap = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $1171fabab2f3639c$var$Item = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  background: transparent;
  border: none;
  box-shadow: none;
  min-height: 0;
  min-width: 0;
  padding: 2px 5px;
  color: inherit;
  text-shadow: none;
  font: inherit;
  cursor: default;

  &&:not(:disabled):not([data-open="true"]):hover,
  &&[data-ghost-hover="true"]:not([data-open="true"]),
  &&[data-open="true"] {
    box-shadow:
      inset 1px 1px #fff,
      inset -1px -1px #808080;
  }

  &&:not(:disabled):active,
  &&[data-open="true"],
  &&[data-open="true"]:hover {
    box-shadow:
      inset 1px 1px #808080,
      inset -1px -1px #fff;
    text-shadow: none;
  }

  &&:focus {
    outline: none;
  }
  &&:focus-visible {
    box-shadow:
      inset 1px 1px #fff,
      inset -1px -1px #808080;
  }

  &&:disabled {
    color: #808080;
    text-shadow: 1px 1px 0 #fff;
  }
`;
const $1171fabab2f3639c$var$Dropdown = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  top: calc(100% - 1px); /* Nolen 2026-09-21: reads 1px high in the ref shots */
  left: 0;
  z-index: 950;
  min-width: 150px;
  display: flex;
  flex-direction: column;
  padding: 2px;
`;
const $1171fabab2f3639c$var$DropdownItem = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  display: flex;
  align-items: center;
  gap: 5px;
  background: transparent;
  border: none;
  box-shadow: none;
  min-height: 0;
  min-width: 0;
  padding: 4px 10px;
  text-align: left;
  font: inherit;
  color: inherit;
  text-shadow: none;
  white-space: nowrap;

  &&:not(:disabled):hover,
  &&[data-ghost-hover="true"] {
    background: #00007b;
    color: #fff;
    box-shadow: none;
  }
  &&:not(:disabled):active {
    box-shadow: none;
    text-shadow: none;
  }
  &&:focus {
    outline: none;
  }
  &&:focus-visible {
    background: #00007b;
    color: #fff;
  }
  &&:disabled {
    color: #808080;
  }
`;
const $1171fabab2f3639c$var$Shortcut = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  font-size: 12px;
  opacity: 0.75;
`;
// Win95 View menus mark the current choice with a leading dot.
const $1171fabab2f3639c$var$Check = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  width: 10px;
  flex-shrink: 0;
  text-align: center;
`;
const $1171fabab2f3639c$var$Label = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  flex: 1 1 auto;
`;
const $1171fabab2f3639c$var$FirstChar = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  text-decoration: underline;
  text-decoration-thickness: 1px; /* integer px — pixel-font rule */
`;
var $1171fabab2f3639c$export$2e2bcd8739ae039 = $1171fabab2f3639c$var$MenuBar;





parcelRequire("acw62");


parcelRequire("acw62");

// Per-cell dimensions of the source sprite sheet. These describe the sheet
// itself — not how cards get rendered on the page. For the display default,
// see DEFAULT_TILE_WIDTH / DEFAULT_TILE_HEIGHT in Tile.js.
const $db9a6e9d90d8f08e$export$1a70cc7f0ad02c3 = 71;
const $db9a6e9d90d8f08e$export$80bc797476280f0d = 96;
const $db9a6e9d90d8f08e$export$3f21081b82c23e7 = 13;
const $db9a6e9d90d8f08e$export$62998708d5db906a = 6;
const $db9a6e9d90d8f08e$export$47ccc2a6abaeb72b = "/solitaire-images-full.png";
const $db9a6e9d90d8f08e$var$SUITS = [
    "spade",
    "heart",
    "club",
    "diamond"
];
const $db9a6e9d90d8f08e$var$RANKS = [
    "A",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K"
];
function $db9a6e9d90d8f08e$var$buildTiles() {
    const tiles = {};
    $db9a6e9d90d8f08e$var$SUITS.forEach((suit, row)=>{
        $db9a6e9d90d8f08e$var$RANKS.forEach((rank, col)=>{
            tiles[`${suit}-${rank}`] = [
                row,
                col
            ];
        });
    });
    for(let i = 0; i < 10; i++)tiles[`back-${i}`] = [
        4,
        i
    ];
    for(let i = 0; i < 9; i++)tiles[`back-${10 + i}`] = [
        5,
        i
    ];
    tiles.recycle = [
        4,
        10
    ];
    tiles["big-x"] = [
        4,
        11
    ];
    tiles.foundation = [
        4,
        12
    ];
    return tiles;
}
const $db9a6e9d90d8f08e$export$34ddeca23ac38a20 = $db9a6e9d90d8f08e$var$buildTiles();
const $db9a6e9d90d8f08e$export$15e876c33fed7287 = Array.from({
    length: 19
}, (_, i)=>`back-${i}`);


const $50d7a68c1c70e782$export$67e895109476e448 = 71;
const $50d7a68c1c70e782$export$8a96fdb4dcd92c65 = $50d7a68c1c70e782$export$67e895109476e448 * ((0, $db9a6e9d90d8f08e$export$80bc797476280f0d) / (0, $db9a6e9d90d8f08e$export$1a70cc7f0ad02c3));
const $50d7a68c1c70e782$var$RANK_WORDS = {
    a: "ace",
    j: "jack",
    q: "queen",
    k: "king"
};
// "heart-10" → "10 of hearts"; non-card sprites ("back-3", "recycle")
// fall back to the raw name. Only spoken for button tiles — div tiles
// are decoration and stay silent.
function $50d7a68c1c70e782$var$tileLabel(name) {
    const m = /^(spade|heart|club|diamond)-(a|[2-9]|10|j|q|k)$/.exec(name);
    if (!m) return name.replace(/-/g, " ");
    return `${$50d7a68c1c70e782$var$RANK_WORDS[m[2]] ?? m[2]} of ${m[1]}s`;
}
function $50d7a68c1c70e782$var$Tile({ name: name, width: width = $50d7a68c1c70e782$export$67e895109476e448, height: height, as: as = "div", className: className, selected: selected = false, ...delegated }) {
    const [row, col] = (0, $db9a6e9d90d8f08e$export$34ddeca23ac38a20)[name];
    // Buttons get a spoken label; decorative div tiles are hidden from
    // the accessibility tree instead.
    const extraProps = as === "button" ? {
        type: "button",
        "aria-label": $50d7a68c1c70e782$var$tileLabel(name)
    } : {
        "aria-hidden": "true"
    };
    // Default to the sprite's native size if neither dimension is given.
    // If exactly one is given, leave the other undefined so CSS aspect-ratio
    // derives it from the source ratio. If both are given, the caller has
    // explicitly opted out of aspect locking.
    const resolvedWidth = width ?? (height == null ? (0, $db9a6e9d90d8f08e$export$1a70cc7f0ad02c3) : undefined);
    const resolvedHeight = height ?? (width == null ? (0, $db9a6e9d90d8f08e$export$80bc797476280f0d) : undefined);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50d7a68c1c70e782$var$Root, {
        as: as,
        $row: row,
        $col: col,
        $width: resolvedWidth,
        $height: resolvedHeight,
        "data-selected": selected ? "true" : undefined,
        className: className,
        ...extraProps,
        ...delegated
    });
}
const $50d7a68c1c70e782$var$Root = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: inline-block;
  /* Tiles are fractional-height inline-blocks; on the default baseline
     alignment, div↔button swaps can shift a container's height by a
     sub-pixel. Pin to top so baseline math never participates in layout. */
  vertical-align: top;
  ${({ $width: $width })=>$width != null && `width: ${$width}px;`}
  ${({ $height: $height })=>$height != null && `height: ${$height}px;`}
  aspect-ratio: ${(0, $db9a6e9d90d8f08e$export$1a70cc7f0ad02c3)} / ${(0, $db9a6e9d90d8f08e$export$80bc797476280f0d)};

  background-image: url("${(0, $db9a6e9d90d8f08e$export$47ccc2a6abaeb72b)}");
  background-color: transparent;
  background-repeat: no-repeat;
  background-size: ${(0, $db9a6e9d90d8f08e$export$3f21081b82c23e7) * 100}% ${(0, $db9a6e9d90d8f08e$export$62998708d5db906a) * 100}%;
  background-position: ${({ $col: $col, $row: $row })=>`${$col / ((0, $db9a6e9d90d8f08e$export$3f21081b82c23e7) - 1) * 100}% ${$row / ((0, $db9a6e9d90d8f08e$export$62998708d5db906a) - 1) * 100}%`};

  border: none;
  box-shadow: none;
  outline: none;
  min-height: 0;
  min-width: 0;
  padding: 0;
  color: inherit;
  text-shadow: none;
  font: inherit;
  cursor: default;

  /* Kill 98.css's pressed-button chrome while a tile is being clicked —
     ALL tiles, selected or not; the selection glow is the ::after wash
     below, which box-shadow can't touch. */
  &&:not(:disabled):active {
    box-shadow: none;
    text-shadow: none;
  }

  &&:focus {
    outline: none;
  }
  /* Mouse clicks stay outline-free; tabbing shows the Win95 dotted
     marquee so keyboard players can see where they are. */
  &&:focus-visible {
    outline: 1px dotted #fff;
    outline-offset: -3px;
  }

  /* Hover styles scoped to the button variant only (div-rendered Tiles
     unaffected). Specificity (0,3,1) is enough to beat 98.css's own
     button hover rules in @media (not (hover)) contexts. */
  &:is(button):not(:disabled):hover {
    cursor: pointer;
    /* Tiles stay chrome-free on hover too — without this, the global
       touch-device hover-neutralizer (global-styles.css) would win and
       raise a bevel on every tapped card. */
    box-shadow: none;
  }

  /* Cards are drag sources; without this, touch devices turn the drag
     into a page scroll before it can start. */
  touch-action: none;

  /* Selection: a dark navy wash, the way Explorer tinted a selected
     icon (not sol.exe's full color-inversion, which reads as jarring).
     Driven by the data-selected attribute rather than a
     styled-components dynamic prop so the rule is statically present
     in the stylesheet. */
  position: relative;

  &&[data-selected="true"]::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 5px;
    background: rgba(0, 0, 123, 0.32);
  }
`;
var $50d7a68c1c70e782$export$2e2bcd8739ae039 = $50d7a68c1c70e782$var$Tile;



parcelRequire("acw62");





// Renders the stock slot's current face:
//   - card back when the stock has cards (clickable, draws next batch)
//   - "big-x" when stock is empty and recycling would just cycle the same
//     cards back through the same fan — a visible "dead end" signal; not
//     clickable.
//   - recycle icon when stock is empty but recycling would yield a
//     different fan than the current waste top (clickable).
//   - nothing when both stock and waste are empty.
//
// Every face renders inside the same fixed-size Slot so the stock cell's
// box never changes across states — swapping the face (or showing none)
// can't nudge the board row's layout.
function $f1fc16156e0c8df5$var$Stock({ count: count, canRecycle: canRecycle, deadEnd: deadEnd, cardBack: cardBack, onClick: onClick }) {
    let face = null;
    if (count > 0) face = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
        name: cardBack,
        as: "button",
        onClick: onClick,
        "aria-label": "Draw from the stock"
    });
    else if (deadEnd) face = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
        name: "big-x"
    });
    else if (canRecycle) face = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
        name: "recycle",
        as: "button",
        onClick: onClick,
        "aria-label": "Turn the waste over"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1fc16156e0c8df5$var$Slot, {
        children: face
    });
}
const $f1fc16156e0c8df5$var$Slot = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: ${(0, $50d7a68c1c70e782$export$67e895109476e448)}px;
  height: ${(0, $50d7a68c1c70e782$export$8a96fdb4dcd92c65)}px;
`;
var $f1fc16156e0c8df5$export$2e2bcd8739ae039 = $f1fc16156e0c8df5$var$Stock;





parcelRequire("acw62");



// Klondike solitaire engine — pure functions, no React, no DOM.
//
// The React layer treats this module as a black box:
//   const state = newGame(seed);
//   const moves = legalMoves(state);
//   const next  = applyMove(state, moves[i]);
//
// Later the server imports the same module to validate move sequences, so
// keep everything here browser-agnostic.
//
// WIRE FORMAT: a game's move history is a flat array of integers, each the
// index of the chosen move within legalMoves(state) at that step —
// including draws, one integer per draw. Deliberately NOT run-length
// encoded: this caps the damage any single stored integer can do on
// replay, at the cost of a few extra bytes for draw-heavy games.
// stripTrailingDraws drops trailing stock cycling on abandon. The
// enumeration order in legalMoves IS the schema — never reorder it without
// a coordinated version bump.
//
// Undo is a protocol affair, not a move: the server pops the last index
// from the history (single-step, never twice in a row), so stored
// histories never contain undone moves and this engine needs no inverse-
// move machinery.
//
// =============================================================================
// CARDS
// =============================================================================
//
// A card is an integer 0..51:
//
//   card = suit * 13 + rank
//   suit: 0 spade, 1 heart, 2 club, 3 diamond   (matches sprite-sheet row order)
//   rank: 0 A, 1 2, 2 3, ..., 9 10, 10 J, 11 Q, 12 K
//
// A full deck is Array.from({length: 52}, (_, i) => i). Helpers below convert
// to/from the "heart-10" sprite keys used by <Tile>; the engine itself never
// touches those strings.
const $73d8f6063558c0ab$export$aa07355720c4600 = Object.freeze({
    SPADE: 0,
    HEART: 1,
    CLUB: 2,
    DIAMOND: 3
});
const $73d8f6063558c0ab$export$9b982809044276a6 = Object.freeze({
    BLACK: 0,
    RED: 1
});
const $73d8f6063558c0ab$export$c3d7e0f1e63de60e = Object.freeze({
    ACE: 0,
    JACK: 10,
    QUEEN: 11,
    KING: 12
});
const $73d8f6063558c0ab$var$SUIT_NAMES = [
    "spade",
    "heart",
    "club",
    "diamond"
];
const $73d8f6063558c0ab$var$RANK_NAMES = [
    "A",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K"
];
function $73d8f6063558c0ab$export$4e7e6d6e5c337948(card) {
    return Math.floor(card / 13);
}
function $73d8f6063558c0ab$export$a92d2f98f42bc3bd(card) {
    return card % 13;
}
function $73d8f6063558c0ab$export$7371e516c83e77f1(card) {
    const s = $73d8f6063558c0ab$export$4e7e6d6e5c337948(card);
    return s === $73d8f6063558c0ab$export$aa07355720c4600.SPADE || s === $73d8f6063558c0ab$export$aa07355720c4600.CLUB ? $73d8f6063558c0ab$export$9b982809044276a6.BLACK : $73d8f6063558c0ab$export$9b982809044276a6.RED;
}
function $73d8f6063558c0ab$export$d5d748e1f5ede0c5(card) {
    return `${$73d8f6063558c0ab$var$SUIT_NAMES[$73d8f6063558c0ab$export$4e7e6d6e5c337948(card)]}-${$73d8f6063558c0ab$var$RANK_NAMES[$73d8f6063558c0ab$export$a92d2f98f42bc3bd(card)]}`;
}
const $73d8f6063558c0ab$export$4f3160f4ba5e301a = Object.freeze({
    WASTE: "waste",
    TABLEAU: "tableau",
    FOUNDATION: "foundation"
});
const $73d8f6063558c0ab$export$93cd7006288e3b81 = Object.freeze({
    DRAW: "draw",
    MOVE: "move"
});
//   { type: MOVE_TYPE.DRAW }
//       Draws drawSize from stock to waste, OR recycles waste->stock if stock
//       is empty. Legal iff stock.length + waste.length > 0.
//
//   { type: MOVE_TYPE.MOVE, from, to }
//       from: { pile: PILE.WASTE }
//           | { pile: PILE.TABLEAU,    index: 0..6, depth: 0..N-1 }
//           | { pile: PILE.FOUNDATION, index: 0..3 }
//       to:   { pile: PILE.TABLEAU,    index: 0..6 }
//           | { pile: PILE.FOUNDATION, index: 0..3 }
//
//   `depth` on a tableau source: 0 grabs just the visually-topmost face-up
//   card (single-card move); depth D grabs the card at
//   faceUp[faceUp.length-1-D] plus everything visually above it. So depth
//   faceUp.length-1 grabs the entire face-up run. Count of cards moved is
//   derivable and not carried on the move.
// =============================================================================
// CANONICAL MOVE ORDER  (effectively wire format — do not reorder)
// =============================================================================
//
// legalMoves(state) returns moves in exactly this order:
//
//   1. { type: DRAW } — if legal.
//   2. Waste top (if non-empty): destinations in DEST_ORDER.
//   3. For each tableau column i in 0..6:
//        For each depth d in 0..faceUp.length-1 (small run first):
//          destinations in DEST_ORDER.
//   4. For each foundation i in 0..3 (if non-empty):
//        destinations in DEST_ORDER, TABLEAU targets only
//        (foundation->foundation moves are never emitted — never useful).
//
// DEST_ORDER for a movable card/run:
//   a. Foundations 0..3 in index order (only for single-card sources).
//   b. Tableau columns 0..6 in index order.
//
// No dedup of equivalent empty destinations: every legal foundation slot and
// every empty tableau column is emitted distinctly so the player's visual
// choice survives into replay.
//
// Auto-flip: when a move exposes a face-down tableau card, it flips to
// face-up inside applyMove. Never a user-visible move.
// =============================================================================
// INTERNAL HELPERS
// =============================================================================
// Deck generation: game ID -> deck is a fixed bijection. The ID is mapped
// to a rank in [0, 52!) by multiplication with MIX (a constant coprime to
// 52!, derived from the golden ratio: floor(52! / phi) bumped to the next
// coprime integer), then the rank is unranked into a permutation via the
// factorial number system (Lehmer code). The MIX step exists because IDs
// are sequential and raw unranking of consecutive integers only permutes
// the tail of the deck — consecutive games would get nearly identical
// deals.
//
// FROZEN: changing FACT52/MIX or the unranking order silently changes every
// stored game's deck. The Go server must reproduce this exactly (math/big);
// the known-answer test in solitaire.test.js is the cross-language fixture.
const $73d8f6063558c0ab$var$FACT52 = 80658175170943878571660636856403766975289505440883277824000000000000n;
const $73d8f6063558c0ab$var$MIX = 49849493726186177023735136051197689539309098536019687269722921809751n;
// factorials 0!..51! for unranking
const $73d8f6063558c0ab$var$FACTORIALS = (()=>{
    const f = [
        1n
    ];
    for(let i = 1n; i <= 51n; i++)f.push(f[f.length - 1] * i);
    return f;
})();
// rank (BigInt in [0, 52!)) -> permutation of card ints 0..51.
function $73d8f6063558c0ab$var$unrankDeck(rank) {
    const pool = Array.from({
        length: 52
    }, (_, i)=>i);
    const deck = [];
    let r = rank;
    for(let i = 51; i >= 0; i--){
        const f = $73d8f6063558c0ab$var$FACTORIALS[i];
        const idx = Number(r / f);
        r %= f;
        deck.push(pool.splice(idx, 1)[0]);
    }
    return deck;
}
function $73d8f6063558c0ab$var$deckForSeed(seed) {
    // Normalize into [0, 52!) — negative or huge seeds still map somewhere
    // deterministic rather than throwing.
    const id = (BigInt(Math.trunc(seed)) % $73d8f6063558c0ab$var$FACT52 + $73d8f6063558c0ab$var$FACT52) % $73d8f6063558c0ab$var$FACT52;
    return $73d8f6063558c0ab$var$unrankDeck(id * $73d8f6063558c0ab$var$MIX % $73d8f6063558c0ab$var$FACT52);
}
function $73d8f6063558c0ab$var$cloneState(s) {
    return {
        stock: s.stock.slice(),
        waste: s.waste.slice(),
        tableau: s.tableau.map((c)=>({
                faceDown: c.faceDown.slice(),
                faceUp: c.faceUp.slice()
            })),
        foundations: s.foundations.map((f)=>f.slice()),
        drawSize: s.drawSize,
        fanSize: s.fanSize ?? 0
    };
}
// fanSize after a move. Visual — not needed for rules — but bundled into
// engine state so the caller never has to maintain it separately. Classic
// MS behavior: fresh draw-3 shows up to three fanned cards; as the player
// plays them off, the fan shrinks; when the stock empties and recycles,
// the fan collapses to zero until the next draw refills it.
function $73d8f6063558c0ab$var$computeNextFanSize(prevFan, prevState, move) {
    if (move.type === $73d8f6063558c0ab$export$93cd7006288e3b81.DRAW) return prevState.stock.length > 0 ? Math.min(prevState.drawSize, prevState.stock.length) : 0;
    if (move.type === $73d8f6063558c0ab$export$93cd7006288e3b81.MOVE && move.from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.WASTE) return Math.max(0, prevFan - 1);
    return prevFan;
}
// Cards that `from` would move, in bottom-to-top order (bottom is the card
// that lands on the destination). Returns null for piles that have nothing
// movable at the requested position (empty waste, depth past end of run,
// empty foundation) — those are the legitimate "no such move" signals; a
// malformed `from` is a bug and is allowed to crash on property access.
function $73d8f6063558c0ab$var$sourceCards(state, from) {
    if (from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.WASTE) {
        if (state.waste.length === 0) return null;
        return [
            state.waste[state.waste.length - 1]
        ];
    } else if (from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU) {
        const col = state.tableau[from.index];
        const len = col.faceUp.length;
        if (from.depth < 0 || from.depth >= len) return null;
        return col.faceUp.slice(len - 1 - from.depth);
    } else if (from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.FOUNDATION) {
        const f = state.foundations[from.index];
        if (f.length === 0) return null;
        return [
            f[f.length - 1]
        ];
    }
    return null;
}
function $73d8f6063558c0ab$var$canDropOnTableau(state, tableauIdx, card) {
    const col = state.tableau[tableauIdx];
    if (col.faceUp.length === 0) return $73d8f6063558c0ab$export$a92d2f98f42bc3bd(card) === $73d8f6063558c0ab$export$c3d7e0f1e63de60e.KING;
    const top = col.faceUp[col.faceUp.length - 1];
    return $73d8f6063558c0ab$export$7371e516c83e77f1(top) !== $73d8f6063558c0ab$export$7371e516c83e77f1(card) && $73d8f6063558c0ab$export$a92d2f98f42bc3bd(top) === $73d8f6063558c0ab$export$a92d2f98f42bc3bd(card) + 1;
}
function $73d8f6063558c0ab$var$canDropOnFoundation(state, foundIdx, card) {
    const f = state.foundations[foundIdx];
    if (f.length === 0) return $73d8f6063558c0ab$export$a92d2f98f42bc3bd(card) === $73d8f6063558c0ab$export$c3d7e0f1e63de60e.ACE;
    const top = f[f.length - 1];
    return $73d8f6063558c0ab$export$4e7e6d6e5c337948(top) === $73d8f6063558c0ab$export$4e7e6d6e5c337948(card) && $73d8f6063558c0ab$export$a92d2f98f42bc3bd(top) + 1 === $73d8f6063558c0ab$export$a92d2f98f42bc3bd(card);
}
function $73d8f6063558c0ab$var$isLegalMove(state, move) {
    if (move.type === $73d8f6063558c0ab$export$93cd7006288e3b81.DRAW) return state.stock.length + state.waste.length > 0;
    if (move.type !== $73d8f6063558c0ab$export$93cd7006288e3b81.MOVE) return false;
    const run = $73d8f6063558c0ab$var$sourceCards(state, move.from);
    if (!run) return false;
    const bottom = run[0];
    const to = move.to;
    // Foundation-to-foundation is never emitted.
    if (move.from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.FOUNDATION && to.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.FOUNDATION) return false;
    // Multi-card runs only land on the tableau.
    if (run.length > 1 && to.pile !== $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU) return false;
    if (to.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU) {
        if (move.from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU && move.from.index === to.index) // no self-move
        return false;
        return $73d8f6063558c0ab$var$canDropOnTableau(state, to.index, bottom);
    } else if (to.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.FOUNDATION) return $73d8f6063558c0ab$var$canDropOnFoundation(state, to.index, bottom);
    return false;
}
function $73d8f6063558c0ab$export$4021de1c0df2c0bd(seed = 0) {
    const deck = $73d8f6063558c0ab$var$deckForSeed(seed);
    const tableau = Array.from({
        length: 7
    }, ()=>({
            faceDown: [],
            faceUp: []
        }));
    let idx = 0;
    for(let col = 0; col < 7; col++)for(let row = 0; row <= col; row++){
        const card = deck[idx++];
        if (row < col) tableau[col].faceDown.push(card);
        else tableau[col].faceUp.push(card);
    }
    return {
        stock: deck.slice(idx),
        waste: [],
        tableau: tableau,
        foundations: [
            [],
            [],
            [],
            []
        ],
        drawSize: 3,
        fanSize: 0
    };
}
function $73d8f6063558c0ab$export$36208696e3534245(state) {
    const moves = [];
    if (state.stock.length + state.waste.length > 0) moves.push({
        type: $73d8f6063558c0ab$export$93cd7006288e3b81.DRAW
    });
    if (state.waste.length > 0) {
        const top = state.waste[state.waste.length - 1];
        const from = {
            pile: $73d8f6063558c0ab$export$4f3160f4ba5e301a.WASTE
        };
        for(let f = 0; f < 4; f++)if ($73d8f6063558c0ab$var$canDropOnFoundation(state, f, top)) moves.push({
            type: $73d8f6063558c0ab$export$93cd7006288e3b81.MOVE,
            from: from,
            to: {
                pile: $73d8f6063558c0ab$export$4f3160f4ba5e301a.FOUNDATION,
                index: f
            }
        });
        for(let t = 0; t < 7; t++)if ($73d8f6063558c0ab$var$canDropOnTableau(state, t, top)) moves.push({
            type: $73d8f6063558c0ab$export$93cd7006288e3b81.MOVE,
            from: from,
            to: {
                pile: $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU,
                index: t
            }
        });
    }
    for(let i = 0; i < 7; i++){
        const col = state.tableau[i];
        for(let d = 0; d < col.faceUp.length; d++){
            const bottom = col.faceUp[col.faceUp.length - 1 - d];
            const from = {
                pile: $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU,
                index: i,
                depth: d
            };
            if (d === 0) {
                for(let f = 0; f < 4; f++)if ($73d8f6063558c0ab$var$canDropOnFoundation(state, f, bottom)) moves.push({
                    type: $73d8f6063558c0ab$export$93cd7006288e3b81.MOVE,
                    from: from,
                    to: {
                        pile: $73d8f6063558c0ab$export$4f3160f4ba5e301a.FOUNDATION,
                        index: f
                    }
                });
            }
            for(let t = 0; t < 7; t++){
                if (t === i) continue;
                if ($73d8f6063558c0ab$var$canDropOnTableau(state, t, bottom)) moves.push({
                    type: $73d8f6063558c0ab$export$93cd7006288e3b81.MOVE,
                    from: from,
                    to: {
                        pile: $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU,
                        index: t
                    }
                });
            }
        }
    }
    for(let i = 0; i < 4; i++){
        const f = state.foundations[i];
        if (f.length === 0) continue;
        const top = f[f.length - 1];
        const from = {
            pile: $73d8f6063558c0ab$export$4f3160f4ba5e301a.FOUNDATION,
            index: i
        };
        for(let t = 0; t < 7; t++)if ($73d8f6063558c0ab$var$canDropOnTableau(state, t, top)) moves.push({
            type: $73d8f6063558c0ab$export$93cd7006288e3b81.MOVE,
            from: from,
            to: {
                pile: $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU,
                index: t
            }
        });
    }
    return moves;
}
function $73d8f6063558c0ab$export$389d1639e42e5db9(state, move) {
    if (!$73d8f6063558c0ab$var$isLegalMove(state, move)) throw new Error(`Illegal move: ${JSON.stringify(move)}`);
    const next = $73d8f6063558c0ab$var$cloneState(state);
    next.fanSize = $73d8f6063558c0ab$var$computeNextFanSize(state.fanSize ?? 0, state, move);
    if (move.type === $73d8f6063558c0ab$export$93cd7006288e3b81.DRAW) {
        if (next.stock.length === 0) {
            next.stock = next.waste;
            next.waste = [];
        } else {
            const n = Math.min(next.drawSize, next.stock.length);
            const drawn = next.stock.splice(0, n);
            next.waste.push(...drawn);
        }
        return next;
    }
    const { from: from, to: to } = move;
    let cards;
    if (from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.WASTE) cards = [
        next.waste.pop()
    ];
    else if (from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU) {
        const col = next.tableau[from.index];
        const count = from.depth + 1;
        cards = col.faceUp.splice(col.faceUp.length - count, count);
        if (col.faceUp.length === 0 && col.faceDown.length > 0) col.faceUp.push(col.faceDown.pop());
    } else if (from.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.FOUNDATION) cards = [
        next.foundations[from.index].pop()
    ];
    else throw new Error(`Invalid from pile: ${from.pile}`);
    if (to.pile === $73d8f6063558c0ab$export$4f3160f4ba5e301a.TABLEAU) next.tableau[to.index].faceUp.push(...cards);
    else next.foundations[to.index].push(...cards);
    return next;
}
function $73d8f6063558c0ab$export$ce2d913972d64cfe(state, move) {
    try {
        return $73d8f6063558c0ab$export$389d1639e42e5db9(state, move);
    } catch  {
        return null;
    }
}
function $73d8f6063558c0ab$export$ccb438d1838ccb16(state, index) {
    const moves = $73d8f6063558c0ab$export$36208696e3534245(state);
    if (index < 0 || index >= moves.length) throw new Error(`Move index out of range: ${index}`);
    return $73d8f6063558c0ab$export$389d1639e42e5db9(state, moves[index]);
}
function $73d8f6063558c0ab$var$movesEqual(a, b) {
    if (a.type !== b.type) return false;
    if (a.type === $73d8f6063558c0ab$export$93cd7006288e3b81.DRAW) return true;
    return a.from.pile === b.from.pile && a.from.index === b.from.index && a.from.depth === b.from.depth && a.to.pile === b.to.pile && a.to.index === b.to.index;
}
function $73d8f6063558c0ab$export$9d099694dbff824c(state, move) {
    const moves = $73d8f6063558c0ab$export$36208696e3534245(state);
    for(let i = 0; i < moves.length; i++){
        if ($73d8f6063558c0ab$var$movesEqual(move, moves[i])) return {
            next: $73d8f6063558c0ab$export$389d1639e42e5db9(state, moves[i]),
            index: i
        };
    }
    return null;
}
function $73d8f6063558c0ab$export$5c9ba34b2d024c9b(seed, moveIndices, { label: label = "replay" } = {}) {
    let s = $73d8f6063558c0ab$export$4021de1c0df2c0bd(seed);
    for(let i = 0; i < moveIndices.length; i++){
        const mv = $73d8f6063558c0ab$export$36208696e3534245(s)[moveIndices[i]];
        if (!mv) {
            console.error(`${label}: bad move index ${moveIndices[i]} at position ${i} for seed ${seed}`);
            return s;
        }
        s = $73d8f6063558c0ab$export$389d1639e42e5db9(s, mv);
    }
    return s;
}
function $73d8f6063558c0ab$export$6111fc34e8718163(seed, moveIndices) {
    let s = $73d8f6063558c0ab$export$4021de1c0df2c0bd(seed);
    let lastProductive = -1;
    for(let i = 0; i < moveIndices.length; i++){
        const mv = $73d8f6063558c0ab$export$36208696e3534245(s)[moveIndices[i]];
        if (!mv) break;
        if (mv.type !== $73d8f6063558c0ab$export$93cd7006288e3b81.DRAW) lastProductive = i;
        s = $73d8f6063558c0ab$export$389d1639e42e5db9(s, mv);
    }
    return moveIndices.slice(0, lastProductive + 1);
}
function $73d8f6063558c0ab$export$34b9657cfbb2ea8e(state) {
    return state.foundations.every((f)=>f.length === 13);
}
function $73d8f6063558c0ab$export$54769e2916a4a062(state) {
    if (state.waste.length === 0) return 0;
    return Math.min(Math.max(1, state.fanSize ?? 0), state.waste.length);
}
function $73d8f6063558c0ab$export$6fd7b02192c582e0(state) {
    return state.stock.length === 0 && state.waste.length > 0 && state.waste.length <= state.drawSize && $73d8f6063558c0ab$export$54769e2916a4a062(state) === state.waste.length;
}


// 13, not 14: at 14 the slice lands exactly on the face cards' inner
// frame line and a sliver of border peeks through.
const $6c17a32203d95adb$var$FAN_HORIZONTAL_OFFSET = 13;
const $6c17a32203d95adb$var$FAN_VERTICAL_OFFSET = 1;
const $6c17a32203d95adb$var$MAX_FAN_CARDS = 3;
// Shows the current waste fan — up to the last `visibleCount` drawn cards,
// fanned from upper-left down to the visible top on the right. Earlier
// waste cards are hidden; only the top is playable. The fan overflows
// rightward beyond one card-width; the Board reserves an empty grid column
// next to Waste to absorb the overflow.
//
// onClick/selected attach only to the topmost (rightmost) card — the fan
// cards beneath are decorative; only the top is playable.
function $6c17a32203d95adb$var$Waste({ cards: cards, visibleCount: visibleCount, onClick: onClick, selected: selected = false, sourceTag: sourceTag }) {
    const count = Math.min(visibleCount != null ? visibleCount : $6c17a32203d95adb$var$MAX_FAN_CARDS, cards.length);
    // One squared-up card UNDER the fan whenever more waste exists below
    // it. Invisible in the resting state, but the moment a drag lifts
    // (hides) the top card of a 1-card fan, the next card is already
    // there — classic MS revealed it on pickup, not on drop.
    const under = count > 0 && cards.length > count ? 1 : 0;
    const visible = count > 0 ? cards.slice(-(count + under)) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6c17a32203d95adb$var$Wrapper, {
        children: visible.map((card, i)=>{
            const isTop = i === visible.length - 1;
            const fanIdx = Math.max(0, i - under);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6c17a32203d95adb$var$Positioned, {
                style: {
                    left: fanIdx * $6c17a32203d95adb$var$FAN_HORIZONTAL_OFFSET,
                    top: fanIdx * $6c17a32203d95adb$var$FAN_VERTICAL_OFFSET
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
                    name: (0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5)(card),
                    ...isTop && onClick ? {
                        as: "button",
                        onClick: onClick
                    } : {},
                    selected: isTop && selected,
                    "data-card-source": isTop && sourceTag ? sourceTag : undefined
                })
            }, i);
        })
    });
}
const $6c17a32203d95adb$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  width: ${(0, $50d7a68c1c70e782$export$67e895109476e448)}px;
  height: ${(0, $50d7a68c1c70e782$export$8a96fdb4dcd92c65)}px;
`;
const $6c17a32203d95adb$var$Positioned = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
`;
var $6c17a32203d95adb$export$2e2bcd8739ae039 = $6c17a32203d95adb$var$Waste;





parcelRequire("acw62");



const $add7d94ec6dd18fa$export$e5dc68ace73c4695 = 1;
const $add7d94ec6dd18fa$export$ca3dade31efc89a3 = 2;
function $add7d94ec6dd18fa$export$c66f179066eea5fa(size) {
    if (size <= 4) return 1; // ace-4
    if (size <= 8) return 2; // 5-8
    if (size <= 12) return 3; // 9-queen
    return 4; // king
}
// A single foundation slot: the empty-foundation placeholder when the
// stack is empty, otherwise the top card atop 0..3 shadow tiles that hint
// at depth. onClick + selected apply to the topmost tile only.
function $add7d94ec6dd18fa$var$Foundation({ stack: stack, onClick: onClick, selected: selected = false, sourceTag: sourceTag }) {
    // Always render the same Wrapper so the empty→stacked transition can't
    // change the slot's box structure.
    if (stack.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($add7d94ec6dd18fa$var$Wrapper, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
            name: "foundation",
            style: {
                gridArea: "area"
            },
            ...onClick ? {
                as: "button",
                onClick: onClick
            } : {},
            selected: selected
        })
    });
    const topCard = (0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5)(stack[stack.length - 1]);
    const numberOfCards = $add7d94ec6dd18fa$export$c66f179066eea5fa(stack.length);
    // The card directly under the top, revealed whenever the top is lifted
    // mid-drag (yours or a spectated player's) — without it, dragging a 2
    // hid the ace and dragging a lone ace left a hole in the felt.
    const underCard = stack.length >= 2 ? (0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5)(stack[stack.length - 2]) : null;
    const underIndex = Math.max(0, $add7d94ec6dd18fa$export$c66f179066eea5fa(stack.length - 1) - 1);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($add7d94ec6dd18fa$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
                name: "foundation",
                style: {
                    gridArea: "area"
                },
                "aria-hidden": "true"
            }),
            underCard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
                name: underCard,
                "aria-hidden": "true",
                style: {
                    gridArea: "area",
                    transform: `translate(${$add7d94ec6dd18fa$export$ca3dade31efc89a3 * underIndex}px, ${$add7d94ec6dd18fa$export$e5dc68ace73c4695 * underIndex}px)`
                }
            }),
            Array.from({
                length: numberOfCards
            }).map((_, index)=>{
                const isTop = index === numberOfCards - 1;
                const style = {
                    gridArea: "area",
                    transform: `translate(${$add7d94ec6dd18fa$export$ca3dade31efc89a3 * index}px, ${$add7d94ec6dd18fa$export$e5dc68ace73c4695 * index}px)`
                };
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
                    // Depth tiles wear the under-card so a lifted top reveals the
                    // card actually beneath it, not a twin.
                    name: isTop ? topCard : underCard ?? topCard,
                    style: style,
                    ...isTop && onClick ? {
                        as: "button",
                        onClick: onClick
                    } : {},
                    selected: isTop && selected,
                    "data-card-source": isTop && sourceTag ? sourceTag : undefined
                }, index);
            })
        ]
    });
}
const $add7d94ec6dd18fa$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-areas: "area";
`;
var $add7d94ec6dd18fa$export$2e2bcd8739ae039 = $add7d94ec6dd18fa$var$Foundation;





parcelRequire("acw62");




// Vertical cascade spacings. Face-down cards sit nearly on top of each other
// (just enough lip to hint at depth); face-up cards fan wider so rank/suit
// stay legible as the run grows.
const $7e34fa2e5dcdbc75$var$FACE_DOWN_OFFSET = 4;
const $7e34fa2e5dcdbc75$var$FACE_UP_OFFSET = 16;
// onCardClick(depth) fires for face-up cards; depth 0 is the visually-top
// card, deeper depths reach further down the run. onEmptyClick fires when
// the whole column is empty and the player is trying to drop a king.
// selectedFromDepth: if non-null, face-up cards at depth <= selectedFromDepth
// render with the selection glow (the run that would move if the selection
// were dropped somewhere). cardBack names the face-down sprite.
function $7e34fa2e5dcdbc75$var$TableauStack({ faceDown: faceDown = [], faceUp: faceUp = [], cardBack: cardBack, onCardClick: onCardClick, onEmptyClick: onEmptyClick, selectedFromDepth: selectedFromDepth = null, sourceTag: // e.g. "t:3" — stamped as data-card-source="t:3:<depth>" on face-up
// tiles so the drag layer can identify grab targets. Omitted for
// spectated boards.
sourceTag }) {
    const isEmpty = faceDown.length === 0 && faceUp.length === 0;
    const positioned = [];
    let y = 0;
    let lastTop = 0;
    for(let i = 0; i < faceDown.length; i++){
        positioned.push({
            key: `d${i}`,
            name: cardBack,
            top: y
        });
        lastTop = y;
        y += $7e34fa2e5dcdbc75$var$FACE_DOWN_OFFSET;
    }
    for(let i = 0; i < faceUp.length; i++){
        const depth = faceUp.length - 1 - i;
        const selected = selectedFromDepth != null && depth <= selectedFromDepth;
        positioned.push({
            key: `u${i}`,
            name: (0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5)(faceUp[i]),
            top: y,
            depth: depth,
            selected: selected
        });
        lastTop = y;
        y += $7e34fa2e5dcdbc75$var$FACE_UP_OFFSET;
    }
    const height = positioned.length > 0 ? lastTop + (0, $50d7a68c1c70e782$export$8a96fdb4dcd92c65) : (0, $50d7a68c1c70e782$export$8a96fdb4dcd92c65);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7e34fa2e5dcdbc75$var$Wrapper, {
        style: {
            height: height
        },
        children: [
            positioned.map((p)=>p.depth != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7e34fa2e5dcdbc75$var$Positioned, {
                    style: {
                        top: p.top
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
                        name: p.name,
                        as: "button",
                        onClick: onCardClick ? ()=>onCardClick(p.depth) : undefined,
                        selected: p.selected,
                        "data-card-source": sourceTag ? `${sourceTag}:${p.depth}` : undefined
                    })
                }, p.key) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7e34fa2e5dcdbc75$var$Positioned, {
                    style: {
                        top: p.top
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
                        name: p.name
                    })
                }, p.key)),
            isEmpty && onEmptyClick && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7e34fa2e5dcdbc75$var$EmptyClickArea, {
                type: "button",
                onClick: onEmptyClick,
                "aria-label": "Empty column"
            })
        ]
    });
}
const $7e34fa2e5dcdbc75$var$Wrapper = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  width: ${(0, $50d7a68c1c70e782$export$67e895109476e448)}px;
`;
const $7e34fa2e5dcdbc75$var$Positioned = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 0;
`;
// Invisible full-size click target for empty columns — the only affordance
// is "something can land here." No glow, no hover border; it's a drop zone.
// Only rendered when Board passes onEmptyClick (i.e., a selection exists),
// so the pointer cursor only shows during drop mode.
const $7e34fa2e5dcdbc75$var$EmptyClickArea = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  position: absolute;
  inset: 0;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  outline: none;
  box-shadow: none;
  cursor: pointer;

  &:focus,
  &:hover,
  &:active {
    outline: none !important;
    box-shadow: none !important;
  }
`;
var $7e34fa2e5dcdbc75$export$2e2bcd8739ae039 = $7e34fa2e5dcdbc75$var$TableauStack;





const $5f4016c432571cf3$var$VERTICAL_GAP = 12;
const $5f4016c432571cf3$var$HORIZONTAL_GAP = 0;
// Board owns the two-row, seven-column grid. Cells pin children to specific
// grid columns/rows so the child components stay layout-agnostic: Stock,
// Waste, Foundation, and TableauStack render their own cards without
// knowing where they sit on the board.
//
// Top row layout:
//   col 1 stock
//   col 2 waste (fan overflows into col 3 which is left empty as a gutter)
//   cols 4..7 foundations 0..3
// Bottom row: cols 1..7 map to tableau columns 0..6.
//
// Click handlers funnel upward — Board doesn't know about engine moves,
// it just translates "clicked this visual thing" into "source X was clicked."
// Solitaire does the engine-level resolution.
function $5f4016c432571cf3$var$Board({ state: state, selection: selection, cardBack: cardBack, interactive: // True only for the player's own board: enables drop-target
// attributes. Card source tags render on EVERY board — spectated
// windows hit-test remote presses against them (they stay inert
// there; SolitaireCore turns pointer-events off).
interactive = false, wasteVisibleCount: wasteVisibleCount, stockDeadEnd: stockDeadEnd, onDrawClick: onDrawClick, onWasteClick: onWasteClick, onFoundationClick: onFoundationClick, onTableauCardClick: onTableauCardClick, onTableauEmptyClick: onTableauEmptyClick, foundationCellRefs: foundationCellRefs }) {
    const isSelected = (pile, index)=>selection != null && selection.pile === pile && selection.index === index;
    const wasteSelected = selection != null && selection.pile === (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).WASTE;
    return(// data-felt: the green playing surface. Both drag adapters clamp
    // and clip the in-flight ghost to this rect — cards live on the
    // felt, not the chrome.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($5f4016c432571cf3$var$Grid, {
        "data-felt": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f4016c432571cf3$var$Cell, {
                $col: 1,
                $row: 1,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1fc16156e0c8df5$export$2e2bcd8739ae039), {
                    count: state.stock.length,
                    canRecycle: state.waste.length > 0,
                    deadEnd: stockDeadEnd,
                    cardBack: cardBack,
                    onClick: onDrawClick
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f4016c432571cf3$var$Cell, {
                $col: 2,
                $row: 1,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c17a32203d95adb$export$2e2bcd8739ae039), {
                    cards: state.waste,
                    visibleCount: wasteVisibleCount,
                    onClick: onWasteClick,
                    selected: wasteSelected,
                    sourceTag: "w"
                })
            }),
            state.foundations.map((f, i)=>{
                // An empty foundation with nothing selected has no useful click
                // behavior — don't make it look like a button. It becomes clickable
                // again the moment a selection exists (as a drop target for an ace).
                const clickable = f.length > 0 || selection != null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f4016c432571cf3$var$Cell, {
                    $col: 4 + i,
                    $row: 1,
                    "data-drop": interactive ? `f:${i}` : undefined,
                    ref: foundationCellRefs ? (el)=>{
                        // Braced body: a returned value would read as a
                        // React 19 ref cleanup function.
                        foundationCellRefs.current[i] = el;
                    } : undefined,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $add7d94ec6dd18fa$export$2e2bcd8739ae039), {
                        stack: f,
                        onClick: clickable ? ()=>onFoundationClick(i) : undefined,
                        selected: isSelected((0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).FOUNDATION, i),
                        sourceTag: `f:${i}`
                    })
                }, i);
            }),
            state.tableau.map((col, i)=>{
                const selectedFromDepth = isSelected((0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU, i) ? selection.depth : null;
                // Empty tableau columns are destination-only — pass onEmptyClick
                // only while a selection exists so the click area (and its cursor
                // pointer) appear only in drop mode.
                const emptyHandler = selection != null ? ()=>onTableauEmptyClick(i) : undefined;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f4016c432571cf3$var$Cell, {
                    $col: i + 1,
                    $row: 2,
                    "data-drop": interactive ? `t:${i}` : undefined,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7e34fa2e5dcdbc75$export$2e2bcd8739ae039), {
                        faceDown: col.faceDown,
                        faceUp: col.faceUp,
                        cardBack: cardBack,
                        onCardClick: (depth)=>onTableauCardClick(i, depth),
                        onEmptyClick: emptyHandler,
                        selectedFromDepth: selectedFromDepth,
                        sourceTag: `t:${i}`
                    })
                }, i);
            })
        ]
    }));
}
const $5f4016c432571cf3$var$Grid = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(7, ${(0, $50d7a68c1c70e782$export$67e895109476e448)}px);
  grid-auto-rows: min-content;
  justify-content: space-between;
  gap: ${$5f4016c432571cf3$var$VERTICAL_GAP}px ${$5f4016c432571cf3$var$HORIZONTAL_GAP}px;
  align-content: start;
  padding: 6px 12px;
  height: 100%;
  width: 100%;
  background-color: var(--felt-green);
  border-top: 2px solid var(--border-interior-color);
  border-left: 2px solid var(--border-interior-color);
  overflow: hidden;
`;
const $5f4016c432571cf3$var$Cell = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  grid-column: ${({ $col: $col })=>$col};
  grid-row: ${({ $row: $row })=>$row};
  width: ${(0, $50d7a68c1c70e782$export$67e895109476e448)}px;
`;
var $5f4016c432571cf3$export$2e2bcd8739ae039 = $5f4016c432571cf3$var$Board;






var $acw62 = parcelRequire("acw62");




const $232faa34b4bfe991$export$ed0a8b5e284442ac = {
    // SIM time advanced per physics+draw step (steps tick at a fixed
    // 60Hz wall cadence — see STEP_WALL_MS). Higher = faster flight,
    // chunkier trail.
    stepMs: 3,
    gravity: 35000,
    launchVyMin: 500,
    launchVyMax: 1200,
    launchVxMin: 900,
    launchVxMax: 1800,
    rightwardChance: 0.35,
    bounceDamping: 0.8
};
const $232faa34b4bfe991$var$FUDGE = 1;
// Deterministic PRNG (mulberry32). Seeded from the game id, the whole
// cascade becomes a pure function of (game, elapsed sim time): the
// winner, every spectator window, and the All Active Games slot all
// watch the SAME show, and any viewer can rebuild the exact trail by
// fast-stepping the sim (every step draws).
function $232faa34b4bfe991$var$mulberry32(a) {
    return function() {
        a |= 0;
        a = a + 0x6d2b79f5 | 0;
        let t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function $232faa34b4bfe991$var$WinCelebration({ active: active, foundations: foundations, foundationRefs: foundationRefs, seed: // Deterministic cascade seed — pass the game id. Omitted falls back
// to a random show.
seed, startedAtMs: // performance.now-domain moment the show STARTED. Omitted/now means
// "from the top"; a value in the past means this viewer joined a show
// already in flight — the sim fast-forwards the missed time in one
// burst before the first frame, landing on the exact frame every
// other viewer is on.
startedAtMs = null, onPopTop: onPopTop, onDone: // Fired once when the cascade runs out of cards naturally (never on
// unmount) — a full 52-card run is minutes long, so anything waiting
// on "the show is over" must be told, not timed.
onDone, params: params }) {
    const canvasRef = (0, $acw62.useRef)(null);
    // Live-tweak escape hatch: effect captures these via refs so mid-run changes
    // (from a future settings window) take effect without restarting the animation.
    const paramsRef = (0, $acw62.useRef)();
    paramsRef.current = {
        ...$232faa34b4bfe991$export$ed0a8b5e284442ac,
        ...params
    };
    const foundationsRef = (0, $acw62.useRef)();
    foundationsRef.current = foundations;
    const onPopTopRef = (0, $acw62.useRef)();
    onPopTopRef.current = onPopTop;
    const onDoneRef = (0, $acw62.useRef)();
    onDoneRef.current = onDone;
    (0, $acw62.useLayoutEffect)(()=>{
        if (!active) return;
        const canvas = canvasRef.current;
        if (!canvas) return;
        // Size the bitmap to match the canvas's visual pixel footprint so what we
        // draw lines up 1:1 with what we measure via getBoundingClientRect.
        const canvasRect = canvas.getBoundingClientRect();
        canvas.width = Math.max(1, Math.round(canvasRect.width));
        canvas.height = Math.max(1, Math.round(canvasRect.height));
        // Infer zoom from the canvas itself (visual px / layout px).
        const zoom = canvas.offsetWidth ? canvasRect.width / canvas.offsetWidth : 1;
        // The sim runs entirely in LAYOUT px — the ~620x435 window space
        // every surface shares — and zoom applies only at draw time (the
        // ctx transform below). Physics in visual px would make scaled
        // copies (e.g. All Active Games slots) play the show faster: same
        // absolute velocities across a smaller canvas means cards exit
        // sooner. Layout space keeps the cascade a single show everywhere.
        const layoutWidth = canvas.offsetWidth || canvasRect.width;
        const layoutHeight = canvas.offsetHeight || canvasRect.height;
        const cardWidth = (0, $50d7a68c1c70e782$export$67e895109476e448);
        const cardHeight = (0, $50d7a68c1c70e782$export$8a96fdb4dcd92c65);
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.setTransform(zoom, 0, 0, zoom, 0, 0);
        ctx.imageSmoothingEnabled = false;
        let raf = null;
        let lastTick = null;
        let flying = null;
        let done = false;
        const rand = seed != null ? $232faa34b4bfe991$var$mulberry32(Math.floor(seed) ^ 0x5eed) : Math.random;
        const randRange = (min, max)=>min + rand() * (max - min);
        // Round-robin index across foundations. Each increment pops one card
        // from whichever foundation is next in rotation, giving us rank-major
        // launch order (K from 0, K from 1, ..., then Q from 0, ...) as long
        // as all foundations start full.
        let launchIdx = 0;
        const img = new Image();
        function tryLaunchNext() {
            const stacks = foundationsRef.current || [];
            const n = stacks.length;
            if (n === 0) return false;
            // At most `n * (ranks per suit)` launches total. Guard with a generous
            // cap so a malformed state can't spin us forever.
            const cap = launchIdx + n * 20;
            while(launchIdx < cap){
                const foundationIdx = launchIdx % n;
                launchIdx++;
                const stack = stacks[foundationIdx];
                if (!stack || stack.length === 0) continue;
                const topName = stack[stack.length - 1];
                const size = stack.length;
                const el = (foundationRefs.current || [])[foundationIdx];
                if (!el) continue;
                const r = el.getBoundingClientRect();
                // Re-measure the canvas per launch: the mount-time rect goes
                // stale if the window is dragged mid-cascade. Rects are visual
                // px; divide back to layout px, where the sim lives.
                const cRect = canvas.getBoundingClientRect();
                const baseX = (r.left - cRect.left) / zoom;
                const baseY = (r.top - cRect.top) / zoom;
                // The visually-topmost card in a Foundation stack is offset by
                // (topIdx * TRANSLATE_RIGHT, topIdx * TRANSLATE_DOWN) source px
                // from the wrapper's origin — already layout px.
                const topIdx = (0, $add7d94ec6dd18fa$export$c66f179066eea5fa)(size) - 1;
                const offsetX = topIdx * (0, $add7d94ec6dd18fa$export$ca3dade31efc89a3);
                const offsetY = topIdx * (0, $add7d94ec6dd18fa$export$e5dc68ace73c4695);
                const p = paramsRef.current;
                const goRight = rand() < p.rightwardChance;
                const vxMag = randRange(p.launchVxMin, p.launchVxMax);
                const vyMag = randRange(p.launchVyMin, p.launchVyMax);
                flying = {
                    name: topName,
                    x: baseX + offsetX,
                    y: baseY + offsetY,
                    vx: (goRight ? 1 : -1) * vxMag,
                    vy: -vyMag
                };
                // Pop this card from the parent's foundation state so the next
                // rank is exposed underneath on re-render.
                if (onPopTopRef.current) onPopTopRef.current(foundationIdx);
                return true;
            }
            return false;
        }
        function step() {
            if (!flying && !tryLaunchNext()) {
                done = true;
                // Natural exhaustion only — the cleanup path sets `done` without
                // coming through here, so unmount never reports completion.
                if (onDoneRef.current) onDoneRef.current();
                return;
            }
            const p = paramsRef.current;
            const dt = p.stepMs / 1000;
            flying.vy += p.gravity * dt;
            flying.x += flying.vx * dt;
            flying.y += flying.vy * dt;
            const floor = layoutHeight - cardHeight + $232faa34b4bfe991$var$FUDGE;
            if (flying.y > floor) {
                flying.y = floor;
                flying.vy = -flying.vy * p.bounceDamping;
            }
            const [row, col] = (0, $db9a6e9d90d8f08e$export$34ddeca23ac38a20)[flying.name];
            ctx.drawImage(img, col * (0, $db9a6e9d90d8f08e$export$1a70cc7f0ad02c3), row * (0, $db9a6e9d90d8f08e$export$80bc797476280f0d), (0, $db9a6e9d90d8f08e$export$1a70cc7f0ad02c3), (0, $db9a6e9d90d8f08e$export$80bc797476280f0d), Math.floor(flying.x), Math.floor(flying.y), cardWidth, cardHeight);
            // Cards exit by drifting off the sides (bouncing keeps them above the floor).
            if (flying.x + cardWidth < 0 || flying.x > layoutWidth) flying = null;
        }
        // One physics step per 60th of a second of WALL time, regardless of
        // display refresh rate — pins the tuned look to 60Hz everywhere
        // (one step per rAF would run 2x speed on a 120Hz screen).
        const STEP_WALL_MS = 1000 / 60;
        function advance(now, cap) {
            if (lastTick == null) lastTick = now;
            let pending = Math.floor((now - lastTick) / STEP_WALL_MS);
            if (pending <= 0) return;
            if (pending > cap) {
                // Over-cap backlog is dropped, not burst into one frame.
                pending = cap;
                lastTick = now - cap * STEP_WALL_MS;
            }
            lastTick += pending * STEP_WALL_MS;
            while(pending-- > 0 && !done)step();
        }
        function frame(now) {
            if (done) return;
            raf = requestAnimationFrame(frame);
            advance(now, 8);
        }
        // A hidden tab gets no rAF, so a timer advances the sim instead
        // while hidden, catching up in full each tick so the show stays in
        // real wall time. The 3600-step cap (one minute of sim) bounds a
        // pathological stall without falling behind even minute-granularity
        // throttling.
        let hiddenTimer = null;
        function onVisibility() {
            if (document.hidden) {
                if (hiddenTimer == null && !done) hiddenTimer = setInterval(()=>{
                    if (!done) advance(performance.now(), 3600);
                }, 250);
            } else if (hiddenTimer != null) {
                clearInterval(hiddenTimer);
                hiddenTimer = null;
            }
        }
        document.addEventListener("visibilitychange", onVisibility);
        function onLoad() {
            if (startedAtMs != null) {
                // Seed the step clock at the win moment and let advance() catch
                // up in one burst — every step draws, so the skipped steps
                // rebuild the exact trail (deterministic per seed). Cap =
                // exactly the backlog, so nothing is dropped.
                const now = performance.now();
                lastTick = Math.min(now, startedAtMs);
                advance(now, Math.floor((now - lastTick) / STEP_WALL_MS) + 1);
            }
            raf = requestAnimationFrame(frame);
            onVisibility();
        }
        img.addEventListener("load", onLoad, {
            once: true
        });
        img.src = (0, $db9a6e9d90d8f08e$export$47ccc2a6abaeb72b);
        return ()=>{
            img.removeEventListener("load", onLoad);
            document.removeEventListener("visibilitychange", onVisibility);
            if (hiddenTimer != null) clearInterval(hiddenTimer);
            if (raf != null) cancelAnimationFrame(raf);
            done = true;
        };
    }, [
        active,
        foundationRefs,
        seed,
        startedAtMs
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($232faa34b4bfe991$var$Canvas, {
        ref: canvasRef
    });
}
const $232faa34b4bfe991$var$Canvas = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).canvas`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
  image-rendering: pixelated;
`;
var $232faa34b4bfe991$export$2e2bcd8739ae039 = $232faa34b4bfe991$var$WinCelebration;





// Shared chrome for both PlayableSolitaire and SpectatedSolitaire: Win95
// window + menu bar + board + score area. Pure render — caller owns state
// and handlers. No open animation lives here: a window either appears
// plainly or the Stage draws its wireframe arrival.
//
// Positioning is explicitly NOT owned here. Callers wrap this in whatever
// positioning container they want (centered for the player's own game,
// grid-slot for neighbors).
const $523f633b3aed431a$var$DEFAULT_CARD_BACK = "back-3";
const $523f633b3aed431a$var$noop = ()=>{};
// The felt's natural box inside the 620x435 window (measured; the
// window overhead is 10px wide — 3px .window padding + 2px body margin
// per side — and ~71px tall: title bar, menu bar, status bar, padding).
// boardScale shrinks THIS box only; chrome renders at full size around it.
const $523f633b3aed431a$var$FELT_W = 610;
const $523f633b3aed431a$var$FELT_H = 364;
const $523f633b3aed431a$var$CHROME_W = 620 - $523f633b3aed431a$var$FELT_W;
const $523f633b3aed431a$var$CHROME_H = 435 - $523f633b3aed431a$var$FELT_H;
function $523f633b3aed431a$export$1f7f5491a289dcff(boardScale) {
    return {
        width: Math.round($523f633b3aed431a$var$FELT_W * boardScale) + $523f633b3aed431a$var$CHROME_W,
        height: Math.round($523f633b3aed431a$var$FELT_H * boardScale) + $523f633b3aed431a$var$CHROME_H
    };
}
function $523f633b3aed431a$var$SolitaireCore({ title: title, state: state, selection: selection = null, titleIcon: // Titlebar icon; must match the window's taskbar icon.
titleIcon = "solitaire", cardBack: cardBack = $523f633b3aed431a$var$DEFAULT_CARD_BACK, controls: controls = [
    "minimize",
    "maximize",
    "close"
], disabledControls: disabledControls, pressedControls: pressedControls, onControlClick: onControlClick, interactive: interactive = true, inactive: // Real desktop focus: the Stage decides which ONE window is active.
// Distinct from `interactive` (can you play this board) — your own
// window greys out too when a neighbor has focus.
inactive = false, onDrawClick: onDrawClick = $523f633b3aed431a$var$noop, onWasteClick: onWasteClick = $523f633b3aed431a$var$noop, onFoundationClick: onFoundationClick = $523f633b3aed431a$var$noop, onTableauCardClick: onTableauCardClick = $523f633b3aed431a$var$noop, onTableauEmptyClick: onTableauEmptyClick = $523f633b3aed431a$var$noop, winCelebration: // { foundations: string[][] (sprite names), onPopTop: (i) => void }.
// When set, the cascading-cards canvas overlays the window body and pops
// cards off the caller's celebration state as they launch.
winCelebration = null, menus: // MenuBar items; PlayableSolitaire passes a real Game menu, spectated
// windows keep the decorative defaults.
menus = [
    "Game",
    "Help"
], boardScale: // Scale the GAME SURFACE only — chrome stays full-size. Currently
// safe only for static, non-interactive windows (the past-game
// viewer): remote cursors, the close ritual, and the cascade overlay
// all assume the uniform 620x435 window space, so spectated windows
// need a coordinate remap before they can use this (REVISIT.md).
boardScale = 1, className: className }) {
    const foundationCellRefs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    // The cascade canvas measures itself at mount; give the window a tick
    // to be laid out before the overlay measures, so a show joined
    // mid-flight doesn't read a 0px rect and play invisibly.
    const hasCelebration = winCelebration != null;
    const [overlayReady, setOverlayReady] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!hasCelebration) {
            setOverlayReady(false);
            return undefined;
        }
        const t = setTimeout(()=>setOverlayReady(true), 50);
        return ()=>clearTimeout(t);
    }, [
        hasCelebration
    ]);
    // Cards-to-foundations is the one stat the state can vouch for. During
    // a win celebration `state` is the popped-down display copy the
    // cascade drains — the real count is a won game's 52, not the drained 0.
    const cardsUp = hasCelebration ? 52 : state.foundations.reduce((n, f)=>n + f.length, 0);
    const scaled = boardScale !== 1;
    const frame = scaled ? $523f633b3aed431a$export$1f7f5491a289dcff(boardScale) : null;
    const board = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4016c432571cf3$export$2e2bcd8739ae039), {
        state: state,
        selection: selection,
        cardBack: cardBack,
        interactive: interactive,
        wasteVisibleCount: (0, $73d8f6063558c0ab$export$54769e2916a4a062)(state),
        stockDeadEnd: (0, $73d8f6063558c0ab$export$6fd7b02192c582e0)(state),
        onDrawClick: onDrawClick,
        onWasteClick: onWasteClick,
        onFoundationClick: onFoundationClick,
        onTableauCardClick: onTableauCardClick,
        onTableauEmptyClick: onTableauEmptyClick,
        foundationCellRefs: foundationCellRefs
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($523f633b3aed431a$var$WindowFrame, {
        className: className,
        style: scaled ? {
            "--frame-w": frame.width + "px",
            "--frame-h": frame.height + "px"
        } : undefined,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($523f633b3aed431a$var$StyledWindow, {
            title: title,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                name: titleIcon,
                size: 16
            }),
            controls: controls,
            disabledControls: disabledControls,
            pressedControls: pressedControls,
            onControlClick: onControlClick,
            bodyStyle: {
                margin: "0px 2px 0px"
            },
            inactive: inactive,
            statusFields: [
                `Cards: ${cardsUp} / 52`
            ],
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($523f633b3aed431a$var$Content, {
                $interactive: interactive,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1171fabab2f3639c$export$2e2bcd8739ae039), {
                        items: menus
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($523f633b3aed431a$var$FeltArea, {
                        children: [
                            scaled ? // Natural-size felt stage, transform-scaled: sprites stay
                            // integer-designed and the board layout never learns about
                            // the scale.
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($523f633b3aed431a$var$FeltStage, {
                                style: {
                                    "--board-scale": boardScale
                                },
                                children: board
                            }) : board,
                            winCelebration && overlayReady && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $232faa34b4bfe991$export$2e2bcd8739ae039), {
                                active: true,
                                foundations: winCelebration.foundations,
                                foundationRefs: foundationCellRefs,
                                seed: winCelebration.seed,
                                startedAtMs: winCelebration.startedAtMs,
                                onPopTop: winCelebration.onPopTop,
                                onDone: winCelebration.onDone
                            })
                        ]
                    })
                ]
            })
        })
    });
}
const $523f633b3aed431a$var$WindowFrame = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: var(--frame-w, 620px);
  height: var(--frame-h, 435px);
`;
// Fixed natural-size stage for a scaled board: the Board lays out at
// full size and the transform does the shrinking, exactly like the
// whole-window ScaleBox — but inside full-size chrome.
const $523f633b3aed431a$var$FeltStage = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: ${$523f633b3aed431a$var$FELT_W}px;
  height: ${$523f633b3aed431a$var$FELT_H}px;
  transform: scale(var(--board-scale));
  transform-origin: top left;
`;
const $523f633b3aed431a$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 100%;
  height: 100%;
`;
// The felt and ONLY the felt: the cascade canvas anchors here, so
// bounced cards clip at the felt's top edge instead of drawing over
// the menu bar (the original clipped to the client area too).
const $523f633b3aed431a$var$FeltArea = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
`;
const $523f633b3aed431a$var$Content = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  /* Lock MenuBar (first child) at its natural height. Without this, a
     tableau column with lots of stacked cards grows Board tall enough to
     push total children > container, and both flex items shrink — visibly
     squishing the bar. Board absorbs any excess instead. (The status bar
     now lives in Window chrome, outside this flex column.) */
  & > :first-child {
    flex-shrink: 0;
  }
  /* Non-interactive mode (spectating): suppress clicks on the board + score
     area but keep the menubar clickable for any future chrome-level UI. */
  ${(props)=>!props.$interactive && `
    & > *:not(:first-child) {
      pointer-events: none;
    }
  `}
`;
var $523f633b3aed431a$export$2e2bcd8739ae039 = $523f633b3aed431a$var$SolitaireCore;





parcelRequire("acw62");



const $819181fac6426bb2$export$fc0166e227b888f4 = 16;
const $819181fac6426bb2$export$a98f18492ccbcfdf = 5;
function $819181fac6426bb2$export$5a73d0ce225fce09(tag) {
    if (tag === "w") return {
        pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).WASTE
    };
    const [kind, a, b] = tag.split(":");
    if (kind === "f") return {
        pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).FOUNDATION,
        index: Number(a)
    };
    if (kind === "t") return {
        pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU,
        index: Number(a),
        depth: Number(b)
    };
    return null;
}
function $819181fac6426bb2$export$a814dd72efa359f9(a, b) {
    if (!a || !b || a.pile !== b.pile) return false;
    if (a.pile === (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).WASTE) return true;
    if (a.pile === (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).FOUNDATION) return a.index === b.index;
    if (a.pile === (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU) return a.index === b.index && a.depth === b.depth;
    return false;
}
function $819181fac6426bb2$export$9e1cd1aeed37a9fb(state, src) {
    if (src.pile === (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).WASTE) return [
        (0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5)(state.waste[state.waste.length - 1])
    ];
    if (src.pile === (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).FOUNDATION) {
        const f = state.foundations[src.index];
        return [
            (0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5)(f[f.length - 1])
        ];
    }
    const faceUp = state.tableau[src.index].faceUp;
    return faceUp.slice(faceUp.length - 1 - src.depth).map((0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5));
}
function $819181fac6426bb2$export$8942935387d2cf41(root, src, grabEl) {
    if (!root) return grabEl ? [
        grabEl
    ] : [];
    if (src.pile !== (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU) {
        if (grabEl) return [
            grabEl
        ];
        const el = root.querySelector(`[data-card-source="${src.pile === (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).WASTE ? "w" : `f:${src.index}`}"]`);
        return el ? [
            el
        ] : [];
    }
    const els = [];
    for(let depth = 0; depth <= src.depth; depth++){
        const el = root.querySelector(`[data-card-source="t:${src.index}:${depth}"]`);
        if (el) els.push(el);
    }
    return els;
}
function $819181fac6426bb2$export$94ea06b00f779d4b(els) {
    for (const el of els)el.style.visibility = "hidden";
}
function $819181fac6426bb2$export$bf29272de9e9a11(els) {
    for (const el of els)el.style.visibility = "";
}
function $819181fac6426bb2$export$bed061c40191b04a(root, clientX, clientY, radiusPx = 0) {
    if (!root) return null;
    let contained = null;
    let nearest = null;
    let nearestDist = Infinity;
    for (const el of root.querySelectorAll("[data-card-source]")){
        const r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0) continue;
        if (clientX >= r.left && clientX <= r.right && clientY >= r.top && clientY <= r.bottom) {
            contained = el;
            continue;
        }
        if (radiusPx > 0) {
            const dx = clientX - (r.left + r.width / 2);
            const dy = clientY - (r.top + r.height / 2);
            const d = Math.hypot(dx, dy);
            if (d < nearestDist) {
                nearestDist = d;
                nearest = el;
            }
        }
    }
    const el = contained ?? (nearestDist <= radiusPx ? nearest : null);
    if (!el) return null;
    const src = $819181fac6426bb2$export$5a73d0ce225fce09(el.getAttribute("data-card-source"));
    return src ? {
        src: src,
        el: el
    } : null;
}
function $819181fac6426bb2$export$2b96b937b2c6f3c7({ cards: cards }) {
    return cards.map((name, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($819181fac6426bb2$var$GhostSlot, {
            style: {
                top: i * $819181fac6426bb2$export$fc0166e227b888f4 + "px"
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
                name: name
            })
        }, i));
}
const $819181fac6426bb2$var$GhostSlot = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 0;
`;



parcelRequire("acw62");




const $7dbf13d94cedcb11$export$21decfe5b6941f4b = "saat.cardBack";
function $7dbf13d94cedcb11$var$DeckPicker({ current: current, onChoose: onChoose, onClose: onClose }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7dbf13d94cedcb11$var$StyledWindow, {
        title: "Select Card Back",
        controls: [
            "close"
        ],
        onControlClick: (c)=>c === "close" && onClose && onClose(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7dbf13d94cedcb11$var$Body, {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7dbf13d94cedcb11$var$Grid, {
                children: (0, $db9a6e9d90d8f08e$export$15e876c33fed7287).map((name)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7dbf13d94cedcb11$var$BackButton, {
                        type: "button",
                        "data-selected": name === current ? "true" : undefined,
                        onClick: ()=>{
                            try {
                                localStorage.setItem($7dbf13d94cedcb11$export$21decfe5b6941f4b, name);
                            } catch  {
                            // storage unavailable — session-only deck choice is fine
                            }
                            onChoose(name);
                            if (onClose) onClose();
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50d7a68c1c70e782$export$2e2bcd8739ae039), {
                            name: name,
                            width: 52
                        })
                    }, name))
            })
        })
    });
}
const $7dbf13d94cedcb11$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 420px;
`;
const $7dbf13d94cedcb11$var$Body = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  padding: 10px 12px;
`;
const $7dbf13d94cedcb11$var$Grid = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  justify-items: center;
`;
const $7dbf13d94cedcb11$var$BackButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  min-width: 0;
  min-height: 0;
  padding: 3px;
  background: transparent;
  border: none;
  box-shadow: none;

  &&[data-selected="true"] {
    outline: 2px solid #00007b;
    outline-offset: 1px;
  }
  &&:not(:disabled):hover {
    outline: 1px dotted #00007b;
    outline-offset: 1px;
  }
  &&:not(:disabled):active {
    box-shadow: none;
  }
  &&:focus {
    outline: 2px dotted #00007b;
  }
`;
var $7dbf13d94cedcb11$export$2e2bcd8739ae039 = $7dbf13d94cedcb11$var$DeckPicker;





var $acw62 = parcelRequire("acw62");
// Global keyboard modality flag. While a modal dialog is up, every
// useKey listener that hasn't opted in (whenModal) goes inert — a single
// choke point instead of per-hook guards.
//
// A module-level flag, not React state: useKey handlers consult it at
// event time, and the Stage (the only writer) syncs it from the window
// manager in an effect. Deliberately not reactive — nothing re-renders
// on modality; things just stop hearing keys.
let $8b3c1001fecd4747$var$active = false;
function $8b3c1001fecd4747$export$526b4b9b480d0ce0(v) {
    $8b3c1001fecd4747$var$active = !!v;
}
function $8b3c1001fecd4747$export$db3706802ff2f4eb() {
    return $8b3c1001fecd4747$var$active;
}


function $8c77a2f882a1085d$export$2e2bcd8739ae039(key, handler, { whenModal: whenModal = false, caseless: caseless = false } = {}) {
    const handlerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(handler);
    handlerRef.current = handler;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const matches = caseless ? (k)=>k.toLowerCase() === key.toLowerCase() : (k)=>k === key;
        const onKey = (e)=>{
            if ((0, $8b3c1001fecd4747$export$db3706802ff2f4eb)() && !whenModal) return;
            if (matches(e.key)) handlerRef.current(e);
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        key,
        whenModal,
        caseless
    ]);
}



// The piece's sound layer. Everything is synthesized with WebAudio — no
// audio assets, and definitely nothing of Microsoft's. Sparse on purpose:
// clicks, a gentle CRT hum, soft card sounds. No startup chime.
//
// The AudioContext must be created/resumed inside a user gesture; the
// login dialog's OK click calls unlock(). Every play function is a no-op
// until then, so callers never need to check.

var $acw62 = parcelRequire("acw62");
// Tiny persisted-settings store: localStorage + a window event so every
// consumer of a setting re-renders when any window (Settings panel,
// tray volume, etc.) changes it. Values are JSON-encoded.
const $213c0628df7e524f$var$EVENT = "saat:setting";
function $213c0628df7e524f$export$5e210d233dcded1b(key, fallback) {
    try {
        const raw = localStorage.getItem(key);
        if (raw == null) return fallback;
        return JSON.parse(raw);
    } catch  {
        return fallback;
    }
}
function $213c0628df7e524f$export$4e0ecc6c4b6d7004(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch  {
    // Storage full/blocked: the in-session event still works.
    }
    window.dispatchEvent(new CustomEvent($213c0628df7e524f$var$EVENT, {
        detail: {
            key: key,
            value: value
        }
    }));
}
function $213c0628df7e524f$export$2e2bcd8739ae039(key, fallback) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$213c0628df7e524f$export$5e210d233dcded1b(key, fallback));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onChange = (e)=>{
            if (e.detail?.key === key) setValue(e.detail.value);
        };
        window.addEventListener($213c0628df7e524f$var$EVENT, onChange);
        return ()=>window.removeEventListener($213c0628df7e524f$var$EVENT, onChange);
    }, [
        key
    ]);
    const set = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((v)=>$213c0628df7e524f$export$4e0ecc6c4b6d7004(key, v), [
        key
    ]);
    return [
        value,
        set
    ];
}


// Audio graph handles live on globalThis so a dev-server hot reload of
// this module reuses (and can silence) the existing context instead of
// stacking a second hum on top of an orphaned first one. Harmless in
// production (one module instance, one stash).
const $ffdb7a25fbb7044c$var$STASH = globalThis.__saatSound = globalThis.__saatSound || {
    ctx: null,
    master: null,
    hum: null
};
let $ffdb7a25fbb7044c$var$ctx = $ffdb7a25fbb7044c$var$STASH.ctx;
let $ffdb7a25fbb7044c$var$master = $ffdb7a25fbb7044c$var$STASH.master;
if ($ffdb7a25fbb7044c$var$STASH.hum) {
    // A previous module instance left a hum running; take it over.
    try {
        $ffdb7a25fbb7044c$var$STASH.hum.stop();
    } catch  {
    // already stopped
    }
    $ffdb7a25fbb7044c$var$STASH.hum = null;
}
// Master volume (0..1), persisted through the ONE settings store
// (hooks/useSetting); writeSetting also fires the event every volume
// UI listens for.
const $ffdb7a25fbb7044c$var$VOLUME_KEY = "saat.volume";
let $ffdb7a25fbb7044c$var$volume = (()=>{
    const v = (0, $213c0628df7e524f$export$5e210d233dcded1b)($ffdb7a25fbb7044c$var$VOLUME_KEY, 0.5);
    return Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : 0.5;
})();
function $ffdb7a25fbb7044c$export$246e658b67178cb0(v) {
    $ffdb7a25fbb7044c$var$volume = Math.min(1, Math.max(0, v));
    if ($ffdb7a25fbb7044c$var$master) $ffdb7a25fbb7044c$var$master.gain.value = $ffdb7a25fbb7044c$var$volume;
    (0, $213c0628df7e524f$export$4e0ecc6c4b6d7004)($ffdb7a25fbb7044c$var$VOLUME_KEY, $ffdb7a25fbb7044c$var$volume);
}
function $ffdb7a25fbb7044c$export$f3d6704bb885c205() {
    return $ffdb7a25fbb7044c$var$volume;
}
function $ffdb7a25fbb7044c$export$eccddd504975e05d() {
    if ($ffdb7a25fbb7044c$var$dead) return; // powered off: the speaker is gone for good
    if ($ffdb7a25fbb7044c$var$ctx) {
        $ffdb7a25fbb7044c$var$syncSuspend();
        return;
    }
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    $ffdb7a25fbb7044c$var$ctx = new AC();
    $ffdb7a25fbb7044c$var$master = $ffdb7a25fbb7044c$var$ctx.createGain();
    $ffdb7a25fbb7044c$var$master.gain.value = $ffdb7a25fbb7044c$var$volume;
    $ffdb7a25fbb7044c$var$master.connect($ffdb7a25fbb7044c$var$ctx.destination);
    $ffdb7a25fbb7044c$var$STASH.ctx = $ffdb7a25fbb7044c$var$ctx;
    $ffdb7a25fbb7044c$var$STASH.master = $ffdb7a25fbb7044c$var$master;
    $ffdb7a25fbb7044c$var$syncSuspend();
}
function $ffdb7a25fbb7044c$export$9a4f07bd43a39c1a() {
    return $ffdb7a25fbb7044c$var$ctx != null;
}
// The tab being hidden and the screensaver running each suspend the
// whole context (hum included) independently; audio resumes only when
// the LAST reason clears, so waking one in the background can't bring
// the hum back early. Suspending beats muting: no battery spent
// synthesizing sound nobody can hear.
const $ffdb7a25fbb7044c$var$pauseReasons = new Set();
if (typeof document !== "undefined" && document.hidden) $ffdb7a25fbb7044c$var$pauseReasons.add("hidden");
function $ffdb7a25fbb7044c$var$syncSuspend() {
    if (!$ffdb7a25fbb7044c$var$ctx) return;
    if ($ffdb7a25fbb7044c$var$pauseReasons.size > 0) $ffdb7a25fbb7044c$var$ctx.suspend();
    else $ffdb7a25fbb7044c$var$ctx.resume();
}
function $ffdb7a25fbb7044c$export$af96c16dd8b4c215(reason, active) {
    if (active) $ffdb7a25fbb7044c$var$pauseReasons.add(reason);
    else $ffdb7a25fbb7044c$var$pauseReasons.delete(reason);
    $ffdb7a25fbb7044c$var$syncSuspend();
}
if (typeof document !== "undefined") document.addEventListener("visibilitychange", ()=>{
    $ffdb7a25fbb7044c$export$af96c16dd8b4c215("hidden", document.hidden);
});
function $ffdb7a25fbb7044c$export$64ef1bee2b9504c1() {
    if (!$ffdb7a25fbb7044c$var$ctx) return;
    const t0 = $ffdb7a25fbb7044c$var$ctx.currentTime;
    for (const [at, gain, freq] of [
        [
            0,
            0.6,
            2400
        ],
        [
            0.055,
            0.35,
            1900
        ]
    ]){
        const dur = 0.012;
        const buf = $ffdb7a25fbb7044c$var$ctx.createBuffer(1, $ffdb7a25fbb7044c$var$ctx.sampleRate * dur, $ffdb7a25fbb7044c$var$ctx.sampleRate);
        const data = buf.getChannelData(0);
        for(let i = 0; i < data.length; i++)data[i] = (Math.random() * 2 - 1) * (1 - i / data.length);
        const src = $ffdb7a25fbb7044c$var$ctx.createBufferSource();
        src.buffer = buf;
        const bp = $ffdb7a25fbb7044c$var$ctx.createBiquadFilter();
        bp.type = "bandpass";
        bp.frequency.value = freq;
        bp.Q.value = 1.2;
        const g = $ffdb7a25fbb7044c$var$ctx.createGain();
        g.gain.value = gain;
        src.connect(bp).connect(g).connect($ffdb7a25fbb7044c$var$master);
        src.start(t0 + at);
    }
}
function $ffdb7a25fbb7044c$export$35a597aa3b97208a(gainScale = 1) {
    if (!$ffdb7a25fbb7044c$var$ctx) return;
    const t0 = $ffdb7a25fbb7044c$var$ctx.currentTime;
    const dur = 0.05;
    const buf = $ffdb7a25fbb7044c$var$ctx.createBuffer(1, $ffdb7a25fbb7044c$var$ctx.sampleRate * dur, $ffdb7a25fbb7044c$var$ctx.sampleRate);
    const data = buf.getChannelData(0);
    for(let i = 0; i < data.length; i++)data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / data.length, 2);
    const src = $ffdb7a25fbb7044c$var$ctx.createBufferSource();
    src.buffer = buf;
    const lp = $ffdb7a25fbb7044c$var$ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 900 + Math.random() * 300;
    const g = $ffdb7a25fbb7044c$var$ctx.createGain();
    g.gain.value = 0.5 * gainScale;
    src.connect(lp).connect(g).connect($ffdb7a25fbb7044c$var$master);
    src.start(t0);
}
function $ffdb7a25fbb7044c$export$6b377d304b8bff15(gainScale = 1) {
    if (!$ffdb7a25fbb7044c$var$ctx) return;
    const t0 = $ffdb7a25fbb7044c$var$ctx.currentTime;
    const dur = 0.09;
    const buf = $ffdb7a25fbb7044c$var$ctx.createBuffer(1, $ffdb7a25fbb7044c$var$ctx.sampleRate * dur, $ffdb7a25fbb7044c$var$ctx.sampleRate);
    const data = buf.getChannelData(0);
    for(let i = 0; i < data.length; i++){
        const env = Math.sin(i / data.length * Math.PI);
        data[i] = (Math.random() * 2 - 1) * env * env;
    }
    const src = $ffdb7a25fbb7044c$var$ctx.createBufferSource();
    src.buffer = buf;
    const bp = $ffdb7a25fbb7044c$var$ctx.createBiquadFilter();
    bp.type = "bandpass";
    bp.frequency.value = 2600;
    bp.Q.value = 0.7;
    const g = $ffdb7a25fbb7044c$var$ctx.createGain();
    g.gain.value = 0.22 * gainScale;
    src.connect(bp).connect(g).connect($ffdb7a25fbb7044c$var$master);
    src.start(t0);
}
function $ffdb7a25fbb7044c$export$b101e1013980b7df() {
    if (!$ffdb7a25fbb7044c$var$ctx) return;
    const t0 = $ffdb7a25fbb7044c$var$ctx.currentTime;
    const g = $ffdb7a25fbb7044c$var$ctx.createGain();
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(0.16, t0 + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.32);
    g.connect($ffdb7a25fbb7044c$var$master);
    for (const [freq, gain] of [
        [
            740,
            1
        ],
        [
            1480,
            0.25
        ]
    ]){
        const o = $ffdb7a25fbb7044c$var$ctx.createOscillator();
        o.type = "sine";
        o.frequency.value = freq;
        const og = $ffdb7a25fbb7044c$var$ctx.createGain();
        og.gain.value = gain;
        o.connect(og).connect(g);
        o.start(t0);
        o.stop(t0 + 0.35);
    }
}
function $ffdb7a25fbb7044c$export$a636d5f53a584b37() {
    if (!$ffdb7a25fbb7044c$var$ctx) return;
    const t0 = $ffdb7a25fbb7044c$var$ctx.currentTime;
    const g = $ffdb7a25fbb7044c$var$ctx.createGain();
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(0.14, t0 + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.22);
    g.connect($ffdb7a25fbb7044c$var$master);
    for (const [freq, gain] of [
        [
            523,
            1
        ],
        [
            1046,
            0.18
        ]
    ]){
        const o = $ffdb7a25fbb7044c$var$ctx.createOscillator();
        o.type = "triangle";
        o.frequency.value = freq;
        const og = $ffdb7a25fbb7044c$var$ctx.createGain();
        og.gain.value = gain;
        o.connect(og).connect(g);
        o.start(t0);
        o.stop(t0 + 0.25);
    }
}
// The CRT hum: a very quiet 60Hz-ish tone + its second harmonic + a
// whisper of filtered noise, faded in over a couple seconds. Runs until
// stopHum. Deliberately at the edge of perception.
let $ffdb7a25fbb7044c$var$hum = null;
function $ffdb7a25fbb7044c$export$45a3a1ca5d5aecec() {
    if (!$ffdb7a25fbb7044c$var$ctx || $ffdb7a25fbb7044c$var$hum) return;
    const g = $ffdb7a25fbb7044c$var$ctx.createGain();
    g.gain.value = 0;
    g.gain.linearRampToValueAtTime(0.01, $ffdb7a25fbb7044c$var$ctx.currentTime + 2.5);
    g.connect($ffdb7a25fbb7044c$var$master);
    const o1 = $ffdb7a25fbb7044c$var$ctx.createOscillator();
    o1.type = "sine";
    o1.frequency.value = 60;
    const o2 = $ffdb7a25fbb7044c$var$ctx.createOscillator();
    o2.type = "sine";
    o2.frequency.value = 120;
    const o2g = $ffdb7a25fbb7044c$var$ctx.createGain();
    o2g.gain.value = 0.4;
    const noiseDur = 2;
    const buf = $ffdb7a25fbb7044c$var$ctx.createBuffer(1, $ffdb7a25fbb7044c$var$ctx.sampleRate * noiseDur, $ffdb7a25fbb7044c$var$ctx.sampleRate);
    const data = buf.getChannelData(0);
    for(let i = 0; i < data.length; i++)data[i] = Math.random() * 2 - 1;
    const noise = $ffdb7a25fbb7044c$var$ctx.createBufferSource();
    noise.buffer = buf;
    noise.loop = true;
    const nf = $ffdb7a25fbb7044c$var$ctx.createBiquadFilter();
    nf.type = "highpass";
    nf.frequency.value = 8000;
    const ng = $ffdb7a25fbb7044c$var$ctx.createGain();
    // The "fuzz" noise floor — kept low, felt more than heard under the 60Hz tone.
    ng.gain.value = 0.04;
    o1.connect(g);
    o2.connect(o2g).connect(g);
    noise.connect(nf).connect(ng).connect(g);
    o1.start();
    o2.start();
    noise.start();
    $ffdb7a25fbb7044c$var$hum = {
        g: g,
        stop: ()=>[
                o1,
                o2,
                noise
            ].forEach((n)=>n.stop())
    };
    $ffdb7a25fbb7044c$var$STASH.hum = $ffdb7a25fbb7044c$var$hum;
}
function $ffdb7a25fbb7044c$export$d7c4db59990f22f5() {
    if (!$ffdb7a25fbb7044c$var$ctx || !$ffdb7a25fbb7044c$var$hum) return;
    const h = $ffdb7a25fbb7044c$var$hum;
    $ffdb7a25fbb7044c$var$hum = null;
    $ffdb7a25fbb7044c$var$STASH.hum = null;
    h.g.gain.linearRampToValueAtTime(0, $ffdb7a25fbb7044c$var$ctx.currentTime + 0.5);
    setTimeout(()=>h.stop(), 600);
}
// The machine is off. Hum fades, then the whole AudioContext closes
// and stays closed — no ambient card sounds, clicks, or dings can
// play over "It's now safe to close this tab", and a later gesture
// can't resurrect audio (unlock() refuses once dead).
let $ffdb7a25fbb7044c$var$dead = false;
function $ffdb7a25fbb7044c$export$3e0a41b1eea2afb3() {
    $ffdb7a25fbb7044c$var$dead = true;
    $ffdb7a25fbb7044c$export$d7c4db59990f22f5();
    const c = $ffdb7a25fbb7044c$var$ctx;
    $ffdb7a25fbb7044c$var$ctx = null;
    $ffdb7a25fbb7044c$var$STASH.ctx = null;
    $ffdb7a25fbb7044c$var$master = null;
    if (c) // Let stopHum's 0.5s fade finish on the closing context.
    setTimeout(()=>{
        try {
            c.close();
        } catch  {
        // Already closed: fine, it's off either way.
        }
    }, 700);
}


// Local-only play statistics: games played, moves made, draws, games
// won. localStorage on this browser, never sent anywhere, and allowed
// to be inaccurate — every operation is best-effort and failure-silent.
const $249580010b86d987$var$KEY = "sat-stats-v1";
function $249580010b86d987$export$8b5c195b500c5f0d() {
    try {
        const raw = JSON.parse(localStorage.getItem($249580010b86d987$var$KEY)) ?? {};
        return {
            games: raw.games | 0,
            moves: raw.moves | 0,
            draws: raw.draws | 0,
            wins: raw.wins | 0
        };
    } catch  {
        return {
            games: 0,
            moves: 0,
            draws: 0,
            wins: 0
        };
    }
}
function $249580010b86d987$export$83d08c1ad4ef0948() {
    try {
        localStorage.removeItem($249580010b86d987$var$KEY);
    } catch  {
    // Stats are decorative by decree.
    }
}
function $249580010b86d987$export$143d51c027d50d83(key, n = 1) {
    try {
        const s = $249580010b86d987$export$8b5c195b500c5f0d();
        s[key] = (s[key] | 0) + n;
        localStorage.setItem($249580010b86d987$var$KEY, JSON.stringify(s));
    } catch  {
    // Stats are decorative by decree.
    }
}


// The player's own game. Owns engine state + selection + click resolution;
// hands rendering to SolitaireCore. Positioning lives in the Stage, so this
// component produces a plain unpositioned game that can be dropped anywhere.
//
// Resolution rules:
//   - Stock click always applies DRAW; clears selection.
//   - If there's a selection and the clicked thing is a legal destination:
//     apply move, clear selection.
//   - If the click is on the already-selected source: deselect.
//   - Otherwise: if the clicked thing is a valid source, select it (illegal
//     drop attempts fall through to reselection instead of erroring).
//     Empty-column clicks are destination-only.
//   - ESC always clears the selection.
// Drag presentation (ghost stack, source tags, hide/restore) is shared
// with SpectatedSolitaire via ../SolitaireCore/dragKit — this file owns
// only the pointer-event input adapter and move resolution.
function $5f6c13e68f433d1b$var$PlayableSolitaire({ title: title, gameId: gameId, cardBack: cardBack, sendMove: sendMove, sendUndo: sendUndo, dealNewGame: dealNewGame, initialMoves: initialMoves, initialCanUndo: initialCanUndo = false, sendCursor: // Presence: relays this player's mouse position to their watchers.
sendCursor, inactive: // Injected by the Stage: focus, title-bar buttons, Help → About hook.
inactive = false, onControlClick: onControlClick, onHelpAbout: onHelpAbout, disabledControls: // Which title-bar buttons are honestly grey. Desktop disables only
// maximize; compact also greys minimize (nowhere to minimize TO).
disabledControls = [
    "maximize"
] }) {
    // gameId is the seed — one deck per game ID via the engine's Lehmer
    // unranking bijection. `key={gameId}` in the parent fully remounts this
    // component with a fresh deck whenever the game ID changes.
    //
    // initialMoves is the server's move history, used to resume after a
    // refresh; read once in the lazy init, ignored thereafter.
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $73d8f6063558c0ab$export$5c9ba34b2d024c9b)(gameId, initialMoves ?? [], {
            label: "PlayableSolitaire"
        }));
    const [selection, setSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Foundation copies (engine ints) snapshotted at the win; the cascade
    // pops cards off these as it launches them so the rendered stacks
    // shrink underneath the flying cards. null = not celebrating.
    const [celebrationFoundations, setCelebrationFoundations] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // A resumed game may already be won (refresh right after winning).
    const alreadyWon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef((0, $73d8f6063558c0ab$export$34b9657cfbb2ea8e)(state));
    // Single-step undo: the state before the most recent move, or null.
    // Cleared by using it — an undo can never follow an undo. A resumed
    // game rebuilds its armed undo by replaying one move short.
    const undoStateRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Whether the most recent applied op was a draw — undo needs this so
    // the idle-clock mirror treats undoing a draw as stock-cycling too.
    const lastAppliedWasDrawRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const [canUndo, setCanUndo] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        if (initialCanUndo && (initialMoves?.length ?? 0) > 0) {
            undoStateRef.current = (0, $73d8f6063558c0ab$export$5c9ba34b2d024c9b)(gameId, initialMoves.slice(0, -1), {
                label: "PlayableSolitaire:undo-arm"
            });
            return true;
        }
        return false;
    });
    // The chosen deck (Game → Deck…): prop is the initial value, the
    // dialog updates + persists it.
    const [deck, setDeck] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(cardBack);
    const [deckOpen, setDeckOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("Escape", ()=>setSelection(null));
    const startCelebration = (foundations)=>{
        setSelection(null);
        setCelebrationFoundations(foundations.map((f)=>f.slice()));
    };
    // A game counts as "played" at your FIRST move, not at the deal — a
    // refresh-resume arrives with history, so it starts pre-counted.
    const gameCountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef((initialMoves?.length ?? 0) > 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (alreadyWon.current) startCelebration(state.foundations);
        else if (// Dev knob: `?celebrate` fires the cascade immediately with four full
        // foundations, so the animation can be eyeballed without winning.
        new URLSearchParams(window.location.search).has("celebrate")) startCelebration([
            0,
            1,
            2,
            3
        ].map((suit)=>Array.from({
                length: 13
            }, (_, rank)=>suit * 13 + rank)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onPopTop = (foundationIdx)=>{
        setCelebrationFoundations((prev)=>{
            if (!prev) return prev;
            const next = prev.map((f)=>f.slice());
            next[foundationIdx].pop();
            return next;
        });
    };
    const applyAndRelay = (move, releaseAt = null)=>{
        // Once the cascade starts, the popped-down celebration foundations no
        // longer match engine state — ignore further input.
        if (celebrationFoundations != null) return null;
        const result = (0, $73d8f6063558c0ab$export$9d099694dbff824c)(state, move);
        if (result == null) return null;
        if (move.type === (0, $73d8f6063558c0ab$export$93cd7006288e3b81).DRAW) (0, $ffdb7a25fbb7044c$export$6b377d304b8bff15)();
        else (0, $ffdb7a25fbb7044c$export$35a597aa3b97208a)();
        // Local stats ledger; best-effort, undo doesn't un-count.
        if (!gameCountedRef.current) {
            gameCountedRef.current = true;
            (0, $249580010b86d987$export$143d51c027d50d83)("games");
        }
        (0, $249580010b86d987$export$143d51c027d50d83)(move.type === (0, $73d8f6063558c0ab$export$93cd7006288e3b81).DRAW ? "draws" : "moves");
        undoStateRef.current = state;
        lastAppliedWasDrawRef.current = move.type === (0, $73d8f6063558c0ab$export$93cd7006288e3b81).DRAW;
        setCanUndo(true);
        setState(result.next);
        if (sendMove) sendMove(result.index, releaseAt, {
            draw: move.type === (0, $73d8f6063558c0ab$export$93cd7006288e3b81).DRAW
        });
        if ((0, $73d8f6063558c0ab$export$34b9657cfbb2ea8e)(result.next)) {
            (0, $249580010b86d987$export$143d51c027d50d83)("wins");
            startCelebration(result.next.foundations);
        }
        return result.next;
    };
    const tryDestination = (to)=>{
        if (!selection) return false;
        const next = applyAndRelay({
            type: (0, $73d8f6063558c0ab$export$93cd7006288e3b81).MOVE,
            from: selection,
            to: to
        });
        if (next == null) return false;
        setSelection(null);
        // A successful drop is a completed gesture — must not seed a
        // double-click on the card it just placed.
        lastClickRef.current = {
            key: null,
            at: 0
        };
        return true;
    };
    const selectOrDeselect = (source)=>{
        if ((0, $819181fac6426bb2$export$a814dd72efa359f9)(selection, source)) setSelection(null);
        else setSelection(source);
    };
    // Double-click a card to auto-play it to a foundation (classic MS).
    // Tracked by timing rather than onDoubleClick so the first click can
    // still select normally, and an unplayable double-click degrades to
    // the usual select/deselect toggle. EVERY click target must stamp
    // this (noteClick), not just the auto-playable ones, or an unrelated
    // pair of clicks on the same key within 400ms reads as a double-click.
    const lastClickRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        key: null,
        at: 0
    });
    const noteClick = (key)=>{
        lastClickRef.current = {
            key: key,
            at: Date.now()
        };
    };
    const isDoubleClick = (key)=>{
        const now = Date.now();
        const isDouble = lastClickRef.current.key === key && now - lastClickRef.current.at < 400;
        lastClickRef.current = {
            key: isDouble ? null : key,
            at: now
        };
        return isDouble;
    };
    const tryAutoFoundation = (from)=>{
        for(let f = 0; f < 4; f++){
            const next = applyAndRelay({
                type: (0, $73d8f6063558c0ab$export$93cd7006288e3b81).MOVE,
                from: from,
                to: {
                    pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).FOUNDATION,
                    index: f
                }
            });
            if (next != null) {
                setSelection(null);
                return true;
            }
        }
        return false;
    };
    const doUndo = ()=>{
        if (undoStateRef.current == null || celebrationFoundations != null) return;
        // Ctrl+Z with a card in hand: land it first — the board is about to
        // be replaced under the gesture, and a drag over nodes React may
        // recreate would strand hidden cards and drop against a stale source.
        if (dragSessionRef.current) {
            clearLiftVisuals(dragSessionRef.current);
            dragSessionRef.current = null;
        }
        (0, $ffdb7a25fbb7044c$export$35a597aa3b97208a)();
        setState(undoStateRef.current);
        undoStateRef.current = null;
        setCanUndo(false);
        setSelection(null);
        if (sendUndo) sendUndo({
            draw: lastAppliedWasDrawRef.current
        });
    };
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("z", (e)=>{
        // Not Shift+Z (redo's chord) and not while a neighbor's window
        // has focus (Ctrl+Z acts on the window you're IN).
        if (inactive || e.shiftKey) return;
        if (e.ctrlKey || e.metaKey) doUndo();
    }, {
        caseless: true
    });
    const onDrawClick = ()=>{
        noteClick("stock");
        setSelection(null);
        applyAndRelay({
            type: (0, $73d8f6063558c0ab$export$93cd7006288e3b81).DRAW
        });
    };
    const onWasteClick = ()=>{
        if (state.waste.length === 0) return;
        if (isDoubleClick("waste") && tryAutoFoundation({
            pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).WASTE
        })) return;
        selectOrDeselect({
            pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).WASTE
        });
    };
    const onFoundationClick = (i)=>{
        noteClick(`foundation:${i}`);
        if (tryDestination({
            pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).FOUNDATION,
            index: i
        })) return;
        if (state.foundations[i].length === 0) return;
        selectOrDeselect({
            pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).FOUNDATION,
            index: i
        });
    };
    const onTableauCardClick = (col, depth)=>{
        if (depth !== 0) // Deep cards can't auto-play; distinct key so a deep click can't
        // pair with a top-card click into a phantom double.
        noteClick(`tableau:${col}:${depth}`);
        else if (isDoubleClick(`tableau:${col}`) && tryAutoFoundation({
            pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU,
            index: col,
            depth: 0
        })) return;
        if (tryDestination({
            pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU,
            index: col
        })) return;
        selectOrDeselect({
            pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU,
            index: col,
            depth: depth
        });
    };
    const onTableauEmptyClick = (col)=>{
        noteClick(`empty:${col}`);
        tryDestination({
            pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU,
            index: col
        });
    };
    // ------------------------------------------------------------------
    // Drag-and-drop (classic MS behavior, coexisting with click-select).
    // Pointer down on a card arms a potential drag; crossing the movement
    // threshold lifts the card (or the partial run below it) into a ghost
    // that follows the pointer. Release over a tableau/foundation cell
    // attempts the move; anywhere else snaps back instantly (no return
    // animation). A completed drag suppresses the click that browsers
    // fire after pointerup, so click-select never sees it.
    // ------------------------------------------------------------------
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const ghostRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The lift's slide-up wrapper inside the ghost (see GhostRiser).
    const riserRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const dragSessionRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Set by the cursor-presence effect below (server/PROTOCOL.md §4):
    // releaseCursorRef sends a BARE release edge (abandoned drag / plain
    // click); takeReleaseRef consumes the release WITHOUT sending, for
    // drags that complete as a move — the release coords ride ON the move
    // message ({..., c:[x,y,0]}) so spectators get release+move as one
    // atomic frame, avoiding a drop flicker from two separate frames.
    const releaseCursorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const takeReleaseRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const sendCursorRawRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The just-finished drag's release point, or null: the one click the
    // browser echoes after a drag is swallowed by proximity, not timing
    // (see finish()).
    const suppressClickRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // {cards: [sprite names], x, y} while a drag is live.
    const [drag, setDrag] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const stateRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(state);
    stateRef.current = state;
    const applyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    applyRef.current = (move, releaseAt)=>{
        const next = applyAndRelay(move, releaseAt);
        if (next != null) setSelection(null);
        return next;
    };
    // TOUCH_LIFT: a fingertip hides exactly the card it's moving, so touch
    // interactions lift the grabbed cards above the touch point. The lift
    // arms on a short HOLD, not on drag start (the card should already be
    // up when you start moving) — but never on a quick tap: taps release
    // before the hold fires, so tap-to-select and double-tap-to-foundation
    // see the board untouched (a lifted card under a click hit-tests wrong).
    const TOUCH_LIFT_HOLD_MS = 160;
    // Lift amount is a function of WHERE on the card the finger pressed: a
    // run grab presses the thin exposed sliver at a card's top edge (the
    // finger covers the face, needing a big lift to show which card is
    // held), while a single card is grabbed near its middle with its face
    // already half-visible. One rule covers both: lift so the card's TOP
    // rides ~70% of a card above the finger, clamped to a 15%-55% lift.
    //
    // The lift is rendered through the DRAG GHOST from the moment the hold
    // fires — the real tiles are never transformed. An in-flow transform
    // promotes a tile to its own compositing layer, and under the compact
    // stage's fractional scale that re-snaps neighboring cards to different
    // device pixels. The ghost overlay + visibility-hidden sources are the
    // same machinery every drag uses, proven shift-free.
    const touchLiftPx = (h, grabOffY)=>Math.round(Math.min(Math.max(h * 0.7 - grabOffY, h * 0.15), h * 0.55));
    // Set each render by the drag effect below: mounts the lift/drag
    // visuals for a session (hold timers live outside the effect).
    const mountVisualsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The one teardown for a session's visuals, pending or active: real
    // cards back INSTANTLY and synchronously (on a release this runs in
    // the pointerup handler, before the browser hit-tests the compat
    // click — the ghost is pointer-events: none so it can't shadow the
    // card), ghost unmounted, hold timer dead.
    const clearLiftVisuals = (d)=>{
        clearTimeout(d.holdTimer);
        if (!d.visualsMounted) return;
        (0, $819181fac6426bb2$export$bf29272de9e9a11)(d.hidden);
        d.hidden = [];
        d.visualsMounted = false;
        setDrag(null);
    };
    const onRootPointerDown = (e)=>{
        // A fresh press voids any armed click suppressor: the suppressor
        // exists to swallow a release's own echo click, and an echo always
        // dispatches before the next press reaches pointerdown. iOS often
        // fires NO echo at all for a lifted put-back, so a stale suppressor
        // would otherwise eat the next real tap whenever it landed within
        // 12px/400ms or resolved to the same card.
        suppressClickRef.current = null;
        if (celebrationFoundations != null) return;
        if (e.pointerType === "mouse" && e.button !== 0) return;
        const cur = dragSessionRef.current;
        if (cur?.active) {
            // One drag at a time: while a drag is in flight, other fingers
            // are bystanders — replacing the session here would orphan the
            // ghost and leave the real cards hidden forever.
            if (e.pointerId !== cur.pointerId) return;
            // The SAME pointer pressing again means its release was lost
            // (shouldn't happen under capture + cancel + blur, but a stuck
            // session must not brick dragging): reset the stray drag.
            clearLiftVisuals(cur);
            dragSessionRef.current = null;
        } else if (cur) // A second finger landing mid-press must not orphan the first
        // session's lift/timer.
        clearLiftVisuals(cur);
        const el = e.target.closest?.("[data-card-source]");
        if (!el || !rootRef.current?.contains(el)) return;
        const src = (0, $819181fac6426bb2$export$5a73d0ce225fce09)(el.getAttribute("data-card-source"));
        if (!src) return;
        const d = {
            src: src,
            grabEl: el,
            pointerId: e.pointerId,
            startX: e.clientX,
            startY: e.clientY,
            // Touch lifts the cards above the finger (see TOUCH_LIFT above);
            // a mouse pointer doesn't occlude, so it drags flush.
            touch: e.pointerType === "touch",
            active: false,
            hidden: []
        };
        if (d.touch) d.holdTimer = setTimeout(()=>{
            // Only if this press is still the pending session: a tap
            // released, a replaced session, or an already-active drag
            // (which mounted the visuals itself) all skip.
            if (dragSessionRef.current === d && !d.active && !d.visualsMounted) mountVisualsRef.current?.(d, d.startX, d.startY);
        }, TOUCH_LIFT_HOLD_MS);
        dragSessionRef.current = d;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const clamp = (v, lo, hi)=>Math.min(Math.max(v, lo), Math.max(lo, hi));
        // Ghost position in FELT-local px: the grabbed card pinned inside
        // the felt no matter where the pointer goes.
        const ghostPos = (d, e)=>({
                x: (clamp(e.clientX - d.offX, d.felt.left, d.felt.right - d.cardW) - d.felt.left) / d.scale,
                y: (clamp(e.clientY - d.offY, d.felt.top, d.felt.bottom - d.cardH) - d.felt.top) / d.scale
            });
        // Mount the lift/drag visuals at (atX, atY): measure the scene,
        // put the ghost up (lifted for touch, flush for mouse), hide the
        // real cards. Used by BOTH the hold timer (press-and-hold, drag
        // not yet real) and threshold activation (fast drags that outran
        // the hold) — one system, so there is no handoff to get wrong.
        //
        // The ghost is confined to the FELT: the grabbed card is clamped
        // fully inside the green surface (a single card can't leave it at
        // all), and a dragged run's fanned tail clips at the felt edge.
        // Measure once here; the window can't move mid-press (the pointer
        // is on the card), so the rects are stable.
        const mountVisuals = (d, atX, atY)=>{
            // The lift is a MODE BOUNDARY: once the card visibly rises you
            // are HOLDING it — any standing selection clears now, and
            // releasing without dragging puts the card back rather than
            // selecting (see finish). Only quick taps — which never lift —
            // select.
            setSelection(null);
            const rootRect = rootRef.current.getBoundingClientRect();
            const feltEl = rootRef.current.querySelector("[data-felt]");
            d.felt = (feltEl ?? rootRef.current).getBoundingClientRect();
            // Guards against a CSS-scaled copy of this window ever existing
            // (mobile compact, --ui-zoom ≠ 1); today scale is 1.
            d.scale = rootRect.width / rootRef.current.offsetWidth || 1;
            const rect = d.grabEl.getBoundingClientRect();
            d.cardW = rect.width;
            d.cardH = rect.height;
            d.offX = d.startX - rect.left;
            d.offY = d.startY - rect.top;
            // Folding the lift into offY means every downstream computation
            // — felt clamp, ghost position, run-tail clip, drop resolution
            // — sees the lifted card (see TOUCH_LIFT above).
            d.lift = d.touch ? touchLiftPx(d.cardH, d.offY) : 0;
            d.offY += d.lift;
            // The clip layer sits exactly over the felt, in root-local px.
            d.clip = {
                left: (d.felt.left - rootRect.left) / d.scale,
                top: (d.felt.top - rootRect.top) / d.scale,
                width: d.felt.width / d.scale,
                height: d.felt.height / d.scale
            };
            // Ghost FIRST (synchronously — this can run in a native window
            // listener, where React flushes state in a microtask that can
            // slip past a paint), THEN hide the sources: reversing the order
            // leaves a ghostless, cardless frame at drag start.
            // The session keeps a handle on the state object so onMove can
            // keep its x/y current (see the re-render note there).
            d.dragState = {
                cards: (0, $819181fac6426bb2$export$9e1cd1aeed37a9fb)(stateRef.current, d.src),
                clip: d.clip,
                ...ghostPos(d, {
                    clientX: atX,
                    clientY: atY
                })
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).flushSync(()=>{
                setDrag(d.dragState);
            });
            d.hidden = (0, $819181fac6426bb2$export$8942935387d2cf41)(rootRef.current, d.src, d.grabEl);
            (0, $819181fac6426bb2$export$94ea06b00f779d4b)(d.hidden);
            d.visualsMounted = true;
            // The rise is IMPERATIVE only, set before this task's paint: mount
            // at the finger, then ease up to riding height (top on the riser —
            // see GhostRiser for why never a transform). It must not live in
            // the React style prop — a mid-drag re-render would re-assert the
            // stale mount value and drop the risen ghost back down.
            // Only a stationary press-and-hold ANIMATES the rise. A fast drag
            // (threshold activation, d.active already true) mounts already
            // risen — animating from the finger-flush position would paint the
            // card below its rest spot and ease it up while the finger keeps
            // moving. The riser's default top is 0 (risen), so skipping the
            // assignments entirely is correct there.
            if (d.lift > 0 && riserRef.current && !d.active) {
                riserRef.current.style.top = d.lift / d.scale + "px";
                // Double rAF: a style change in the mount frame coalesces
                // with the initial paint and the transition never plays.
                requestAnimationFrame(()=>requestAnimationFrame(()=>{
                        if (riserRef.current) riserRef.current.style.top = "0px";
                    }));
            }
        };
        mountVisualsRef.current = mountVisuals;
        const onMove = (e)=>{
            const d = dragSessionRef.current;
            if (!d) return;
            // The session belongs to ONE pointer: a palm edge or resting
            // second finger must neither steer the ghost nor activate the
            // drag. (Synthetic events without a pointerId pass — see finish.)
            if (e.pointerId != null && e.pointerId !== d.pointerId) return;
            if (!d.active) {
                // Stale session self-heal: a sub-threshold press whose release
                // happened outside the browser window never saw pointerup —
                // without this, wandering back across the board with the button
                // UP would start a drag out of thin air.
                if (e.buttons === 0) {
                    clearLiftVisuals(d);
                    dragSessionRef.current = null;
                    return;
                }
                const dist = Math.hypot(e.clientX - d.startX, e.clientY - d.startY);
                if (dist < (0, $819181fac6426bb2$export$a98f18492ccbcfdf)) return;
                d.active = true;
                // (Selection clears in mountVisuals — every grab passes
                // through it, held or fast.)
                // Capture only once the drag is real: it guarantees move/up
                // delivery even outside the browser window (release past the
                // screen edge used to strand the ghost). Capturing on the
                // pointerDOWN would retarget the compat click and break plain
                // click-to-select, so it waits for the threshold.
                try {
                    rootRef.current.setPointerCapture(d.pointerId);
                } catch  {
                // pointer already gone (e.g. pen lifted) — window listeners
                // still cover the common paths.
                }
                // A held press already put the ghost up (the hold timer); a
                // fast drag mounts it here and its slide-up plays en route.
                if (!d.visualsMounted) {
                    clearTimeout(d.holdTimer);
                    mountVisuals(d, e.clientX, e.clientY);
                }
                return;
            }
            e.preventDefault();
            const el = ghostRef.current;
            if (el) {
                const p = ghostPos(d, e);
                el.style.left = p.x + "px";
                el.style.top = p.y + "px";
                // Keep the state object current too: React re-applies its
                // style prop on any re-render (the desktop re-renders under
                // us all the time), and a stale mount position would teleport
                // a paused ghost back to where the drag began.
                if (d.dragState) {
                    d.dragState.x = p.x;
                    d.dragState.y = p.y;
                }
            }
        };
        const finish = (e, cancelled)=>{
            const d = dragSessionRef.current;
            if (!d) return;
            // A second finger lifting somewhere must not drop the card at
            // ITS coordinates (or end a pending press). Synthetic finishes —
            // blur's {} and Escape's keyboard event — carry no pointerId and
            // always pass: they are how a stuck session gets cleaned up.
            if (e.pointerId != null && e.pointerId !== d.pointerId) return;
            dragSessionRef.current = null;
            if (!d.active) {
                // A LIFTED press that never dragged is a put-back, not a tap:
                // once the card visibly rose, selecting on release read as a
                // flicker, and iOS made the outcome a coin flip anyway
                // (long-press releases sometimes fire no click; a finger
                // rolling >5px on liftoff converts to a micro-drag). Swallow
                // the echo so every lifted path ends the same: card home,
                // nothing selected. Quick taps never lift and remain the one
                // road to selection — their click passes untouched.
                if (d.visualsMounted && e.clientX != null) suppressClickRef.current = {
                    x: e.clientX,
                    y: e.clientY,
                    t: performance.now(),
                    src: d.src
                };
                // Visuals clear synchronously HERE, in the pointerup handler,
                // so any click that does pass hit-tests the restored real card
                // (the ghost is pointer-events: none and can't shadow it).
                clearLiftVisuals(d);
                return;
            }
            try {
                rootRef.current?.releasePointerCapture(d.pointerId);
            } catch  {
            // already released (implicit on pointerup) — fine
            }
            // Consume the release edge: if the drop below resolves to a move,
            // the coords ride the move message; any early return past this
            // point is an abandoned drag and sends the bare edge instead.
            const releaseAt = takeReleaseRef.current?.() ?? null;
            const bareRelease = ()=>{
                if (releaseAt) sendCursorRawRef.current?.(releaseAt, false);
            };
            // Swallow the click browsers fire right after pointerup — but ONLY
            // that one, identified by WHERE it lands, not by when: post-drag
            // clicks dispatch synchronously on mouse but async on iOS, where
            // input events can outrun a fixed timer. A click within a card's
            // reach of the release point inside 400ms is the drag's own echo;
            // anything else is a real click. A SYNTHETIC finish (Escape, blur
            // — no client coords) has no echo coming, so it must not arm the
            // suppressor: with the src match below it would eat a real click
            // on that card right after.
            if (e.clientX != null) suppressClickRef.current = {
                x: e.clientX,
                y: e.clientY,
                t: performance.now(),
                // The source the drag grabbed: its echo click must never
                // select the dragged card, even when it lands outside the
                // proximity window (see onClickCapture).
                src: d.src
            };
            clearLiftVisuals(d);
            if (cancelled) return bareRelease();
            // Resolve the drop at CLAMPED points: the card is pinned to the
            // felt, so a release with the pointer past the edge lands where
            // the card visibly is. A lifted touch drag is generous: the
            // visible top card's center is tried first, the finger point
            // second, and the first candidate whose move is LEGAL wins — a
            // near-miss on one pile doesn't waste a legal drop on the other.
            const dropPoints = [];
            if (d.lift) dropPoints.push({
                x: clamp(e.clientX - d.offX, d.felt.left, d.felt.right - d.cardW) + d.cardW / 2,
                y: clamp(e.clientY - d.offY, d.felt.top, d.felt.bottom - d.cardH) + d.cardH / 2
            });
            dropPoints.push({
                x: e.clientX,
                y: e.clientY
            });
            const tried = new Set();
            for (const pt of dropPoints){
                const under = document.elementFromPoint(clamp(pt.x, d.felt.left + 1, d.felt.right - 1), clamp(pt.y, d.felt.top + 1, d.felt.bottom - 1));
                const target = under?.closest?.("[data-drop]");
                if (!target || !rootRef.current?.contains(target)) continue;
                const drop = target.getAttribute("data-drop");
                if (tried.has(drop)) continue;
                tried.add(drop);
                const [kind, idx] = drop.split(":");
                const to = kind === "f" ? {
                    pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).FOUNDATION,
                    index: Number(idx)
                } : {
                    pile: (0, $73d8f6063558c0ab$export$4f3160f4ba5e301a).TABLEAU,
                    index: Number(idx)
                };
                const applied = applyRef.current({
                    type: (0, $73d8f6063558c0ab$export$93cd7006288e3b81).MOVE,
                    from: d.src,
                    to: to
                }, releaseAt);
                if (applied != null) return;
            }
            // No candidate landed a move: the release edge still must go out.
            bareRelease();
        };
        const onUp = (e)=>finish(e, false);
        const onCancel = (e)=>finish(e, true);
        // Escape mid-drag: cards snap home, no move, spectators see the
        // hand let go (bare release edge) — same path as pointercancel.
        const onKeyDown = (e)=>{
            if (e.key === "Escape" && dragSessionRef.current?.active) finish(e, true);
        };
        // Focus loss mid-drag (cmd-tab, alt-tab): the release will land in
        // another app, so treat it as a cancel now rather than a stuck ghost.
        const onBlur = ()=>{
            if (dragSessionRef.current?.active) finish({}, true);
            else {
                if (dragSessionRef.current) clearLiftVisuals(dragSessionRef.current);
                dragSessionRef.current = null;
            }
        };
        window.addEventListener("pointermove", onMove);
        window.addEventListener("pointerup", onUp);
        window.addEventListener("pointercancel", onCancel);
        window.addEventListener("keydown", onKeyDown);
        window.addEventListener("blur", onBlur);
        return ()=>{
            window.removeEventListener("pointermove", onMove);
            window.removeEventListener("pointerup", onUp);
            window.removeEventListener("pointercancel", onCancel);
            window.removeEventListener("keydown", onKeyDown);
            window.removeEventListener("blur", onBlur);
        };
    }, []);
    // While celebrating, render the popped-down foundation copies so stacks
    // shrink as cards fly; the rest of the board stays frozen at the win.
    const displayState = celebrationFoundations != null ? {
        ...state,
        foundations: celebrationFoundations
    } : state;
    const gameMenu = {
        label: "Game",
        items: [
            {
                label: "Undo",
                shortcut: "Ctrl+Z",
                onClick: doUndo,
                disabled: !canUndo || celebrationFoundations != null
            },
            {
                label: "Deck\u2026",
                onClick: ()=>setDeckOpen(true)
            },
            {
                label: "Deal New Game",
                onClick: ()=>dealNewGame && dealNewGame(),
                disabled: !dealNewGame
            }
        ]
    };
    // sceneTargets: the first-visit boot scene's ghost cursor opens About
    // through this real menu (Stage aims at the data-scene-target attrs
    // and fires real .click()s — only YOUR window carries the tags).
    const helpMenu = {
        label: "Help",
        sceneTarget: "menu-help",
        items: [
            {
                label: "About Solitaire Alone Together\u2026",
                sceneTarget: "menu-help-about",
                onClick: onHelpAbout,
                disabled: !onHelpAbout
            }
        ]
    };
    // Cursor presence: window-local coordinates in the fixed 620x435
    // space, throttled client-side (the server throttles again). The
    // watcher's copy of this window is the same size, so px map 1:1.
    // `down` mirrors the held button; press/release edges send
    // immediately (a throttled-away release would leave watchers seeing
    // a hand stuck holding a card).
    const lastCursorSentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const cursorDownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const lastCursorPosRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // True while our hand is "on the table" (any move/press since the last
    // leave edge). Gates the keepalive below.
    const cursorPresentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const windowCursorPos = (e)=>{
        const root = rootRef.current;
        if (!root) return null;
        const rect = root.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return null;
        return {
            x: Math.round((e.clientX - rect.left) / rect.width * 620),
            y: Math.round((e.clientY - rect.top) / rect.height * 435)
        };
    };
    const sendCursorNow = (pos, down)=>{
        if (!sendCursor || !pos) return;
        lastCursorSentRef.current = performance.now();
        sendCursor(pos.x, pos.y, down);
    };
    const onRootPointerMove = (e)=>{
        if (!sendCursor) return;
        const pos = windowCursorPos(e);
        if (!pos) return;
        lastCursorPosRef.current = pos;
        cursorPresentRef.current = true;
        if (performance.now() - lastCursorSentRef.current < 110) return;
        sendCursorNow(pos, cursorDownRef.current);
    };
    const onCursorPressDown = (e)=>{
        if (e.pointerType === "mouse" && e.button !== 0) return;
        cursorDownRef.current = true;
        const pos = windowCursorPos(e) ?? lastCursorPosRef.current;
        lastCursorPosRef.current = pos;
        cursorPresentRef.current = true;
        sendCursorNow(pos, true);
    };
    // Keepalive: watchers evaporate a cursor 8s after its last frame (a
    // severed player never sends a leave edge, so silence must eventually
    // mean gone). A real idle hand should stay honestly parked, so re-send
    // the last frame every 5s while present; only the leave edge stops it.
    // Hidden-tab throttling means a long-backgrounded hand can blink for
    // watchers — accepted, since that case isn't really "at the table"
    // anyway; this exists for the brief-silence/wifi-blip case.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!sendCursor) return undefined;
        const t = setInterval(()=>{
            const pos = lastCursorPosRef.current;
            if (!cursorPresentRef.current || !pos) return;
            sendCursorNow(pos, cursorDownRef.current);
        }, 5000);
        return ()=>clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sendCursor
    ]);
    // Releases happen anywhere (drags end outside the window), so listen
    // globally while mounted. Idempotent (the down ref gates it), so the
    // drag path calling it early via releaseCursorRef is safe — this
    // listener then no-ops.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const release = ()=>{
            if (!cursorDownRef.current) return;
            cursorDownRef.current = false;
            sendCursorNow(lastCursorPosRef.current, false);
        };
        releaseCursorRef.current = release;
        // Consume the held state and hand back the release coords WITHOUT
        // sending — the caller attaches them to the move message.
        takeReleaseRef.current = ()=>{
            if (!cursorDownRef.current) return null;
            cursorDownRef.current = false;
            const pos = lastCursorPosRef.current;
            return pos ? [
                pos.x,
                pos.y
            ] : null;
        };
        sendCursorRawRef.current = ([x, y], down)=>sendCursorNow({
                x: x,
                y: y
            }, down);
        window.addEventListener("pointerup", release);
        window.addEventListener("pointercancel", release);
        return ()=>{
            window.removeEventListener("pointerup", release);
            window.removeEventListener("pointercancel", release);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($5f6c13e68f433d1b$var$Root, {
        ref: rootRef,
        onPointerDown: (e)=>{
            onCursorPressDown(e);
            onRootPointerDown(e);
        },
        onPointerMove: onRootPointerMove,
        onPointerLeave: ()=>{
            cursorPresentRef.current = false;
            if (sendCursor) sendCursor(-1, -1, false);
        },
        onClickCapture: (e)=>{
            // While a drag is in flight, clicks don't exist: the dragging
            // pointer can't click (its release ends the session first),
            // so any click here is a bystander finger — which must not
            // select a card mid-drag, and MUST not double-tap a card onto
            // a foundation while the board is mid-gesture.
            if (dragSessionRef.current?.active) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            const s = suppressClickRef.current;
            if (!s) return;
            suppressClickRef.current = null; // one shot, echo or not
            if (performance.now() - s.t >= 400) return;
            // The drag's own echo, identified by WHERE it lands — or by
            // WHAT it lands on: a drag must never end with its own card
            // selected, so a click resolving to the dragged-from source
            // inside the window is swallowed even if the coordinates
            // drifted past the proximity check.
            const clickSrc = (0, $819181fac6426bb2$export$5a73d0ce225fce09)(e.target.closest?.("[data-card-source]")?.getAttribute("data-card-source") ?? "");
            if (Math.hypot(e.clientX - s.x, e.clientY - s.y) < 12 || clickSrc && (0, $819181fac6426bb2$export$a814dd72efa359f9)(clickSrc, s.src)) {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $523f633b3aed431a$export$2e2bcd8739ae039), {
                title: title,
                state: displayState,
                selection: selection,
                menus: [
                    gameMenu,
                    helpMenu
                ],
                cardBack: deck,
                disabledControls: disabledControls,
                onControlClick: onControlClick,
                inactive: inactive,
                interactive: true,
                onDrawClick: onDrawClick,
                onWasteClick: onWasteClick,
                onFoundationClick: onFoundationClick,
                onTableauCardClick: onTableauCardClick,
                onTableauEmptyClick: onTableauEmptyClick,
                winCelebration: celebrationFoundations != null ? {
                    foundations: celebrationFoundations.map((f)=>f.map((0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5))),
                    seed: gameId,
                    onPopTop: onPopTop
                } : null
            }),
            drag && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f6c13e68f433d1b$var$GhostClip, {
                "aria-hidden": "true",
                style: {
                    left: drag.clip.left + "px",
                    top: drag.clip.top + "px",
                    width: drag.clip.width + "px",
                    height: drag.clip.height + "px"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f6c13e68f433d1b$var$DragGhost, {
                    ref: ghostRef,
                    "data-drag-ghost": "true",
                    style: {
                        left: drag.x + "px",
                        top: drag.y + "px"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f6c13e68f433d1b$var$GhostRiser, {
                        ref: riserRef,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $819181fac6426bb2$export$2b96b937b2c6f3c7), {
                            cards: drag.cards
                        })
                    })
                })
            }),
            deckOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f6c13e68f433d1b$var$DialogOverlay, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dbf13d94cedcb11$export$2e2bcd8739ae039), {
                    current: deck,
                    onChoose: setDeck,
                    onClose: ()=>setDeckOpen(false)
                })
            })
        ]
    });
}
const $5f6c13e68f433d1b$var$Root = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
`;
// The cards in flight, confined to the FELT: the grabbed card is
// clamped fully inside the green surface (a single card can't leave it
// at all), and a dragged run's fanned tail clips at the felt edge.
// Positioned over the felt rect at drag start; inside the window's own
// stacking context, so overlapping windows still cover it correctly.
const $5f6c13e68f433d1b$var$GhostClip = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  overflow: hidden;
  z-index: 30;
  pointer-events: none;
`;
const $5f6c13e68f433d1b$var$DragGhost = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  pointer-events: none;
`;
// The touch lift's slide-up. NO TRANSFORMS in the local drag path: a
// transform TRANSITION gets promoted to a temporary compositing layer
// for its duration, and inside the compact stage's fractionally-scaled
// subtree that layer's create/destroy re-snaps neighboring cards'
// rasterization. `top` on a relatively-positioned wrapper animates as
// plain repaints instead: no layer, no churn. Mounted at the finger
// (+rise, set imperatively by mountVisuals — never via the React style
// prop, which a mid-drag re-render would re-assert), then eased to 0.
const $5f6c13e68f433d1b$var$GhostRiser = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  transition: top 160ms ease-out;
  pointer-events: none;
`;
const $5f6c13e68f433d1b$var$DialogOverlay = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var $5f6c13e68f433d1b$export$2e2bcd8739ae039 = $5f6c13e68f433d1b$var$PlayableSolitaire;






var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");






function $ec53346e7fcdea16$export$5a8a79c6ad2fc273(gameId) {
    const h = (gameId + 1) * 2654435761 >>> 0;
    return (0, $db9a6e9d90d8f08e$export$15e876c33fed7287)[h % (0, $db9a6e9d90d8f08e$export$15e876c33fed7287).length];
}
// How far (window px) a remote press may land from any card and still
// count as grabbing it. Humans are pixel-exact (same 620x435 space both
// ends); bots aim with jitter — a near-miss snap reads better than a
// hand dragging nothing.
const $ec53346e7fcdea16$var$REMOTE_HIT_RADIUS = 20;
// Remote playback runs through a fixed-delay line (entity
// interpolation): every subscription event — cursor frames, moves,
// undos, terminal — is stamped `arrival + delayMs` and processed in
// order when due, so the whole performance (hand, cards, sounds)
// replays at its true recorded pace, a constant beat late. The drawn
// arrow interpolates between the last processed cursor sample and the
// next queued one: velocity is the player's own, lag is bounded by the
// delay and never accumulates. Press/release edges and the board move
// ride the same stamped timeline, so the hand is AT the card when the
// card moves, by construction. Ghost games need no special casing: the
// wire hides ghost identity and the server paces their replay, so the
// same buffer smooths both.
//
// The wire carries ~12Hz samples with no timestamps; the write pump may
// coalesce frames into one burst. Stamping re-spreads burst-arrived
// motion frames toward the nominal cadence (bounded by PACE_SLACK_MS so
// delay can't creep).
//
// Slowing things down happens HERE, at stamping, never at drawing: a
// motion frame that covers more distance than maxSpeed allows gets its
// stamp pushed later, and every subsequent event clamps to the same
// monotonic timeline, so the drop, the click, and the board change all
// wait for the hand.
//
// Delay depth and speed ceiling vary per game id (deterministic,
// stable per game) and every viewer of a given game shares them — the
// playstyle itself is the player's own recorded motion.
function $ec53346e7fcdea16$var$handFeel(gameId) {
    const h = (gameId + 1) * 0x9e3779b1 >>> 0;
    const u = (h & 0xffff) / 0xffff;
    const v = (h >>> 16 & 0xffff) / 0xffff;
    return {
        delayMs: 160 + u * 60,
        // Hands never appear to move faster than this (window-local px/s).
        // Enforced by time-stretch at stamping, so raising/lowering it
        // slows or speeds the WHOLE performance in sync — this is the
        // "everything a little slower/faster" knob.
        maxSpeed: 550 + v * 200
    };
}
// Server-side cursor relay cadence is ~12Hz (~85ms). Motion frames
// that arrive closer together than the cadence allows were coalesced
// in transit — re-space them at stamping so the hand glides through
// instead of teleporting…
const $ec53346e7fcdea16$var$BURST_MIN_GAP_MS = 40;
// …but never let re-spacing or speed-limit stretching push a stamp
// more than this past its nominal `arrival + delayMs` slot. Bounds
// the total delay under sustained fast motion; the buffer recovers
// during the player's pauses (solitaire is mostly pauses).
const $ec53346e7fcdea16$var$PACE_SLACK_MS = 350;
// Non-motion events (press/release edges, moves, undos, endings)
// stamped within this window of the previous stamp share it EXACTLY.
// The release edge and its move arrive in one task (PROTOCOL.md §4);
// sharing a stamp keeps them in one drain pass. This is HALF of the
// no-drop-flicker guarantee — the other half is the flushSync around
// the drain (see tick), which commits that pass's React updates
// before the frame paints. Do not remove either without restoring
// the guarantee some other way.
const $ec53346e7fcdea16$var$STAMP_MERGE_MS = 8;
// An ARRIVAL gap between cursor samples longer than this is a real
// pause, not the frame cadence: hold the hand, then close the
// distance with an eased reach (duration scaled to the distance at
// the hand's speed ceiling) instead of drifting across the silence.
const $ec53346e7fcdea16$var$PAUSE_GAP_MS = 250;
const $ec53346e7fcdea16$var$REACH_MIN_MS = 140;
const $ec53346e7fcdea16$var$REACH_MAX_MS = 600;
// Smoothstep's peak velocity is 1.5x its average: pad the reach
// duration by the same factor so even mid-reach the hand honors the
// game's speed ceiling (very long reaches cap at REACH_MAX_MS and may
// briefly exceed it — a decisive move after a think).
const $ec53346e7fcdea16$var$REACH_PEAK_FACTOR = 1.5;
const $ec53346e7fcdea16$var$clampGhost = (v, lo, hi)=>Math.min(Math.max(v, lo), Math.max(lo, hi));
// Someone else's game, watched over the wire. Pure subscriber — engine
// state is owned by useSolitaireServer, which reduces incoming moves once
// and fans them out here.
//
// The wire carries the player's cursor with its button state, and
// press/release edges are never dropped or throttled (server/PROTOCOL.md).
// This component replays those frames
// through the same drag-presentation kit the player's own board uses —
// hit-test the press against the rendered cards, lift them into a ghost
// that rides the remote cursor, drop on release. The move itself arrives
// as its own message right after the release edge (§4 ordering), so the
// board snaps to truth the moment the hand lets go; if no move follows,
// the drag was abandoned and the restored cards already ARE the truth.
// Click-without-drag shows the selection wash, exactly like at home.
function $ec53346e7fcdea16$var$SpectatedSolitaire({ title: title, gameId: gameId, subscribeGame: subscribeGame, generation: // Machine identity generation from the hook: bumps when this id's
// machine was rebuilt from scratch (ghost replays reuse historical
// numbers). Re-runs the subscription effect so a frozen terminal
// instance re-arms instead of silently wearing a different game's id.
generation = 0, inactive: // Injected by the Stage (desktop shell): focus, title-bar buttons,
// and the Help → About hook.
inactive = true, onControlClick: onControlClick, onHelpAbout: onHelpAbout, ambientSound: ambientSound = true, disabledControls: // Fired when a won game's cascade has fully played out here — the
// Desktop greys only maximize; compact also greys minimize (the
// Other Games grid has nowhere to minimize to).
disabledControls = [
    "maximize"
], onDeparted: // Desktop windows only: fired when this game's departure has fully
// played (the close ritual for a loss/abandon, the cascade for a
// win). The shell then closes the window; the server redeals the
// seat after its beat. Browse-grid slots omit it and keep their
// ended-stub behavior.
onDeparted = null }) {
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // The player's mouse inside their own window (their screen, their
    // cursor). Live-only presence: hidden when they leave the window or
    // go quiet for a while.
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Click-select mirrored from their press/release (cleared by the next
    // press or by any move — same lifecycle as the real selection).
    const [selection, setSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // {cards, offX, offY} while their drag is in flight; position derives
    // from the interpolated cursor, so ghost and arrow travel together.
    const [lift, setLift] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // {stacks, startedAtMs} while THEIR win cascade plays (the hook keeps
    // a won neighbor mounted until we report the cascade done, so watchers
    // get the whole show). stacks: foundations copies the cascade drains;
    // startedAtMs: performance.now-domain epoch of the win — witnessed
    // live it's "now", but a window mounted mid-show (All Active Games
    // opened during the cascade) sets it in the past so WinCelebration
    // fast-forwards to the frame every other viewer is on.
    const [celebration, setCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const stateRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    stateRef.current = state;
    // Live press being tracked: {x, y, src, grabEl, dragging, hidden[]}.
    const pressRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const downRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    // Once a game ends, late frames are noise: live cursor updates during
    // the terminal beat could otherwise make a frozen final board look live.
    const terminalRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    // The close ritual (terminal desktop windows): timers + one-shot guard.
    const closingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const closeTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Last live hand position, so the ritual's walk starts from wherever
    // the player's cursor actually was.
    const lastCursorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The delay line (see the block comment above handFeel): stamped
    // items pending processing, in stamp order. Wire items are
    // {at, event}; the close ritual pushes synthetic {at, ritual:true,
    // x, y, down} samples through the same pipe so it glides too.
    const queueRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    // Monotonic stamping state: the last stamp handed out, and the down
    // state as of the last stamped cursor frame (press/release edges are
    // order-clamped but never re-spaced — edges must not drift).
    const lastStampRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const stampDownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    // The drawn hand: prevSampleRef is the last PROCESSED cursor sample
    // ({at, x, y} — the interpolation segment's start), drawnRef the
    // position actually painted this frame. The rAF loop writes straight
    // to the arrow/ghost DOM nodes so 60fps motion never re-renders React.
    const prevSampleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const drawnRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const arrowElRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const ghostElRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const liftRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    liftRef.current = lift;
    // Hand hide (and the won/celebration paths) go through here; showing
    // happens in processItem, where the stamped time is known.
    const setHand = (p)=>{
        if (!p) {
            prevSampleRef.current = null;
            drawnRef.current = null;
        }
        setCursor(p);
    };
    // Paint the hand (and any lifted cards riding it) at a window-local
    // point. The single writer for arrow/ghost position.
    const drawHand = (x, y)=>{
        drawnRef.current = {
            x: x,
            y: y
        };
        const arrowEl = arrowElRef.current;
        if (arrowEl) {
            arrowEl.style.setProperty("--rx", x + "px");
            arrowEl.style.setProperty("--ry", y + "px");
        }
        const l = liftRef.current;
        const ghostEl = ghostElRef.current;
        if (l && ghostEl) {
            const { gx: gx, gy: gy } = ghostXY({
                x: x,
                y: y
            }, l);
            ghostEl.style.setProperty("--gx", gx + "px");
            ghostEl.style.setProperty("--gy", gy + "px");
        }
    };
    // Window-space (620x435) → client px, via the rendered rect (handles
    // the scaled-down copies: mobile Other Games, All Active Games).
    const toClient = (x, y)=>{
        const root = rootRef.current;
        if (!root) return null;
        const r = root.getBoundingClientRect();
        if (r.width === 0) return null;
        const scale = r.width / 620;
        return {
            x: r.left + x * scale,
            y: r.top + y * scale,
            rect: r,
            scale: scale
        };
    };
    const dropLift = ()=>{
        const p = pressRef.current;
        if (p && p.hidden.length) (0, $819181fac6426bb2$export$bf29272de9e9a11)(p.hidden);
        pressRef.current = null;
        setLift(null);
    };
    // Lifted cards ride the hand, confined to the felt (top card clamped
    // fully inside). Shared by the React render (mount position) and the
    // rAF follower (motion) so both draw from the same math.
    const ghostXY = (pt, l)=>({
            gx: $ec53346e7fcdea16$var$clampGhost(pt.x - l.offX, l.felt.x, l.felt.x + l.felt.w - l.cardW) - l.felt.x,
            gy: $ec53346e7fcdea16$var$clampGhost(pt.y - l.offY, l.felt.y, l.felt.y + l.felt.h - l.cardH) - l.felt.y
        });
    // The departure ceremony: the ghost hand walks up to the titlebar X
    // and clicks it, then the window closes and the server redeals the
    // seat after its beat. Clearer than a blink-out — "they closed their
    // game."
    const beginCloseRitual = ()=>{
        if (closingRef.current) return;
        closingRef.current = true;
        dropLift();
        setSelection(null);
        // Start from wherever the hand is actually DRAWN right now (it may
        // be mid-glide behind the last raw frame), else its last known
        // spot, else mid-window.
        const from = drawnRef.current ?? lastCursorRef.current ?? {
            x: 310,
            y: 240
        };
        const to = {
            x: 601,
            y: 12
        }; // the Close button, window-local px
        // Hidden tab: the rAF loop that walks the queue is parked and no
        // further wire events will arrive (the game is over), so queued
        // waypoints would stall forever. Nobody's watching — skip the walk
        // and close after a beat.
        if (document.hidden) {
            queueRef.current.length = 0;
            closeTimerRef.current = setTimeout(()=>{
                if (onDeparted) onDeparted();
            }, 1000);
            return;
        }
        // The walk rides the same delay-line queue as live frames: synthetic
        // smoothstepped waypoints, glided between by the interpolator. Any
        // undelivered live items are moot — the game is over.
        const q = queueRef.current;
        q.length = 0;
        const now = performance.now();
        prevSampleRef.current = {
            at: now,
            x: from.x,
            y: from.y
        };
        setCursor({
            x: from.x,
            y: from.y,
            down: false
        });
        const STEPS = 6;
        for(let i = 1; i <= STEPS; i++){
            const t = i / STEPS;
            const k = t * t * (3 - 2 * t); // smoothstep: settle, don't slam
            q.push({
                at: now + i * 130,
                ritual: true,
                x: from.x + (to.x - from.x) * k,
                y: from.y + (to.y - from.y) * k,
                down: false
            });
        }
        // The click on the X, held long enough to read (processItem fires
        // onDeparted 450ms after this sample lands), then the window goes.
        q.push({
            at: now + STEPS * 130 + 170,
            ritual: true,
            x: to.x,
            y: to.y,
            down: true,
            press: true
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>clearTimeout(closeTimerRef.current), []);
    const onCursorFrame = (c)=>{
        const wasDown = downRef.current;
        downRef.current = c.down;
        if (c.down && !wasDown) {
            // Press edge: a new press always re-evaluates the selection (and
            // settles any ghost still waiting out its post-release hold).
            dropLift();
            setSelection(null);
            const pt = toClient(c.x, c.y);
            const hit = pt && (0, $819181fac6426bb2$export$bed061c40191b04a)(rootRef.current, pt.x, pt.y, $ec53346e7fcdea16$var$REMOTE_HIT_RADIUS * pt.scale);
            pressRef.current = hit ? {
                x: c.x,
                y: c.y,
                src: hit.src,
                grabEl: hit.el,
                dragging: false,
                hidden: []
            } : null;
            return;
        }
        if (!c.down && wasDown) {
            // Release edge. A release that completed a MOVE arrives embedded
            // in the move message (c on the move frame — PROTOCOL.md §4), so
            // this handler and the board update run in the same task → one
            // commit → no origin-flash. A BARE release edge therefore means
            // the drag was abandoned: snap home immediately.
            const p = pressRef.current;
            if (p) {
                if (p.dragging) dropLift();
                else {
                    pressRef.current = null;
                    setSelection(p.src);
                }
            }
            return;
        }
        // Motion while held: crossing the threshold lifts the cards.
        const p = pressRef.current;
        if (!c.down || !p || p.dragging) return;
        if (Math.hypot(c.x - p.x, c.y - p.y) < (0, $819181fac6426bb2$export$a98f18492ccbcfdf)) return;
        const pt = toClient(0, 0);
        const s = stateRef.current;
        if (!pt || !s) return;
        const er = p.grabEl.getBoundingClientRect();
        p.dragging = true;
        // Felt rect + card size in window-local px: the ghost is confined
        // to the felt exactly like the dragger's own view (top card clamped
        // fully inside; a run's fanned tail clips at the felt edge).
        const feltEl = rootRef.current.querySelector("[data-felt]");
        const fr = (feltEl ?? rootRef.current).getBoundingClientRect();
        // Ghost first, hide second — same anti-flicker order as the real
        // drag (this runs from a websocket message, another native context
        // where React's flush can miss a paint).
        (0, $1u0KT.flushSync)(()=>{
            setLift({
                cards: (0, $819181fac6426bb2$export$9e1cd1aeed37a9fb)(s, p.src),
                offX: p.x - (er.left - pt.rect.left) / pt.scale,
                offY: p.y - (er.top - pt.rect.top) / pt.scale,
                felt: {
                    x: (fr.left - pt.rect.left) / pt.scale,
                    y: (fr.top - pt.rect.top) / pt.scale,
                    w: fr.width / pt.scale,
                    h: fr.height / pt.scale
                },
                cardW: er.width / pt.scale,
                cardH: er.height / pt.scale
            });
        });
        p.hidden = (0, $819181fac6426bb2$export$8942935387d2cf41)(rootRef.current, p.src, p.grabEl);
        (0, $819181fac6426bb2$export$94ea06b00f779d4b)(p.hidden);
    };
    // The live subscribe handle, kept for onCascadeDone: a finished
    // cascade reports back so a browse-grid celebration's deferred
    // teardown can land (no-op for watched desktop windows).
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        terminalRef.current = false;
        closingRef.current = false;
        clearTimeout(closeTimerRef.current);
        queueRef.current = [];
        lastStampRef.current = 0;
        stampDownRef.current = false;
        prevSampleRef.current = null;
        drawnRef.current = null;
        const feel = $ec53346e7fcdea16$var$handFeel(gameId);
        // They WON. Play their cascade in this window — the piece's one
        // gift, witnessed from the next table over. A real win has full
        // foundations; the ?spectatewin dev knob fakes the ending on a
        // mid-game board, so synthesize a full set there (mirrors the
        // ?celebrate knob on the player's own board). elapsedMs > 0 means
        // we're joining a show already in flight.
        const startCelebration = (board, elapsedMs)=>{
            const s = board;
            const founds = s && (0, $73d8f6063558c0ab$export$34b9657cfbb2ea8e)(s) ? s.foundations.map((f)=>f.slice()) : [
                0,
                1,
                2,
                3
            ].map((suit)=>Array.from({
                    length: 13
                }, (_, rank)=>suit * 13 + rank));
            setCelebration({
                stacks: founds,
                startedAtMs: performance.now() - elapsedMs
            });
        };
        // Process one due item from the delay line. Everything a spectator
        // sees or hears happens here, at the item's stamped time.
        const processItem = (item)=>{
            if (item.ritual) {
                // Synthetic close-ritual waypoint: position only (the queue
                // was cleared of wire items when the ritual began).
                prevSampleRef.current = {
                    at: item.at,
                    x: item.x,
                    y: item.y
                };
                setCursor({
                    x: item.x,
                    y: item.y,
                    down: item.down
                });
                if (item.press) // The click on the X, held long enough to read, then the
                // window actually goes.
                closeTimerRef.current = setTimeout(()=>{
                    if (onDeparted) onDeparted();
                }, 450);
                return;
            }
            const event = item.event;
            if (terminalRef.current) return;
            if (event.cursor) {
                if (event.cursor.x < 0) {
                    // Their hand left the window (the leave frame carries
                    // down=false, so any drag already dropped above).
                    onCursorFrame({
                        x: 0,
                        y: 0,
                        down: false
                    });
                    lastCursorRef.current = null;
                    setHand(null);
                } else {
                    onCursorFrame(event.cursor);
                    lastCursorRef.current = event.cursor;
                    prevSampleRef.current = {
                        at: item.at,
                        x: event.cursor.x,
                        y: event.cursor.y
                    };
                    // A hand APPEARING snaps to its first sample — never a
                    // glide in from stale coordinates.
                    if (!drawnRef.current) drawHand(event.cursor.x, event.cursor.y);
                    setCursor(event.cursor);
                }
                return;
            }
            if (event.terminal) {
                terminalRef.current = true;
                dropLift();
                setSelection(null);
                if (event.reason === "won") {
                    // Their hand leaves the frame for the show — a cursor parked
                    // over a cascade reads as a stuck spectator, not a winner.
                    downRef.current = false;
                    setHand(null);
                    // event.curState, NOT stateRef: the machine applied the
                    // winning move synchronously, but the write pump coalesces
                    // that move with game_ended into one frame batch — React
                    // hasn't re-rendered between them, so stateRef still holds
                    // the pre-win board, isWon() would fail, and the spectator's
                    // cascade would fall back to canonical suit-ordered
                    // foundations instead of the winner's real ace order.
                    startCelebration(event.curState ?? stateRef.current, event.wonElapsedMs ?? 0);
                } else if (event.reason && onDeparted) {
                    // A desktop window: they left, so their hand closes the
                    // window (onDeparted fires when the press lands).
                    downRef.current = false;
                    beginCloseRitual();
                } else {
                    downRef.current = false;
                    setHand(null);
                }
                return;
            }
            // A move/undo means the world changed: any in-flight drag is
            // over (restore BEFORE the re-render reuses those nodes) and the
            // selection it came from is stale.
            dropLift();
            setSelection(null);
            // Hands at nearby tables: a neighbor placing a card is just barely
            // audible. Draws stay silent — six tables of stock-flipping would
            // be patter, not ambience.
            if (ambientSound && event.move && event.move.type === (0, $73d8f6063558c0ab$export$93cd7006288e3b81).MOVE) (0, $ffdb7a25fbb7044c$export$35a597aa3b97208a)(0.12);
            setState(event.curState);
        };
        // Stamp an arriving wire event into the delay line, preserving
        // arrival order (FIFO is a protocol invariant — never reorder).
        // Last stamped cursor position + arrival time: the speed-limit
        // stretch and the pause (reach) detection both key off arrivals,
        // not stamps. Reset on leave so nothing stretches or reaches
        // across a disappearance.
        let lastPos = null;
        let lastCursorArrival = -Infinity;
        const enqueue = (event)=>{
            // Hidden tab: rAF is parked, so the queue would pile up while
            // the board froze. Nobody can see smoothness there — flush and
            // apply immediately instead.
            if (document.hidden) {
                const q = queueRef.current;
                while(q.length)processItem(q.shift());
                processItem({
                    at: performance.now(),
                    event: event
                });
                return;
            }
            const now = performance.now();
            let at = now + feel.delayMs;
            const c = event.cursor;
            const isMotion = !!c && c.x >= 0 && c.down === stampDownRef.current;
            if (isMotion && lastPos) {
                // Pure motion frame (no press/release edge): re-space
                // burst-arrived frames toward the wire cadence, and stretch
                // time so the hand never covers ground faster than its speed
                // ceiling — everything downstream clamps to the same
                // timeline, so the whole performance slows together. Bounded
                // so total delay can't creep.
                const dist = Math.hypot(c.x - lastPos.x, c.y - lastPos.y);
                at = Math.max(at, lastStampRef.current + $ec53346e7fcdea16$var$BURST_MIN_GAP_MS, lastStampRef.current + dist / feel.maxSpeed * 1000);
                at = Math.min(at, now + feel.delayMs + $ec53346e7fcdea16$var$PACE_SLACK_MS);
            }
            at = Math.max(at, lastStampRef.current);
            // Edges, moves, undos, endings: share the previous stamp when
            // they arrived on its heels (see STAMP_MERGE_MS — this is the
            // no-flicker guarantee for release + move).
            if (!isMotion && at - lastStampRef.current < $ec53346e7fcdea16$var$STAMP_MERGE_MS) at = lastStampRef.current;
            const item = {
                at: at,
                event: event
            };
            if (c) {
                stampDownRef.current = c.x < 0 ? false : c.down;
                if (c.x >= 0) {
                    // A long silence since the last sample ARRIVED is a real
                    // pause — the interpolator holds, then reaches.
                    item.reach = lastPos && now - lastCursorArrival > $ec53346e7fcdea16$var$PAUSE_GAP_MS;
                    lastPos = {
                        x: c.x,
                        y: c.y
                    };
                    lastCursorArrival = now;
                } else lastPos = null;
            }
            lastStampRef.current = at;
            queueRef.current.push(item);
        };
        const handle = subscribeGame(gameId, enqueue);
        setState(handle.state ?? null);
        // The playback loop: drain due items, then paint the hand at its
        // interpolated position along the stamped timeline — between the
        // last processed sample and the next queued one, so the drawn
        // arrow and the game logic share one clock and the hand is AT the
        // card when the card moves.
        let raf;
        const tick = (now)=>{
            const q = queueRef.current;
            if (q.length && q[0].at <= now) // flushSync, NOT a plain loop: processing pairs direct-DOM
            // mutations (hide/restore of the dragged cards) with React
            // state updates (ghost unmount, board change). We are inside
            // rAF — the browser paints immediately after this task, and
            // React's default flush from here is a scheduled macrotask
            // that runs only AFTER that paint. Without the sync commit,
            // every remote drop would paint one frame with the restored
            // cards back at their origin and the board not yet advanced.
            // With it, everything a drain does lands in a single paint.
            // STAMP_MERGE_MS is the
            // other half of the guarantee: it keeps a release edge and its
            // move in the same drain.
            (0, $1u0KT.flushSync)(()=>{
                while(q.length && q[0].at <= now)processItem(q.shift());
            });
            const prev = prevSampleRef.current;
            if (prev) {
                let next = null;
                for (const it of q){
                    if (it.ritual) {
                        next = it;
                        break;
                    }
                    const c = it.event.cursor;
                    if (c && c.x >= 0) {
                        next = {
                            at: it.at,
                            x: c.x,
                            y: c.y,
                            reach: it.reach
                        };
                        break;
                    }
                    // A queued leave frame: hold — never glide toward a
                    // position on the far side of a disappearance.
                    if (c) break;
                }
                let x = prev.x;
                let y = prev.y;
                if (next && next.at > prev.at) {
                    let start = prev.at;
                    if (next.reach) {
                        // After a real pause: hold, then close the distance with
                        // an eased reach paced to the hand's speed ceiling.
                        const dist = Math.hypot(next.x - prev.x, next.y - prev.y);
                        const reachMs = Math.min($ec53346e7fcdea16$var$REACH_MAX_MS, Math.max($ec53346e7fcdea16$var$REACH_MIN_MS, dist / feel.maxSpeed * 1000 * $ec53346e7fcdea16$var$REACH_PEAK_FACTOR));
                        start = Math.max(prev.at, next.at - reachMs);
                    }
                    let t = (now - start) / (next.at - start);
                    t = Math.min(Math.max(t, 0), 1);
                    if (next.reach) t = t * t * (3 - 2 * t);
                    x = prev.x + (next.x - prev.x) * t;
                    y = prev.y + (next.y - prev.y) * t;
                }
                // Parked hands write nothing — a room of settled mice costs
                // no style churn.
                const d = drawnRef.current;
                if (!d || d.x !== x || d.y !== y) drawHand(x, y);
            }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        // Tab going hidden parks the rAF loop mid-queue: flush everything
        // due-or-not so the board stays truthful while nobody's watching
        // (new arrivals take the immediate path in enqueue).
        const onHide = ()=>{
            if (!document.hidden) return;
            const q = queueRef.current;
            while(q.length)processItem(q.shift());
        };
        document.addEventListener("visibilitychange", onHide);
        handleRef.current = handle;
        // Mounted mid-show: the terminal won event fired before this window
        // existed (All Active Games opened during a neighbor's cascade). The
        // handle carries how far the show has run — join it in progress.
        if (handle.celebrationElapsedMs != null && handle.state) {
            terminalRef.current = true;
            startCelebration(handle.state, handle.celebrationElapsedMs);
        }
        return ()=>{
            handleRef.current = null;
            handle.unsubscribe();
            cancelAnimationFrame(raf);
            document.removeEventListener("visibilitychange", onHide);
            queueRef.current = [];
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gameId,
        generation,
        subscribeGame,
        ambientSound
    ]);
    // Quiet mice evaporate — nobody's hand hovers motionless for 8s. A
    // stale lift can't outlive its hand (belt-and-braces; the release
    // edge is must-deliver, but a severed player never sends one).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // The ritual owns the hand once it starts — evaporation must not
        // blank it mid-walk or mid-press.
        if (!cursor || closingRef.current) return undefined;
        const t = setTimeout(()=>{
            dropLift();
            downRef.current = false;
            setHand(null);
        }, 8000);
        return ()=>clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cursor
    ]);
    if (!state) return null;
    // While their cascade plays, render the popped-down foundation copies
    // so stacks shrink under the flying cards (same trick as the player's
    // own board). The rest of the board is bare felt: a real win emptied
    // it move by move, but the ?spectatewin knob fakes the ending on a
    // mid-game board, so wipe it explicitly either way.
    const displayState = celebration != null ? {
        ...state,
        foundations: celebration.stacks,
        tableau: state.tableau.map(()=>({
                faceDown: [],
                faceUp: []
            })),
        waste: [],
        stock: []
    } : state;
    const onPopTop = (foundationIdx)=>{
        setCelebration((prev)=>{
            if (!prev) return prev;
            const stacks = prev.stacks.map((f)=>f.slice());
            stacks[foundationIdx].pop();
            return {
                ...prev,
                stacks: stacks
            };
        });
    };
    const onCascadeDone = ()=>{
        setCelebration(null);
        if (handleRef.current?.cascadeDone) handleRef.current.cascadeDone();
        // A won desktop window departs once its show is over; the server
        // redeals the seat after the celebration window.
        if (onDeparted) onDeparted();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ec53346e7fcdea16$var$Root, {
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $523f633b3aed431a$export$2e2bcd8739ae039), {
                title: title,
                state: displayState,
                selection: selection,
                winCelebration: celebration != null ? {
                    foundations: celebration.stacks.map((f)=>f.map((0, $73d8f6063558c0ab$export$d5d748e1f5ede0c5))),
                    seed: gameId,
                    startedAtMs: celebration.startedAtMs,
                    onPopTop: onPopTop,
                    onDone: onCascadeDone
                } : null,
                // The real Solitaire application icon is shared by every game window.
                titleIcon: "solitaire",
                cardBack: $ec53346e7fcdea16$export$5a8a79c6ad2fc273(gameId),
                interactive: false,
                inactive: inactive,
                // Not your game: the Game menu is honestly grey. Help still works.
                menus: [
                    {
                        label: "Game",
                        disabled: true
                    },
                    {
                        label: "Help",
                        items: [
                            {
                                label: "About Solitaire Alone Together\u2026",
                                onClick: onHelpAbout,
                                disabled: !onHelpAbout
                            }
                        ]
                    }
                ],
                // Minimize and close work on neighbors now (close = stop watching);
                // maximize stays honestly disabled everywhere.
                disabledControls: disabledControls,
                pressedControls: closingRef.current && cursor?.down ? [
                    "close"
                ] : undefined,
                onControlClick: onControlClick
            }),
            lift && cursor && (()=>{
                // Mount at the DRAWN position, not the raw frame — the rAF
                // loop owns motion from here; React re-renders (12Hz frames,
                // board updates) must re-assert the same point or the ghost
                // would flicker between interpolated and raw.
                const { gx: gx, gy: gy } = ghostXY(drawnRef.current ?? cursor, lift);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec53346e7fcdea16$var$RemoteGhostClip, {
                    "aria-hidden": "true",
                    style: {
                        left: lift.felt.x + "px",
                        top: lift.felt.y + "px",
                        width: lift.felt.w + "px",
                        height: lift.felt.h + "px"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec53346e7fcdea16$var$RemoteGhost, {
                        ref: ghostElRef,
                        "data-remote-ghost": "true",
                        style: {
                            "--gx": gx + "px",
                            "--gy": gy + "px"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $819181fac6426bb2$export$2b96b937b2c6f3c7), {
                            cards: lift.cards
                        })
                    })
                });
            })(),
            cursor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec53346e7fcdea16$var$RemoteCursor, {
                ref: arrowElRef,
                style: {
                    "--rx": (drawnRef.current ?? cursor).x + "px",
                    "--ry": (drawnRef.current ?? cursor).y + "px"
                },
                "data-pressed": cursor.down ? "true" : undefined,
                viewBox: "0 0 12 19",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M1 1 L1 15 L4.5 12 L7 18 L9.5 17 L7 11 L11 11 Z",
                    fill: "#c9c9c9",
                    stroke: "#000",
                    strokeWidth: "1"
                })
            })
        ]
    });
}
const $ec53346e7fcdea16$var$Root = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  /* Size to the fixed 620x435 window inside, NOT the ambient width —
     as a plain block this clipped scaled-down copies (mobile Other
     Games, All Active Games) to their footprint width before the transform. */
  width: fit-content;
  height: fit-content;
  /* The remote arrow stops at the window edge, like a real screen. */
  overflow: hidden;
`;
// Their cards in flight, riding the SAME smoothed follower as the
// arrow, so hand and cards travel as one gesture. Below the arrow,
// above the board; confined to the felt exactly like the dragger's
// own view (clamped top card, clipped run tail).
const $ec53346e7fcdea16$var$RemoteGhostClip = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  overflow: hidden;
  z-index: 25;
  pointer-events: none;
`;
const $ec53346e7fcdea16$var$RemoteGhost = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(var(--gx), var(--gy));
  /* No CSS transition: the rAF delay-line interpolator owns motion (a
     retargeted linear transition is exactly the sprint/stall this
     replaced). */
  pointer-events: none;
`;
// Their arrow, on their screen. The delay-line interpolator above glides
// it between ~12Hz frames so travel reads as motion, not teleports (see
// the block comment above handFeel); clipped by the window (overflow)
// like a real screen edge. Grey and translucent — a stranger's cursor
// on their own screen, seen through the glass (grey body over lowered
// opacity so it doesn't disappear into the felt). Presses shrink
// slightly so clicks and drags read as clicks and drags rather than a
// hovering arrow while cards mysteriously move.
const $ec53346e7fcdea16$var$RemoteCursor = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).svg`
  position: absolute;
  left: 0;
  top: 0;
  width: 15px;
  height: 24px;
  opacity: 0.9;
  transform: translate(var(--rx), var(--ry));
  z-index: 30;
  pointer-events: none;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.35));

  &[data-pressed="true"] {
    transform: translate(var(--rx), var(--ry)) scale(0.92);
  }
`;
var // Memoized: All Active Games re-renders on every scroll frame, and a
// dozen-plus full boards re-rendering per frame is the difference between
// smooth and janky scrolling on weak machines. Callers keep prop
// identities stable (module-const arrays, useCallback handlers) so the
// shallow compare actually holds.
$ec53346e7fcdea16$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($ec53346e7fcdea16$var$SpectatedSolitaire);






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




const $b9747e1bfffdb7e5$export$29da88b03c854821 = "saat.kiosk";
const $b9747e1bfffdb7e5$var$CLOCK_CLICKS = 10;
// Max gap between consecutive clicks for the run to keep counting.
const $b9747e1bfffdb7e5$var$CLOCK_CLICK_GAP_MS = 1000;
function $b9747e1bfffdb7e5$export$85001a6be391bd58() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has("kiosk")) return;
    const raw = params.get("kiosk");
    (0, $213c0628df7e524f$export$4e0ecc6c4b6d7004)($b9747e1bfffdb7e5$export$29da88b03c854821, !(raw === "off" || raw === "0"));
}
function $b9747e1bfffdb7e5$export$bb6482adf8fb51dc() {
    return (0, $213c0628df7e524f$export$2e2bcd8739ae039)($b9747e1bfffdb7e5$export$29da88b03c854821, false)[0] === true;
}
// Returns the clock's click handler. Module-level run state: there is
// exactly one taskbar clock.
let $b9747e1bfffdb7e5$var$run = 0;
let $b9747e1bfffdb7e5$var$lastAt = 0;
function $b9747e1bfffdb7e5$export$8f48318ca2b6728b() {
    const now = performance.now();
    $b9747e1bfffdb7e5$var$run = now - $b9747e1bfffdb7e5$var$lastAt <= $b9747e1bfffdb7e5$var$CLOCK_CLICK_GAP_MS ? $b9747e1bfffdb7e5$var$run + 1 : 1;
    $b9747e1bfffdb7e5$var$lastAt = now;
    if ($b9747e1bfffdb7e5$var$run < $b9747e1bfffdb7e5$var$CLOCK_CLICKS) return;
    $b9747e1bfffdb7e5$var$run = 0;
    (0, $213c0628df7e524f$export$4e0ecc6c4b6d7004)($b9747e1bfffdb7e5$export$29da88b03c854821, (0, $213c0628df7e524f$export$5e210d233dcded1b)($b9747e1bfffdb7e5$export$29da88b03c854821, false) !== true);
}



// The Win95 taskbar: Start button, one button per open window, clock tray.
// Purely presentational — the Stage owns which windows exist, which is
// focused, and whether the Start menu is open.
//
// Sits in unzoomed-viewport space at the bottom of the screen. The bar is
// always full-width; window buttons shrink to fit like the real thing.
function $d2026809cde12e7e$var$formatClock(date) {
    let h = date.getHours();
    const suffix = h < 12 ? "AM" : "PM";
    h = h % 12 || 12;
    const m = String(date.getMinutes()).padStart(2, "0");
    return `${h}:${m} ${suffix}`;
}
function $d2026809cde12e7e$var$useClock() {
    const [now, setNow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Date());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // Tick on the minute boundary so the clock is never visibly stale.
        let timeout;
        const schedule = ()=>{
            const ms = 60000 - Date.now() % 60000 + 50;
            timeout = setTimeout(()=>{
                setNow(new Date());
                schedule();
            }, ms);
        };
        schedule();
        return ()=>clearTimeout(timeout);
    }, []);
    return now;
}
// The tray speaker: click for a little Win95 volume popup (slider +
// Mute). Shares state with the Settings panel via the setting event.
function $d2026809cde12e7e$var$TrayVolume() {
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [volSetting] = (0, $213c0628df7e524f$export$2e2bcd8739ae039)("saat.volume", (0, $ffdb7a25fbb7044c$export$f3d6704bb885c205)());
    const vol = volSetting ?? 0.5;
    const lastNonZeroRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(vol > 0 ? vol : 0.5);
    // Effect, not render-time write: StrictMode double-renders would make
    // a render-phase ref mutation observably impure.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (vol > 0) lastNonZeroRef.current = vol;
    }, [
        vol
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$TrayVolumeWrap, {
        onMouseDown: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$TrayButton, {
                type: "button",
                "aria-label": "Volume",
                title: "Volume",
                onClick: ()=>{
                    (0, $ffdb7a25fbb7044c$export$64ef1bee2b9504c1)();
                    setOpen((v)=>!v);
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "speaker",
                        size: 16
                    }),
                    vol === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$MuteX, {
                        "aria-hidden": "true",
                        children: "\xd7"
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$PopupBackdrop, {
                onMouseDown: ()=>setOpen(false)
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$VolumePopup, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$VolumeTitle, {
                        children: "Volume"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$MidRow, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$Wedge, {
                                viewBox: "0 0 14 84",
                                width: "14",
                                height: "84",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                                    points: "1,2 12,2 12,82",
                                    fill: "#fff",
                                    stroke: "#808080",
                                    strokeWidth: "1"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$TrackBox, {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$VSlider, {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "range",
                                        className: "has-box-indicator",
                                        "aria-label": "Volume",
                                        min: "0",
                                        max: "100",
                                        value: Math.round(vol * 100),
                                        onChange: (e)=>(0, $ffdb7a25fbb7044c$export$246e658b67178cb0)(parseInt(e.target.value, 10) / 100),
                                        // The real thing dings when you let go of the
                                        // slider, so you hear the level you just picked.
                                        onPointerUp: (0, $ffdb7a25fbb7044c$export$b101e1013980b7df),
                                        onKeyUp: (e)=>{
                                            if (e.key.startsWith("Arrow")) (0, $ffdb7a25fbb7044c$export$b101e1013980b7df)();
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$MuteRow, {
                        className: "field-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "tray-mute",
                                type: "checkbox",
                                checked: vol === 0,
                                onChange: (e)=>(0, $ffdb7a25fbb7044c$export$246e658b67178cb0)(e.target.checked ? 0 : lastNonZeroRef.current)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                htmlFor: "tray-mute",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("u", {
                                        children: "M"
                                    }),
                                    "ute"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $d2026809cde12e7e$var$Taskbar({ windows: windows = [], onWindowClick: onWindowClick, onWindowContextMenu: onWindowContextMenu, startOpen: startOpen = false, onStartToggle: onStartToggle, className: className }) {
    const now = $d2026809cde12e7e$var$useClock();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$Bar, {
        className: [
            "window",
            className
        ].filter(Boolean).join(" "),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$StartButton, {
                type: "button",
                "data-open": startOpen ? "true" : undefined,
                "data-scene-target": "start",
                onClick: onStartToggle,
                // The Stage's outside-click handler closes the menu; stop the
                // mousedown here so opening and closing don't fight.
                onMouseDown: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$StartGlyph, {
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {})
                        ]
                    }),
                    "Start"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$Divider, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$WindowButtons, {
                children: windows.map((w)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$WindowButton, {
                        type: "button",
                        "data-active": w.active ? "true" : undefined,
                        "data-taskbar-button": w.id,
                        onClick: ()=>onWindowClick && onWindowClick(w.id),
                        onContextMenu: (e)=>{
                            e.preventDefault();
                            // Keep the Stage's outside-click closer from immediately
                            // eating the menu this opens.
                            e.stopPropagation();
                            if (onWindowContextMenu) onWindowContextMenu(w.id, e);
                        },
                        title: w.label,
                        children: [
                            w.icon,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$ButtonLabel, {
                                children: w.label
                            })
                        ]
                    }, w.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d2026809cde12e7e$var$Tray, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2026809cde12e7e$var$TrayVolume, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("time", {
                        onClick: (0, $b9747e1bfffdb7e5$export$8f48318ca2b6728b),
                        children: $d2026809cde12e7e$var$formatClock(now)
                    })
                ]
            })
        ]
    });
}
const $d2026809cde12e7e$export$e7ce2d3fe3294aef = 34;
const $d2026809cde12e7e$var$Bar = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  /* Chrome text (clock, button labels) is furniture, not copy —
     dragging across the desktop must never highlight "4:12 PM". */
  -webkit-user-select: none;
  user-select: none;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  height: ${$d2026809cde12e7e$export$e7ce2d3fe3294aef}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 3px 4px;
  /* The real taskbar has no side/bottom bevel — it only rises at the top. */
  border-left: none;
  border-right: none;
  border-bottom: none;
  box-shadow: inset 0 1px #fff;
`;
const $d2026809cde12e7e$var$StartButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: bold;
  min-width: 0;
  padding: 2px 8px 2px 5px;
  flex-shrink: 0;

  &&[data-open="true"] {
    box-shadow:
      inset -1px -1px #fff,
      inset 1px 1px #0a0a0a,
      inset -2px -2px #dfdfdf,
      inset 2px 2px #808080;
  }

  /* No dotted focus marquee from a mouse click — the pressed look is
     right, the black dots are wrong — but keep it for keyboard focus
     so tab-navigation stays visible. */
  &&:focus {
    outline: none;
  }
  &&:focus-visible {
    outline: 1px dotted #000;
    outline-offset: -4px;
  }
`;
// A four-pane "flag" drawn in CSS — enough to read as a start glyph
// without shipping an asset.
const $d2026809cde12e7e$var$StartGlyph = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  display: grid;
  grid-template-columns: 7px 7px;
  grid-template-rows: 7px 7px;
  gap: 1px;
  transform: skewX(-8deg);

  & i {
    display: block;
  }
  & i:nth-child(1) {
    background: #d40000;
  }
  & i:nth-child(2) {
    background: #00a300;
  }
  & i:nth-child(3) {
    background: #0051c6;
  }
  & i:nth-child(4) {
    background: #ffbf00;
  }
`;
const $d2026809cde12e7e$var$Divider = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: 2px;
  align-self: stretch;
  margin: 1px 0;
  border-left: 1px solid #808080;
  border-right: 1px solid #fff;
  flex-shrink: 0;
`;
const $d2026809cde12e7e$var$WindowButtons = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 3px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
`;
const $d2026809cde12e7e$var$WindowButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  flex: 0 1 180px;
  min-width: 48px;
  padding: 2px 6px;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 5px;

  &&[data-active="true"] {
    font-weight: bold;
    background-image: repeating-conic-gradient(
      #fff 0% 25%,
      #dfdfdf 0% 50%
    );
    background-size: 2px 2px;
    box-shadow:
      inset -1px -1px #fff,
      inset 1px 1px #0a0a0a,
      inset -2px -2px #dfdfdf,
      inset 2px 2px #808080;
  }
`;
const $d2026809cde12e7e$var$ButtonLabel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $d2026809cde12e7e$var$Tray = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex-shrink: 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  box-shadow:
    inset -1px -1px #fff,
    inset 1px 1px #808080;
  font-variant-numeric: tabular-nums;
`;
const $d2026809cde12e7e$var$TrayVolumeWrap = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
`;
const $d2026809cde12e7e$var$TrayButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  position: relative;
  background: transparent;
  border: none;
  box-shadow: none;
  min-width: 0;
  min-height: 0;
  padding: 1px;
  display: flex;
  align-items: center;

  &&:not(:disabled):hover,
  &&:not(:disabled):active {
    box-shadow: none;
  }
  &&:focus {
    outline: none;
  }
`;
const $d2026809cde12e7e$var$MuteX = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  position: absolute;
  right: -3px;
  bottom: -2px;
  color: #c00;
  font-weight: bold;
  font-size: 12px;
  text-shadow: 1px 1px 0 #fff;
`;
const $d2026809cde12e7e$var$PopupBackdrop = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: fixed;
  inset: 0;
  z-index: 1250;
`;
const $d2026809cde12e7e$var$VolumePopup = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  right: 0;
  bottom: ${$d2026809cde12e7e$export$e7ce2d3fe3294aef - 4}px;
  width: 88px;
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 1300;
  /* Not window chrome: the real popup has a plain thin outline with a
     white top-left sliver, not a raised 3D bevel. */
  background: silver;
  border: 1px solid #0a0a0a;
  box-shadow: inset 1px 1px 0 #fff;
`;
const $d2026809cde12e7e$var$MidRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const $d2026809cde12e7e$var$Wedge = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).svg`
  shape-rendering: crispEdges;
  flex-shrink: 0;
`;
// The dotted rectangle the real thing drew around the slider track.
const $d2026809cde12e7e$var$TrackBox = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  border: 1px dotted #808080;
  padding: 6px 8px;
`;
// Our own vertical-slider geometry (98.css's .is-vertical assumes a
// surrounding layout we don't have): a fixed upright box with the
// horizontal input rotated a quarter turn about its center. min ends up
// at the bottom, which is where quiet belongs.
const $d2026809cde12e7e$var$VSlider = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  width: 21px;
  height: 76px;

  & > input[type="range"] {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 76px;
    height: 21px;
    margin: 0;
    transform: translate(-50%, -50%) rotate(270deg);
  }
`;
const $d2026809cde12e7e$var$MuteRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  align-self: flex-start;
  margin-left: 6px;
`;
const $d2026809cde12e7e$var$VolumeTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  font-size: 11px;
  -webkit-user-select: none;
  user-select: none;
`;
var $d2026809cde12e7e$export$2e2bcd8739ae039 = $d2026809cde12e7e$var$Taskbar;




// A world-positioned, optionally draggable wrapper.
//
// One Layout element with transform
// `translate(-50%, -50%) translate(x + dx, y + dy)`. The `-50%` sizes
// against Layout's own box, which matches the child's size, so the child's
// center lands at (x + dx, y + dy) without us measuring anything. The
// optional `transition` prop drives CSS transitions so layout phase
// changes (wide → focused) animate; callers drop it once the layout is
// static so the compositor layer goes away and drag feels instant.
//
// Drag handle: any descendant with `data-drag-handle` (Window's title
// bar sets this). Buttons inside a handle still click normally — we skip
// drag initiation when the mousedown target is a button.
// Our transforms live inside #root, which has `zoom: var(--ui-zoom)`.
// clientX/clientY from mouse events are in unzoomed viewport CSS pixels,
// so we divide by the zoom factor to get the matching translate amount.
// Read each drag start (cheap; constant in practice but tracks any runtime
// change to the variable).
function $a980e0228e57c86d$var$readUiZoom() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--ui-zoom");
    const n = parseFloat(raw);
    return Number.isFinite(n) && n > 0 ? n : 1;
}
function $a980e0228e57c86d$var$PositionedWindow({ position: position, opacity: opacity = 1, draggable: draggable = false, transition: transition, zIndex: zIndex, onActivate: onActivate, boxId: // Stamped as data-window-box so the Stage can measure this window
// for the minimize/restore zoom-rectangle effect.
boxId, inert: // Fully non-interactive (used for faded-out windows so invisible
// neighbors can't swallow clicks or be dragged).
inert = false, children: children }) {
    const [drag, setDrag] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        dx: 0,
        dy: 0
    });
    const layoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Live handlers for the current drag session, so we can detach on
    // unmount if the user never releases (React strict-mode remounts,
    // parent unmounts mid-drag, etc.).
    const sessionRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        return ()=>{
            const s = sessionRef.current;
            if (!s) return;
            window.removeEventListener("pointermove", s.onMove);
            window.removeEventListener("pointerup", s.onUp);
            window.removeEventListener("pointercancel", s.onUp);
            sessionRef.current = null;
        };
    }, []);
    // Pointer events, not mouse events: fingers drag windows too (the
    // handle sets touch-action: none below so the page doesn't scroll
    // out from under a title-bar drag).
    const onPointerDown = (e)=>{
        // Any press claims focus (desktop-style raise), even ones that
        // don't start a drag.
        if (onActivate) onActivate();
        if (!draggable) return;
        if (e.button !== 0) return;
        if (e.target.closest("button, input, [data-no-drag]")) return;
        if (!e.target.closest("[data-drag-handle]")) return;
        e.preventDefault();
        const startX = e.clientX;
        const startY = e.clientY;
        const baseDx = drag.dx;
        const baseDy = drag.dy;
        const zoom = $a980e0228e57c86d$var$readUiZoom();
        // Real-Windows drag clamp: the title bar can never go above the top
        // of the screen or under the taskbar, and at least a hand's width
        // of the window stays on screen horizontally — a window can hang
        // off, but never become unreachable. Coordinates: our (dx,dy) are
        // window-CENTER offsets from the viewport center.
        const rect = layoutRef.current?.getBoundingClientRect();
        const winW = rect ? rect.width / zoom : 620;
        const winH = rect ? rect.height / zoom : 435;
        const clamp = (dx, dy)=>{
            const W = window.innerWidth / zoom;
            const H = window.innerHeight / zoom;
            const GRAB_X = 60;
            let cx = W / 2 + position.x + dx;
            let cy = H / 2 + position.y + dy;
            cx = Math.max(GRAB_X - winW / 2, Math.min(W - GRAB_X + winW / 2, cx));
            const minCy = winH / 2; // top edge can't cross the screen top
            const maxCy = H - (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef) - 24 + winH / 2;
            cy = Math.max(minCy, Math.min(maxCy, cy));
            return {
                dx: cx - W / 2 - position.x,
                dy: cy - H / 2 - position.y
            };
        };
        // Imperative during the drag: write the CSS vars straight onto the
        // node per mousemove so the window rides the cursor with zero React
        // lag; commit to state once on mouseup so React's world agrees.
        let liveDx = baseDx;
        let liveDy = baseDy;
        const onMove = (ev)=>{
            const clamped = clamp(baseDx + (ev.clientX - startX) / zoom, baseDy + (ev.clientY - startY) / zoom);
            liveDx = clamped.dx;
            liveDy = clamped.dy;
            const el = layoutRef.current;
            if (el) {
                el.style.setProperty("--dx", position.x + liveDx + "px");
                el.style.setProperty("--dy", position.y + liveDy + "px");
            }
        };
        const onUp = ()=>{
            window.removeEventListener("pointermove", onMove);
            window.removeEventListener("pointerup", onUp);
            window.removeEventListener("pointercancel", onUp);
            sessionRef.current = null;
            setDrag({
                dx: liveDx,
                dy: liveDy
            });
        };
        window.addEventListener("pointermove", onMove);
        window.addEventListener("pointerup", onUp);
        window.addEventListener("pointercancel", onUp);
        sessionRef.current = {
            onMove: onMove,
            onUp: onUp
        };
    };
    const layoutStyle = {
        "--dx": position.x + drag.dx + "px",
        "--dy": position.y + drag.dy + "px",
        "--opacity": opacity
    };
    if (transition) layoutStyle["--transition"] = transition;
    if (zIndex != null) layoutStyle.zIndex = zIndex;
    if (inert) layoutStyle.pointerEvents = "none";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a980e0228e57c86d$var$Layout, {
        ref: layoutRef,
        onPointerDown: onPointerDown,
        style: layoutStyle,
        "data-window-box": boxId,
        "data-draggable": draggable && !inert ? "true" : undefined,
        children: children
    });
}
const $a980e0228e57c86d$var$Layout = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-50%, -50%) translate(var(--dx), var(--dy));
  opacity: var(--opacity);
  transition: var(--transition, none);

  /* A finger on the title bar drags the WINDOW, never scrolls the
     page (touch pointermove would otherwise be eaten by scrolling). */
  & [data-drag-handle] {
    touch-action: none;
  }
`;
var $a980e0228e57c86d$export$2e2bcd8739ae039 = $a980e0228e57c86d$var$PositionedWindow;







var $acw62 = parcelRequire("acw62");



// The Start menu: raised panel anchored above the Start button with the
// classic blue sidebar banner. Items are provided by the Stage:
//   { label, icon, onClick?, disabled?, submenu?: [items], sceneTarget? }
//   — or the string "separator".
// Items with `submenu` open a cascading panel on hover (Programs ▸).
// `sceneTarget` stamps data-scene-target for the boot scene's ghost
// cursor to find. Escape closes; outside clicks are handled by the Stage.
function $29cdb8b3eaf012ca$var$MenuItem({ item: item, onClose: onClose, depth: depth = 0, forceSubmenuFor: forceSubmenuFor, forceHoverFor: forceHoverFor }) {
    const [subOpen, setSubOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    if (item === "separator") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$Separator, {});
    const hasSub = Array.isArray(item.submenu);
    // The boot scene's ghost cursor can't hover — the Stage can force a
    // submenu open (and its hover highlight) by scene target instead.
    const showSub = hasSub && (subOpen || forceSubmenuFor === item.label);
    const forcedHover = item.sceneTarget != null && forceHoverFor === item.sceneTarget;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($29cdb8b3eaf012ca$var$ItemWrap, {
        onMouseEnter: ()=>hasSub && setSubOpen(true),
        onMouseLeave: ()=>hasSub && setSubOpen(false),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($29cdb8b3eaf012ca$var$Item, {
                type: "button",
                role: "menuitem",
                disabled: item.disabled,
                "data-scene-target": item.sceneTarget,
                "data-top": depth === 0 ? "true" : undefined,
                "data-forced-hover": forcedHover ? "true" : undefined,
                "data-sub-open": showSub ? "true" : undefined,
                onClick: ()=>{
                    if (hasSub) {
                        // Open, never toggle: iOS fires mouseenter+click on the same
                        // tap, so a toggle would re-close what the enter just opened.
                        setSubOpen(true);
                        return;
                    }
                    if (onClose) onClose();
                    if (item.onClick) item.onClick();
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$ItemIcon, {
                        "aria-hidden": "true",
                        "data-big": depth === 0 ? "true" : undefined,
                        children: item.icon && depth === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item.icon, {
                            size: 32
                        }) : item.icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$ItemLabel, {
                        children: item.label
                    }),
                    hasSub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$SubArrow, {
                        "aria-hidden": "true",
                        children: "\u25B8"
                    })
                ]
            }),
            showSub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$SubPanel, {
                className: "window",
                $depth: depth,
                children: item.submenu.map((sub, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$MenuItem, {
                        item: sub,
                        onClose: onClose,
                        depth: depth + 1,
                        forceHoverFor: forceHoverFor
                    }, i))
            })
        ]
    });
}
function $29cdb8b3eaf012ca$var$StartMenu({ open: open, items: items = [], onClose: onClose, banner: banner = "Solitaire", forceSubmenuFor: forceSubmenuFor, forceHoverFor: forceHoverFor }) {
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("Escape", ()=>open && onClose && onClose());
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Arrow keys walk the menu via roving focus over visible menuitems;
    // Enter activates natively since they're real buttons.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKeyDown = (e)=>{
            if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
            const panel = panelRef.current;
            if (!panel) return;
            e.preventDefault();
            const items_ = Array.from(panel.querySelectorAll('[role="menuitem"]:not(:disabled)'));
            if (items_.length === 0) return;
            const idx = items_.indexOf(document.activeElement);
            const delta = e.key === "ArrowDown" ? 1 : -1;
            const next = idx < 0 ? delta > 0 ? 0 : items_.length - 1 : (idx + delta + items_.length) % items_.length;
            items_[next].focus();
        };
        window.addEventListener("keydown", onKeyDown);
        return ()=>window.removeEventListener("keydown", onKeyDown);
    }, [
        open
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($29cdb8b3eaf012ca$var$Panel, {
        ref: panelRef,
        className: "window",
        role: "menu",
        // Keep desktop-level outside-click handlers from seeing clicks
        // inside the menu.
        onMouseDown: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$Banner, {
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: banner
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$Items, {
                children: items.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($29cdb8b3eaf012ca$var$MenuItem, {
                        item: item,
                        onClose: onClose,
                        forceSubmenuFor: forceSubmenuFor,
                        forceHoverFor: forceHoverFor
                    }, i))
            })
        ]
    });
}
const $29cdb8b3eaf012ca$var$Panel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 2px;
  bottom: ${(0, $d2026809cde12e7e$export$e7ce2d3fe3294aef)}px;
  z-index: 1100;
  display: flex;
  flex-direction: row;
  padding: 3px;
  min-width: 220px;
`;
const $29cdb8b3eaf012ca$var$Banner = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: 26px;
  flex-shrink: 0;
  align-self: stretch;
  background: linear-gradient(180deg, #00007b 0%, #0000c4 100%);
  position: relative;

  & span {
    position: absolute;
    bottom: 6px;
    left: 50%;
    transform: rotate(180deg) translateX(50%);
    transform-origin: center;
    writing-mode: vertical-rl;
    color: #fff;
    font-weight: bold;
    /* 11px (integer only — pixel font): the full title fits the menu's
       height at 11px; larger sizes overflow the panel top. */
    font-size: 11px;
    letter-spacing: 1px;
    white-space: nowrap;
    -webkit-user-select: none;
    user-select: none;
  }
`;
const $29cdb8b3eaf012ca$var$Items = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 2px 0;
`;
const $29cdb8b3eaf012ca$var$ItemWrap = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $29cdb8b3eaf012ca$var$Item = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: transparent;
  border: none;
  box-shadow: none;
  min-height: 0;
  min-width: 0;
  padding: 3px 14px 3px 7px;
  text-align: left;
  font: inherit;
  color: inherit;
  text-shadow: none;
  white-space: nowrap;

  /* 32px pitch at the top level, ~22px in cascades; the icons establish
     both heights. */
  &&[data-top="true"] {
    padding: 0 14px 0 4px;
  }

  &&:not(:disabled):hover,
  &&[data-ghost-hover="true"],
  &&[data-forced-hover="true"],
  &&[data-sub-open="true"] {
    background: #00007b;
    color: #fff;
    box-shadow: none;
  }
  &&:not(:disabled):active {
    box-shadow: none;
    text-shadow: none;
  }
  &&:focus {
    outline: none;
  }
  /* Keyboard focus reads as hover, like the real menus. */
  &&:focus-visible {
    background: #00007b;
    color: #fff;
  }
  &&:disabled {
    color: #808080;
  }
`;
const $29cdb8b3eaf012ca$var$ItemIcon = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  width: 20px;
  display: inline-flex;
  justify-content: center;
  flex-shrink: 0;

  &[data-big="true"] {
    width: 32px;
  }
`;
const $29cdb8b3eaf012ca$var$ItemLabel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  flex: 1 1 auto;
`;
const $29cdb8b3eaf012ca$var$SubArrow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  margin-left: 12px;
`;
const $29cdb8b3eaf012ca$var$SubPanel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: calc(100% - 3px);
  top: -3px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  padding: 3px 0;
  z-index: 1;
`;
const $29cdb8b3eaf012ca$var$Separator = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  height: 2px;
  margin: 3px 6px;
  border-top: 1px solid #808080;
  border-bottom: 1px solid #fff;
`;
var $29cdb8b3eaf012ca$export$2e2bcd8739ae039 = $29cdb8b3eaf012ca$var$StartMenu;






var $acw62 = parcelRequire("acw62");

// A desktop icon: emoji glyph + label, single click selects, double click
// opens. Selection is local — clicking the desktop elsewhere deselects via
// the blur handler, like the real thing. Selection happens on pointer DOWN
// (not click): Win95 highlights the label the instant you press, so a drag
// carries a navy label the whole way rather than lighting up on drop.
function $44bdb76f21627302$var$DesktopIcon({ icon: icon, label: label, onOpen: onOpen }) {
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // "Double click" counted by hand from click events: browsers never
    // synthesize dblclick from a touch double-tap. Mouse behavior is
    // unchanged — the second click of a real double-click still arrives
    // as its own click first.
    const lastTapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const onClick = ()=>{
        const now = Date.now();
        if (now - lastTapRef.current < 500) {
            lastTapRef.current = 0;
            setSelected(false);
            if (onOpen) onOpen();
        } else lastTapRef.current = now;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($44bdb76f21627302$var$Root, {
        type: "button",
        "data-selected": selected ? "true" : undefined,
        onPointerDown: (e)=>{
            if (e.button === 0) setSelected(true);
        },
        onBlur: ()=>setSelected(false),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44bdb76f21627302$var$Glyph, {
                "aria-hidden": "true",
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($44bdb76f21627302$var$Label, {
                "data-selected": selected ? "true" : undefined,
                children: label
            })
        ]
    });
}
const $44bdb76f21627302$var$Root = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 76px;
  padding: 4px 2px;
  background: transparent;
  border: none;
  box-shadow: none;
  min-width: 0;
  min-height: 0;
  font: inherit;
  cursor: default;
  /* Two quick taps open — don't spend the second on double-tap zoom. */
  touch-action: manipulation;

  &&:not(:disabled):hover,
  &&:not(:disabled):active {
    box-shadow: none;
    text-shadow: none;
  }
  &&:focus {
    outline: none;
  }
  &&:focus-visible span:last-child {
    background: #00007b;
    outline: 1px dotted #ffff7b;
  }
`;
const $44bdb76f21627302$var$Glyph = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  font-size: 30px;
  line-height: 1;
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.4));
`;
const $44bdb76f21627302$var$Label = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  color: #fff;
  font-size: 13px;
  line-height: 1.15;
  text-align: center;
  padding: 1px 3px;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.7);

  &[data-selected="true"] {
    background: #00007b;
    text-shadow: none;
    outline: 1px dotted #ffff7b;
  }
`;
var $44bdb76f21627302$export$2e2bcd8739ae039 = $44bdb76f21627302$var$DesktopIcon;






var $acw62 = parcelRequire("acw62");




function $bebe1cbb5a309c8c$export$99a30d7bac18108e(locationLike) {
    if (!locationLike) return "ws://127.0.0.1:8787/ws";
    const { hostname: hostname, host: host, port: port, protocol: protocol } = locationLike;
    const localParcel = port === "1234" && (hostname === "127.0.0.1" || hostname === "localhost");
    if (localParcel) return "ws://127.0.0.1:8787/ws";
    const wsProtocol = protocol === "https:" ? "wss:" : "ws:";
    return `${wsProtocol}//${host}/ws`;
}
function $bebe1cbb5a309c8c$export$8b5626961a2da654(locationLike) {
    if (!locationLike) return "http://127.0.0.1:8787";
    const { hostname: hostname, host: host, port: port, protocol: protocol } = locationLike;
    const localParcel = port === "1234" && (hostname === "127.0.0.1" || hostname === "localhost");
    if (localParcel) return "http://127.0.0.1:8787";
    return `${protocol}//${host}`;
}
const $bebe1cbb5a309c8c$export$e1d22fd22e60a13d = $bebe1cbb5a309c8c$export$99a30d7bac18108e(typeof window === "undefined" ? null : window.location);
const $bebe1cbb5a309c8c$export$778e4213e2788579 = $bebe1cbb5a309c8c$export$8b5626961a2da654(typeof window === "undefined" ? null : window.location);


const $bc6426009fe17cee$export$8a2102d02cd79ea7 = 200;
async function $bc6426009fe17cee$export$c6029246c165f7f8({ beforeId: beforeId = null, limit: limit = $bc6426009fe17cee$export$8a2102d02cd79ea7 } = {}) {
    const url = new URL("/api/games", (0, $bebe1cbb5a309c8c$export$778e4213e2788579));
    if (beforeId != null) url.searchParams.set("before_id", String(beforeId));
    url.searchParams.set("limit", String(limit));
    const res = await fetch(url);
    if (!res.ok) throw new Error(`history list failed (${res.status})`);
    const data = await res.json();
    return {
        total: typeof data.total === "number" ? data.total : null,
        records: (data.games ?? []).map((g)=>({
                gameId: g.game_id,
                outcome: g.outcome,
                moves: g.move_count,
                endedAt: g.ended_at,
                durationSecs: Math.max(0, Math.round((g.ended_at - g.started_at) / 1000))
            }))
    };
}
async function $bc6426009fe17cee$export$7cace6c5bbcb0712(gameId) {
    const res = await fetch(new URL(`/api/games/${gameId}/board`, (0, $bebe1cbb5a309c8c$export$778e4213e2788579)));
    if (!res.ok) throw new Error(`board fetch failed (${res.status})`);
    const data = await res.json();
    return data.board;
}


// The "every game ever played" explorer: a Win95 file-manager window over
// the full game history, chronological only (a portrait, not a database —
// no search, no filters). Driven by the server's Past Games read API,
// newest first, fetched a page at a time as the pane scrolls (the folder
// will eventually hold every game the piece has ever seen).
//
// Details view only. Clicking selects; double-click (or Enter) opens
// the game's final board in its own frozen window via onOpenGame.
function $e5a252a010a2a0a6$var$formatDate(ts) {
    const d = new Date(ts);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yy = String(d.getFullYear()).slice(2);
    let h = d.getHours();
    const suffix = h < 12 ? "AM" : "PM";
    h = h % 12 || 12;
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${mm}/${dd}/${yy} ${h}:${min} ${suffix}`;
}
function $e5a252a010a2a0a6$var$formatDuration(secs) {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
}
function $e5a252a010a2a0a6$var$outcomeLabel(outcome) {
    return outcome === "won" ? "Won" : "Lost";
}
// Patina: the past fades a little. Newest rows are crisp; year-old rows
// sit at ~60%.
function $e5a252a010a2a0a6$var$patinaOpacity(endedAt, now) {
    const ageDays = (now - endedAt) / 86400000;
    return Math.max(0.6, 1 - ageDays / 900);
}
function $e5a252a010a2a0a6$var$HistoryWindow({ onClose: onClose, inactive: inactive = false, onHelpAbout: onHelpAbout, onOpenGame: onOpenGame }) {
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Date.now(), []);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [records, setRecords] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // The archive's true size (server COUNT) — the status bar's number.
    // null until the first page answers; the loaded-row count is only
    // the fallback for old servers that don't send it.
    const [archiveTotal, setArchiveTotal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // "loading" | "idle" | "exhausted" | "error"
    const [pageState, setPageState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("loading");
    const paneRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // In-flight guard + cursor live in a ref so scroll handlers never race.
    const pagingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        busy: false,
        beforeId: null,
        done: false
    });
    const loadMore = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const p = pagingRef.current;
        if (p.busy || p.done) return;
        p.busy = true;
        setPageState("loading");
        try {
            const { records: page, total: total } = await (0, $bc6426009fe17cee$export$c6029246c165f7f8)({
                beforeId: p.beforeId
            });
            if (total != null) setArchiveTotal(total);
            if (page.length > 0) p.beforeId = page[page.length - 1].gameId;
            if (page.length < (0, $bc6426009fe17cee$export$8a2102d02cd79ea7)) p.done = true;
            setRecords((prev)=>{
                // Games that ended between two fetches shift the pages; dedupe
                // by id so a row can't appear twice.
                const seen = new Set(prev.map((r)=>r.gameId));
                return [
                    ...prev,
                    ...page.filter((r)=>!seen.has(r.gameId))
                ];
            });
            setPageState(p.done ? "exhausted" : "idle");
        } catch  {
            setPageState("error");
        } finally{
            p.busy = false;
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadMore();
    }, [
        loadMore
    ]);
    // Fetch the next page when the pane scrolls near its bottom.
    const onPaneScroll = (e)=>{
        const el = e.currentTarget;
        if (el.scrollHeight - el.scrollTop - el.clientHeight < 300) loadMore();
    };
    const openRecord = (gameId)=>{
        setSelected(gameId);
        if (onOpenGame) onOpenGame(gameId);
    };
    // Row activation that works for mouse AND touch: the first click/tap
    // selects, a second on the same row inside the double-click window
    // opens. Browsers never synthesize dblclick from a touch double-tap,
    // so the old onDoubleClick made compact Past Games rows un-openable
    // on phones; for the mouse this is behaviorally identical, since the
    // second click of a double-click arrives as its own click first.
    const lastTapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        id: null,
        t: 0
    });
    const tapRecord = (gameId)=>{
        const last = lastTapRef.current;
        const now = Date.now();
        lastTapRef.current = {
            id: gameId,
            t: now
        };
        if (last.id === gameId && now - last.t < 500) openRecord(gameId);
        else setSelected(gameId);
    };
    const selectedRecord = selected != null ? records.find((r)=>r.gameId === selected) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e5a252a010a2a0a6$var$StyledWindow, {
        title: "Past Games",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
            name: "folder",
            size: 16
        }),
        inactive: inactive,
        controls: [
            "close"
        ],
        onControlClick: (control)=>{
            if (control === "close" && onClose) onClose();
        },
        statusFields: [
            `${archiveTotal ?? records.length} game(s)`,
            // Only a real second field — an empty string still drew its
            // sunken bevel, a little empty tray for nothing.
            ...selectedRecord ? [
                `Game #${selectedRecord.gameId} \u{2014} ${$e5a252a010a2a0a6$var$outcomeLabel(selectedRecord.outcome)}`
            ] : []
        ],
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e5a252a010a2a0a6$var$Chrome, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1171fabab2f3639c$export$2e2bcd8739ae039), {
                    items: [
                        {
                            label: "File",
                            items: [
                                {
                                    label: "Close",
                                    onClick: onClose
                                }
                            ]
                        },
                        {
                            label: "Help",
                            items: [
                                {
                                    label: "About Solitaire Alone Together\u2026",
                                    onClick: onHelpAbout,
                                    disabled: !onHelpAbout
                                }
                            ]
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e5a252a010a2a0a6$var$Pane, {
                    ref: paneRef,
                    onScroll: onPaneScroll,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e5a252a010a2a0a6$var$DetailsTable, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Result"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Moves"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Time"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                children: "Ended"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: records.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e5a252a010a2a0a6$var$Row, {
                                            "data-selected": selected === r.gameId ? "true" : undefined,
                                            style: {
                                                "--patina": $e5a252a010a2a0a6$var$patinaOpacity(r.endedAt, now)
                                            },
                                            onClick: ()=>tapRecord(r.gameId),
                                            // Rows are selectable: give the keyboard the same
                                            // power the mouse has. Explorer semantics: Space
                                            // selects, Enter opens.
                                            tabIndex: 0,
                                            onKeyDown: (e)=>{
                                                if (e.key === " ") {
                                                    e.preventDefault();
                                                    setSelected(r.gameId);
                                                } else if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    openRecord(r.gameId);
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e5a252a010a2a0a6$var$NameCell, {
                                                        children: [
                                                            "Game #",
                                                            r.gameId
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    "data-outcome": r.outcome === "won" ? "won" : "lost",
                                                    children: $e5a252a010a2a0a6$var$outcomeLabel(r.outcome)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: r.moves
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $e5a252a010a2a0a6$var$formatDuration(r.durationSecs)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    children: $e5a252a010a2a0a6$var$formatDate(r.endedAt)
                                                })
                                            ]
                                        }, r.gameId))
                                })
                            ]
                        }),
                        pageState === "loading" && records.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e5a252a010a2a0a6$var$EdgeLine, {
                            children: "Reading\u2026"
                        }),
                        pageState === "error" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e5a252a010a2a0a6$var$EdgeLine, {
                            as: "button",
                            type: "button",
                            onClick: ()=>{
                                pagingRef.current.busy = false;
                                loadMore();
                            },
                            children: "Error retrieving games. Click to retry."
                        }),
                        pageState === "exhausted" && records.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e5a252a010a2a0a6$var$EdgeLine, {
                            children: "No games yet."
                        })
                    ]
                })
            ]
        })
    });
}
const $e5a252a010a2a0a6$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 620px;
  height: 440px;
`;
const $e5a252a010a2a0a6$var$Chrome = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  height: 100%;
  display: flex;
  flex-direction: column;

  & > :first-child {
    flex-shrink: 0;
  }
`;
const $e5a252a010a2a0a6$var$Pane = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  /* Keep inertial scrolling, but do not let a hard fling rubber-band the
     sticky Details header down and expose the pane behind it. */
  overscroll-behavior: none;
  background: #fff;
  border: 2px solid;
  border-color: #808080 #fff #fff #808080;
`;
const $e5a252a010a2a0a6$var$DetailsTable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  & th {
    position: sticky;
    top: 0;
    /* The patina rows' opacity creates stacking contexts that would
       otherwise paint over the sticky header as they scroll under it. */
    z-index: 1;
    text-align: left;
    font-weight: normal;
    background: silver;
    padding: 2px 8px;
    /* Raised button bevel, per the real Explorer (reference/explorer/
       win95desktop3.png: headers are 3D bars even though ours don't
       sort — the history stays chronological only). Left-aligned even
       for numeric columns, which is also period-correct. */
    box-shadow:
      inset -1px -1px #0a0a0a,
      inset 1px 1px #fff,
      inset -2px -2px grey,
      inset 2px 2px #dfdfdf;
    -webkit-user-select: none;
    user-select: none;
  }
  & td {
    padding: 2px 8px;
    white-space: nowrap;
    vertical-align: middle;
  }
  & td[data-outcome="won"] {
    color: #008000;
    font-weight: bold;
  }
`;
// Keep the selection wash tight around the filename, like Explorer,
// rather than filling the whole Name cell.
const $e5a252a010a2a0a6$var$NameCell = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  display: inline-flex;
  align-items: center;
`;
const $e5a252a010a2a0a6$var$Row = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).tr`
  opacity: var(--patina, 1);
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
  /* Two quick taps open the row — don't let the browser spend the
     second one on double-tap zoom. */
  touch-action: manipulation;

  /* Win95 Details view highlights only the icon+name, never the whole
     row (reference/explorer/win95desktop3.png). */
  &[data-selected="true"] ${$e5a252a010a2a0a6$var$NameCell} {
    background: #00007b;
    color: #fff;
  }
`;
const $e5a252a010a2a0a6$var$EdgeLine = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 8px;
  font-size: 13px;
  color: #808080;
  background: transparent;
  border: none;
  box-shadow: none;
  text-align: left;
  width: 100%;
`;
var $e5a252a010a2a0a6$export$2e2bcd8739ae039 = $e5a252a010a2a0a6$var$HistoryWindow;






var $acw62 = parcelRequire("acw62");



// A finished game, opened from Past Games: the final board, frozen —
// a lighter alternative to replay. Same 620x435 Solitaire window as
// everything else; nothing here is playable.
const $b4399e4a175c0590$var$EMPTY_STATE = Object.freeze({
    stock: [],
    waste: [],
    tableau: Array.from({
        length: 7
    }, ()=>({
            faceDown: [],
            faceUp: []
        })),
    foundations: [
        [],
        [],
        [],
        []
    ],
    drawSize: 3
});
function $b4399e4a175c0590$var$PastGameWindow({ gameId: gameId, onClose: onClose, inactive: inactive = false }) {
    const [board, setBoard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let cancelled = false;
        // The one viewer window swaps games in place — drop the previous
        // game's board immediately so it can't wear the new title.
        setBoard(null);
        (0, $bc6426009fe17cee$export$7cace6c5bbcb0712)(gameId).then((b)=>{
            if (!cancelled) setBoard(b);
        }).catch(()=>{
        // The empty felt stands in; closing and reopening retries.
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        gameId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $523f633b3aed431a$export$2e2bcd8739ae039), {
        title: `(Past Game) Game #${gameId} \u{2014} Solitaire Alone Together`,
        // Half-size assets, full-size chrome. Safe here because the board
        // is frozen — no cursors, no ritual, no cascade.
        boardScale: 0.5,
        state: board ?? $b4399e4a175c0590$var$EMPTY_STATE,
        titleIcon: "solitaire",
        cardBack: (0, $ec53346e7fcdea16$export$5a8a79c6ad2fc273)(gameId),
        interactive: false,
        inactive: inactive,
        controls: [
            "close"
        ],
        onControlClick: (control)=>{
            if (control === "close" && onClose) onClose();
        },
        menus: [
            {
                label: "Game",
                disabled: true
            },
            {
                label: "Help",
                disabled: true
            }
        ]
    });
}
var $b4399e4a175c0590$export$2e2bcd8739ae039 = $b4399e4a175c0590$var$PastGameWindow;





parcelRequire("acw62");




// The little "About" dialog, reachable from the Start menu. Deliberately
// understated — a description of the room, not a credits screen.
// Kiosk mode (mouse, no keyboard — see kiosk.js): a link that navigates
// away strands the machine, so the credits render as plain text. Still
// underlined but not blue — that's the visible tell that kiosk is on.
function $7127b1122afa3ceb$var$CreditLink({ href: href, children: children }) {
    const kiosk = (0, $b9747e1bfffdb7e5$export$bb6482adf8fb51dc)();
    if (kiosk) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7127b1122afa3ceb$var$KioskCredit, {
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noreferrer",
        children: children
    });
}
function $7127b1122afa3ceb$var$AboutWindow({ onClose: onClose, inactive: inactive = false }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7127b1122afa3ceb$var$StyledWindow, {
        title: "About Solitaire Alone Together",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
            name: "information",
            size: 16
        }),
        inactive: inactive,
        controls: [
            "close"
        ],
        onControlClick: (control)=>{
            if (control === "close" && onClose) onClose();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7127b1122afa3ceb$var$Body, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7127b1122afa3ceb$var$Suits, {
                    "aria-hidden": "true",
                    children: [
                        "\u2660 ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7127b1122afa3ceb$var$Red, {
                            children: "\u2665"
                        }),
                        " \u2663 ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7127b1122afa3ceb$var$Red, {
                            children: "\u2666"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "this is a place to play solitaire",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "with the rest of the internet"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7127b1122afa3ceb$var$Credit, {
                    children: [
                        "built by",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7127b1122afa3ceb$var$CreditLink, {
                            href: "https://eieio.games",
                            children: "eieio"
                        }),
                        " ",
                        "for",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7127b1122afa3ceb$var$CreditLink, {
                            href: "https://rhizome.org",
                            children: "rhizome"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7127b1122afa3ceb$var$OkRow, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        children: "OK"
                    })
                })
            ]
        })
    });
}
const $7127b1122afa3ceb$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 340px;
`;
const $7127b1122afa3ceb$var$Body = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px 12px;
  text-align: center;
`;
const $7127b1122afa3ceb$var$Suits = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  font-size: 22px;
  letter-spacing: 6px;
`;
const $7127b1122afa3ceb$var$Red = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  color: #c00000;
`;
const $7127b1122afa3ceb$var$Credit = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  font-size: 12px;
  color: #444;

  & a {
    color: #00007b;
  }
`;
const $7127b1122afa3ceb$var$KioskCredit = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  text-decoration: underline;
`;
const $7127b1122afa3ceb$var$OkRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  margin-top: 4px;

  & button {
    min-width: 80px;
  }
`;
var $7127b1122afa3ceb$export$2e2bcd8739ae039 = $7127b1122afa3ceb$var$AboutWindow;






var $acw62 = parcelRequire("acw62");





// Your stats, presented the way a person in 1995 would actually keep
// them: a little text file they update between games. It looks like a
// Notepad note but isn't really editable (readOnly textarea: the caret
// blinks, typing does nothing). The numbers come from localStorage —
// this browser, this person, no server, honestly approximate — but the
// note never says so; that would break the immersion.
function $83b929d59f755c5f$var$StatsWindow({ onClose: onClose, inactive: inactive = false }) {
    const stats = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo((0, $249580010b86d987$export$8b5c195b500c5f0d), []);
    const text = [
        "my statistics",
        "",
        `games played: ${stats.games.toLocaleString()}`,
        `games won: ${stats.wins.toLocaleString()}`,
        `moves made: ${stats.moves.toLocaleString()}`,
        `cards drawn: ${stats.draws.toLocaleString()}`,
        ""
    ].join("\n");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($83b929d59f755c5f$var$StyledWindow, {
        title: "stats.txt - Notepad",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
            name: "notepad",
            size: 16
        }),
        inactive: inactive,
        controls: [
            "close"
        ],
        onControlClick: (control)=>{
            if (control === "close" && onClose) onClose();
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1171fabab2f3639c$export$2e2bcd8739ae039), {
                items: [
                    {
                        label: "File",
                        disabled: true
                    },
                    {
                        label: "Edit",
                        disabled: true
                    },
                    {
                        label: "Search",
                        disabled: true
                    },
                    {
                        label: "Help",
                        disabled: true
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83b929d59f755c5f$var$Page, {
                value: text,
                readOnly: true,
                spellCheck: false,
                "aria-label": "Your statistics"
            })
        ]
    });
}
const $83b929d59f755c5f$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 280px;
`;
// The document area: sunken white field, Notepad's fixed-width face.
const $83b929d59f755c5f$var$Page = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).textarea`
  display: block;
  width: 100%;
  height: 150px;
  margin: 0;
  padding: 4px 6px;
  border: none;
  resize: none;
  background: #fff;
  color: #000;
  /* Real Notepad used Fixedsys, a heavy bitmap face we don't ship.
     Bold Courier at 14px is the closest legible stand-in. */
  font-family: "Courier New", Courier, monospace;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.35;
  box-shadow:
    inset -1px -1px #fff,
    inset 1px 1px grey,
    inset -2px -2px #dfdfdf,
    inset 2px 2px #0a0a0a;

  &:focus {
    outline: none;
  }
`;
var $83b929d59f755c5f$export$2e2bcd8739ae039 = $83b929d59f755c5f$var$StatsWindow;





parcelRequire("acw62");



// The front door: a Win95-style logon dialog over the bare desktop. Its
// one job besides mood is being the user gesture that unlocks audio.
// No username field on purpose: it wouldn't do anything.
function $126dd6f61a64a0c7$var$LoginDialog({ onEnter: onEnter }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($126dd6f61a64a0c7$var$Centered, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($126dd6f61a64a0c7$var$StyledWindow, {
            title: "Welcome",
            controls: [],
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($126dd6f61a64a0c7$var$Body, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($126dd6f61a64a0c7$var$Keys, {
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                            name: "key",
                            size: 32
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($126dd6f61a64a0c7$var$Text, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Welcome to Solitaire Alone Together."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Click OK to log on."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($126dd6f61a64a0c7$var$Buttons, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            autoFocus: true,
                            onClick: onEnter,
                            children: "OK"
                        })
                    })
                ]
            })
        })
    });
}
const $126dd6f61a64a0c7$var$Centered = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $126dd6f61a64a0c7$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 360px;
`;
const $126dd6f61a64a0c7$var$Body = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 48px 1fr;
  grid-template-areas:
    "icon text"
    "buttons buttons";
  gap: 12px;
  padding: 14px 16px 12px;
  align-items: center;
`;
const $126dd6f61a64a0c7$var$Keys = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  grid-area: icon;
  text-align: center;
`;
const $126dd6f61a64a0c7$var$Text = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  grid-area: text;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const $126dd6f61a64a0c7$var$Buttons = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  grid-area: buttons;
  display: flex;
  justify-content: center;

  & button {
    min-width: 90px;
  }
`;
var $126dd6f61a64a0c7$export$2e2bcd8739ae039 = $126dd6f61a64a0c7$var$LoginDialog;






var $acw62 = parcelRequire("acw62");


// The scripted mouse for the first-visit boot scene: a classic white
// arrow that glides between DOM targets and "clicks" them. The real
// cursor is hidden by the caller while this plays.
//
// steps: [{ target: "<data-scene-target value>" | {x,y},
//           click?: true,       // play click sound + fire onArrive
//           travelMs?, pauseMs? }]
// onStep(index) fires when a step's movement finishes (before pauseMs);
// use it to open menus at the right beat. onDone fires after the last
// pause.
const $a6c8befb55b0458f$var$DEFAULT_TRAVEL = 900;
const $a6c8befb55b0458f$var$DEFAULT_PAUSE = 350;
// #root carries `zoom: var(--ui-zoom)`; getBoundingClientRect reports
// visual (zoomed) px while our fixed-position coordinates live inside the
// zoomed space — divide to convert.
function $a6c8befb55b0458f$var$readUiZoom() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--ui-zoom");
    const n = parseFloat(raw);
    return Number.isFinite(n) && n > 0 ? n : 1;
}
function $a6c8befb55b0458f$var$resolveTarget(target) {
    // Function targets resolve at step START — for aiming at things only
    // known then (e.g. wherever the player's real mouse currently is).
    if (typeof target === "function") target = target();
    if (target == null) return null;
    if (typeof target === "object") return target;
    const el = document.querySelector(`[data-scene-target="${target}"]`);
    if (!el) return null;
    const r = el.getBoundingClientRect();
    const zoom = $a6c8befb55b0458f$var$readUiZoom();
    // Aim slightly inside the element, like a person would.
    return {
        x: (r.left + r.width * 0.5) / zoom,
        y: (r.top + r.height * 0.55) / zoom
    };
}
// Cubic ease-in-out with a whisper of overshoot on arrival — human-ish,
// not robotic-linear.
function $a6c8befb55b0458f$var$ease(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
// The ghost can't fire real mouseenter events, but menus should still
// react as it passes: hit-test the arrow tip each frame and stamp
// data-ghost-hover on whichever menuitem is underneath (styles in
// StartMenu/MenuBar treat it as hover).
let $a6c8befb55b0458f$var$ghostHoverEl = null;
function $a6c8befb55b0458f$var$updateGhostHover(x, y, zoom) {
    // elementsFromPoint (plural): the scene's invisible click-to-skip
    // blocker sits on top and would otherwise swallow every hit-test —
    // walk the stack for the first real menu item under the arrow.
    const el = document.elementsFromPoint(x * zoom, y * zoom).map((e)=>e.closest?.('[role="menuitem"]')).find(Boolean);
    if (el === $a6c8befb55b0458f$var$ghostHoverEl) return;
    if ($a6c8befb55b0458f$var$ghostHoverEl) $a6c8befb55b0458f$var$ghostHoverEl.removeAttribute("data-ghost-hover");
    $a6c8befb55b0458f$var$ghostHoverEl = el ?? null;
    if ($a6c8befb55b0458f$var$ghostHoverEl) $a6c8befb55b0458f$var$ghostHoverEl.setAttribute("data-ghost-hover", "true");
}
function $a6c8befb55b0458f$var$clearGhostHover() {
    if ($a6c8befb55b0458f$var$ghostHoverEl) $a6c8befb55b0458f$var$ghostHoverEl.removeAttribute("data-ghost-hover");
    $a6c8befb55b0458f$var$ghostHoverEl = null;
}
function $a6c8befb55b0458f$var$GhostCursor({ steps: steps, onStep: onStep, onDone: onDone, startAt: startAt }) {
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(startAt ?? {
        x: 0,
        y: 0
    });
    const [pressed, setPressed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const posRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(pos);
    posRef.current = pos;
    const callbacksRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        onStep: onStep,
        onDone: onDone
    });
    callbacksRef.current = {
        onStep: onStep,
        onDone: onDone
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let cancelled = false;
        let raf = null;
        let timeout = null;
        const runStep = (i)=>{
            if (cancelled) return;
            if (i >= steps.length) {
                if (callbacksRef.current.onDone) callbacksRef.current.onDone();
                return;
            }
            const step = steps[i];
            const to = $a6c8befb55b0458f$var$resolveTarget(step.target);
            if (!to) {
                // Target not in the DOM (layout changed?) — skip the beat rather
                // than strand the scene.
                runStep(i + 1);
                return;
            }
            const from = {
                ...posRef.current
            };
            const travel = step.travelMs ?? $a6c8befb55b0458f$var$DEFAULT_TRAVEL;
            const t0 = performance.now();
            const frame = (now)=>{
                if (cancelled) return;
                const t = Math.min(1, (now - t0) / travel);
                const k = $a6c8befb55b0458f$var$ease(t);
                const x = from.x + (to.x - from.x) * k;
                const y = from.y + (to.y - from.y) * k;
                setPos({
                    x: x,
                    y: y
                });
                $a6c8befb55b0458f$var$updateGhostHover(x, y, $a6c8befb55b0458f$var$readUiZoom());
                if (t < 1) raf = requestAnimationFrame(frame);
                else {
                    if (step.click) {
                        (0, $ffdb7a25fbb7044c$export$64ef1bee2b9504c1)();
                        setPressed(true);
                        setTimeout(()=>!cancelled && setPressed(false), 120);
                    }
                    if (callbacksRef.current.onStep) callbacksRef.current.onStep(i);
                    timeout = setTimeout(()=>runStep(i + 1), step.pauseMs ?? $a6c8befb55b0458f$var$DEFAULT_PAUSE);
                }
            };
            raf = requestAnimationFrame(frame);
        };
        runStep(0);
        return ()=>{
            cancelled = true;
            $a6c8befb55b0458f$var$clearGhostHover();
            if (raf != null) cancelAnimationFrame(raf);
            if (timeout != null) clearTimeout(timeout);
        };
    // The scene runs once per mount, driven by the steps it mounted with.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a6c8befb55b0458f$var$Arrow, {
        style: {
            "--x": pos.x + "px",
            "--y": pos.y + "px"
        },
        "data-pressed": pressed ? "true" : undefined,
        viewBox: "0 0 12 19",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M1 1 L1 15 L4.5 12 L7 18 L9.5 17 L7 11 L11 11 Z",
            fill: "#fff",
            stroke: "#000",
            strokeWidth: "1"
        })
    });
}
const $a6c8befb55b0458f$var$Arrow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).svg`
  position: fixed;
  left: 0;
  top: 0;
  width: 17px;
  height: 27px;
  transform: translate(var(--x), var(--y));
  z-index: 5000;
  pointer-events: none;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));

  &[data-pressed="true"] {
    transform: translate(var(--x), var(--y)) scale(0.92);
  }
`;
var $a6c8befb55b0458f$export$2e2bcd8739ae039 = $a6c8befb55b0458f$var$GhostCursor;






var $acw62 = parcelRequire("acw62");




function $d97721bde78e9860$export$3f06a51bda79210f({ onOpen: onOpen, full: full = false }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
            name: full ? "recycle-bin-full" : "recycle-bin-empty",
            size: 32
        }),
        label: "Recycle Bin",
        onOpen: onOpen
    });
}
function $d97721bde78e9860$export$bcd92586a2930384({ onClose: onClose, inactive: inactive = false, items: items = [] }) {
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const iconName = items.length ? "recycle-bin-full" : "recycle-bin-empty";
    // Double-click counted from click events so touch double-taps work
    // too (see DesktopIcon — dblclick never fires for taps).
    const lastTapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        label: null,
        t: 0
    });
    const tapItem = (item)=>{
        const last = lastTapRef.current;
        const now = Date.now();
        lastTapRef.current = {
            label: item.label,
            t: now
        };
        if (last.label === item.label && now - last.t < 500) {
            setSelected(null);
            if (item.onRestore) item.onRestore();
        } else setSelected(item.label);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d97721bde78e9860$var$StyledWindow, {
        title: "Recycle Bin",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
            name: iconName,
            size: 16
        }),
        inactive: inactive,
        controls: [
            "close"
        ],
        onControlClick: (control)=>{
            if (control === "close" && onClose) onClose();
        },
        statusFields: [
            `${items.length} object(s)`
        ],
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d97721bde78e9860$var$Pane, {
            onMouseDown: ()=>setSelected(null),
            children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d97721bde78e9860$var$FileItem, {
                    type: "button",
                    "data-selected": selected === item.label ? "true" : undefined,
                    onMouseDown: (e)=>e.stopPropagation(),
                    onClick: ()=>tapItem(item),
                    title: "Double-click to restore",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                            name: item.iconName || "text-file",
                            size: 16
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                            children: item.label
                        })
                    ]
                }, item.label))
        })
    });
}
const $d97721bde78e9860$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 380px;
  height: 280px;
`;
const $d97721bde78e9860$var$Pane = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  height: 100%;
  background: #fff;
  border: 2px solid;
  border-color: #808080 #fff #fff #808080;
  padding: 8px;
`;
const $d97721bde78e9860$var$FileItem = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  box-shadow: none;
  min-width: 0;
  min-height: 0;
  padding: 2px 6px;
  font: inherit;
  font-size: 13px;
  color: inherit;

  & em {
    font-style: normal;
  }
  &&[data-selected="true"] em {
    background: #00007b;
    color: #fff;
  }
  &&:not(:disabled):hover,
  &&:not(:disabled):active {
    box-shadow: none;
  }
  &&:focus {
    outline: none;
  }
`;
var $d97721bde78e9860$export$2e2bcd8739ae039 = $d97721bde78e9860$export$bcd92586a2930384;






var $acw62 = parcelRequire("acw62");


// Display Properties: right-click the desktop → Properties. Period
// gesture, real effect — pick the wallpaper color, it sticks
// (localStorage). Swatches are era-plausible solid colors; patterns/
// tiled wallpapers could join later.
const $079dae0934e9e4c7$var$WALLPAPERS = [
    {
        name: "Teal (default)",
        color: "#058284"
    },
    {
        name: "Desktop Green",
        color: "#3a6b3f"
    },
    {
        name: "Navy",
        color: "#1f3a63"
    },
    {
        name: "Slate",
        color: "#3a6ea5"
    },
    {
        name: "Plum",
        color: "#5a3d5c"
    },
    {
        name: "Clay",
        color: "#8a5a44"
    },
    {
        name: "Charcoal",
        color: "#3b3b3b"
    },
    {
        name: "Black",
        color: "#000000"
    }
];
const $079dae0934e9e4c7$var$BG_KEY = "saat.desktopBg";
// localStorage throws outright when storage access is denied (Safari
// lockdown modes, blocked cookies) — the wallpaper is never worth
// taking the render down over.
function $079dae0934e9e4c7$var$readStoredBg() {
    try {
        return localStorage.getItem($079dae0934e9e4c7$var$BG_KEY);
    } catch  {
        return null;
    }
}
function $079dae0934e9e4c7$export$d983cfe63325de39() {
    const stored = $079dae0934e9e4c7$var$readStoredBg();
    if (stored) document.documentElement.style.setProperty("--desktop-bg", stored);
}
function $079dae0934e9e4c7$var$DisplayProperties({ onClose: onClose, inactive: inactive = false }) {
    const [current, setCurrent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$079dae0934e9e4c7$var$readStoredBg() || getComputedStyle(document.documentElement).getPropertyValue("--desktop-bg").trim());
    const choose = (color)=>{
        setCurrent(color);
        document.documentElement.style.setProperty("--desktop-bg", color);
        try {
            localStorage.setItem($079dae0934e9e4c7$var$BG_KEY, color);
        } catch  {
        // storage unavailable — session-only wallpaper is fine
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($079dae0934e9e4c7$var$StyledWindow, {
        title: "Display Properties",
        inactive: inactive,
        controls: [
            "close"
        ],
        onControlClick: (c)=>c === "close" && onClose && onClose(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($079dae0934e9e4c7$var$Body, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Background"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($079dae0934e9e4c7$var$Swatches, {
                    children: $079dae0934e9e4c7$var$WALLPAPERS.map((w)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($079dae0934e9e4c7$var$Swatch, {
                            type: "button",
                            title: w.name,
                            "data-selected": current === w.color ? "true" : undefined,
                            style: {
                                "--swatch": w.color
                            },
                            onClick: ()=>choose(w.color)
                        }, w.color))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($079dae0934e9e4c7$var$OkRow, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        children: "OK"
                    })
                })
            ]
        })
    });
}
const $079dae0934e9e4c7$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 300px;
`;
const $079dae0934e9e4c7$var$Body = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
`;
const $079dae0934e9e4c7$var$Swatches = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
`;
const $079dae0934e9e4c7$var$Swatch = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  height: 44px;
  min-width: 0;
  padding: 0;
  background: var(--swatch);
  border: 1px solid #000;
  box-shadow: none;

  &&[data-selected="true"] {
    outline: 2px solid #00007b;
    outline-offset: 2px;
  }
  &&:not(:disabled):hover {
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
  &&:focus {
    outline: 2px dotted #00007b;
    outline-offset: 2px;
  }
`;
const $079dae0934e9e4c7$var$OkRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;

  & button {
    min-width: 80px;
  }
`;
var $079dae0934e9e4c7$export$2e2bcd8739ae039 = $079dae0934e9e4c7$var$DisplayProperties;





parcelRequire("acw62");

// The machine turning on: a beat of BIOS-ish self-test text on black,
// then straight to the logon dialog. All original — no Microsoft art
// or text.
const $dc26afc7f31cd267$var$POST_LINES = [
    "eieio systems self-test",
    "",
    "Memory Test :  65536K OK",
    "Video       :  VGA 640x480, 256 colors",
    "Pointer     :  found",
    "Sound       :  found (quiet)",
    "",
    "Booting from C: ..."
];
// `waiting`: still finding a seat — appends a live BIOS-ish status
// line (the POST doubles as the loading screen). `instant`: no
// type-in (used when the text already typed during the connect wait).
function $dc26afc7f31cd267$var$BootScreen({ waiting: waiting = false, instant: instant = false }) {
    const lines = waiting ? [
        ...$dc26afc7f31cd267$var$POST_LINES,
        "Finding you a game ..."
    ] : $dc26afc7f31cd267$var$POST_LINES;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dc26afc7f31cd267$var$Screen, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dc26afc7f31cd267$var$PostText, {
            children: lines.map((line, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dc26afc7f31cd267$var$PostLine, {
                    style: {
                        "--delay": (instant ? 0 : i * 90) + "ms"
                    },
                    children: line === "" ? " " : line
                }, i))
        })
    });
}
const $dc26afc7f31cd267$var$Screen = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: fixed;
  inset: 0;
  z-index: 6000;
  background: #000;
  color: #b8b8b8;
  cursor: none;
`;
const $dc26afc7f31cd267$var$PostText = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  padding: 28px 34px;
  font-family: "Courier New", monospace;
  font-size: 15px;
  line-height: 1.45;
  white-space: pre;
`;
const $dc26afc7f31cd267$var$lineIn = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)`
  from { visibility: hidden; }
  to   { visibility: visible; }
`;
const $dc26afc7f31cd267$var$PostLine = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  animation: ${$dc26afc7f31cd267$var$lineIn} 0ms steps(1, end) var(--delay) both;
`;
var $dc26afc7f31cd267$export$2e2bcd8739ae039 = $dc26afc7f31cd267$var$BootScreen;






var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");


const $85c1cff5a23469e0$export$cfcd38c14ec66973 = "saat.crtStrength";
function $85c1cff5a23469e0$var$CrtOverlay() {
    const [strength] = (0, $213c0628df7e524f$export$2e2bcd8739ae039)($85c1cff5a23469e0$export$cfcd38c14ec66973, 1);
    if (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("crt") === "0") return null;
    if (!(strength > 0)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($85c1cff5a23469e0$var$Glass, {
        "aria-hidden": "true",
        style: {
            "--crt": Math.min(1.4, strength)
        }
    });
}
const $85c1cff5a23469e0$var$Glass = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: fixed;
  inset: 0;
  z-index: 9000;
  pointer-events: none;
  opacity: var(--crt, 1);

  /* Scanlines: 1px whisper every 3px. */
  background-image: repeating-linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.06) 0px,
    rgba(0, 0, 0, 0.06) 1px,
    transparent 1px,
    transparent 3px
  );

  /* Corner vignette, barely there. */
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
      ellipse at center,
      transparent 56%,
      rgba(10, 10, 35, 0.13) 88%,
      rgba(10, 10, 35, 0.28) 100%
    );
  }
`;
var $85c1cff5a23469e0$export$2e2bcd8739ae039 = $85c1cff5a23469e0$var$CrtOverlay;



const $902e75abad36f2b4$export$73949e2aa20bbaf4 = "saat.alwaysBoot";
// What a first-time visitor gets; mirrors the fallbacks each consumer
// passes (sound.js volume, CrtOverlay strength, Stage's boot check).
const $902e75abad36f2b4$var$DEFAULT_VOLUME = 0.5;
const $902e75abad36f2b4$var$DEFAULT_CRT = 1;
const $902e75abad36f2b4$var$DEFAULT_ALWAYS_BOOT = false;
// Start → Settings. Piece-wide knobs: master volume (hum, clicks,
// cards), the CRT glass strength, and whether the boot scene replays
// every visit. Sliders are the 98.css range inputs; changes apply
// instantly and persist (the boot pref takes effect on the next load,
// since it gates the opening).
function $902e75abad36f2b4$var$SettingsWindow({ onClose: onClose, inactive: inactive = false }) {
    // iOS Safari sometimes paints this window's first layout wrong — extra
    // space below the Startup fieldset — and corrects itself on the next
    // interaction-forced reflow. No React re-render happens on
    // pointerdown, so this is the browser's own stale layout; nudge a
    // fresh layout + composite pass ourselves right after first paint.
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let raf2 = null;
        const raf1 = requestAnimationFrame(()=>{
            raf2 = requestAnimationFrame(()=>{
                const el = rootRef.current;
                if (!el) return;
                el.style.transform = "translateZ(0)";
                el.offsetHeight; // force the reflow now, not on the tap
            });
        });
        return ()=>{
            cancelAnimationFrame(raf1);
            if (raf2 != null) cancelAnimationFrame(raf2);
        };
    }, []);
    // Volume lives in sound.js; the setting event keeps this slider in
    // sync with the tray speaker, and vice versa.
    const [volSetting] = (0, $213c0628df7e524f$export$2e2bcd8739ae039)("saat.volume", (0, $ffdb7a25fbb7044c$export$f3d6704bb885c205)());
    const vol = Math.round((volSetting ?? 0.5) * 100);
    const [crt, setCrt] = (0, $213c0628df7e524f$export$2e2bcd8739ae039)((0, $85c1cff5a23469e0$export$cfcd38c14ec66973), 1);
    const [alwaysBoot, setAlwaysBoot] = (0, $213c0628df7e524f$export$2e2bcd8739ae039)($902e75abad36f2b4$export$73949e2aa20bbaf4, false);
    // Puts the three knobs in this window back where a fresh visitor
    // finds them. Deliberately NOT the deck or wallpaper — those live in
    // their own Win95 dialogs (Game → Deck…, Display Properties), and a
    // Control-Panel-style reset wouldn't touch them either.
    const restoreDefaults = ()=>{
        (0, $ffdb7a25fbb7044c$export$64ef1bee2b9504c1)();
        (0, $ffdb7a25fbb7044c$export$246e658b67178cb0)($902e75abad36f2b4$var$DEFAULT_VOLUME);
        setCrt($902e75abad36f2b4$var$DEFAULT_CRT);
        setAlwaysBoot($902e75abad36f2b4$var$DEFAULT_ALWAYS_BOOT);
    };
    const atDefaults = vol === Math.round($902e75abad36f2b4$var$DEFAULT_VOLUME * 100) && crt === $902e75abad36f2b4$var$DEFAULT_CRT && alwaysBoot === $902e75abad36f2b4$var$DEFAULT_ALWAYS_BOOT;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($902e75abad36f2b4$var$StyledWindow, {
        title: "Settings",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
            name: "settings",
            size: 16
        }),
        inactive: inactive,
        controls: [
            "close"
        ],
        onControlClick: (c)=>c === "close" && onClose && onClose(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($902e75abad36f2b4$var$Body, {
            ref: rootRef,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                            children: "Volume"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($902e75abad36f2b4$var$SliderRow, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                    name: "speaker",
                                    size: 16
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "range",
                                    "aria-label": "Volume",
                                    min: "0",
                                    max: "100",
                                    value: vol,
                                    onChange: (e)=>{
                                        (0, $ffdb7a25fbb7044c$export$246e658b67178cb0)(parseInt(e.target.value, 10) / 100);
                                    },
                                    // Same ding as the tray slider: hear the level on release.
                                    onPointerUp: (0, $ffdb7a25fbb7044c$export$b101e1013980b7df),
                                    onKeyUp: (e)=>{
                                        if (e.key.startsWith("Arrow")) (0, $ffdb7a25fbb7044c$export$b101e1013980b7df)();
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                    name: "speaker-loud",
                                    size: 16
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                            children: "Monitor"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "field-row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "crt-enabled",
                                    type: "checkbox",
                                    checked: crt > 0,
                                    onChange: (e)=>{
                                        (0, $ffdb7a25fbb7044c$export$64ef1bee2b9504c1)();
                                        setCrt(e.target.checked ? 1 : 0);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "crt-enabled",
                                    children: "CRT effect"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($902e75abad36f2b4$var$SliderRow, {
                            "data-disabled": crt > 0 ? undefined : "true",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($902e75abad36f2b4$var$SliderLabel, {
                                    children: "subtle"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "range",
                                    "aria-label": "CRT effect strength",
                                    min: "20",
                                    max: "140",
                                    value: Math.round((crt > 0 ? crt : 1) * 100),
                                    disabled: !(crt > 0),
                                    onChange: (e)=>setCrt(parseInt(e.target.value, 10) / 100)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($902e75abad36f2b4$var$SliderLabel, {
                                    children: "strong"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                            children: "Startup"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "field-row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "always-boot",
                                    type: "checkbox",
                                    checked: alwaysBoot === true,
                                    onChange: (e)=>{
                                        (0, $ffdb7a25fbb7044c$export$64ef1bee2b9504c1)();
                                        setAlwaysBoot(e.target.checked);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "always-boot",
                                    children: "Play the opening scene on every visit"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($902e75abad36f2b4$var$ButtonRow, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: restoreDefaults,
                            disabled: atDefaults,
                            children: "Restore Defaults"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            children: "OK"
                        })
                    ]
                })
            ]
        })
    });
}
const $902e75abad36f2b4$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: 300px;
`;
const $902e75abad36f2b4$var$Body = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 6px 6px;
`;
const $902e75abad36f2b4$var$SliderRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;

  & input[type="range"] {
    flex: 1 1 auto;
  }

  &[data-disabled="true"] {
    opacity: 0.5;
  }
`;
const $902e75abad36f2b4$var$SliderLabel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  color: #555;
  -webkit-user-select: none;
  user-select: none;
`;
const $902e75abad36f2b4$var$ButtonRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 6px;
`;
var $902e75abad36f2b4$export$2e2bcd8739ae039 = $902e75abad36f2b4$var$SettingsWindow;






var $acw62 = parcelRequire("acw62");





const $d093ab29b3a03f8a$var$GAME_WIDTH = 620;
const $d093ab29b3a03f8a$var$GAME_HEIGHT = 435;
const $d093ab29b3a03f8a$var$SCALE = 0.5;
const $d093ab29b3a03f8a$var$ITEM_WIDTH = $d093ab29b3a03f8a$var$GAME_WIDTH * $d093ab29b3a03f8a$var$SCALE;
const $d093ab29b3a03f8a$var$BOARD_HEIGHT = Math.ceil($d093ab29b3a03f8a$var$GAME_HEIGHT * $d093ab29b3a03f8a$var$SCALE);
const $d093ab29b3a03f8a$var$CONTROL_HEIGHT = 30;
const $d093ab29b3a03f8a$var$ITEM_HEIGHT = $d093ab29b3a03f8a$var$BOARD_HEIGHT + $d093ab29b3a03f8a$var$CONTROL_HEIGHT;
const $d093ab29b3a03f8a$var$ROW_GAP = 20;
const $d093ab29b3a03f8a$var$TOP_PADDING = 16;
const $d093ab29b3a03f8a$var$BOTTOM_PADDING = 16;
const $d093ab29b3a03f8a$var$ROW_PITCH = $d093ab29b3a03f8a$var$ITEM_HEIGHT + $d093ab29b3a03f8a$var$ROW_GAP;
const $d093ab29b3a03f8a$var$OVERSCAN_ROWS = 2;
const $d093ab29b3a03f8a$var$EMPTY_ID_SET = new Set();
const $d093ab29b3a03f8a$var$EMPTY_STATE_MAP = new Map();
const $d093ab29b3a03f8a$var$EMPTY_STATE = Object.freeze({
    stock: [],
    waste: [],
    tableau: Array.from({
        length: 7
    }, ()=>({
            faceDown: [],
            faceUp: []
        })),
    foundations: [
        [],
        [],
        [],
        []
    ],
    drawSize: 3
});
// Stable identity for cloneElement props — a fresh array every render
// would defeat SpectatedSolitaire's React.memo.
const $d093ab29b3a03f8a$var$PREVIEW_DISABLED_CONTROLS = [
    "minimize",
    "maximize",
    "close"
];
const $d093ab29b3a03f8a$var$StaticGame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function StaticGame({ gameId: gameId, state: state = $d093ab29b3a03f8a$var$EMPTY_STATE }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $523f633b3aed431a$export$2e2bcd8739ae039), {
        title: `Game #${gameId} \u{2014} Solitaire Alone Together`,
        state: state,
        titleIcon: "solitaire",
        cardBack: (0, $ec53346e7fcdea16$export$5a8a79c6ad2fc273)(gameId),
        interactive: false,
        inactive: true,
        controls: [
            "minimize",
            "maximize",
            "close"
        ],
        disabledControls: [
            "minimize",
            "maximize",
            "close"
        ],
        menus: [
            {
                label: "Game",
                disabled: true
            },
            {
                label: "Help",
                disabled: true
            }
        ]
    });
});
function $d093ab29b3a03f8a$var$ActiveGamesWindow({ gameIds: gameIds, endedGameIds: endedGameIds, readyGameIds: readyGameIds, finalStates: finalStates = $d093ab29b3a03f8a$var$EMPTY_STATE_MAP, gameSlots: gameSlots, watchDisabledIds: watchDisabledIds = $d093ab29b3a03f8a$var$EMPTY_ID_SET, width: width, height: height, fill: fill = false, inactive: inactive = false, suspended: suspended = false, onRangeChange: onRangeChange, onLoadFinal: onLoadFinal, onWatch: onWatch, onMinimize: onMinimize, onClose: onClose }) {
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const gridRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const latestScrollTopRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const [viewportHeight, setViewportHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(Math.max(1, (height ?? 435) - 54));
    const [columns, setColumns] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [scrollTop, setScrollTop] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = scrollerRef.current;
        if (!el) return undefined;
        const read = ()=>{
            setViewportHeight(el.clientHeight);
            // CSS Grid owns horizontal layout; reading its resolved track list
            // tells virtualization how many IDs make one row.
            const template = gridRef.current ? getComputedStyle(gridRef.current).gridTemplateColumns.trim() : "";
            const nextColumns = template && template !== "none" ? template.split(/\s+/).length : 1;
            setColumns((prev)=>prev === nextColumns ? prev : nextColumns);
        };
        read();
        const ro = new ResizeObserver(read);
        ro.observe(el);
        return ()=>ro.disconnect();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            if (frameRef.current != null) cancelAnimationFrame(frameRef.current);
        }, []);
    const onScroll = (e)=>{
        latestScrollTopRef.current = e.currentTarget.scrollTop;
        if (frameRef.current != null) return;
        frameRef.current = requestAnimationFrame(()=>{
            frameRef.current = null;
            setScrollTop(latestScrollTopRef.current);
        });
    };
    const totalRows = Math.ceil(gameIds.length / columns);
    const firstVisibleRow = Math.floor(Math.max(0, scrollTop - $d093ab29b3a03f8a$var$TOP_PADDING) / $d093ab29b3a03f8a$var$ROW_PITCH);
    const lastVisibleRow = Math.floor(Math.max(0, scrollTop + viewportHeight - 1 - $d093ab29b3a03f8a$var$TOP_PADDING) / $d093ab29b3a03f8a$var$ROW_PITCH);
    const firstRow = Math.max(0, firstVisibleRow - $d093ab29b3a03f8a$var$OVERSCAN_ROWS);
    const lastRow = Math.min(Math.max(0, totalRows - 1), lastVisibleRow + $d093ab29b3a03f8a$var$OVERSCAN_ROWS);
    const firstIndex = firstRow * columns;
    const lastIndex = Math.min(gameIds.length, (lastRow + 1) * columns);
    const renderedIds = gameIds.slice(firstIndex, lastIndex);
    // Ended entries stay in the request until their final board arrives.
    // The wire only names an ended id for the celebration join (a win
    // mid-cascade answers with won_elapsed_ms); the final board comes over
    // HTTP below, so an offscreen ending still settles into its real final
    // state rather than a permanently dim empty board.
    const requestedIds = suspended ? [] : renderedIds.filter((id)=>!endedGameIds.has(id) || !finalStates.has(id));
    const requestedKey = requestedIds.join(",");
    // Ended stubs in (or near) view fetch their final board from the Past
    // Games endpoint; the hook dedupes and retries the just-ended
    // persistence race.
    const neededFinalsKey = suspended ? "" : renderedIds.filter((id)=>endedGameIds.has(id) && !finalStates.has(id)).join(",");
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!onLoadFinal || neededFinalsKey === "") return;
        for (const raw of neededFinalsKey.split(","))onLoadFinal(Number(raw));
    }, [
        neededFinalsKey,
        onLoadFinal
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // A short debounce collapses momentum-scroll churn. Two overscan
        // rows hide the delay while keeping honest use comfortably below
        // the server's independent browse-rate bucket.
        const t = setTimeout(()=>onRangeChange(requestedIds), 150);
        return ()=>clearTimeout(t);
    // requestedKey is the stable wire identity; requestedIds is
    // intentionally rebuilt from the latest roster on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        requestedKey,
        onRangeChange
    ]);
    const slotById = new Map(gameSlots.map((slot)=>[
            String(slot.key),
            slot
        ]));
    const activeCount = gameIds.reduce((count, id)=>count + (endedGameIds.has(id) ? 0 : 1), 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$StyledWindow, {
        title: "All Active Games",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
            name: "all-games",
            size: 16
        }),
        controls: [
            "minimize",
            "close"
        ],
        onControlClick: (control)=>{
            if (control === "minimize") onMinimize();
            else if (control === "close") onClose();
        },
        inactive: inactive,
        "data-fill": fill ? "true" : undefined,
        statusFields: [
            activeCount > 0 ? `${activeCount} other ${activeCount === 1 ? "game" : "games"} in progress` : "you're the only one here right now"
        ],
        style: {
            "--browser-w": fill ? "100%" : `${width}px`,
            "--browser-h": fill ? "100%" : `${height}px`
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$Scroller, {
            ref: scrollerRef,
            onScroll: onScroll,
            "data-active-games-scroller": true,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$Spacer, {
                style: {
                    height: Math.max(0, $d093ab29b3a03f8a$var$TOP_PADDING + totalRows * $d093ab29b3a03f8a$var$ROW_PITCH - $d093ab29b3a03f8a$var$ROW_GAP + $d093ab29b3a03f8a$var$BOTTOM_PADDING)
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$GameGrid, {
                    ref: gridRef,
                    style: {
                        "--grid-top": `${$d093ab29b3a03f8a$var$TOP_PADDING + firstRow * $d093ab29b3a03f8a$var$ROW_PITCH}px`
                    },
                    children: renderedIds.map((gameId)=>{
                        const ended = endedGameIds.has(gameId);
                        const slot = slotById.get(String(gameId));
                        const finalState = finalStates.get(gameId);
                        const loaded = ended ? finalState != null : readyGameIds.has(gameId) && slot != null;
                        const watchable = loaded && !watchDisabledIds.has(gameId);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d093ab29b3a03f8a$var$GameItem, {
                            "data-active-game-id": gameId,
                            "data-active-game-loaded": loaded ? "true" : "false",
                            "data-active-game-ended": ended ? "true" : undefined,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$Preview, {
                                    "data-placeholder": !loaded ? "true" : undefined,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$ScaleBox, {
                                        children: ended && finalState ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$StaticGame, {
                                            gameId: gameId,
                                            state: finalState
                                        }) : loaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(slot, {
                                            ambientSound: false,
                                            disabledControls: $d093ab29b3a03f8a$var$PREVIEW_DISABLED_CONTROLS
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$StaticGame, {
                                            gameId: gameId
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d093ab29b3a03f8a$var$ControlStrip, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d093ab29b3a03f8a$var$GameLabel, {
                                            children: [
                                                "Game #",
                                                gameId
                                            ]
                                        }),
                                        ended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d093ab29b3a03f8a$var$EndedLabel, {
                                            children: "Ended"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            "aria-label": `Watch Game #${gameId}`,
                                            disabled: !watchable,
                                            onClick: ()=>onWatch(gameId),
                                            children: "Watch"
                                        })
                                    ]
                                })
                            ]
                        }, gameId);
                    })
                })
            })
        })
    });
}
const $d093ab29b3a03f8a$var$StyledWindow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $68869157a003f4ce$export$2e2bcd8739ae039))`
  width: var(--browser-w);
  height: var(--browser-h);
`;
const $d093ab29b3a03f8a$var$Scroller = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  height: 100%;
  overflow-y: auto;
  background: #808080;
  border: 2px solid;
  border-color: #404040 #fff #fff #404040;
  /* Touch scrolling/long-press must never select the game labels or
     preview boards. */
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
`;
const $d093ab29b3a03f8a$var$Spacer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  min-height: 100%;
`;
const $d093ab29b3a03f8a$var$GameGrid = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  top: var(--grid-top);
  left: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, ${$d093ab29b3a03f8a$var$ITEM_WIDTH}px);
  grid-auto-rows: ${$d093ab29b3a03f8a$var$ITEM_HEIGHT}px;
  justify-content: space-around;
  row-gap: ${$d093ab29b3a03f8a$var$ROW_GAP}px;
`;
const $d093ab29b3a03f8a$var$GameItem = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: ${$d093ab29b3a03f8a$var$ITEM_WIDTH}px;
  height: ${$d093ab29b3a03f8a$var$ITEM_HEIGHT}px;
`;
const $d093ab29b3a03f8a$var$Preview = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: ${$d093ab29b3a03f8a$var$ITEM_WIDTH}px;
  height: ${$d093ab29b3a03f8a$var$BOARD_HEIGHT}px;
  overflow: hidden;
  pointer-events: none;

  &[data-placeholder="true"] {
    filter: grayscale(0.35) brightness(0.62);
    opacity: 0.72;
  }

`;
const $d093ab29b3a03f8a$var$ScaleBox = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  transform: scale(${$d093ab29b3a03f8a$var$SCALE});
  transform-origin: top left;
`;
const $d093ab29b3a03f8a$var$ControlStrip = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  box-sizing: border-box;
  height: ${$d093ab29b3a03f8a$var$CONTROL_HEIGHT}px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 4px;
  background: #c0c0c0;
  border-top: 1px solid #fff;
  box-shadow:
    inset -1px -1px #404040,
    inset 1px 1px #dfdfdf;

  button {
    min-width: 62px;
    padding: 2px 10px;
  }
`;
const $d093ab29b3a03f8a$var$GameLabel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const $d093ab29b3a03f8a$var$EndedLabel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  padding: 0 6px;
  color: #404040;
`;
var $d093ab29b3a03f8a$export$2e2bcd8739ae039 = $d093ab29b3a03f8a$var$ActiveGamesWindow;






var $acw62 = parcelRequire("acw62");
// True on narrow (phone-ish) viewports — including phones held sideways,
// which are wide but far too short for full-size windows. The desktop
// metaphor scales down rather than being replaced: same chrome, compact
// arrangement.
const $f8c2256ec504592b$var$QUERY = "(max-width: 700px), (max-height: 500px)";
function $f8c2256ec504592b$export$2e2bcd8739ae039() {
    const [compact, setCompact] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof window !== "undefined" && window.matchMedia($f8c2256ec504592b$var$QUERY).matches);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const mql = window.matchMedia($f8c2256ec504592b$var$QUERY);
        const onChange = (e)=>setCompact(e.matches);
        mql.addEventListener("change", onChange);
        return ()=>mql.removeEventListener("change", onChange);
    }, []);
    return compact;
}
function $f8c2256ec504592b$export$d699905dd57c73ca() {
    const read = ()=>typeof window !== "undefined" ? {
            width: window.innerWidth,
            height: window.innerHeight
        } : {
            width: 1600,
            height: 900
        };
    const [size, setSize] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(read);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onResize = ()=>setSize(read());
        window.addEventListener("resize", onResize);
        return ()=>window.removeEventListener("resize", onResize);
    }, []);
    return size;
}
function $f8c2256ec504592b$export$3ce37a513c68c53() {
    return $f8c2256ec504592b$export$d699905dd57c73ca().width;
}








var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");

// Preserve MessageBox's small semantic API while routing its artwork
// through the same swappable period-icon manifest as the rest of the UI.
function $9b214a41817fd354$var$MsgIcon({ kind: kind = "question", size: size = 32, className: className }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
        name: `message-${kind}`,
        size: size,
        className: className
    });
}
var $9b214a41817fd354$export$2e2bcd8739ae039 = $9b214a41817fd354$var$MsgIcon;





// THE Win95 message box — every modal dialog in the piece renders
// through this one component. Anatomy: title bar, 32px icon at the
// left of left-aligned text, centered button row. The scrim is part
// of the component: clicking outside the box answers with a ding +
// title-bar flash rather than doing nothing (Win95's "this dialog
// owns you" gesture).
//
// Keyboard (whole-window listeners; modalGate silences everything
// else while mounted): Enter = default (first) button, Escape =
// onCancel when given, Tab cycles the buttons.
//
// Button guard: clicks are ignored for a beat after mount, so a click
// aimed at a dialog this one replaced in place can't land on this
// one's button. Remount-per-content is the caller's job (key on the
// dialog id).
const $fc07faf54de939b5$var$FLASH_TOGGLES = 6; // 3 off/on cycles of the title bar
const $fc07faf54de939b5$var$FLASH_MS = 60;
function $fc07faf54de939b5$var$MessageBox({ title: title, icon: icon = "question", buttons: buttons, onCancel: onCancel, children: children }) {
    const [armed, setArmed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const t = setTimeout(()=>setArmed(true), 350);
        return ()=>clearTimeout(t);
    }, []);
    // Title-bar flash: rapid active/inactive toggling, counted down by an
    // interval. Restarted (not stacked) if they keep clicking outside.
    const [flashLeft, setFlashLeft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (flashLeft <= 0) return undefined;
        const t = setTimeout(()=>setFlashLeft((n)=>n - 1), $fc07faf54de939b5$var$FLASH_MS);
        return ()=>clearTimeout(t);
    }, [
        flashLeft
    ]);
    const rebuff = ()=>{
        (0, $ffdb7a25fbb7044c$export$a636d5f53a584b37)();
        setFlashLeft($fc07faf54de939b5$var$FLASH_TOGGLES);
    };
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // Focus lands on the default button; Tab cycles inside the dialog.
        const root = rootRef.current;
        if (!root) return undefined;
        const buttonEls = ()=>Array.from(root.querySelectorAll("button"));
        buttonEls()[0]?.focus();
        const onKey = (e)=>{
            if (e.key === "Tab") {
                const els = buttonEls();
                if (els.length === 0) return;
                e.preventDefault();
                const i = els.indexOf(document.activeElement);
                const next = (i + (e.shiftKey ? -1 : 1) + els.length) % els.length;
                els[next].focus();
            } else if (e.key === "Enter") {
                e.preventDefault();
                const el = document.activeElement;
                if (el && buttonEls().includes(el)) el.click();
                else buttonEls()[0]?.click();
            } else if (e.key === "Escape" && onCancel) {
                e.preventDefault();
                onCancel();
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fc07faf54de939b5$var$Scrim, {
        onMouseDown: rebuff,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fc07faf54de939b5$var$BoxWrap, {
            ref: rootRef,
            onMouseDown: (e)=>e.stopPropagation(),
            "data-flash-dim": flashLeft % 2 === 1 ? "true" : undefined,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68869157a003f4ce$export$2e2bcd8739ae039), {
                title: title,
                inactive: flashLeft % 2 === 1,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fc07faf54de939b5$var$Body, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fc07faf54de939b5$var$Message, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b214a41817fd354$export$2e2bcd8739ae039), {
                                    kind: icon,
                                    size: 32
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fc07faf54de939b5$var$MessageText, {
                                    children: children
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fc07faf54de939b5$var$Buttons, {
                            children: buttons.map((b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: armed ? b.onClick : undefined,
                                    children: b.label
                                }, b.label))
                        })
                    ]
                })
            })
        })
    });
}
// Truly modal: the scrim catches every pointer event, so nothing behind
// the dialog is interactable while it's up — and it answers the click.
const $fc07faf54de939b5$var$Scrim = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $fc07faf54de939b5$var$BoxWrap = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  min-width: 260px;
  max-width: 400px;
`;
const $fc07faf54de939b5$var$Body = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  padding: 14px 18px 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const $fc07faf54de939b5$var$Message = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  /* Icon rides the top-left like a real Win9x message box — stays
     visible on tall bodies. */
  align-items: flex-start;
  gap: 14px;
  text-align: left;

  & p {
    margin: 0;
  }
`;
const $fc07faf54de939b5$var$MessageText = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  margin: 0;
`;
const $fc07faf54de939b5$var$Buttons = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  gap: 8px;

  & button {
    min-width: 74px;
  }
`;
var $fc07faf54de939b5$export$2e2bcd8739ae039 = $fc07faf54de939b5$var$MessageBox;





var $acw62 = parcelRequire("acw62");

// Hand-recorded window arrangements, made in the Layout Studio
// (`?layout`, a standalone tool with no server/boot) and pasted here.
// Multiple entries may share a width/height: they're VARIANTS of the
// same room, and a session picks one at random.
//
// Shape: { width, height,            // the resolution it was made at
//          self: {x, y},             // your window's center offset
//          neighbors: [{x, y}, …] }  // one per seat; LENGTH sets how
//                                    // many neighbors this room shows.
// Coordinates are window-CENTER offsets from the viewport center, in
// zoomed CSS px — exactly what PositionedWindow's `position` takes.
//
// The loader never demands an exact match: chooseLayout picks the
// nearest recorded size and applyLayout stretches its offsets to the
// real viewport (scale clamped so rooms neither crunch nor fly apart)
// and then clamps every window to reachability — a short window gets a
// gracefully squashed version of the nearest room, not a broken one.
const $bba88ad91e659bf9$export$98152132b21eabe0 = [
    {
        "width": 1280,
        "height": 660,
        "self": {
            "x": 0,
            "y": 0
        },
        "neighbors": [
            {
                "x": -274,
                "y": -98
            },
            {
                "x": 342,
                "y": -85
            },
            {
                "x": 407,
                "y": 172
            }
        ]
    },
    {
        "width": 1512,
        "height": 830,
        "self": {
            "x": 0,
            "y": 0
        },
        "neighbors": [
            {
                "x": -399,
                "y": -169
            },
            {
                "x": -276,
                "y": 156
            },
            {
                "x": 417,
                "y": -193
            },
            {
                "x": 90,
                "y": -112
            },
            {
                "x": 580,
                "y": 250
            }
        ]
    },
    {
        "width": 1920,
        "height": 950,
        "self": {
            "x": 0,
            "y": 0
        },
        "neighbors": [
            {
                "x": -466,
                "y": -202
            },
            {
                "x": 126,
                "y": -151
            },
            {
                "x": 764,
                "y": -244
            },
            {
                "x": -593,
                "y": 255
            },
            {
                "x": 644,
                "y": 268
            }
        ]
    },
    {
        "width": 2560,
        "height": 1300,
        "self": {
            "x": 0,
            "y": 9
        },
        "neighbors": [
            {
                "x": -597,
                "y": -135
            },
            {
                "x": -772,
                "y": -409
            },
            {
                "x": 88,
                "y": -329
            },
            {
                "x": -744,
                "y": 261
            },
            {
                "x": 934,
                "y": -415
            },
            {
                "x": 40,
                "y": 373
            },
            {
                "x": 773,
                "y": 319
            },
            {
                "x": 873,
                "y": 32
            }
        ]
    },
    {
        "width": 1600,
        "height": 520,
        "self": {
            "x": -228,
            "y": -8
        },
        "neighbors": [
            {
                "x": 589,
                "y": 137
            },
            {
                "x": 220,
                "y": -42
            }
        ]
    }
];
function $bba88ad91e659bf9$export$9de203fcc6e657de(w, h, layouts = $bba88ad91e659bf9$export$98152132b21eabe0, rand = Math.random) {
    if (!layouts.length) return null;
    let bestScore = Infinity;
    for (const l of layouts){
        const score = Math.abs(Math.log(w / l.width)) + Math.abs(Math.log(h / l.height));
        if (score < bestScore) bestScore = score;
    }
    const winners = layouts.filter((l)=>Math.abs(Math.log(w / l.width)) + Math.abs(Math.log(h / l.height)) === bestScore);
    return winners[Math.floor(rand() * winners.length) % winners.length];
}
// How far offsets stretch before we'd rather let clamping take over —
// unbounded scaling would fling a 1280px room across a 5120px wall.
const $bba88ad91e659bf9$var$MIN_STRETCH = 0.6;
const $bba88ad91e659bf9$var$MAX_STRETCH = 1.5;
function $bba88ad91e659bf9$export$8ba37776491df5b8(layout, { W: W, H: H, winW: winW, winH: winH, taskbar: taskbar }) {
    const sx = Math.min($bba88ad91e659bf9$var$MAX_STRETCH, Math.max($bba88ad91e659bf9$var$MIN_STRETCH, W / layout.width));
    const sy = Math.min($bba88ad91e659bf9$var$MAX_STRETCH, Math.max($bba88ad91e659bf9$var$MIN_STRETCH, H / layout.height));
    const GRAB_X = 60;
    const clamp = (p)=>{
        let cx = W / 2 + p.x * sx;
        let cy = H / 2 + p.y * sy;
        cx = Math.max(GRAB_X - winW / 2, Math.min(W - GRAB_X + winW / 2, cx));
        cy = Math.max(winH / 2, Math.min(H - taskbar - 24 + winH / 2, cy));
        return {
            x: Math.round(cx - W / 2),
            y: Math.round(cy - H / 2)
        };
    };
    return {
        self: clamp(layout.self ?? {
            x: 0,
            y: 0
        }),
        neighbors: layout.neighbors.map(clamp)
    };
}


const $1116e8cea5385e22$export$30aa94369a2bd63f = 620;
const $1116e8cea5385e22$export$c958d123d2828377 = 435;
const $1116e8cea5385e22$export$2873c030859a950d = 5;
function $1116e8cea5385e22$var$readUiZoom() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--ui-zoom");
    const n = parseFloat(raw);
    return Number.isFinite(n) && n > 0 ? n : 1;
}
function $1116e8cea5385e22$export$2e2bcd8739ae039(compact) {
    const roomRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    if (!compact && roomRef.current === undefined) {
        const zoom = $1116e8cea5385e22$var$readUiZoom();
        const W = window.innerWidth / zoom;
        const H = window.innerHeight / zoom;
        const chosen = (0, $bba88ad91e659bf9$export$9de203fcc6e657de)(W, H);
        roomRef.current = chosen ? (0, $bba88ad91e659bf9$export$8ba37776491df5b8)(chosen, {
            W: W,
            H: H,
            winW: $1116e8cea5385e22$export$30aa94369a2bd63f,
            winH: $1116e8cea5385e22$export$c958d123d2828377,
            taskbar: (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef)
        }) : null;
    }
    return roomRef.current ?? null;
}





// The desktop's window registry as a pure state machine (same philosophy
// as engine/gameMachine.js): ONE source of truth, everything else
// derived. A window exists iff it's in the stack — so the taskbar,
// minimize state, focus, and z-order cannot disagree with each other.
//
// State shape:
//   {
//     stack: [ { id, kind, minimized, modal, priority, openSeq, payload } ],
//     popup: { id, ... } | null,
//     nextSeq,
//   }
// stack is back-to-front: ARRAY ORDER IS THE Z-ORDER. openSeq is a
// monotonic counter recording when each window was first opened — the
// taskbar lists windows in open order (real Win95), not stack order.
//
// Modality: at most ONE modal window, ever. Opening a modal while one is
// up either REPLACES it (strictly higher priority — e.g. "timed out"
// over "still there?") or is REFUSED (equal/lower). Refusals return the
// state object unchanged (===), so callers can detect and log them. A
// modal is always top of stack; while it's up, focus/minimize/taskbar
// ops on other windows are refused (the caller answers those with the
// Win95 ding + title-bar flash).
//
// Pure module: no React, no DOM. Side-effectful concerns (minimize
// zoom rectangles, sounds) live with the caller.
const $26590d9c4cc3e906$export$79d3df7dce95d7c4 = Object.freeze({
    GAME: "game",
    TOOL: "tool",
    DIALOG: "dialog"
});
const $26590d9c4cc3e906$export$bb34f3538ba26c7e = Object.freeze({
    TIMED_OUT: 100,
    CONFIRM: 50,
    NET_TROUBLE: 30,
    STILL_THERE: 20
});
const $26590d9c4cc3e906$export$d4c72bab9d6cc13a = Object.freeze({
    stack: [],
    popup: null,
    nextSeq: 1
});
function $26590d9c4cc3e906$export$38b2d434cce3ea22(state, id) {
    return state.stack.find((w)=>w.id === id) ?? null;
}
function $26590d9c4cc3e906$export$ea0830439c7fc698(state, id) {
    return $26590d9c4cc3e906$export$38b2d434cce3ea22(state, id) != null;
}
function $26590d9c4cc3e906$export$6c721b2b43376760(state, id) {
    const w = $26590d9c4cc3e906$export$38b2d434cce3ea22(state, id);
    return w ? w.minimized : false;
}
function $26590d9c4cc3e906$export$d959a9128ff4ea89(state) {
    const top = state.stack[state.stack.length - 1];
    return top && top.modal ? top : null;
}
function $26590d9c4cc3e906$export$40613afbd9ffdb28(state) {
    const m = $26590d9c4cc3e906$export$d959a9128ff4ea89(state);
    if (m) return m.id;
    for(let i = state.stack.length - 1; i >= 0; i--){
        if (!state.stack[i].minimized) return state.stack[i].id;
    }
    return null;
}
function $26590d9c4cc3e906$export$e4efc616fd443112(state, id) {
    const i = state.stack.findIndex((w)=>w.id === id);
    return i < 0 ? 1 : i + 2;
}
function $26590d9c4cc3e906$export$5ddce467f995da5c(state) {
    return state.stack.filter((w)=>w.kind !== $26590d9c4cc3e906$export$79d3df7dce95d7c4.DIALOG && w.taskbar !== false).slice().sort((a, b)=>{
        if (!!a.pin !== !!b.pin) return a.pin ? -1 : 1;
        return a.openSeq - b.openSeq;
    });
}
// ---------------------------------------------------------------------
// Transitions
// ---------------------------------------------------------------------
function $26590d9c4cc3e906$var$raise(stack, id) {
    const i = stack.findIndex((w)=>w.id === id);
    if (i < 0 || i === stack.length - 1) return stack;
    const w = stack[i];
    return [
        ...stack.slice(0, i),
        ...stack.slice(i + 1),
        w
    ];
}
function $26590d9c4cc3e906$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        // open {id, kind, modal?, priority?, payload?}
        // Existing window: raise + restore (+ refresh payload). New window:
        // push on top — except a new NON-modal under an active modal, which
        // slots in just beneath it (the modal must stay top).
        case "open":
            {
                const { id: id, kind: kind, modal: modal = false, priority: priority = 0, payload: payload, taskbar: // Some windows never get a taskbar button (Display Properties —
                // control-panel dialogs didn't have one in Win95 either).
                taskbar = true, behind: // Passive arrivals (neighbor windows dealt in by the server)
                // open at the BOTTOM of the stack — they must never cover the
                // window you're using.
                behind = false, pin: // Pinned windows lead the taskbar regardless of open order.
                pin = false } = action;
                const existing = $26590d9c4cc3e906$export$38b2d434cce3ea22(state, id);
                const curModal = $26590d9c4cc3e906$export$d959a9128ff4ea89(state);
                if (existing) {
                    if (curModal && curModal.id !== id) return state; // refused
                    // Idempotence guard: re-opening the already-topmost window with
                    // the same payload is a no-op (===), so declarative "keep this
                    // open" effects can dispatch freely without looping.
                    if (!existing.minimized && state.stack[state.stack.length - 1] === existing && (payload === undefined || payload === existing.payload)) return state;
                    const stack = $26590d9c4cc3e906$var$raise(state.stack, id).map((w)=>w.id === id ? {
                            ...w,
                            minimized: false,
                            payload: payload ?? w.payload,
                            // Same-id re-opens may re-rank (the system-notice slot
                            // swaps content and priority together).
                            priority: action.priority ?? w.priority
                        } : w);
                    return {
                        ...state,
                        stack: stack
                    };
                }
                const win = {
                    id: id,
                    kind: kind,
                    modal: modal,
                    priority: priority,
                    minimized: false,
                    openSeq: state.nextSeq,
                    payload: payload,
                    taskbar: taskbar,
                    pin: pin
                };
                if (behind && !modal) return {
                    ...state,
                    stack: [
                        win,
                        ...state.stack
                    ],
                    nextSeq: state.nextSeq + 1
                };
                if (curModal) {
                    if (modal) {
                        if (priority > curModal.priority) {
                            // Replace: the newcomer's premise supersedes (timed-out over
                            // still-there). The replaced dialog does NOT come back — its
                            // premise is stale by definition.
                            const stack = [
                                ...state.stack.filter((w)=>w.id !== curModal.id),
                                win
                            ];
                            return {
                                ...state,
                                stack: stack,
                                popup: null,
                                nextSeq: state.nextSeq + 1
                            };
                        }
                        return state; // refused: one modal at a time
                    }
                    // Non-modal opens go UNDER the modal.
                    const stack = [
                        ...state.stack.slice(0, -1),
                        win,
                        curModal
                    ];
                    return {
                        ...state,
                        stack: stack,
                        nextSeq: state.nextSeq + 1
                    };
                }
                return {
                    ...state,
                    stack: [
                        ...state.stack,
                        win
                    ],
                    // Opening a window dismisses any transient popup (menus close
                    // when the world changes under them).
                    popup: modal ? null : state.popup,
                    nextSeq: state.nextSeq + 1
                };
            }
        // close {id}: remove from existence. The ONLY way a window leaves,
        // and it leaves everywhere at once (taskbar, focus, z-order).
        case "close":
            if (!$26590d9c4cc3e906$export$ea0830439c7fc698(state, action.id)) return state;
            return {
                ...state,
                stack: state.stack.filter((w)=>w.id !== action.id)
            };
        // focus {id}: raise + restore. Refused for non-modal targets while a
        // modal is up (you can't focus past a modal).
        case "focus":
            {
                const w = $26590d9c4cc3e906$export$38b2d434cce3ea22(state, action.id);
                if (!w) return state;
                const m = $26590d9c4cc3e906$export$d959a9128ff4ea89(state);
                if (m && m.id !== action.id) return state; // refused
                if (!w.minimized && state.stack[state.stack.length - 1] === w) return state; // already focused
                const stack = $26590d9c4cc3e906$var$raise(state.stack, action.id).map((x)=>x.id === action.id ? {
                        ...x,
                        minimized: false
                    } : x);
                return {
                    ...state,
                    stack: stack
                };
            }
        // minimize {id}: keep stack position, hide. Modals can't minimize.
        case "minimize":
            {
                const w = $26590d9c4cc3e906$export$38b2d434cce3ea22(state, action.id);
                if (!w || w.modal || w.minimized) return state;
                if ($26590d9c4cc3e906$export$d959a9128ff4ea89(state)) return state; // refused under a modal
                return {
                    ...state,
                    stack: state.stack.map((x)=>x.id === action.id ? {
                            ...x,
                            minimized: true
                        } : x)
                };
            }
        // taskbarClick {id}: the Win95 button rule — restore if minimized,
        // minimize if it's the active window, raise otherwise.
        case "taskbarClick":
            {
                const w = $26590d9c4cc3e906$export$38b2d434cce3ea22(state, action.id);
                if (!w) return state;
                if ($26590d9c4cc3e906$export$d959a9128ff4ea89(state)) return state; // refused: modal owns input
                if (w.minimized) return $26590d9c4cc3e906$export$1650419e431d3ba3(state, {
                    type: "focus",
                    id: action.id
                });
                if ($26590d9c4cc3e906$export$40613afbd9ffdb28(state) === action.id) return $26590d9c4cc3e906$export$1650419e431d3ba3(state, {
                    type: "minimize",
                    id: action.id
                });
                return $26590d9c4cc3e906$export$1650419e431d3ba3(state, {
                    type: "focus",
                    id: action.id
                });
            }
        // Transient popups (Start menu, context menus): one slot, at most
        // one open; opening another replaces it. Refused while a modal is up.
        case "openPopup":
            if ($26590d9c4cc3e906$export$d959a9128ff4ea89(state)) return state;
            return {
                ...state,
                popup: action.popup
            };
        case "closePopup":
            if (state.popup == null) return state;
            return {
                ...state,
                popup: null
            };
        default:
            return state;
    }
}



var $1d63b2be859c85cf$exports = {};
$1d63b2be859c85cf$exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAbCAQAAAAw%2F6wXAAABGklEQVR42oXSvyvEYQDH8ff3TvgHbEoUg1Imi5LxOKQYHItuMN2iLEQGZbrNf%2BD%2BAItBKX%2BAyT%2Bgc5PJjyjR%2BX7fBr49pzzu%2FUxPvfo8ywNlanRpDtnm38qI1LqsLIrsEG0em1bzpRi5M7NqfKmMTQ0oTjRzI0cxoqnrWY4iJKAIiaJA4igQA1o1RxGin66EpUDiqBTIq%2FrhgHSePZjLyZVDvqu7IhVmyU%2B%2B0rCY4anaMpEDQt8rR2KhUbyeSlWXLNxTCKSECyKHwBreqBciy79I0qYCQG%2FxYUvNHEmTy86Hnpgm77gvfVbrIqP8NMEwoSE8UR%2Fty6jzd8n5WFt1054X%2BqPffd%2FJN0xuGY%2FMFFuknFEiIdoMg53XL18POWwuhxJFAAAAAElFTkSuQmCC";


// The Stage is the desktop (see CLAUDE.md "Arrival"). Flow:
//   login  — Win95 logon dialog over the bare desktop; the OK click is
//            the user gesture that unlocks audio.
//   scene  — first visit only: the real cursor hides and a scripted
//            ghost cursor opens Start → Programs → Solitaire Alone
//            Together. Any click skips it.
//   play   — your game window centered, About on top (first visit),
//            neighbors scattered behind at reduced scale, some hanging
//            off the edges. No camera, no zoom, ever.
// Every game window renders at 1:1 — a real desktop doesn't have
// shrunken windows, and fractional scaling resamples the pixel
// font/sprites into mush. The room reads through overlap and off-edge
// hang instead of size.
const $210cc6c367e16937$var$EMPTY_ID_SET = new Set();
const $210cc6c367e16937$var$EMPTY_STATE_MAP = new Map();
// Visible-neighbor cap is always slotsRef.current.length — one window
// per slot, never more — so recorded layouts (layouts.js) can seat
// rooms of any size without overflow windows colliding at a fallback slot.
const $210cc6c367e16937$var$BOOT_SEEN_KEY = "saat.bootSeen";
// Re-show the full opening after a week away.
const $210cc6c367e16937$var$BOOT_RESHOW_MS = 604800000;
const $210cc6c367e16937$var$SELF_ID = "self";
function $210cc6c367e16937$var$readUiZoom() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--ui-zoom");
    const n = parseFloat(raw);
    return Number.isFinite(n) && n > 0 ? n : 1;
}
// Five neighbor slots: 2 "top row-ish" with strong vertical variation,
// 3 "bottom row-ish" staggered rather than a straight row, so the
// desktop peeks through instead of reading as a grid. The upper-left
// corner stays clear for desktop icons. Windows may hang a little
// off-edge (OFF_EDGE), never mostly offscreen.
const $210cc6c367e16937$var$SCATTER_ANCHORS = [
    // top pair (right of the icon column, y's far apart)
    {
        x: 0.06,
        y: -0.45
    },
    {
        x: 0.36,
        y: -0.28
    },
    // bottom trio (staggered, not a straight row)
    {
        x: -0.34,
        y: 0.34
    },
    {
        x: 0.04,
        y: 0.5
    },
    {
        x: 0.38,
        y: 0.2
    }
];
function $210cc6c367e16937$var$generateScatterSlots() {
    const zoom = $210cc6c367e16937$var$readUiZoom();
    const W = window.innerWidth / zoom;
    const H = (window.innerHeight - (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef)) / zoom;
    const jitter = (n)=>(Math.random() * 2 - 1) * n;
    // Spawn clamp: at most OFF_EDGE px of a window may hang off any
    // side, and the title bar always stays fully reachable (top edge
    // on-screen, bar above the taskbar). Coordinates are window-center
    // offsets from the viewport center.
    const OFF_EDGE = 120;
    const maxX = Math.max(0, W / 2 - (0, $1116e8cea5385e22$export$30aa94369a2bd63f) / 2 + OFF_EDGE);
    const minY = 6 - H / 2 + (0, $1116e8cea5385e22$export$c958d123d2828377) / 2; // top edge on-screen
    const maxY = H / 2 - (0, $1116e8cea5385e22$export$c958d123d2828377) / 2 + OFF_EDGE;
    return $210cc6c367e16937$var$SCATTER_ANCHORS.map((a)=>{
        const x = Math.max(-maxX, Math.min(maxX, a.x * W + jitter(70)));
        const y = Math.max(minY, Math.min(Math.max(minY, maxY), a.y * H + jitter(90)));
        return {
            x: x,
            y: y
        };
    });
}
// Dev knob: `?fakechaos=40` fills All Active Games with N locally
// simulated boards so virtualization can be tested without a full room.
function $210cc6c367e16937$var$readFakeChaos() {
    const raw = new URLSearchParams(window.location.search).get("fakechaos");
    const n = parseInt(raw ?? "", 10);
    return Number.isFinite(n) && n > 0 ? Math.min(n, 200) : 0;
}
function $210cc6c367e16937$var$fakeChaosStates(count) {
    const states = [];
    for(let i = 0; i < count; i++){
        let st = (0, $73d8f6063558c0ab$export$4021de1c0df2c0bd)(1000000 + i);
        let seed = (i + 1) * 2654435761;
        const rand = ()=>{
            seed = seed * 1664525 + 1013904223 >>> 0;
            return seed / 2 ** 32;
        };
        const moves = 10 + Math.floor(rand() * 40);
        for(let m = 0; m < moves; m++){
            const legal = (0, $73d8f6063558c0ab$export$36208696e3534245)(st);
            if (legal.length === 0) break;
            st = (0, $73d8f6063558c0ab$export$ccb438d1838ccb16)(st, Math.floor(rand() * legal.length));
        }
        states.push(st);
    }
    return states;
}
function $210cc6c367e16937$var$Stage({ playerSlot: playerSlot, neighborSlots: neighborSlots, browserGameSlots: browserGameSlots = [], playerGameId: playerGameId, playerGameOver: // True once the server has timed the game out: the window is gone
// (closed, no taskbar button); the system notice handles what's next.
playerGameOver = false, playerGameWon: // True once your own win has echoed back: "Deal New Game" has nothing
// to abandon and skips the confirm.
playerGameWon = false, systemNotice: // The one ambient notice App wants shown (already priority-selected:
// timed-out > net-trouble > still-there), or null. Renders through
// the same modal slot as every other dialog.
systemNotice = null, dealNewGame: dealNewGame, abandonGame: // Powering off gives the game up immediately (fire-and-forget wire
// abandon) — you can't resume a computer you turned off.
abandonGame, roomActive: roomActive = 0, browseGameIds: browseGameIds = [], browseEndedIds: browseEndedIds = $210cc6c367e16937$var$EMPTY_ID_SET, browseReadyIds: browseReadyIds = $210cc6c367e16937$var$EMPTY_ID_SET, browseFinalStates: browseFinalStates = $210cc6c367e16937$var$EMPTY_STATE_MAP, openGameBrowser: openGameBrowser, setBrowsedGames: setBrowsedGames, loadBrowseFinal: loadBrowseFinal, closeGameBrowser: closeGameBrowser, watchGame: watchGame, unwatchGame: unwatchGame, departGame: // A watched window's departure ceremony finished — the hook hides it
// until the server's reseat welcome turns the seat over.
departGame, quietArrivalIds: // Game ids whose windows must open silently — reconnect reseats of
// seats that died offline. Everything else joining mid-play gets the
// wireframe arrival.
quietArrivalIds = $210cc6c367e16937$var$EMPTY_ID_SET, roomLayout: roomLayout = null, onPhaseChange: onPhaseChange }) {
    const compact = (0, $f8c2256ec504592b$export$2e2bcd8739ae039)();
    const { width: viewportWidth, height: viewportHeight } = (0, $f8c2256ec504592b$export$d699905dd57c73ca)();
    // `?boot` forces the full first-visit opening (POST, splash, scene)
    // without having to clear localStorage by hand.
    const forceBoot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new URLSearchParams(window.location.search).has("boot"), []);
    // `?noboot`: dev knob for automated tests — skips the scene/About and
    // shrinks the POST hold, so a fresh profile doesn't sit through the
    // whole scripted opening. The login click stays (it's the
    // audio-unlock gesture).
    const skipBoot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new URLSearchParams(window.location.search).has("noboot"), []);
    const firstVisit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (skipBoot) return false;
        if (forceBoot) return true;
        // Settings → "always play the opening scene": desktop only — compact
        // has no scene, so the pref would just re-pop About every visit there.
        if (!compact && (0, $213c0628df7e524f$export$5e210d233dcded1b)((0, $902e75abad36f2b4$export$73949e2aa20bbaf4), false)) return true;
        try {
            // The stamp is the last time the opening finished (unparseable
            // values are treated as long-ago). Away a week or more re-shows it.
            const t = parseInt(localStorage.getItem($210cc6c367e16937$var$BOOT_SEEN_KEY), 10);
            if (!Number.isFinite(t)) return true;
            return Date.now() - t > $210cc6c367e16937$var$BOOT_RESHOW_MS;
        } catch  {
            return true; // storage denied — treat every visit as the first
        }
    }, [
        skipBoot,
        forceBoot,
        compact
    ]);
    // post → login → scene (first visit, not compact) → play. POST plays
    // every visit — App already shows it while the socket connects, and
    // holding it a beat longer lets boot cover loading.
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("post");
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (phase === "post") {
            const t = setTimeout(()=>setPhase("login"), skipBoot ? 50 : 1700);
            return ()=>clearTimeout(t);
        }
        return undefined;
    }, [
        phase,
        skipBoot
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (onPhaseChange) onPhaseChange(phase);
    }, [
        phase,
        onPhaseChange
    ]);
    // Which beat of the scripted scene we're on (drives menu state).
    const [sceneBeat, setSceneBeat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // Act 2 of the scene: phase is already "play" (the desk is up, the
    // game window just booted) but the ghost cursor keeps the stage to
    // open About through the real Help menu.
    const [sceneAct2, setSceneAct2] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The window registry (windowManager.js): one pure reducer owns every
    // window's existence, stacking, focus, minimize state, and the single
    // modal slot. Everything the shell shows is derived from `wm` — no
    // parallel open/minimized/zOrder structures to drift.
    const [wm, wmDispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer((0, $26590d9c4cc3e906$export$1650419e431d3ba3), (0, $26590d9c4cc3e906$export$d4c72bab9d6cc13a));
    const focused = (0, $26590d9c4cc3e906$export$40613afbd9ffdb28)(wm);
    const modalWin = (0, $26590d9c4cc3e906$export$d959a9128ff4ea89)(wm);
    // Transient popups (Start menu, context menus) share the manager's
    // one popup slot: at most one open, opening another replaces it.
    const popup = wm.popup;
    const openPopup = (p)=>wmDispatch({
            type: "openPopup",
            popup: p
        });
    const closePopup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>wmDispatch({
            type: "closePopup"
        }), []);
    const startOpen = popup?.id === "start";
    const setStartOpen = (v)=>v ? openPopup({
            id: "start"
        }) : closePopup();
    const ctxMenu = popup?.id === "ctx" ? popup : null;
    const taskbarMenu = popup?.id === "tb" ? popup : null;
    // Dialogs are windows with modal: true; content travels in the
    // window payload and renders through the one MessageBox host below.
    const openDialog = (id, priority, payload)=>wmDispatch({
            type: "open",
            id: id,
            kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).DIALOG,
            modal: true,
            priority: priority,
            payload: payload
        });
    const closeDialog = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>wmDispatch({
            type: "close",
            id: id
        }), []);
    // Keyboard modality follows the modal slot: while a dialog is up,
    // every useKey outside it goes inert (see modalGate.js).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $8b3c1001fecd4747$export$526b4b9b480d0ce0)(modalWin != null);
        return ()=>(0, $8b3c1001fecd4747$export$526b4b9b480d0ce0)(false);
    }, [
        modalWin
    ]);
    // All Active Games is an ordinary containing window now. Its room
    // roster may be large, but only the virtualized visible+overscan range
    // receives board state and live traffic.
    const chaosOpen = (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "chaos");
    const fakeChaosCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo($210cc6c367e16937$var$readFakeChaos, []);
    const fakeChaos = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fakeChaosCount ? $210cc6c367e16937$var$fakeChaosStates(fakeChaosCount) : [], [
        fakeChaosCount
    ]);
    const fakeChaosIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fakeChaos.map((_, i)=>1000000 + i), [
        fakeChaos
    ]);
    const fakeChaosSlots = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fakeChaos.map((state, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $523f633b3aed431a$export$2e2bcd8739ae039), {
                title: `Game #${1000000 + i} \u{2014} Solitaire Alone Together`,
                state: state,
                interactive: false,
                inactive: true,
                disabledControls: [
                    "minimize",
                    "maximize",
                    "close"
                ]
            }, 1000000 + i)), [
        fakeChaos
    ]);
    const fakeChaosIdSet = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set(fakeChaosIds), [
        fakeChaosIds
    ]);
    const ignoreBrowseRange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{}, []);
    const activeBrowserIds = fakeChaosCount ? fakeChaosIds : browseGameIds;
    const activeBrowserEndedIds = fakeChaosCount ? $210cc6c367e16937$var$EMPTY_ID_SET : browseEndedIds;
    const activeBrowserReadyIds = fakeChaosCount ? fakeChaosIdSet : browseReadyIds;
    const updateBrowserRange = fakeChaosCount ? ignoreBrowseRange : setBrowsedGames ?? ignoreBrowseRange;
    // Larger than one 620x435 game when the viewport permits, capped so a
    // cinema display cannot turn the browser into another unbounded wall.
    // 0.78 makes it a little taller than the game's 0.70 height/width.
    const activeBrowserWidth = Math.min(1060, Math.max(660, viewportWidth - 80));
    const activeBrowserHeight = Math.max(360, Math.min(820, Math.round(activeBrowserWidth * 0.78), viewportHeight - (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef) - 48));
    // Watching a game that already has a desktop window should reveal the
    // thing that's already there, not manufacture another arrival. A short
    // Win95-style active/inactive title-bar flash makes the raised window
    // findable in an overlapping room.
    const [attentionFlash, setAttentionFlash] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!attentionFlash) return undefined;
        const t = setTimeout(()=>{
            setAttentionFlash((prev)=>{
                if (!prev || prev.id !== attentionFlash.id) return prev;
                return prev.toggles <= 1 ? null : {
                    ...prev,
                    toggles: prev.toggles - 1
                };
            });
        }, 80);
        return ()=>clearTimeout(t);
    }, [
        attentionFlash
    ]);
    // Watch is a socket round trip. Compact mode opens the chosen window
    // optimistically; close it again if no authoritative welcome arrives.
    // Optimistic compact-mode watch: the window opens immediately and a
    // 5s timer closes it again if the watch never lands in the
    // authoritative set. Keyed timers ARE the pending state.
    const pendingWatchTimersRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            for (const timer of pendingWatchTimersRef.current.values())clearTimeout(timer);
        }, []);
    // Win95-style confirmation before abandoning your own game — via the
    // titlebar X, the Game menu, or Start -> Deal New Game (all the same
    // semantic: walk away, fresh deal). Copy is verbatim canon.
    const requestDeal = dealNewGame ? ()=>{
        // A won game has nothing to abandon: deal straight away, no dialog.
        if (playerGameWon) {
            dealNewGame();
            return;
        }
        openDialog("dlg:deal", (0, $26590d9c4cc3e906$export$bb34f3538ba26c7e).CONFIRM, {
            title: "Solitaire Alone Together",
            icon: "question",
            message: "Deal a new game?",
            buttons: [
                {
                    label: "OK",
                    onClick: ()=>{
                        closeDialog("dlg:deal");
                        dealNewGame();
                    }
                },
                {
                    label: "Cancel",
                    onClick: ()=>closeDialog("dlg:deal")
                }
            ],
            onCancel: ()=>closeDialog("dlg:deal")
        });
    } : undefined;
    // Dragging the Solitaire icon into the Recycle Bin asks "are you
    // sure" and, on Yes, ends the visit; dragging the Past Games icon in
    // bins it for the session (double-click it in the bin to restore).
    const [binnedViewer, setBinnedViewer] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // One past-game viewer window at a time: opening another entry swaps
    // the contents of the same window and re-foregrounds it —
    // Explorer-with-one-preview, not a window per file.
    const [pastGameId, setPastGameId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const openPastGame = (gameId)=>{
        setPastGameId(gameId);
        openTool("pastgame");
    };
    const [poweredOff, setPoweredOff] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Set the instant Shut Down commits, before the 250ms end-screen
    // beat: the abandon's game_ended can round-trip inside that beat, and
    // the resulting "Timed out" notice must never flash on a machine
    // that's already turning off.
    const [poweringOff, setPoweringOff] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Per-icon "snap back home" functions, registered by the slots at
    // drag end — used to un-freeze the Solitaire icon if the delete
    // confirm is declined.
    const iconRevertsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const registerIconRevert = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id, fn)=>{
        iconRevertsRef.current.set(id, fn);
    }, []);
    const cancelTrash = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        closeDialog("dlg:trash");
        const revert = iconRevertsRef.current.get("solitaire");
        if (revert) revert();
    }, [
        closeDialog
    ]);
    // Kiosk mode (mouse, no keyboard — see kiosk.js): the end screen is a
    // dead end nobody at the install can leave, so there it heals itself —
    // any click, or a short wait, restarts the machine. The guard keeps
    // the tail of the OK double-click from rebooting instantly.
    const kiosk = (0, $b9747e1bfffdb7e5$export$bb6482adf8fb51dc)();
    const poweredOffAtRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!poweredOff) return undefined;
        poweredOffAtRef.current = performance.now();
        if (!kiosk) return undefined;
        const t = setTimeout($210cc6c367e16937$var$restartMachine, $210cc6c367e16937$var$KIOSK_REBOOT_MS);
        return ()=>clearTimeout(t);
    }, [
        poweredOff,
        kiosk
    ]);
    const onEndScreenDown = ()=>{
        if (!kiosk) return;
        if (performance.now() - poweredOffAtRef.current < $210cc6c367e16937$var$KIOSK_REBOOT_GUARD_MS) return;
        $210cc6c367e16937$var$restartMachine();
    };
    // The shared power-off exit (Shut Down "Shut down", binning the
    // Solitaire icon): the game is given up immediately — an off computer
    // can't be resumed. The end screen must come up no matter what
    // window.close() does: iOS Safari can throw on tabs a script didn't
    // open; desktop browsers just ignore it.
    const powerOff = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        // End screen first and unconditionally — every step after is
        // best-effort, since window.close() and audio teardown can throw
        // on iOS Safari and an exception here would leave the game abandoned
        // but the end screen never shown.
        setPoweringOff(true); // suppress notices now, not after the beat
        setTimeout(()=>setPoweredOff(true), 250);
        try {
            if (abandonGame) abandonGame();
        } catch  {}
        try {
            (0, $ffdb7a25fbb7044c$export$3e0a41b1eea2afb3)();
        } catch  {}
        try {
            window.close();
        } catch  {}
    }, [
        abandonGame
    ]);
    const trashSelf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        closeDialog("dlg:trash");
        // Deleting the game deletes the visit.
        powerOff();
    }, [
        closeDialog,
        powerOff
    ]);
    // stats.txt → bin = "start my note over": confirm, zero the localStorage
    // ledger, snap the icon home — the file survives (a fresh one), so
    // nothing lives in the bin afterward.
    const cancelStatsTrash = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        closeDialog("dlg:trash-stats");
        const revert = iconRevertsRef.current.get("stats");
        if (revert) revert();
    }, [
        closeDialog
    ]);
    const trashStats = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        closeDialog("dlg:trash-stats");
        (0, $249580010b86d987$export$83d08c1ad4ef0948)();
        // An open Notepad showing the old numbers would give the delete
        // the lie — close it; reopening reads the fresh zeros.
        wmDispatch({
            type: "close",
            id: "stats"
        });
        const revert = iconRevertsRef.current.get("stats");
        if (revert) revert();
    }, [
        closeDialog
    ]);
    // Shut Down… is the piece's exit gesture, shaped like the real Win95
    // dialog — one modal, three radio choices. Shut down = the black end
    // screen; restart = replay the boot; stand by = the screensaver, now.
    const shutdownChoiceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef("shutdown");
    const cancelShutDown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>closeDialog("dlg:shutdown"), [
        closeDialog
    ]);
    const confirmShutDown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const choice = shutdownChoiceRef.current;
        closeDialog("dlg:shutdown");
        if (choice === "shutdown") // Same exit as binning the Solitaire icon.
        powerOff();
        else if (choice === "restart") $210cc6c367e16937$var$restartMachine();
        else window.dispatchEvent(new Event("saat:force-idle"));
    }, [
        closeDialog,
        powerOff
    ]);
    const openShutDown = ()=>{
        shutdownChoiceRef.current = "shutdown";
        openDialog("dlg:shutdown", (0, $26590d9c4cc3e906$export$bb34f3538ba26c7e).CONFIRM, {
            // Radio copy lives in ShutDownChoices.
            title: "Shut Down Solitaire Alone Together",
            icon: "shutdown",
            message: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$ShutDownChoices, {
                choiceRef: shutdownChoiceRef
            }),
            // OK/Cancel, not Yes/No — the Win98 lead-in isn't a yes/no question.
            buttons: [
                {
                    label: "OK",
                    onClick: confirmShutDown
                },
                {
                    label: "Cancel",
                    onClick: cancelShutDown
                }
            ],
            onCancel: cancelShutDown
        });
    };
    const iconDropped = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id, x, y)=>{
        if (id === "bin") return false;
        const bin = document.querySelector('[data-icon-slot="bin"]');
        if (!bin) return false;
        const r = bin.getBoundingClientRect();
        if (x < r.left || x > r.right || y < r.top || y > r.bottom) return false;
        if (id === "solitaire") {
            // Freeze the icon where it was dropped while the confirm is up;
            // "No" snaps it home via the registered revert.
            openDialog("dlg:trash", (0, $26590d9c4cc3e906$export$bb34f3538ba26c7e).CONFIRM, {
                title: "Confirm Delete",
                icon: "question",
                message: "Are you sure you want to send 'Solitaire Alone Together' to the Recycle Bin?",
                buttons: [
                    {
                        label: "Yes",
                        onClick: trashSelf
                    },
                    {
                        label: "No",
                        onClick: cancelTrash
                    }
                ],
                onCancel: cancelTrash
            });
            return "hold";
        }
        if (id === "viewer") {
            setBinnedViewer(true);
            return "revert"; // home position again when restored from the bin
        }
        if (id === "stats") {
            openDialog("dlg:trash-stats", (0, $26590d9c4cc3e906$export$bb34f3538ba26c7e).CONFIRM, {
                title: "Confirm Delete",
                icon: "question",
                message: "Are you sure you want to clear your stats?",
                buttons: [
                    {
                        label: "Yes",
                        onClick: trashStats
                    },
                    {
                        label: "No",
                        onClick: cancelStatsTrash
                    }
                ],
                onCancel: cancelStatsTrash
            });
            return "hold";
        }
        return false;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        trashSelf,
        cancelTrash,
        trashStats,
        cancelStatsTrash
    ]);
    // Escape backs out of any transient surface, oldest desktop reflex
    // there is. (The Start menu and card selection handle their own;
    // dialogs handle Escape themselves and gate everyone else out via
    // modalGate.)
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("Escape", ()=>{
        closePopup();
        if (chaosOpen) closeChaos();
    });
    const openChaos = ()=>{
        if (chaosOpen) {
            raise("chaos");
            return;
        }
        if (openGameBrowser) openGameBrowser();
        wmDispatch({
            type: "open",
            id: "chaos",
            kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).TOOL
        });
    };
    const closeChaos = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        wmDispatch({
            type: "close",
            id: "chaos"
        });
        if (closeGameBrowser) closeGameBrowser();
    }, [
        closeGameBrowser
    ]);
    // Mobile's containing browser is the default room view. Open it once
    // when the compact desktop arrives; an explicit later close stays closed.
    const compactBrowserOpenedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (phase !== "play" || !compact || compactBrowserOpenedRef.current) return;
        compactBrowserOpenedRef.current = true;
        if (openGameBrowser) openGameBrowser();
        wmDispatch({
            type: "open",
            id: "chaos",
            kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).TOOL
        });
    }, [
        phase,
        compact,
        openGameBrowser
    ]);
    // Watch is the only per-game action: put that game into the visible
    // desktop set, then close the containing browser. The server handles
    // watch before browse_close on the socket's FIFO stream.
    const watchFromChaos = (key)=>{
        const id = String(key);
        const alreadyOnDesktop = (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wmRef.current, id) && visibleNeighbors.some((slot)=>String(slot.key) === id);
        // Ended windows depart and reseat on their own, so a visible desktop
        // window for this id is always the live game: foreground it. Compact
        // leaves All Active Games exactly where it is — the watched window
        // rides on top of it, your own game never moves, and nothing
        // minimizes out from under your thumb.
        if (alreadyOnDesktop) {
            if (!compact) closeChaos();
            raise(id);
            setAttentionFlash({
                id: id,
                toggles: 4
            });
            return;
        }
        if (compact) {
            // Only compact opens a window before the server confirms — only
            // compact needs the give-up timer.
            const oldTimer = pendingWatchTimersRef.current.get(id);
            if (oldTimer != null) clearTimeout(oldTimer);
            pendingWatchTimersRef.current.set(id, setTimeout(()=>{
                pendingWatchTimersRef.current.delete(id);
                wmDispatch({
                    type: "close",
                    id: id
                });
            }, 5000));
        }
        if (watchGame) watchGame(Number(id));
        if (compact) // Open on top immediately; the board appears as soon as the watch
        // snapshot arrives. All Active Games stays open underneath — the
        // watched window is an overlay on top of it.
        wmDispatch({
            type: "open",
            id: id,
            kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).GAME
        });
        else closeChaos();
    };
    // Staggered neighbor reveal after the app "boots".
    const [revealedNeighbors, setRevealedNeighbors] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // Stable scatter: slot positions fixed for the session; game ids keep
    // their slot for as long as they're present. A hand-recorded layout
    // (the Layout Studio, ?layout → layouts.js) wins over the generated
    // scatter: the nearest recorded room is stretched/clamped to this
    // viewport, and its length sets how many neighbors this room seats.
    const recordedLayout = roomLayout;
    const slotByGameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const slotsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const slotLayoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    if (slotsRef.current == null || recordedLayout && slotLayoutRef.current !== recordedLayout) {
        slotsRef.current = recordedLayout ? recordedLayout.neighbors.map((p)=>({
                ...p
            })) : $210cc6c367e16937$var$generateScatterSlots();
        slotLayoutRef.current = recordedLayout;
        slotByGameRef.current = new Map();
    }
    // Desktop right-click -> Refresh re-deals the neighbor scatter, like
    // refreshing icon layout on a real desktop. The nonce forces a render.
    // (A recorded layout is deliberate — refresh keeps it, no jitter.)
    const [, setScatterNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const refreshScatter = ()=>{
        if (!recordedLayout) {
            slotsRef.current = $210cc6c367e16937$var$generateScatterSlots();
            slotByGameRef.current = new Map();
        }
        setScatterNonce((n)=>n + 1);
    };
    // Win95 minimize/restore: a wireframe rectangle zooms between the
    // window and its taskbar button (the window itself just blinks out —
    // that's genuinely what Win95 drew). Rect of a minimized window is
    // remembered so restore can aim back at it.
    const [zoomFx, setZoomFx] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const finishZoomFx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setZoomFx(null), []);
    const lastWinRectRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const wmRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(wm);
    wmRef.current = wm;
    const rectOf = (sel)=>{
        const el = document.querySelector(sel);
        return el ? el.getBoundingClientRect() : null;
    };
    const playZoomFx = (from, to)=>{
        if (!from || !to) return;
        setZoomFx({
            from: from,
            to: to,
            nonce: performance.now()
        });
    };
    // raise/minimize are the reducer's focus/minimize plus the MinAnimate
    // wireframe side effect — the DOM rect capture stays here at the
    // edge; the pure machine never touches the DOM.
    const raise = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        // Raising restores: you can't focus a window that isn't on screen.
        if ((0, $26590d9c4cc3e906$export$6c721b2b43376760)(wmRef.current, id)) playZoomFx(rectOf(`[data-taskbar-button="${id}"]`), lastWinRectRef.current.get(id));
        wmDispatch({
            type: "focus",
            id: id
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const zIndexOf = (id)=>(0, $26590d9c4cc3e906$export$e4efc616fd443112)(wm, id);
    const focusedId = focused;
    const minimize = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        const win = rectOf(`[data-window-box="${id}"]`);
        if (win) {
            lastWinRectRef.current.set(id, win);
            playZoomFx(win, rectOf(`[data-taskbar-button="${id}"]`));
        }
        wmDispatch({
            type: "minimize",
            id: id
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // A game window arriving on the desktop (your own at boot, each
    // staggered neighbor, a witnessed reseat, a Watch addition) uses the
    // same Win95 gesture as a restore: a wireframe zooms from its
    // taskbar button — which appears in the same commit — to its frame,
    // and only then does the window itself exist visually. This is the
    // one arrival animation; a window always either appears instantly or
    // wireframes in. Silent.
    const [arrivingIds, setArrivingIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($210cc6c367e16937$var$EMPTY_ID_SET);
    const arrivalTimersRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const prevGameWindowIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            for (const t of arrivalTimersRef.current.values())clearTimeout(t);
        }, []);
    // Layout effect: the hide must land before the browser paints the
    // freshly-opened window, or it flashes for a frame ahead of its own
    // wireframe.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const current = new Set(wm.stack.filter((w)=>w.kind === (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).GAME).map((w)=>w.id));
        const prev = prevGameWindowIdsRef.current;
        prevGameWindowIdsRef.current = current;
        if (compact || phase !== "play") return;
        for (const id of current){
            if (prev.has(id)) continue;
            if (quietArrivalIds.has(Number(id))) continue;
            const win = rectOf(`[data-window-box="${id}"]`);
            if (!win) continue; // not rendered this commit — appear plainly
            setArrivingIds((s)=>new Set(s).add(id));
            playZoomFx(rectOf(`[data-taskbar-button="${id}"]`), win);
            const old = arrivalTimersRef.current.get(id);
            if (old != null) clearTimeout(old);
            arrivalTimersRef.current.set(id, setTimeout(()=>{
                arrivalTimersRef.current.delete(id);
                setArrivingIds((s)=>{
                    const next = new Set(s);
                    next.delete(id);
                    return next;
                });
            }, $210cc6c367e16937$var$ARRIVAL_HIDE_MS));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wm,
        compact,
        phase,
        quietArrivalIds
    ]);
    // unwatchGame removes the id from the hook's published watched set
    // optimistically, so the slot disappears this same render — no
    // parallel suppression set needed here.
    const closeNeighbor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        if (unwatchGame) unwatchGame(Number(id));
        wmDispatch({
            type: "close",
            id: id
        });
    }, [
        unwatchGame
    ]);
    // Title-bar button clicks for game windows, wired in via cloneElement.
    const onGameControlClick = (id, control)=>{
        if (control === "minimize") minimize(id);
        else if (control === "close") {
            if (id === $210cc6c367e16937$var$SELF_ID) {
                if (requestDeal) requestDeal();
            } else closeNeighbor(id);
        }
    };
    // --- phase transitions ---
    // Every path out of the scene (finished, skipped, or never run)
    // converges here; the About auto-open effect below watches the same
    // states, so About appears exactly once on a first visit no matter
    // which door you left through.
    const enterPlay = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        try {
            // Timestamp, not a flag: firstVisit compares against it to
            // re-show the opening after a week away.
            localStorage.setItem($210cc6c367e16937$var$BOOT_SEEN_KEY, String(Date.now()));
        } catch  {
        // storage denied — they'll just see the scene again next visit
        }
        setStartOpen(false);
        setSceneBeat(0);
        setSceneAct2(false);
        setPhase("play");
    }, []);
    // Rotating/resizing into compact mid-scene used to strand
    // phase="scene" forever (compact renders no scene): every system
    // notice stayed suppressed for the session and BOOT_SEEN was never
    // stamped. Snap to the desk instead.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (compact && (phase === "scene" || sceneAct2)) enterPlay();
    }, [
        compact,
        phase,
        sceneAct2,
        enterPlay
    ]);
    const onLogin = ()=>{
        (0, $ffdb7a25fbb7044c$export$eccddd504975e05d)();
        (0, $ffdb7a25fbb7044c$export$64ef1bee2b9504c1)();
        (0, $ffdb7a25fbb7044c$export$45a3a1ca5d5aecec)(); // the monitor was always on
        // A pending system notice (the game timed out while they were away)
        // means we're resuming a dead session — playing the opening
        // ceremony and stacking About under a "Timed out" dialog would read
        // as nonsense. Reality first, no scene.
        if (firstVisit && !compact && !systemNotice) setPhase("scene");
        else enterPlay();
    };
    // Your own window exists exactly while the game does. Dispatches are
    // idempotent (the reducer answers redundant ops with the same state),
    // so this declarative sync is loop-safe.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (phase !== "play") return;
        if (playerGameOver) wmDispatch({
            type: "close",
            id: $210cc6c367e16937$var$SELF_ID
        });
        else wmDispatch({
            type: "open",
            id: $210cc6c367e16937$var$SELF_ID,
            kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).GAME,
            pin: true
        });
    }, [
        phase,
        playerGameOver
    ]);
    // About auto-opens on top of the fresh game on the first visit —
    // except while the scene's act 2 is running (the ghost cursor opens
    // it through the Help menu; when act 2 ends this re-runs as a no-op
    // if the ghost succeeded, a safety net if it didn't), and except under
    // a pending system notice (About must never stack beneath a dialog).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (phase !== "play" || sceneAct2) return;
        if (firstVisit && !systemNotice) wmDispatch({
            type: "open",
            id: "about",
            kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).TOOL
        });
    // Deliberately NOT reacting to systemNotice: once suppressed,
    // About stays away for the session instead of popping up later
    // when the notice resolves.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        phase,
        sceneAct2
    ]);
    // Neighbors deal in one at a time once we're playing — your window
    // first, then the room assembles behind you. On a first visit the
    // trickle paces the About-reading beat (1-2s apart, still arriving
    // while the ghost hand does act 2); a plain login gets a tighter
    // stagger, the whole room seated in a few seconds.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (phase !== "play") return undefined;
        if (revealedNeighbors >= slotsRef.current.length) return undefined;
        const delay = revealedNeighbors === 0 ? firstVisit ? 900 : 500 : firstVisit ? 1000 + Math.random() * 800 : 650 + Math.random() * 350;
        const t = setTimeout(()=>setRevealedNeighbors((n)=>n + 1), delay);
        return ()=>clearTimeout(t);
    }, [
        phase,
        revealedNeighbors,
        firstVisit
    ]);
    // --- scripted scene ---
    // Where the player's real mouse is, tracked through the scene so the
    // ghost can end its performance there — without this, the hidden real
    // cursor would reappear wherever it physically rested, a visible jump
    // at the handoff.
    const realMouseRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onMove = (e)=>{
            realMouseRef.current = {
                x: e.clientX,
                y: e.clientY
            };
        };
        window.addEventListener("mousemove", onMove);
        return ()=>window.removeEventListener("mousemove", onMove);
    }, []);
    const sceneSteps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            {
                target: "start",
                click: true,
                travelMs: 1300,
                pauseMs: 500
            },
            {
                target: "menu-programs",
                travelMs: 700,
                pauseMs: 550
            },
            {
                target: "menu-solitaire",
                click: true,
                travelMs: 800,
                pauseMs: 700
            },
            // Act 2 — the game window has booted; the same hand opens About
            // through the window's real Help menu (targets live on your
            // window only, tagged in PlayableSolitaire).
            {
                target: "menu-help",
                click: true,
                travelMs: 1000,
                pauseMs: 450
            },
            {
                target: "menu-help-about",
                click: true,
                travelMs: 550,
                pauseMs: 650
            },
            // Curtain call: glide to (nearly) where the real mouse is, so
            // the swap from ghost to real cursor is invisible. If the mouse
            // never moved this visit there's no position to betray — the
            // function target returns null and the beat is skipped.
            {
                target: ()=>{
                    const m = realMouseRef.current;
                    if (!m) return null;
                    const zoom = $210cc6c367e16937$var$readUiZoom();
                    return {
                        x: m.x / zoom - 1,
                        y: m.y / zoom - 1
                    };
                },
                travelMs: 600,
                pauseMs: 150
            }
        ], []);
    // Act-2 beats drive the REAL MenuBar (its own component state) by
    // clicking the actual buttons — no parallel force-open plumbing.
    const sceneClick = (target)=>document.querySelector(`[data-scene-target="${target}"]`)?.click();
    const onSceneStep = (i)=>{
        if (i === 0) setStartOpen(true);
        if (i === 1) setSceneBeat(2); // forces the Programs submenu open
        if (i === 2) {
            // The launch click: menu closes, the desk comes up, and the ghost
            // keeps the stage for act 2. If a system notice slipped in during
            // the scene (game timed out), bail to the desk instead — enterPlay
            // flips sceneAct2 off, which unmounts the ghost before act 2.
            if (systemNotice) enterPlay();
            else {
                setStartOpen(false);
                setSceneBeat(0);
                setSceneAct2(true);
                setPhase("play");
            }
        }
        if (i === 3) sceneClick("menu-help");
        if (i === 4) sceneClick("menu-help-about");
    };
    // --- slot bookkeeping ---
    const liveNeighborIdsKey = neighborSlots.map((slot)=>String(slot.key)).join(",");
    const liveNeighborIds = new Set(neighborSlots.map((slot)=>String(slot.key)));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        for (const id of Array.from(pendingWatchTimersRef.current.keys())){
            if (!liveNeighborIds.has(id)) continue;
            clearTimeout(pendingWatchTimersRef.current.get(id));
            pendingWatchTimersRef.current.delete(id);
        }
    // liveNeighborIdsKey is the stable identity; the Set is rebuilt for
    // the render-time filters below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        liveNeighborIdsKey
    ]);
    const visibleNeighbors = neighborSlots.slice(0, compact ? 8 : slotsRef.current.length);
    {
        // Assign/free slots. Runs during render on refs — cheap and keeps
        // assignment perfectly in sync with what we're about to draw.
        const present = new Set(visibleNeighbors.map((s)=>String(s.key)));
        const map = slotByGameRef.current;
        for (const id of Array.from(map.keys()))if (!present.has(id)) map.delete(id);
        const used = new Set(map.values());
        for (const slot of visibleNeighbors){
            const id = String(slot.key);
            if (map.has(id)) continue;
            for(let i = 0; i < slotsRef.current.length; i++)if (!used.has(i)) {
                map.set(id, i);
                used.add(i);
                break;
            }
        }
    }
    // Neighbor windows exist exactly while their game is in the visible
    // set — opened behind everything (a dealt-in stranger must never
    // cover the window you're using), closed the moment they leave.
    // Registry opens are gated on the reveal counter, so a neighbor's
    // taskbar button appears in the same commit as its window and its
    // arrival wireframe — never a bank of buttons for windows that
    // haven't landed yet.
    const visibleIdsKey = visibleNeighbors.map((s)=>String(s.key)).join(",");
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (phase !== "play") return;
        const present = new Set(visibleIdsKey ? visibleIdsKey.split(",") : []);
        const revealOrder = Array.from(slotByGameRef.current.keys());
        for (const id of present){
            const order = revealOrder.indexOf(id);
            if (order >= 0 && order >= revealedNeighbors) continue;
            if (!(0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wmRef.current, id)) wmDispatch({
                type: "open",
                id: id,
                kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).GAME,
                behind: true
            });
        }
        for (const w of wmRef.current.stack)if (w.kind === (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).GAME && w.id !== $210cc6c367e16937$var$SELF_ID && !present.has(w.id)) wmDispatch({
            type: "close",
            id: w.id
        });
    }, [
        phase,
        visibleIdsKey,
        revealedNeighbors
    ]);
    // Sync App's notice into the modal slot. A notice that loses to an
    // open confirm (lower priority) is refused now and retried when the
    // slot frees up — the wm dep re-runs this effect on every registry
    // change, and the reducer's idempotence makes the retries free.
    const noticeId = systemNotice ? `dlg:notice:${systemNotice.key}` : null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // Wait out the scene's act 2: a dialog popping mid-choreography
        // would stack over the ghost's Help-menu act. It appears the
        // moment the ghost yields the stage. A powered-off machine shows
        // nothing at all — the Shut Down abandon ends our own game, and the
        // resulting "Timed out" notice must not pop under the end screen.
        if (phase !== "play" || sceneAct2 || poweringOff) {
            if (poweringOff) {
                for (const w of wm.stack)if (w.id.startsWith("dlg:notice:")) wmDispatch({
                    type: "close",
                    id: w.id
                });
            }
            return;
        }
        for (const w of wm.stack)if (w.id.startsWith("dlg:notice:") && w.id !== noticeId) wmDispatch({
            type: "close",
            id: w.id
        });
        if (systemNotice) wmDispatch({
            type: "open",
            id: noticeId,
            kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).DIALOG,
            modal: true,
            priority: systemNotice.priority,
            payload: systemNotice
        });
    }, [
        phase,
        sceneAct2,
        systemNotice,
        noticeId,
        wm,
        poweringOff
    ]);
    const isActive = (id)=>focusedId === id;
    // Every taskbar button carries its window's 16px icon, like the real
    // thing did. Labels/icons are presentation; existence and order come
    // from the registry (open order, like real Win95).
    const tbIcon = (name)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
            name: name,
            size: 16
        });
    const tbMeta = (id)=>{
        if (id === $210cc6c367e16937$var$SELF_ID) return {
            label: playerGameId != null ? `(You) Game #${playerGameId}` : "Solitaire Alone Together",
            icon: tbIcon("solitaire")
        };
        if (id === "pastgame") return {
            label: `(Past Game) Game #${pastGameId ?? ""}`,
            icon: tbIcon("solitaire")
        };
        const named = {
            history: {
                label: "Past Games",
                icon: tbIcon("folder")
            },
            about: {
                label: "About",
                icon: tbIcon("information")
            },
            bin: {
                label: "Recycle Bin",
                icon: tbIcon(binnedViewer ? "recycle-bin-full" : "recycle-bin-empty")
            },
            settings: {
                label: "Settings",
                icon: tbIcon("settings")
            },
            stats: {
                label: "stats.txt",
                icon: tbIcon("notepad")
            },
            chaos: {
                label: "All Active Games",
                icon: tbIcon("all-games")
            }
        }[id];
        return named ?? {
            label: `Game #${id}`,
            icon: tbIcon("solitaire")
        };
    };
    // The rest of the room: everyone live beyond your visible neighbors.
    // One taskbar identity for it: while the window is visible it's named
    // "All Active Games"; minimized or closed, the button advertises what's
    // behind it — "and N more…" — falling back to the name when there's
    // nothing to count. Mobile always says "All Active Games" (zero seeded
    // games there; "more" than what?).
    const moreCount = fakeChaosCount || Math.max(0, roomActive - 1 - visibleNeighbors.length);
    const moreLabel = compact || moreCount === 0 ? "All Active Games" : `and ${moreCount} more\u{2026}`;
    // The closed launcher waits out the arrival parade: windows and their
    // taskbar buttons appear together, and the room's "and N more…" must
    // not show up before the room itself has finished sitting down.
    const paradeDone = compact || revealedNeighbors >= slotsRef.current.length;
    const taskbarWindows = [
        ...(0, $26590d9c4cc3e906$export$5ddce467f995da5c)(wm).map((w)=>({
                id: w.id,
                ...tbMeta(w.id),
                ...w.id === "chaos" && w.minimized ? {
                    label: moreLabel
                } : {},
                active: isActive(w.id)
            })),
        ...!chaosOpen && moreCount > 0 && paradeDone ? [
            {
                id: "chaos",
                label: moreLabel,
                icon: tbIcon("all-games"),
                active: false
            }
        ] : []
    ];
    const openTool = (id)=>{
        if ((0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wmRef.current, id)) raise(id); // raise() plays restore fx
        else wmDispatch({
            type: "open",
            id: id,
            kind: (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).TOOL,
            // Display Properties is a control-panel dialog: no taskbar
            // button, exactly like the real one.
            taskbar: id !== "display"
        });
    };
    const closeTool = (id)=>wmDispatch({
            type: "close",
            id: id
        });
    // Real Win95 taskbar-button behavior: restore if minimized, minimize
    // if it's the active window, otherwise bring to front.
    const onTaskbarWindowClick = (id)=>{
        // The closed "and N more…" launcher is not a registry window yet.
        if (id === "chaos" && !(0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, id)) return openChaos();
        const w = (0, $26590d9c4cc3e906$export$38b2d434cce3ea22)(wm, id);
        if (!w) return;
        if (w.minimized) raise(id);
        else if (focusedId === id) minimize(id);
        else raise(id);
    };
    const onTaskbarWindowContextMenu = (id, e)=>{
        const zoom = $210cc6c367e16937$var$readUiZoom();
        openPopup({
            id: "tb",
            winId: id,
            x: e.clientX / zoom,
            y: e.clientY / zoom
        });
    };
    const closeAnyWindow = (id)=>{
        if (id === $210cc6c367e16937$var$SELF_ID) {
            if (requestDeal) requestDeal();
        } else if (id === "chaos") closeChaos();
        else if ((0, $26590d9c4cc3e906$export$38b2d434cce3ea22)(wm, id)?.kind === (0, $26590d9c4cc3e906$export$79d3df7dce95d7c4).TOOL) closeTool(id);
        else closeNeighbor(id);
    };
    const startMenuItems = [
        {
            label: "Programs",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                name: "folder",
                size: 16
            }),
            sceneTarget: "menu-programs",
            submenu: [
                {
                    label: "Solitaire Alone Together",
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "solitaire",
                        size: 16
                    }),
                    sceneTarget: "menu-solitaire",
                    onClick: ()=>raise($210cc6c367e16937$var$SELF_ID)
                },
                {
                    label: "Past Games",
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "folder",
                        size: 16
                    }),
                    onClick: ()=>openTool("history")
                },
                // All Active Games is always reachable. On mobile it starts open,
                // but this entry can bring it back after an explicit close.
                {
                    label: "All Active Games",
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "all-games",
                        size: 16
                    }),
                    onClick: ()=>openChaos()
                },
                {
                    label: "stats.txt",
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "text-file",
                        size: 16
                    }),
                    onClick: ()=>openTool("stats")
                }
            ]
        },
        "separator",
        {
            label: "Settings",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                name: "settings",
                size: 16
            }),
            onClick: ()=>openTool("settings")
        },
        "separator",
        {
            label: "Deal New Game",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                name: "solitaire",
                size: 16
            }),
            onClick: ()=>requestDeal && requestDeal(),
            disabled: !requestDeal
        },
        "separator",
        {
            label: "About Solitaire\u2026",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                name: "information",
                size: 16
            }),
            onClick: ()=>openTool("about")
        },
        "separator",
        {
            label: "Shut Down\u2026",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                name: "shutdown",
                size: 16
            }),
            onClick: openShutDown
        }
    ];
    // The dialog host: whatever modal the registry holds renders here,
    // through the one MessageBox. Keyed by id so a replacement (still-
    // there → timed-out) remounts and re-arms the button guard.
    const dialogHost = modalWin && modalWin.payload && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$DialogHost, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc07faf54de939b5$export$2e2bcd8739ae039), {
            title: modalWin.payload.title,
            icon: modalWin.payload.icon,
            buttons: modalWin.payload.buttons,
            onCancel: modalWin.payload.onCancel,
            children: modalWin.payload.message
        }, modalWin.id)
    });
    // The exit: black screen, machine off. Verbatim canon copy.
    const endScreen = poweredOff && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$EndScreen, {
        onMouseDown: onEndScreenDown,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "It's now safe to close this tab."
        })
    });
    const inScene = phase === "scene";
    const inPlay = phase === "play";
    // ------------------------------------------------------------------
    // Compact (phone) layout: login gate, then a compact desktop. All Active
    // Games is the room view and starts open; ordinary watched windows are
    // zero. Watch adds explicit game windows to this desktop. No scripted
    // scene on phones.
    // ------------------------------------------------------------------
    if (compact) {
        // Sideways phone: not enough height for a stacked column, so the
        // browser sits beside your game instead of above it.
        const isLandscape = viewportHeight <= 520 && viewportWidth > viewportHeight;
        const gameScale = isLandscape ? Math.min(1, (viewportHeight - (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef) - 16) / (0, $1116e8cea5385e22$export$c958d123d2828377), (viewportWidth - 12) * 0.62 / (0, $1116e8cea5385e22$export$30aa94369a2bd63f)) : Math.min(1, (viewportWidth - 8) / (0, $1116e8cea5385e22$export$30aa94369a2bd63f));
        // 0.5 exactly: halving keeps the pixel font/sprites legible in a way
        // arbitrary fractions don't.
        const neighborScale = 0.5;
        // Compact shows ONE tool window at a time: the topmost open one in
        // the registry (raise-on-open makes taskbar clicks switch between
        // them). The old fixed priority chain meant opening the bin while
        // the viewer was up showed a taskbar button for… nothing.
        const COMPACT_TOOLS = [
            "history",
            "bin",
            "stats",
            "about",
            "settings"
        ];
        const compactTool = [
            ...wm.stack
        ].filter((w)=>COMPACT_TOOLS.includes(w.id) && !w.minimized).pop()?.id ?? null;
        const compactTaskbarWindows = (0, $26590d9c4cc3e906$export$5ddce467f995da5c)(wm).map((w)=>({
                id: w.id,
                ...tbMeta(w.id),
                active: focusedId === w.id
            }));
        // The full desktop's icon set, compact-sized. The Solitaire icon
        // scrolls your always-present game into view — same gesture as its
        // taskbar button.
        const scrollCompactSelf = ()=>{
            raise($210cc6c367e16937$var$SELF_ID);
            document.querySelector("[data-compact-self]")?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        };
        const openCompactChaos = ()=>{
            openChaos();
            requestAnimationFrame(()=>document.querySelector("[data-compact-chaos]")?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                }));
        };
        const compactIcons = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$CompactIconStrip, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "solitaire",
                        size: 32
                    }),
                    label: "Solitaire Alone Together",
                    onOpen: scrollCompactSelf
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "folder",
                        size: 32
                    }),
                    label: "Past Games",
                    onOpen: ()=>openTool("history")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "all-games",
                        size: 32
                    }),
                    label: "All Active Games",
                    onOpen: openCompactChaos
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                        name: "text-file",
                        size: 32
                    }),
                    label: "stats.txt",
                    onOpen: ()=>openTool("stats")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CompactBinSlot, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d97721bde78e9860$export$3f06a51bda79210f), {
                        full: binnedViewer,
                        onOpen: ()=>openTool("bin")
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$Viewport, {
            onMouseDown: ()=>setStartOpen(false),
            // Long-press on phones spawns the browser context menu over the
            // '95 chrome; the desktop branch suppresses it, compact now too.
            onContextMenu: (e)=>e.preventDefault(),
            children: [
                phase === "post" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc26afc7f31cd267$export$2e2bcd8739ae039), {
                    instant: true
                }) : phase === "login" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $126dd6f61a64a0c7$export$2e2bcd8739ae039), {
                    onEnter: onLogin
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$CompactColumn, {
                    "data-landscape": isLandscape ? "true" : undefined,
                    style: {
                        "--taskbar-h": (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef) + "px"
                    },
                    children: [
                        !isLandscape && compactIcons,
                        (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "chaos") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                            "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "chaos") ? "true" : undefined,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$TouchDragBox, {
                                fill: true,
                                "data-compact-chaos": "true",
                                onActivate: ()=>raise("chaos"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d093ab29b3a03f8a$export$2e2bcd8739ae039), {
                                    gameIds: activeBrowserIds,
                                    endedGameIds: activeBrowserEndedIds,
                                    readyGameIds: activeBrowserReadyIds,
                                    finalStates: browseFinalStates,
                                    gameSlots: [
                                        ...browserGameSlots,
                                        ...fakeChaosSlots
                                    ],
                                    watchDisabledIds: fakeChaosIdSet,
                                    fill: true,
                                    inactive: focusedId !== "chaos",
                                    suspended: (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "chaos"),
                                    onRangeChange: updateBrowserRange,
                                    onLoadFinal: loadBrowseFinal,
                                    onWatch: watchFromChaos,
                                    onMinimize: ()=>minimize("chaos"),
                                    onClose: closeChaos
                                })
                            })
                        }),
                        isLandscape ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$LandscapeRail, {
                            children: [
                                compactIcons,
                                !playerGameOver && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$TouchDragBox, {
                                    "data-compact-self": "true",
                                    style: {
                                        "--w": Math.ceil((0, $1116e8cea5385e22$export$30aa94369a2bd63f) * gameScale) + "px",
                                        "--h": Math.ceil((0, $1116e8cea5385e22$export$c958d123d2828377) * gameScale) + "px"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$ScaleBox, {
                                        style: {
                                            "--scale": gameScale
                                        },
                                        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(playerSlot, {
                                            dealNewGame: requestDeal,
                                            // Close = walk away (same confirm as desktop);
                                            // minimize has nowhere to go in the dock.
                                            disabledControls: [
                                                "minimize",
                                                "maximize"
                                            ],
                                            onControlClick: (control)=>control === "close" && requestDeal && requestDeal()
                                        })
                                    })
                                })
                            ]
                        }) : !playerGameOver ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$TouchDragBox, {
                            "data-compact-self": "true",
                            style: {
                                "--w": Math.ceil((0, $1116e8cea5385e22$export$30aa94369a2bd63f) * gameScale) + "px",
                                "--h": Math.ceil((0, $1116e8cea5385e22$export$c958d123d2828377) * gameScale) + "px"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$ScaleBox, {
                                style: {
                                    "--scale": gameScale
                                },
                                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(playerSlot, {
                                    dealNewGame: requestDeal,
                                    disabledControls: [
                                        "minimize",
                                        "maximize"
                                    ],
                                    onControlClick: (control)=>control === "close" && requestDeal && requestDeal()
                                })
                            })
                        }) : null
                    ]
                }),
                phase === "play" && visibleNeighbors.map((slot)=>{
                    const id = String(slot.key);
                    if (!(0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, id) || (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, id)) return null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CompactGameLayer, {
                        style: {
                            "--z": 100 + zIndexOf(id)
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$TouchDragBox, {
                            "data-compact-game": id,
                            onActivate: ()=>raise(id),
                            style: {
                                "--w": Math.ceil((0, $1116e8cea5385e22$export$30aa94369a2bd63f) * neighborScale) + "px",
                                "--h": Math.ceil((0, $1116e8cea5385e22$export$c958d123d2828377) * neighborScale) + "px"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$ScaleBox, {
                                style: {
                                    "--scale": neighborScale
                                },
                                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(slot, {
                                    inactive: focusedId !== id || attentionFlash?.id === id && attentionFlash.toggles % 2 === 1,
                                    disabledControls: [
                                        "maximize"
                                    ],
                                    onControlClick: (control)=>onGameControlClick(id, control),
                                    onHelpAbout: ()=>openTool("about"),
                                    onDeparted: ()=>departGame?.(Number(id))
                                })
                            })
                        })
                    }, id);
                }),
                phase === "play" && pastGameId != null && (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "pastgame") && !(0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "pastgame") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CompactGameLayer, {
                    style: {
                        "--z": 100 + zIndexOf("pastgame")
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$TouchDragBox, {
                        "data-compact-game": "pastgame",
                        onActivate: ()=>raise("pastgame"),
                        style: {
                            "--w": (0, $523f633b3aed431a$export$1f7f5491a289dcff)(0.5).width + "px",
                            "--h": (0, $523f633b3aed431a$export$1f7f5491a289dcff)(0.5).height + "px"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4399e4a175c0590$export$2e2bcd8739ae039), {
                            gameId: pastGameId,
                            inactive: focusedId !== "pastgame",
                            onClose: ()=>closeTool("pastgame")
                        })
                    })
                }),
                compactTool != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$CompactToolLayer, {
                    style: {
                        "--z": 100 + zIndexOf(compactTool)
                    },
                    children: [
                        compactTool === "history" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CompactScaler, {
                            style: {
                                "--scale": gameScale,
                                "--w": "620px",
                                "--h": "440px"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$ScaleBox, {
                                style: {
                                    "--scale": gameScale
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5a252a010a2a0a6$export$2e2bcd8739ae039), {
                                    onClose: ()=>closeTool("history"),
                                    onOpenGame: openPastGame
                                })
                            })
                        }),
                        compactTool === "bin" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d97721bde78e9860$export$bcd92586a2930384), {
                            onClose: ()=>closeTool("bin")
                        }),
                        compactTool === "stats" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83b929d59f755c5f$export$2e2bcd8739ae039), {
                            onClose: ()=>closeTool("stats")
                        }),
                        compactTool === "about" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7127b1122afa3ceb$export$2e2bcd8739ae039), {
                            onClose: ()=>closeTool("about")
                        }),
                        compactTool === "settings" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $902e75abad36f2b4$export$2e2bcd8739ae039), {
                            onClose: ()=>closeTool("settings")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2026809cde12e7e$export$2e2bcd8739ae039), {
                    windows: phase === "login" ? [] : compactTaskbarWindows,
                    onWindowClick: (id)=>{
                        // Your own game remains docked in the scroll column.
                        if (id === $210cc6c367e16937$var$SELF_ID) {
                            raise(id);
                            document.querySelector("[data-compact-self]")?.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                            return;
                        }
                        const restoringBrowser = id === "chaos" && (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "chaos");
                        onTaskbarWindowClick(id);
                        if (restoringBrowser) requestAnimationFrame(()=>document.querySelector("[data-compact-chaos]")?.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            }));
                    },
                    startOpen: startOpen,
                    onStartToggle: ()=>setStartOpen(!startOpen)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29cdb8b3eaf012ca$export$2e2bcd8739ae039), {
                    open: startOpen,
                    onClose: ()=>setStartOpen(false),
                    items: startMenuItems,
                    banner: "Solitaire Alone Together"
                }),
                dialogHost,
                endScreen
            ]
        });
    }
    // ------------------------------------------------------------------
    // Desktop
    // ------------------------------------------------------------------
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$Viewport, {
        "data-bezel": "true",
        "data-hide-cursor": inScene || sceneAct2 ? "true" : undefined,
        // Sound rides the CAPTURE phase so a child's stopPropagation (Start
        // button, menus — they stop the bubble so closePopup can't eat the
        // popup they just opened) can never swallow the click. closePopup
        // stays on the bubble phase for exactly that reason.
        onMouseDownCapture: (0, $ffdb7a25fbb7044c$export$64ef1bee2b9504c1 /* no-ops until audio is unlocked */ ),
        onMouseDown: closePopup,
        onContextMenu: (e)=>{
            // Right-click is Windows right-click everywhere — never the
            // browser menu. The desktop surface gets its menu during play;
            // other surfaces do nothing until they earn a real menu.
            e.preventDefault();
            if (!inPlay) return;
            if (e.target.closest(".window")) return;
            const zoom = $210cc6c367e16937$var$readUiZoom();
            openPopup({
                id: "ctx",
                x: e.clientX / zoom,
                y: e.clientY / zoom
            });
        },
        children: [
            phase === "post" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc26afc7f31cd267$export$2e2bcd8739ae039), {
                instant: true
            }),
            (inScene || inPlay) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$DraggableIconSlot, {
                        id: "solitaire",
                        anchor: {
                            left: 10,
                            top: 12
                        },
                        onDropped: iconDropped,
                        registerRevert: registerIconRevert,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                name: "solitaire",
                                size: 32
                            }),
                            label: "Solitaire Alone Together",
                            onOpen: ()=>raise($210cc6c367e16937$var$SELF_ID)
                        })
                    }),
                    !binnedViewer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$DraggableIconSlot, {
                        id: "viewer",
                        anchor: {
                            left: 10,
                            top: 116
                        },
                        onDropped: iconDropped,
                        registerRevert: registerIconRevert,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                name: "folder",
                                size: 32
                            }),
                            label: "Past Games",
                            onOpen: ()=>openTool("history")
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$DraggableIconSlot, {
                        id: "viewall",
                        anchor: {
                            left: 10,
                            top: 220
                        },
                        onDropped: iconDropped,
                        registerRevert: registerIconRevert,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                name: "all-games",
                                size: 32
                            }),
                            label: "All Active Games",
                            onOpen: ()=>openChaos()
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$DraggableIconSlot, {
                        id: "stats",
                        anchor: {
                            left: 10,
                            top: 324
                        },
                        onDropped: iconDropped,
                        registerRevert: registerIconRevert,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                name: "text-file",
                                size: 32
                            }),
                            label: "stats.txt",
                            onOpen: ()=>openTool("stats")
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$DraggableIconSlot, {
                        id: "bin",
                        anchor: {
                            left: 10,
                            bottom: (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef) + 10
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d97721bde78e9860$export$3f06a51bda79210f), {
                            full: binnedViewer,
                            onOpen: ()=>openTool("bin")
                        })
                    })
                ]
            }),
            inPlay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$World, {
                children: [
                    visibleNeighbors.map((slot)=>{
                        const id = String(slot.key);
                        const slotIdx = slotByGameRef.current.get(id) ?? 0;
                        const pos = slotsRef.current[slotIdx];
                        const order = Array.from(slotByGameRef.current.keys()).indexOf(id);
                        if (order >= revealedNeighbors) return null;
                        // Render only once the registry holds the window: the frame,
                        // its taskbar button, and the arrival wireframe hide all land
                        // in the same commit — no one-frame flash before the outline.
                        if (!(0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, id)) return null;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                            "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, id) ? "true" : undefined,
                            "data-arriving": arrivingIds.has(id) ? "true" : undefined,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                                position: pos,
                                draggable: true,
                                zIndex: zIndexOf(id),
                                boxId: id,
                                onActivate: ()=>raise(id),
                                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(slot, {
                                    inactive: focusedId !== id || attentionFlash?.id === id && attentionFlash.toggles % 2 === 1,
                                    onControlClick: (control)=>onGameControlClick(id, control),
                                    onHelpAbout: ()=>openTool("about"),
                                    onDeparted: ()=>departGame?.(Number(id))
                                })
                            })
                        }, slot.key);
                    }),
                    !playerGameOver && (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, $210cc6c367e16937$var$SELF_ID) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, $210cc6c367e16937$var$SELF_ID) ? "true" : undefined,
                        "data-arriving": arrivingIds.has($210cc6c367e16937$var$SELF_ID) ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: recordedLayout?.self ?? {
                                x: 0,
                                y: 0
                            },
                            draggable: true,
                            zIndex: zIndexOf($210cc6c367e16937$var$SELF_ID),
                            boxId: $210cc6c367e16937$var$SELF_ID,
                            onActivate: ()=>raise($210cc6c367e16937$var$SELF_ID),
                            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(playerSlot, {
                                inactive: focusedId !== $210cc6c367e16937$var$SELF_ID,
                                onControlClick: (control)=>onGameControlClick($210cc6c367e16937$var$SELF_ID, control),
                                onHelpAbout: ()=>openTool("about"),
                                dealNewGame: requestDeal
                            })
                        })
                    })
                ]
            }),
            inPlay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$ToolLayer, {
                children: [
                    (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "history") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "history") ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: {
                                x: 0,
                                y: -40
                            },
                            draggable: true,
                            zIndex: zIndexOf("history"),
                            boxId: "history",
                            onActivate: ()=>raise("history"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5a252a010a2a0a6$export$2e2bcd8739ae039), {
                                inactive: focusedId !== "history",
                                onClose: ()=>closeTool("history"),
                                onHelpAbout: ()=>openTool("about"),
                                onOpenGame: openPastGame
                            })
                        })
                    }),
                    (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "pastgame") && pastGameId != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "pastgame") ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: {
                                x: 60,
                                y: -10
                            },
                            draggable: true,
                            zIndex: zIndexOf("pastgame"),
                            boxId: "pastgame",
                            onActivate: ()=>raise("pastgame"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4399e4a175c0590$export$2e2bcd8739ae039), {
                                gameId: pastGameId,
                                inactive: focusedId !== "pastgame",
                                onClose: ()=>closeTool("pastgame")
                            })
                        })
                    }),
                    (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "chaos") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "chaos") ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: {
                                x: 0,
                                y: -(0, $d2026809cde12e7e$export$e7ce2d3fe3294aef) / 2
                            },
                            draggable: true,
                            zIndex: zIndexOf("chaos"),
                            boxId: "chaos",
                            onActivate: ()=>raise("chaos"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d093ab29b3a03f8a$export$2e2bcd8739ae039), {
                                gameIds: activeBrowserIds,
                                endedGameIds: activeBrowserEndedIds,
                                readyGameIds: activeBrowserReadyIds,
                                finalStates: browseFinalStates,
                                gameSlots: [
                                    ...browserGameSlots,
                                    ...fakeChaosSlots
                                ],
                                watchDisabledIds: fakeChaosIdSet,
                                width: activeBrowserWidth,
                                height: activeBrowserHeight,
                                inactive: focusedId !== "chaos",
                                suspended: (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "chaos"),
                                onRangeChange: updateBrowserRange,
                                onLoadFinal: loadBrowseFinal,
                                onWatch: watchFromChaos,
                                onMinimize: ()=>minimize("chaos"),
                                onClose: closeChaos
                            })
                        })
                    }),
                    (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "about") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "about") ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: {
                                x: 30,
                                y: -10
                            },
                            draggable: true,
                            zIndex: zIndexOf("about"),
                            boxId: "about",
                            onActivate: ()=>raise("about"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7127b1122afa3ceb$export$2e2bcd8739ae039), {
                                inactive: focusedId !== "about",
                                onClose: ()=>closeTool("about")
                            })
                        })
                    }),
                    (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "stats") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "stats") ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: {
                                x: 60,
                                y: 30
                            },
                            draggable: true,
                            zIndex: zIndexOf("stats"),
                            boxId: "stats",
                            onActivate: ()=>raise("stats"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83b929d59f755c5f$export$2e2bcd8739ae039), {
                                inactive: focusedId !== "stats",
                                onClose: ()=>closeTool("stats")
                            })
                        })
                    }),
                    (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "bin") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "bin") ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: {
                                x: -180,
                                y: 120
                            },
                            draggable: true,
                            zIndex: zIndexOf("bin"),
                            boxId: "bin",
                            onActivate: ()=>raise("bin"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d97721bde78e9860$export$bcd92586a2930384), {
                                inactive: focusedId !== "bin",
                                onClose: ()=>closeTool("bin"),
                                items: binnedViewer ? [
                                    {
                                        label: "Past Games",
                                        iconName: "folder",
                                        onRestore: ()=>setBinnedViewer(false)
                                    }
                                ] : []
                            })
                        })
                    }),
                    (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "settings") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "settings") ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: {
                                x: -140,
                                y: -90
                            },
                            draggable: true,
                            zIndex: zIndexOf("settings"),
                            boxId: "settings",
                            onActivate: ()=>raise("settings"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $902e75abad36f2b4$export$2e2bcd8739ae039), {
                                inactive: focusedId !== "settings",
                                onClose: ()=>closeTool("settings")
                            })
                        })
                    }),
                    (0, $26590d9c4cc3e906$export$ea0830439c7fc698)(wm, "display") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$Hidden, {
                        "data-hidden": (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, "display") ? "true" : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a980e0228e57c86d$export$2e2bcd8739ae039), {
                            position: {
                                x: 160,
                                y: -120
                            },
                            draggable: true,
                            zIndex: zIndexOf("display"),
                            boxId: "display",
                            onActivate: ()=>raise("display"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $079dae0934e9e4c7$export$2e2bcd8739ae039), {
                                inactive: focusedId !== "display",
                                onClose: ()=>closeTool("display")
                            })
                        })
                    })
                ]
            }),
            ctxMenu && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$CtxMenu, {
                className: "window",
                style: {
                    "--cx": ctxMenu.x + "px",
                    "--cy": ctxMenu.y + "px"
                },
                onMouseDown: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CtxItem, {
                        type: "button",
                        onClick: ()=>{
                            closePopup();
                            refreshScatter();
                        },
                        children: "Refresh"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CtxSeparator, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CtxItem, {
                        type: "button",
                        onClick: ()=>{
                            closePopup();
                            openTool("display");
                        },
                        children: "Properties"
                    })
                ]
            }),
            (inScene || inPlay) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2026809cde12e7e$export$2e2bcd8739ae039), {
                        windows: inPlay ? taskbarWindows : [],
                        onWindowClick: onTaskbarWindowClick,
                        onWindowContextMenu: onTaskbarWindowContextMenu,
                        startOpen: startOpen,
                        onStartToggle: ()=>setStartOpen(!startOpen)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29cdb8b3eaf012ca$export$2e2bcd8739ae039), {
                        open: startOpen,
                        onClose: ()=>setStartOpen(false),
                        items: startMenuItems,
                        banner: "Solitaire Alone Together",
                        forceSubmenuFor: sceneBeat >= 2 ? "Programs" : undefined,
                        forceHoverFor: sceneBeat === 2 ? "menu-programs" : sceneBeat === 3 ? "menu-solitaire" : undefined
                    })
                ]
            }),
            taskbarMenu && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$CtxMenu, {
                className: "window",
                "data-up": "true",
                style: {
                    "--cx": taskbarMenu.x + "px",
                    "--cy": taskbarMenu.y + "px"
                },
                onMouseDown: (e)=>e.stopPropagation(),
                children: [
                    (0, $26590d9c4cc3e906$export$6c721b2b43376760)(wm, taskbarMenu.winId) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CtxItem, {
                        type: "button",
                        onClick: ()=>{
                            raise(taskbarMenu.winId);
                            closePopup();
                        },
                        children: "Restore"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CtxItem, {
                        type: "button",
                        onClick: ()=>{
                            minimize(taskbarMenu.winId);
                            closePopup();
                        },
                        children: "Minimize"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CtxSeparator, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$CtxItem, {
                        type: "button",
                        onClick: ()=>{
                            closeAnyWindow(taskbarMenu.winId);
                            closePopup();
                        },
                        children: "Close"
                    })
                ]
            }),
            dialogHost,
            endScreen,
            zoomFx && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$ZoomFx, {
                fx: zoomFx,
                onDone: finishZoomFx
            }, zoomFx.nonce),
            phase === "login" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $126dd6f61a64a0c7$export$2e2bcd8739ae039), {
                onEnter: onLogin
            }),
            (inScene || sceneAct2) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6c8befb55b0458f$export$2e2bcd8739ae039), {
                        steps: sceneSteps,
                        startAt: $210cc6c367e16937$var$sceneStartPosition(),
                        onStep: onSceneStep,
                        onDone: enterPlay
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$SceneBlocker, {
                        onMouseDown: enterPlay
                    })
                ]
            })
        ]
    });
}
// The minimize/restore wireframe, the way Win95/98's MinAnimate actually
// drew it: a handful of discrete rectangle outlines stepping from source
// to destination — chunky frames, no easing, no tween. 5 frames at 38ms
// reads as visibly stepped. Coordinates are raw client px (zoom is 1).
const $210cc6c367e16937$var$ZOOM_FX_FRAMES = 5;
const $210cc6c367e16937$var$ZOOM_FX_FRAME_MS = 38;
// An arriving window stays invisible until its wireframe has landed
// (plus a beat so the last outline frame isn't cut off mid-hold).
const $210cc6c367e16937$var$ARRIVAL_HIDE_MS = $210cc6c367e16937$var$ZOOM_FX_FRAMES * $210cc6c367e16937$var$ZOOM_FX_FRAME_MS + 30;
function $210cc6c367e16937$var$ZoomFx({ fx: fx, onDone: onDone }) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = ref.current;
        if (!el) return undefined;
        const lerp = (a, b, t)=>Math.round(a + (b - a) * t);
        const drawFrame = (i)=>{
            const t = i / ($210cc6c367e16937$var$ZOOM_FX_FRAMES - 1);
            el.style.left = lerp(fx.from.left, fx.to.left, t) + "px";
            el.style.top = lerp(fx.from.top, fx.to.top, t) + "px";
            el.style.width = lerp(fx.from.width, fx.to.width, t) + "px";
            el.style.height = lerp(fx.from.height, fx.to.height, t) + "px";
        };
        let frame = 0;
        drawFrame(0);
        const interval = setInterval(()=>{
            frame += 1;
            if (frame >= $210cc6c367e16937$var$ZOOM_FX_FRAMES) {
                clearInterval(interval);
                onDone();
                return;
            }
            drawFrame(frame);
        }, $210cc6c367e16937$var$ZOOM_FX_FRAME_MS);
        return ()=>clearInterval(interval);
    }, [
        fx,
        onDone
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$FxRect, {
        ref: ref,
        "aria-hidden": "true"
    });
}
const $210cc6c367e16937$var$FxRect = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: fixed;
  z-index: 2600;
  pointer-events: none;
  border: 2px solid #dfdfdf;
  box-shadow:
    0 0 0 1px #404040,
    inset 0 0 0 1px #404040;
`;
// Shut Down → Restart: reload into the boot sequence.
function $210cc6c367e16937$var$restartMachine() {
    const url = new URL(window.location.href);
    url.search = "?boot";
    window.location.href = url.toString();
}
const $210cc6c367e16937$var$KIOSK_REBOOT_MS = 20000;
const $210cc6c367e16937$var$KIOSK_REBOOT_GUARD_MS = 1000;
function $210cc6c367e16937$var$sceneStartPosition() {
    const zoom = $210cc6c367e16937$var$readUiZoom();
    return {
        x: window.innerWidth / zoom / 2 + 120,
        y: window.innerHeight / zoom / 2 - 60
    };
}
const $210cc6c367e16937$var$Viewport = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: fixed;
  inset: 0;
  /* iOS Safari: the layout viewport extends under the collapsing URL
     bar, so bottom: 0 would bury the taskbar. dvh tracks what's truly
     visible; vh line is the fallback for older browsers. */
  bottom: auto;
  height: 100vh;
  height: 100dvh;
  /* clip, not hidden: hidden boxes can still be scrolled
     programmatically (scrollIntoView from keyboard focus, find-in-
     page), which would drag the whole desktop — taskbar included —
     off its anchors. clip forbids scrolling outright. */
  overflow: hidden;
  overflow: clip;
  /* The desktop color lives here (body behind it is black bezel). */
  background: var(--desktop-bg);

  /* Desktop only: inset the whole screen a hair inside a black bezel
     with softly rounded corners, so rounded physical displays never
     clip the taskbar corners — and the screen reads a little more like
     glass in a monitor. */
  &[data-bezel="true"] {
    top: 5px;
    left: 5px;
    right: 5px;
    height: calc(100vh - 10px);
    height: calc(100dvh - 10px);
    border-radius: 8px;
  }

  /* One machine, one cursor: the whole desktop (and everything on it)
     uses the period arrow — the same drawing the ghost cursor and the
     neighbors' remote cursors use. !important flattens the browser's
     per-widget cursors (pointer over buttons, I-beam, grab on title
     bars); Win95 showed the arrow for all of those. */
  &,
  & * {
    cursor: url(${(0, (/*@__PURE__*/$parcel$interopDefault($1d63b2be859c85cf$exports)))}) 1 1, default !important;
  }

  &[data-hide-cursor="true"],
  &[data-hide-cursor="true"] * {
    cursor: none !important;
  }
`;
// Centered, unscaled coordinate space for the game windows. No z-index
// of its own — every window (games AND tools) carries its zOrder value
// and they all stack in one shared space, so anything can be raised
// above anything. Desktop icons sit at 1, taskbar at 1000.
const $210cc6c367e16937$var$World = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 50%;
  left: 50%;
`;
// display: contents so it never disturbs positioning; display: none when
// its window is minimized (kept mounted — spectator subscriptions and
// the player's own game state survive the round trip to the taskbar).
const $210cc6c367e16937$var$Hidden = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: contents;

  &[data-hidden="true"] {
    display: none;
  }

  /* Mid-arrival: the window occupies its spot (the wireframe needs a
     real rect to zoom to) but stays invisible until the outline lands.
     visibility inherits straight through display: contents. */
  &[data-arriving="true"] {
    visibility: hidden;
  }
`;
// ---- draggable desktop icons ----
// Each icon has a home slot (its CSS anchor) plus a persisted drag
// offset, so a rearranged desktop survives reload — your machine, your
// mess. Offsets, not absolute positions: an undragged Recycle Bin stays
// glued to the bottom corner across window resizes.
const $210cc6c367e16937$var$ICON_POS_KEY = "saat.iconPos.v1";
function $210cc6c367e16937$var$readIconOffsets() {
    try {
        return JSON.parse(localStorage.getItem($210cc6c367e16937$var$ICON_POS_KEY)) || {};
    } catch  {
        return {};
    }
}
function $210cc6c367e16937$var$writeIconOffset(id, offset) {
    try {
        const all = $210cc6c367e16937$var$readIconOffsets();
        all[id] = offset;
        localStorage.setItem($210cc6c367e16937$var$ICON_POS_KEY, JSON.stringify(all));
    } catch  {
    // storage unavailable — session-only positions are fine
    }
}
// `onDropped(id, clientX, clientY)` fires after a real drag ends and
// says what happens to the icon:
//   false     — normal drop: stays put, position persists
//   "revert"  — snaps home immediately (drop consumed the icon)
//   "hold"    — FREEZES where dropped, nothing persisted; the owner
//               later calls the function passed to `registerRevert` to
//               snap it back (confirm-dialog flows).
// `registerRevert(id, fn)` hands the owner a revert function for this
// slot. While dragging, the slot marks the bin slot with
// data-drop-target when hovering it, like a real drop target.
function $210cc6c367e16937$var$DraggableIconSlot({ id: id, anchor: anchor, onDropped: onDropped, registerRevert: registerRevert, children: children }) {
    const [offset, setOffset] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const o = $210cc6c367e16937$var$readIconOffsets()[id];
        return o && Number.isFinite(o.x) && Number.isFinite(o.y) ? o : {
            x: 0,
            y: 0
        };
    });
    // While in-flight the icon rides above the windows (you're holding
    // it); at rest it lives on the wallpaper beneath them.
    const [dragging, setDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const onPointerDown = (e)=>{
        if (e.button !== 0) return;
        const el = rootRef.current;
        if (!el) return;
        const zoom = $210cc6c367e16937$var$readUiZoom();
        const rect = el.getBoundingClientRect();
        // Movement bounds: the icon stays fully on the desktop (above the
        // taskbar) — Windows never let you strand an icon off-screen.
        const minDx = -rect.left / zoom;
        const maxDx = (window.innerWidth - rect.right) / zoom;
        const minDy = -rect.top / zoom;
        const maxDy = (window.innerHeight - rect.bottom) / zoom - (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef);
        const startX = e.clientX;
        const startY = e.clientY;
        const base = offset;
        let latest = base;
        let moved = false;
        const binEl = id === "bin" ? null : document.querySelector('[data-icon-slot="bin"]');
        const overBin = (ev)=>{
            if (!binEl) return false;
            const r = binEl.getBoundingClientRect();
            return ev.clientX >= r.left && ev.clientX <= r.right && ev.clientY >= r.top && ev.clientY <= r.bottom;
        };
        const markBin = (hot)=>{
            if (!binEl) return;
            if (hot) binEl.setAttribute("data-drop-target", "true");
            else binEl.removeAttribute("data-drop-target");
        };
        const onMove = (ev)=>{
            const dx = (ev.clientX - startX) / zoom;
            const dy = (ev.clientY - startY) / zoom;
            // Small threshold so a plain click (select / double-click open)
            // never registers as a drag.
            if (!moved && Math.hypot(dx, dy) < 4) return;
            if (!moved) setDragging(true);
            moved = true;
            latest = {
                x: base.x + Math.max(minDx, Math.min(maxDx, dx)),
                y: base.y + Math.max(minDy, Math.min(maxDy, dy))
            };
            setOffset(latest);
            markBin(overBin(ev));
        };
        const onUp = (ev)=>{
            window.removeEventListener("pointermove", onMove);
            window.removeEventListener("pointerup", onUp);
            window.removeEventListener("pointercancel", onUp);
            markBin(false);
            if (!moved) {
                setDragging(false);
                return;
            }
            if (registerRevert) registerRevert(id, ()=>{
                setOffset(base);
                setDragging(false);
            });
            const verdict = onDropped && onDropped(id, ev.clientX ?? 0, ev.clientY ?? 0);
            if (verdict === "revert") {
                setOffset(base);
                setDragging(false);
            } else if (verdict === "hold") ;
            else {
                setDragging(false);
                $210cc6c367e16937$var$writeIconOffset(id, latest);
            }
        };
        window.addEventListener("pointermove", onMove);
        window.addEventListener("pointerup", onUp);
        window.addEventListener("pointercancel", onUp);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$IconSlot, {
        ref: rootRef,
        "data-icon-slot": id,
        "data-dragging": dragging ? "true" : undefined,
        onPointerDown: onPointerDown,
        style: {
            ...anchor,
            "--ix": offset.x + "px",
            "--iy": offset.y + "px"
        },
        children: children
    });
}
const $210cc6c367e16937$var$IconSlot = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 1;
  transform: translate(var(--ix, 0px), var(--iy, 0px));
  touch-action: none;

  /* An icon you're holding rides above everything short of the taskbar
     and dialogs — same as dragging a desktop icon over windows in real
     Win95. At rest it drops back under the windows. */
  &[data-dragging="true"] {
    z-index: 950;
  }

  /* Drop-target feedback while another icon is dragged over this one
     (only ever set on the bin): label lights up like a selection. */
  &[data-drop-target="true"] button span:last-child {
    background: #00007b;
    color: #fff;
    text-shadow: none;
    outline: 1px dotted #ffff7b;
  }
`;
// Same coordinate space as World; z comes from each window's zOrder.
const $210cc6c367e16937$var$ToolLayer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 50%;
  left: 50%;
`;
const $210cc6c367e16937$var$CtxMenu = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: var(--cx);
  top: var(--cy);
  z-index: 1200;
  display: flex;
  flex-direction: column;
  min-width: 150px;
  padding: 2px;

  /* Taskbar-button menus open upward, like the real thing. */
  &[data-up="true"] {
    transform: translateY(-100%);
  }
`;
// The modal layer: above every window, the taskbar, and its menus —
// MessageBox's own scrim does the click-swallowing (and answers with
// the ding + title-bar flash).
const $210cc6c367e16937$var$DialogHost = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  z-index: 3000;
`;
// The Shut Down dialog's body uses Win98's phrasing (Stand by was a
// Win98 addition; Win95's "Are you sure you want to:" reads oddly next
// to it). Selection state lives here (the modal registry payload is
// inert), mirrored into choiceRef so the OK button can read the answer.
function $210cc6c367e16937$var$ShutDownChoices({ choiceRef: choiceRef }) {
    const [choice, setChoice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(choiceRef.current);
    const pick = (v)=>{
        choiceRef.current = v;
        setChoice(v);
    };
    const options = [
        [
            "standby",
            "Stand by"
        ],
        [
            "shutdown",
            "Shut down"
        ],
        [
            "restart",
            "Restart"
        ]
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($210cc6c367e16937$var$ShutDownBody, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "What do you want the computer to do?"
            }),
            options.map(([value, label])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "field-row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "radio",
                            id: `shutdown-${value}`,
                            name: "shutdown-choice",
                            checked: choice === value,
                            onChange: ()=>pick(value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: `shutdown-${value}`,
                            children: label
                        })
                    ]
                }, value))
        ]
    });
}
const $210cc6c367e16937$var$ShutDownBody = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;

  & > p {
    margin: 0 0 2px;
  }
`;
// Machine off. Plain black with quiet amber text, above everything.
const $210cc6c367e16937$var$EndScreen = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: fixed;
  inset: 0;
  z-index: 6000;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d88f2a;
  font-size: 18px;
  -webkit-user-select: none;
  user-select: none;
  cursor: default;
`;
const $210cc6c367e16937$var$CtxItem = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  background: transparent;
  border: none;
  box-shadow: none;
  min-height: 0;
  min-width: 0;
  padding: 5px 12px;
  text-align: left;
  font: inherit;
  color: inherit;
  text-shadow: none;

  &&:not(:disabled):hover {
    background: #00007b;
    color: #fff;
    box-shadow: none;
  }
  &&:not(:disabled):active {
    box-shadow: none;
    text-shadow: none;
  }
  &&:focus {
    outline: none;
  }
`;
const $210cc6c367e16937$var$CtxSeparator = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  height: 2px;
  margin: 3px 5px;
  border-top: 1px solid #808080;
  border-bottom: 1px solid #fff;
`;
const $210cc6c367e16937$var$SceneBlocker = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  z-index: 4000;
  cursor: none;
`;
// ---- compact-mode pieces ----
// In-flow draggable wrapper for compact-mode windows. It keeps its slot
// in the layout but can be picked up by the title bar and moved anywhere
// — it's still a window. Pointer events cover mouse and touch alike; the
// fill variant leaves its scrolling client area to the browser.
function $210cc6c367e16937$var$TouchDragBox({ style: style, fill: fill = false, onActivate: onActivate, children: children, ...delegated }) {
    const [d, setD] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const sessionRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        return ()=>{
            const s = sessionRef.current;
            if (!s) return;
            window.removeEventListener("pointermove", s.onMove);
            window.removeEventListener("pointerup", s.onUp);
            window.removeEventListener("pointercancel", s.onUp);
            sessionRef.current = null;
        };
    }, []);
    const onPointerDown = (e)=>{
        if (onActivate) onActivate();
        if (e.target.closest("button, input, [data-no-drag]")) return;
        if (!e.target.closest("[data-drag-handle]")) return;
        e.preventDefault();
        const startX = e.clientX;
        const startY = e.clientY;
        const base = {
            ...d
        };
        const onMove = (ev)=>{
            setD({
                x: base.x + ev.clientX - startX,
                y: base.y + ev.clientY - startY
            });
        };
        const onUp = ()=>{
            window.removeEventListener("pointermove", onMove);
            window.removeEventListener("pointerup", onUp);
            window.removeEventListener("pointercancel", onUp);
            sessionRef.current = null;
        };
        window.addEventListener("pointermove", onMove);
        window.addEventListener("pointerup", onUp);
        window.addEventListener("pointercancel", onUp);
        sessionRef.current = {
            onMove: onMove,
            onUp: onUp
        };
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($210cc6c367e16937$var$DragBox, {
        onPointerDown: onPointerDown,
        style: {
            ...style,
            "--tx": d.x + "px",
            "--ty": d.y + "px"
        },
        "data-draggable": "true",
        "data-fill": fill ? "true" : undefined,
        ...delegated,
        children: children
    });
}
const $210cc6c367e16937$var$DragBox = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  z-index: 20;
  width: var(--w);
  height: var(--h);
  flex-shrink: 0;
  transform: translate(var(--tx), var(--ty));
  touch-action: none;
  /* iOS: a window drag must never double as a long-press selection or
     image callout on whatever the finger crossed (cards included). */
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;

  /* The Other Games wrapper fills its flex slot. Unlike the player's
     board, its client area must keep native momentum scrolling; only
     the title bar claims touch gestures for window dragging. */
  &[data-fill="true"] {
    flex: 1 1 auto;
    align-self: stretch;
    min-width: 0;
    min-height: 0;
    width: auto;
    height: auto;
    touch-action: auto;
  }

  &[data-fill="true"] [data-drag-handle] {
    touch-action: none;
  }
`;
const $210cc6c367e16937$var$CompactColumn = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  bottom: var(--taskbar-h);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 4px 4px 6px;

  &[data-landscape="true"] {
    flex-direction: row;
    align-items: stretch;
  }
`;
// Landscape: icons up top, your game pinned to the bottom-right corner.
const $210cc6c367e16937$var$LandscapeRail = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;
// A slice of wallpaper for the desktop icons — mobile still has a desktop.
const $210cc6c367e16937$var$CompactIconStrip = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  flex-shrink: 0;
`;
const $210cc6c367e16937$var$CompactBinSlot = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  margin-left: auto;
`;
const $210cc6c367e16937$var$CompactScaler = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: calc(var(--w) * var(--scale));
  height: calc(var(--h) * var(--scale));
  flex-shrink: 0;
`;
// Scales fixed-size window subtrees. The transform must live on this
// plain wrapper, NOT on the window itself — SolitaireCore's open
// animation (fill-mode: both) pins `transform` on its frame and would
// silently override any transform we put there.
const $210cc6c367e16937$var$ScaleBox = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  transform: scale(var(--scale));
  transform-origin: top left;
`;
const $210cc6c367e16937$var$CompactToolLayer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  bottom: var(--taskbar-h, 34px);
  z-index: var(--z, 500);
  /* The layer only centers the tool; it must not eat clicks meant for
     the desktop around it (a short landscape viewport looks like the
     full desktop, and a dead desktop reads as a hang). */
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  & > * {
    pointer-events: auto;
  }
`;
const $210cc6c367e16937$var$CompactGameLayer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  bottom: ${(0, $d2026809cde12e7e$export$e7ce2d3fe3294aef)}px;
  z-index: var(--z);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  & > [data-draggable] {
    pointer-events: auto;
  }
`;
var $210cc6c367e16937$export$2e2bcd8739ae039 = $210cc6c367e16937$var$Stage;











var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// True after `timeoutMs` with no user input (mouse, keys, touch, wheel);
// flips back false on input. Listeners are passive and attach once.
//
// Mouse-move wake uses a distance threshold while idle: `cursor: none`
// only repaints once the pointer moves, so the arrow lingers over the
// screensaver until the first nudge — which must NOT also dismiss it.
// A sub-threshold nudge hides the cursor; a deliberate sweep wakes.
const $20a76b1e35c74840$var$WAKE_MOVE_PX = 40;
// Returning to the tab mid-screensaver: hold the screensaver through
// the arrival so the focus click and incidental mouse motion of
// switching tabs don't instantly dismiss it. Deliberate input after
// the grace still wakes, and several clicks always do — insistence
// beats the grace.
const $20a76b1e35c74840$var$RETURN_GRACE_MS = 1200;
const $20a76b1e35c74840$var$GRACE_CLICKS_TO_WAKE = 2;
function $20a76b1e35c74840$export$2e2bcd8739ae039(timeoutMs) {
    const [idle, setIdle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const idleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    idleRef.current = idle;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let timer = null;
        let idleMoveOrigin = null;
        let graceUntil = 0;
        let graceClicks = 0;
        const inGrace = ()=>performance.now() < graceUntil;
        const arm = ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>setIdle(true), timeoutMs);
        };
        const wake = ()=>{
            idleMoveOrigin = null;
            graceClicks = 0;
            setIdle(false);
            arm();
        };
        const onMouseMove = (e)=>{
            if (!idleRef.current) {
                arm();
                return;
            }
            if (inGrace()) {
                idleMoveOrigin = null;
                return;
            }
            if (idleMoveOrigin == null) {
                idleMoveOrigin = {
                    x: e.clientX,
                    y: e.clientY
                };
                return;
            }
            const dist = Math.hypot(e.clientX - idleMoveOrigin.x, e.clientY - idleMoveOrigin.y);
            if (dist > $20a76b1e35c74840$var$WAKE_MOVE_PX) wake();
        };
        const onActivity = (e)=>{
            if (idleRef.current && inGrace()) {
                // Repeated clicks are unambiguous — wake even mid-grace.
                if (e.type === "mousedown" || e.type === "touchstart") {
                    graceClicks += 1;
                    if (graceClicks >= $20a76b1e35c74840$var$GRACE_CLICKS_TO_WAKE) wake();
                }
                return;
            }
            wake();
        };
        const onReturn = ()=>{
            if (idleRef.current) {
                graceUntil = performance.now() + $20a76b1e35c74840$var$RETURN_GRACE_MS;
                idleMoveOrigin = null;
                graceClicks = 0;
            }
        };
        const onVisibility = ()=>{
            if (!document.hidden) onReturn();
        };
        // Shut Down → Stand by: force the screensaver on demand, with the
        // same return-grace as tab-arrival so click noise can't wake it.
        const onForceIdle = ()=>{
            if (timer) clearTimeout(timer);
            graceUntil = performance.now() + $20a76b1e35c74840$var$RETURN_GRACE_MS;
            idleMoveOrigin = null;
            graceClicks = 0;
            setIdle(true);
        };
        // Capture phase: the Screensaver's root stopPropagation()s input to
        // shield the desktop beneath it, which would otherwise swallow these
        // before a bubble-phase window listener ever saw them.
        const opts = {
            passive: true,
            capture: true
        };
        window.addEventListener("mousemove", onMouseMove, opts);
        const events = [
            "mousedown",
            "keydown",
            "touchstart",
            "wheel"
        ];
        for (const ev of events)window.addEventListener(ev, onActivity, opts);
        window.addEventListener("focus", onReturn);
        document.addEventListener("visibilitychange", onVisibility);
        window.addEventListener("saat:force-idle", onForceIdle);
        arm();
        return ()=>{
            if (timer) clearTimeout(timer);
            window.removeEventListener("mousemove", onMouseMove, opts);
            for (const ev of events)window.removeEventListener(ev, onActivity, opts);
            window.removeEventListener("focus", onReturn);
            document.removeEventListener("visibilitychange", onVisibility);
            window.removeEventListener("saat:force-idle", onForceIdle);
        };
    }, [
        timeoutMs
    ]);
    return idle;
}



// The screensaver: 3D Pipes after a few minutes of inactivity, dismissed
// by any input (the idle hook flips and this unmounts). The pipes module
// (and three.js with it) loads lazily on first activation, so it costs
// the main bundle nothing. Sits under the CRT glass — the monitor is
// still a monitor. Dev knob: ?ss=10 → 10-second idle timeout.
const $8fbbc52a9bb39ab3$var$DEFAULT_IDLE_MS = 180000;
function $8fbbc52a9bb39ab3$export$7dc2e43efa060a76() {
    if (typeof window === "undefined") return $8fbbc52a9bb39ab3$var$DEFAULT_IDLE_MS;
    const raw = new URLSearchParams(window.location.search).get("ss");
    if (!raw) return $8fbbc52a9bb39ab3$var$DEFAULT_IDLE_MS;
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n * 1000 : $8fbbc52a9bb39ab3$var$DEFAULT_IDLE_MS;
}

function $8fbbc52a9bb39ab3$var$PipesCanvas() {
    const canvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let stop = null;
        let cancelled = false;
        (parcelRequire("goMib")).then(({ startPipes: startPipes })=>{
            if (cancelled || !canvasRef.current) return;
            stop = startPipes(canvasRef.current);
        });
        return ()=>{
            cancelled = true;
            if (stop) stop();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8fbbc52a9bb39ab3$var$Canvas, {
        ref: canvasRef
    });
}
function $8fbbc52a9bb39ab3$var$Screensaver() {
    const idle = (0, $20a76b1e35c74840$export$2e2bcd8739ae039)($8fbbc52a9bb39ab3$export$7dc2e43efa060a76());
    // While the pipes are actually running, the machine's speaker rests
    // too: register the screensaver as its own audio pause reason (the
    // hidden-tab reason is tracked independently in sound.js — clearing
    // one can never resume audio while the other still holds).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!idle) return undefined;
        (0, $ffdb7a25fbb7044c$export$af96c16dd8b4c215)("screensaver", true);
        return ()=>(0, $ffdb7a25fbb7044c$export$af96c16dd8b4c215)("screensaver", false);
    }, [
        idle
    ]);
    if (!idle) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8fbbc52a9bb39ab3$var$Cover, {
        // Swallow the waking mousedown so it can't fall through and play a
        // card underneath.
        onMouseDownCapture: (e)=>e.stopPropagation(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8fbbc52a9bb39ab3$var$PipesCanvas, {})
    });
}
const $8fbbc52a9bb39ab3$var$Cover = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: fixed;
  inset: 0;
  z-index: 8500; /* above the desktop, below the CRT glass (9000) */
  background: #000;
  cursor: none;
`;
const $8fbbc52a9bb39ab3$var$Canvas = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).canvas`
  width: 100%;
  height: 100%;
  display: block;
`;
var $8fbbc52a9bb39ab3$export$2e2bcd8739ae039 = $8fbbc52a9bb39ab3$var$Screensaver;







var $acw62 = parcelRequire("acw62");
//#region src/ws.ts
if (!globalThis.EventTarget || !globalThis.Event) console.error(`
  PartySocket requires a global 'EventTarget' class to be available!
  You can polyfill this global by adding this to your code before any partysocket imports: 
  
  \`\`\`
  import 'partysocket/event-target-polyfill';
  \`\`\`
  Please file an issue at https://github.com/partykit/partykit if you're still having trouble.
`);
var $e62ef20f585cc2b1$export$4c6f5e6e10fb9fd0 = class extends Event {
    message;
    error;
    constructor(error, target){
        super("error", target);
        this.message = error.message;
        this.error = error;
    }
};
var $e62ef20f585cc2b1$export$a143ac65dc19b005 = class extends Event {
    code;
    reason;
    wasClean = true;
    constructor(code = 1e3, reason = "", target){
        super("close", target);
        this.code = code;
        this.reason = reason;
    }
};
const $e62ef20f585cc2b1$var$Events = {
    Event: Event,
    ErrorEvent: $e62ef20f585cc2b1$export$4c6f5e6e10fb9fd0,
    CloseEvent: $e62ef20f585cc2b1$export$a143ac65dc19b005
};
function $e62ef20f585cc2b1$var$assert(condition, msg) {
    if (!condition) throw new Error(msg);
}
function $e62ef20f585cc2b1$var$cloneEventBrowser(e) {
    return new e.constructor(e.type, e);
}
function $e62ef20f585cc2b1$var$cloneEventNode(e) {
    if ("data" in e) return new MessageEvent(e.type, e);
    if ("code" in e || "reason" in e) return new $e62ef20f585cc2b1$export$a143ac65dc19b005(e.code || 1999, e.reason || "unknown reason", e);
    if ("error" in e) return new $e62ef20f585cc2b1$export$4c6f5e6e10fb9fd0(e.error, e);
    return new Event(e.type, e);
}
const $e62ef20f585cc2b1$var$isNode = false;
const $e62ef20f585cc2b1$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
const $e62ef20f585cc2b1$var$cloneEvent = $e62ef20f585cc2b1$var$isNode || $e62ef20f585cc2b1$var$isReactNative ? $e62ef20f585cc2b1$var$cloneEventNode : $e62ef20f585cc2b1$var$cloneEventBrowser;
const $e62ef20f585cc2b1$var$DEFAULT = {
    maxReconnectionDelay: 1e4,
    minReconnectionDelay: 1e3 + Math.random() * 4e3,
    minUptime: 5e3,
    reconnectionDelayGrowFactor: 1.3,
    connectionTimeout: 4e3,
    maxRetries: Number.POSITIVE_INFINITY,
    maxEnqueuedMessages: Number.POSITIVE_INFINITY,
    startClosed: false,
    debug: false
};
let $e62ef20f585cc2b1$var$didWarnAboutMissingWebSocket = false;
var $e62ef20f585cc2b1$export$2e2bcd8739ae039 = class ReconnectingWebSocket extends EventTarget {
    _ws;
    _retryCount = -1;
    _uptimeTimeout;
    _connectTimeout;
    _shouldReconnect = true;
    _connectLock = false;
    _binaryType = "blob";
    _closeCalled = false;
    _messageQueue = [];
    _debugLogger = console.log.bind(console);
    _url;
    _protocols;
    _options;
    constructor(url, protocols, options = {}){
        super();
        this._url = url;
        this._protocols = protocols;
        this._options = options;
        if (this._options.startClosed) this._shouldReconnect = false;
        if (this._options.debugLogger) this._debugLogger = this._options.debugLogger;
        this._connect();
    }
    static get CONNECTING() {
        return 0;
    }
    static get OPEN() {
        return 1;
    }
    static get CLOSING() {
        return 2;
    }
    static get CLOSED() {
        return 3;
    }
    get CONNECTING() {
        return ReconnectingWebSocket.CONNECTING;
    }
    get OPEN() {
        return ReconnectingWebSocket.OPEN;
    }
    get CLOSING() {
        return ReconnectingWebSocket.CLOSING;
    }
    get CLOSED() {
        return ReconnectingWebSocket.CLOSED;
    }
    get binaryType() {
        return this._ws ? this._ws.binaryType : this._binaryType;
    }
    set binaryType(value) {
        this._binaryType = value;
        if (this._ws) this._ws.binaryType = value;
    }
    /**
   * Returns the number or connection retries
   */ get retryCount() {
        return Math.max(this._retryCount, 0);
    }
    /**
   * The number of bytes of data that have been queued using calls to send() but not yet
   * transmitted to the network. This value resets to zero once all queued data has been sent.
   * This value does not reset to zero when the connection is closed; if you keep calling send(),
   * this will continue to climb. Read only
   */ get bufferedAmount() {
        return this._messageQueue.reduce((acc, message)=>{
            if (typeof message === "string") acc += message.length;
            else if (message instanceof Blob) acc += message.size;
            else acc += message.byteLength;
            return acc;
        }, 0) + (this._ws ? this._ws.bufferedAmount : 0);
    }
    /**
   * The extensions selected by the server. This is currently only the empty string or a list of
   * extensions as negotiated by the connection
   */ get extensions() {
        return this._ws ? this._ws.extensions : "";
    }
    /**
   * A string indicating the name of the sub-protocol the server selected;
   * this will be one of the strings specified in the protocols parameter when creating the
   * WebSocket object
   */ get protocol() {
        return this._ws ? this._ws.protocol : "";
    }
    /**
   * The current state of the connection; this is one of the Ready state constants
   */ get readyState() {
        if (this._ws) return this._ws.readyState;
        return this._options.startClosed ? ReconnectingWebSocket.CLOSED : ReconnectingWebSocket.CONNECTING;
    }
    /**
   * The URL as resolved by the constructor
   */ get url() {
        return this._ws ? this._ws.url : "";
    }
    /**
   * Whether the websocket object is now in reconnectable state
   */ get shouldReconnect() {
        return this._shouldReconnect;
    }
    /**
   * An event listener to be called when the WebSocket connection's readyState changes to CLOSED
   */ onclose = null;
    /**
   * An event listener to be called when an error occurs
   */ onerror = null;
    /**
   * An event listener to be called when a message is received from the server
   */ onmessage = null;
    /**
   * An event listener to be called when the WebSocket connection's readyState changes to OPEN;
   * this indicates that the connection is ready to send and receive data
   */ onopen = null;
    /**
   * Closes the WebSocket connection or connection attempt, if any. If the connection is already
   * CLOSED, this method does nothing
   */ close(code = 1e3, reason) {
        this._closeCalled = true;
        this._shouldReconnect = false;
        this._clearTimeouts();
        if (!this._ws) {
            this._debug("close enqueued: no ws instance");
            return;
        }
        if (this._ws.readyState === this.CLOSED) {
            this._debug("close: already closed");
            return;
        }
        this._ws.close(code, reason);
    }
    /**
   * Closes the WebSocket connection or connection attempt and connects again.
   * Resets retry counter;
   */ reconnect(code, reason) {
        this._shouldReconnect = true;
        this._closeCalled = false;
        this._retryCount = -1;
        if (!this._ws || this._ws.readyState === this.CLOSED) this._connect();
        else {
            this._disconnect(code, reason);
            this._connect();
        }
    }
    /**
   * Enqueue specified data to be transmitted to the server over the WebSocket connection
   */ send(data) {
        if (this._ws && this._ws.readyState === this.OPEN) {
            this._debug("send", data);
            this._ws.send(data);
        } else {
            const { maxEnqueuedMessages: maxEnqueuedMessages = $e62ef20f585cc2b1$var$DEFAULT.maxEnqueuedMessages } = this._options;
            if (this._messageQueue.length < maxEnqueuedMessages) {
                this._debug("enqueue", data);
                this._messageQueue.push(data);
            }
        }
    }
    _debug(...args) {
        if (this._options.debug) this._debugLogger("RWS>", ...args);
    }
    _getNextDelay() {
        const { reconnectionDelayGrowFactor: reconnectionDelayGrowFactor = $e62ef20f585cc2b1$var$DEFAULT.reconnectionDelayGrowFactor, minReconnectionDelay: minReconnectionDelay = $e62ef20f585cc2b1$var$DEFAULT.minReconnectionDelay, maxReconnectionDelay: maxReconnectionDelay = $e62ef20f585cc2b1$var$DEFAULT.maxReconnectionDelay } = this._options;
        let delay = 0;
        if (this._retryCount > 0) {
            delay = minReconnectionDelay * reconnectionDelayGrowFactor ** (this._retryCount - 1);
            if (delay > maxReconnectionDelay) delay = maxReconnectionDelay;
        }
        this._debug("next delay", delay);
        return delay;
    }
    _wait() {
        return new Promise((resolve)=>{
            setTimeout(resolve, this._getNextDelay());
        });
    }
    _getNextProtocols(protocolsProvider) {
        if (!protocolsProvider) return Promise.resolve(null);
        if (typeof protocolsProvider === "string" || Array.isArray(protocolsProvider)) return Promise.resolve(protocolsProvider);
        if (typeof protocolsProvider === "function") {
            const protocols = protocolsProvider();
            if (!protocols) return Promise.resolve(null);
            if (typeof protocols === "string" || Array.isArray(protocols)) return Promise.resolve(protocols);
            if (protocols.then) return protocols;
        }
        throw Error("Invalid protocols");
    }
    _getNextUrl(urlProvider) {
        if (typeof urlProvider === "string") return Promise.resolve(urlProvider);
        if (typeof urlProvider === "function") {
            const url = urlProvider();
            if (typeof url === "string") return Promise.resolve(url);
            if (url.then) return url;
        }
        throw Error("Invalid URL");
    }
    _connect() {
        if (this._connectLock || !this._shouldReconnect) return;
        this._connectLock = true;
        const { maxRetries: maxRetries = $e62ef20f585cc2b1$var$DEFAULT.maxRetries, connectionTimeout: connectionTimeout = $e62ef20f585cc2b1$var$DEFAULT.connectionTimeout } = this._options;
        if (this._retryCount >= maxRetries) {
            this._debug("max retries reached", this._retryCount, ">=", maxRetries);
            this._connectLock = false;
            return;
        }
        this._retryCount++;
        this._debug("connect", this._retryCount);
        this._removeListeners();
        this._wait().then(()=>Promise.all([
                this._getNextUrl(this._url),
                this._getNextProtocols(this._protocols || null)
            ])).then(([url, protocols])=>{
            if (this._closeCalled) {
                this._connectLock = false;
                return;
            }
            if (!this._options.WebSocket && typeof WebSocket === "undefined" && !$e62ef20f585cc2b1$var$didWarnAboutMissingWebSocket) {
                console.error(`\u{203C}\u{FE0F} No WebSocket implementation available. You should define options.WebSocket. 

For example, if you're using node.js, run \`npm install ws\`, and then in your code:

import PartySocket from 'partysocket';
import WS from 'ws';

const partysocket = new PartySocket({
  host: "127.0.0.1:1999",
  room: "test-room",
  WebSocket: WS
});

`);
                $e62ef20f585cc2b1$var$didWarnAboutMissingWebSocket = true;
            }
            const WS = this._options.WebSocket || WebSocket;
            this._debug("connect", {
                url: url,
                protocols: protocols
            });
            this._ws = protocols ? new WS(url, protocols) : new WS(url);
            this._ws.binaryType = this._binaryType;
            this._connectLock = false;
            this._addListeners();
            this._connectTimeout = setTimeout(()=>this._handleTimeout(), connectionTimeout);
        }).catch((err)=>{
            this._connectLock = false;
            this._handleError(new $e62ef20f585cc2b1$var$Events.ErrorEvent(Error(err.message), this));
        });
    }
    _handleTimeout() {
        this._debug("timeout event");
        this._handleError(new $e62ef20f585cc2b1$var$Events.ErrorEvent(Error("TIMEOUT"), this));
    }
    _disconnect(code = 1e3, reason) {
        this._clearTimeouts();
        if (!this._ws) return;
        this._removeListeners();
        try {
            if (this._ws.readyState === this.OPEN || this._ws.readyState === this.CONNECTING) this._ws.close(code, reason);
            this._handleClose(new $e62ef20f585cc2b1$var$Events.CloseEvent(code, reason, this));
        } catch (_error) {}
    }
    _acceptOpen() {
        this._debug("accept open");
        this._retryCount = 0;
    }
    _handleOpen = (event)=>{
        this._debug("open event");
        const { minUptime: minUptime = $e62ef20f585cc2b1$var$DEFAULT.minUptime } = this._options;
        clearTimeout(this._connectTimeout);
        this._uptimeTimeout = setTimeout(()=>this._acceptOpen(), minUptime);
        $e62ef20f585cc2b1$var$assert(this._ws, "WebSocket is not defined");
        this._ws.binaryType = this._binaryType;
        this._messageQueue.forEach((message)=>{
            this._ws?.send(message);
        });
        this._messageQueue = [];
        if (this.onopen) this.onopen(event);
        this.dispatchEvent($e62ef20f585cc2b1$var$cloneEvent(event));
    };
    _handleMessage = (event)=>{
        this._debug("message event");
        if (this.onmessage) this.onmessage(event);
        this.dispatchEvent($e62ef20f585cc2b1$var$cloneEvent(event));
    };
    _handleError = (event)=>{
        this._debug("error event", event.message);
        this._disconnect(void 0, event.message === "TIMEOUT" ? "timeout" : void 0);
        if (this.onerror) this.onerror(event);
        this._debug("exec error listeners");
        this.dispatchEvent($e62ef20f585cc2b1$var$cloneEvent(event));
        this._connect();
    };
    _handleClose = (event)=>{
        this._debug("close event");
        this._clearTimeouts();
        if (this._shouldReconnect) this._connect();
        if (this.onclose) this.onclose(event);
        this.dispatchEvent($e62ef20f585cc2b1$var$cloneEvent(event));
    };
    _removeListeners() {
        if (!this._ws) return;
        this._debug("removeListeners");
        this._ws.removeEventListener("open", this._handleOpen);
        this._ws.removeEventListener("close", this._handleClose);
        this._ws.removeEventListener("message", this._handleMessage);
        this._ws.removeEventListener("error", this._handleError);
    }
    _addListeners() {
        if (!this._ws) return;
        this._debug("addListeners");
        this._ws.addEventListener("open", this._handleOpen);
        this._ws.addEventListener("close", this._handleClose);
        this._ws.addEventListener("message", this._handleMessage);
        this._ws.addEventListener("error", this._handleError);
    }
    _clearTimeouts() {
        clearTimeout(this._connectTimeout);
        clearTimeout(this._uptimeTimeout);
    }
};


//#region src/index.ts
const $02507cabe609f686$var$valueIsNotNil = (keyValuePair)=>keyValuePair[1] !== null && keyValuePair[1] !== void 0;
function $02507cabe609f686$var$generateUUID() {
    if (crypto?.randomUUID) return crypto.randomUUID();
    let d = Date.now();
    let d2 = performance?.now && performance.now() * 1e3 || 0;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 3 | 8).toString(16);
    });
}
function $02507cabe609f686$var$getPartyInfo(partySocketOptions, defaultProtocol, defaultParams = {}) {
    const { host: rawHost, path: rawPath, protocol: rawProtocol, room: room, party: party, basePath: basePath, prefix: prefix, query: query } = partySocketOptions;
    let host = rawHost.replace(/^(http|https|ws|wss):\/\//, "");
    if (host.endsWith("/")) host = host.slice(0, -1);
    if (rawPath?.startsWith("/")) throw new Error("path must not start with a slash");
    const name = party ?? "main";
    const path = rawPath ? `/${rawPath}` : "";
    const protocol = rawProtocol || (host.startsWith("localhost:") || host.startsWith("127.0.0.1:") || host.startsWith("192.168.") || host.startsWith("10.") || host.startsWith("172.") && host.split(".")[1] >= "16" && host.split(".")[1] <= "31" || host.startsWith("[::ffff:7f00:1]:") ? defaultProtocol : `${defaultProtocol}s`);
    const baseUrl = `${protocol}://${host}/${basePath || `${prefix || "parties"}/${name}/${room}`}${path}`;
    const makeUrl = (query = {})=>`${baseUrl}?${new URLSearchParams([
            ...Object.entries(defaultParams),
            ...Object.entries(query).filter($02507cabe609f686$var$valueIsNotNil)
        ])}`;
    const urlProvider = typeof query === "function" ? async ()=>makeUrl(await query()) : makeUrl(query);
    return {
        host: host,
        path: path,
        room: room,
        name: name,
        protocol: protocol,
        partyUrl: baseUrl,
        urlProvider: urlProvider
    };
}
var $02507cabe609f686$export$4c925b8d49ba1848 = class extends (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039) {
    _pk;
    _pkurl;
    name;
    room;
    host;
    path;
    basePath;
    constructor(partySocketOptions){
        const wsOptions = $02507cabe609f686$var$getWSOptions(partySocketOptions);
        super(wsOptions.urlProvider, wsOptions.protocols, wsOptions.socketOptions);
        this.partySocketOptions = partySocketOptions;
        this.setWSProperties(wsOptions);
        if (!partySocketOptions.startClosed && !this.room && !this.basePath) {
            this.close();
            throw new Error("Either room or basePath must be provided to connect. Use startClosed: true to create a socket and set them via updateProperties before calling reconnect().");
        }
        if (!partySocketOptions.disableNameValidation) {
            if (partySocketOptions.party?.includes("/")) console.warn(`PartySocket: party name "${partySocketOptions.party}" contains forward slash which may cause routing issues. Consider using a name without forward slashes or set disableNameValidation: true to bypass this warning.`);
            if (partySocketOptions.room?.includes("/")) console.warn(`PartySocket: room name "${partySocketOptions.room}" contains forward slash which may cause routing issues. Consider using a name without forward slashes or set disableNameValidation: true to bypass this warning.`);
        }
    }
    updateProperties(partySocketOptions) {
        const wsOptions = $02507cabe609f686$var$getWSOptions({
            ...this.partySocketOptions,
            ...partySocketOptions,
            host: partySocketOptions.host ?? this.host,
            room: partySocketOptions.room ?? this.room,
            path: partySocketOptions.path ?? this.path,
            basePath: partySocketOptions.basePath ?? this.basePath
        });
        this._url = wsOptions.urlProvider;
        this._protocols = wsOptions.protocols;
        this._options = wsOptions.socketOptions;
        this.setWSProperties(wsOptions);
    }
    setWSProperties(wsOptions) {
        const { _pk: _pk, _pkurl: _pkurl, name: name, room: room, host: host, path: path, basePath: basePath } = wsOptions;
        this._pk = _pk;
        this._pkurl = _pkurl;
        this.name = name;
        this.room = room;
        this.host = host;
        this.path = path;
        this.basePath = basePath;
    }
    reconnect(code, reason) {
        if (!this.host) throw new Error("The host must be set before connecting, use `updateProperties` method to set it or pass it to the constructor.");
        if (!this.room && !this.basePath) throw new Error("The room (or basePath) must be set before connecting, use `updateProperties` method to set it or pass it to the constructor.");
        super.reconnect(code, reason);
    }
    get id() {
        return this._pk;
    }
    /**
   * Exposes the static PartyKit room URL without applying query parameters.
   * To access the currently connected WebSocket url, use PartySocket#url.
   */ get roomUrl() {
        return this._pkurl;
    }
    static async fetch(options, init) {
        const party = $02507cabe609f686$var$getPartyInfo(options, "http");
        const url = typeof party.urlProvider === "string" ? party.urlProvider : await party.urlProvider();
        return (options.fetch ?? fetch)(url, init);
    }
};
function $02507cabe609f686$var$getWSOptions(partySocketOptions) {
    const { id: id, host: _host, path: _path, party: _party, room: _room, protocol: _protocol, query: _query, protocols: protocols, ...socketOptions } = partySocketOptions;
    const _pk = id || $02507cabe609f686$var$generateUUID();
    const party = $02507cabe609f686$var$getPartyInfo(partySocketOptions, "ws", {
        _pk: _pk
    });
    return {
        _pk: _pk,
        _pkurl: party.partyUrl,
        name: party.name,
        room: party.room,
        host: party.host,
        path: party.path,
        basePath: partySocketOptions.basePath,
        protocols: protocols,
        socketOptions: socketOptions,
        urlProvider: party.urlProvider
    };
}



// The client-side move processor as a pure state machine. State is
// SELF-CONTAINED: everything a transition needs — including single-step
// undo — lives in the state itself, so a machine built from a server
// snapshot behaves identically to one that watched every move live.
//
// State shape: { board, prevBoard } where prevBoard is the board before
// the most recent move, or null. This shape encodes the single-step-undo
// rule directly: after an undo the prevBoard slot is empty, so a second
// undo is unrepresentable rather than merely refused.
//
// Pure module: no React, no DOM, no network. The same machine drives
// spectated games (fed by wire ops) and could drive replays.

function $2ed1e96d131fed28$export$a452cc4c8630e0ff(seed, moves, canUndo, opts = {}) {
    const board = (0, $73d8f6063558c0ab$export$5c9ba34b2d024c9b)(seed, moves, opts);
    const prevBoard = canUndo && moves.length > 0 ? (0, $73d8f6063558c0ab$export$5c9ba34b2d024c9b)(seed, moves.slice(0, -1), opts) : null;
    return {
        board: board,
        prevBoard: prevBoard
    };
}
function $2ed1e96d131fed28$export$37e14c2bfa1ddb86(machine, moveIndex) {
    const mv = (0, $73d8f6063558c0ab$export$36208696e3534245)(machine.board)[moveIndex];
    if (!mv) return null;
    return {
        machine: {
            board: (0, $73d8f6063558c0ab$export$389d1639e42e5db9)(machine.board, mv),
            prevBoard: machine.board
        },
        move: mv
    };
}
function $2ed1e96d131fed28$export$45cb8543509a58f0(machine) {
    if (!machine.prevBoard) return null;
    return {
        board: machine.prevBoard,
        prevBoard: null
    };
}




// Identity lives in localStorage: one person per browser, surviving
// restarts — a tab close within the idle window resumes the game, and
// reopening the site can't mint zombie duplicate games. `?session`
// switches to per-tab sessionStorage identity for multi-client testing
// (each tab with the flag is its own user).
const $1638376c337d7afc$var$UUID_KEY = "saat.uuid";
const $1638376c337d7afc$var$GAME_KEY = "saat.gameId";
// Storage access itself can throw (Safari lockdown modes, blocked site
// data) — fall back to an in-memory store so identity is session-lifetime
// rather than the app dying at module load.
const $1638376c337d7afc$var$memoryStore = (()=>{
    const m = new Map();
    return {
        getItem: (k)=>m.has(k) ? m.get(k) : null,
        setItem: (k, v)=>m.set(k, String(v)),
        removeItem: (k)=>m.delete(k)
    };
})();
const $1638376c337d7afc$var$identityStore = (()=>{
    try {
        const store = new URLSearchParams(typeof window === "undefined" ? "" : window.location.search).has("session") ? window.sessionStorage : window.localStorage;
        // Verify it actually works — Safari private mode historically
        // exposed a store whose setItem throws.
        store.setItem("saat.probe", "1");
        store.removeItem("saat.probe");
        return store;
    } catch  {
        return $1638376c337d7afc$var$memoryStore;
    }
})();
// Final boards are heavier than roster IDs; bound the cache so a
// browser left open for hours doesn't turn into an unbounded archive.
const $1638376c337d7afc$var$MAX_BROWSE_FINAL_STATES = 64;
function $1638376c337d7afc$var$makeUuid() {
    // crypto.randomUUID needs a secure context; phone-on-LAN dev testing
    // over plain http doesn't have one. Same bytes, hand-formatted.
    if (crypto.randomUUID) return crypto.randomUUID();
    const b = crypto.getRandomValues(new Uint8Array(16));
    b[6] = b[6] & 0x0f | 0x40;
    b[8] = b[8] & 0x3f | 0x80;
    const h = [
        ...b
    ].map((x)=>x.toString(16).padStart(2, "0")).join("");
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
function $1638376c337d7afc$var$getOrCreateUuid() {
    let uuid = $1638376c337d7afc$var$identityStore.getItem($1638376c337d7afc$var$UUID_KEY);
    if (!uuid) {
        uuid = $1638376c337d7afc$var$makeUuid();
        try {
            $1638376c337d7afc$var$identityStore.setItem($1638376c337d7afc$var$UUID_KEY, uuid);
        } catch  {
        // Quota/blocked mid-session: keep the in-memory uuid for this run.
        }
    }
    return uuid;
}
function $1638376c337d7afc$var$getStoredGameId() {
    const raw = $1638376c337d7afc$var$identityStore.getItem($1638376c337d7afc$var$GAME_KEY);
    if (!raw) return null;
    const n = parseInt(raw, 10);
    return Number.isFinite(n) ? n : null;
}
function $1638376c337d7afc$var$storeGameId(n) {
    try {
        if (n == null) $1638376c337d7afc$var$identityStore.removeItem($1638376c337d7afc$var$GAME_KEY);
        else $1638376c337d7afc$var$identityStore.setItem($1638376c337d7afc$var$GAME_KEY, String(n));
    } catch  {
    // Quota/blocked mid-session: resume-after-reload degrades, play doesn't.
    }
}
// Dev affordance: `?seed=42` forces the client to request game_id=42,
// overriding identity storage. Needs -dev-create server-side (off by
// default — see server/scripts/server.sh).
function $1638376c337d7afc$var$readSeedOverride() {
    if (typeof window === "undefined") return null;
    const raw = new URLSearchParams(window.location.search).get("seed");
    if (!raw) return null;
    const n = parseInt(raw, 10);
    return Number.isFinite(n) ? n : null;
}
// Dev knob: fake a neighbor's ending ~6s after the room loads,
// client-side only, so the departure ceremonies can be eyeballed on
// demand. `?ritual` → close ritual (hand walks to the X, presses it,
// window closes); `?spectatewin` → spectated win cascade. The server
// still thinks the game is live, so no reseat follows — the seat stays
// empty until reload (use ?devwin / bots for a real ending + redeal).
function $1638376c337d7afc$var$readSpectateKnob() {
    if (typeof window === "undefined") return null;
    const params = new URLSearchParams(window.location.search);
    if (params.has("spectatewin")) return "won";
    if (params.has("ritual")) return "abandoned";
    return null;
}
function $1638376c337d7afc$export$2e2bcd8739ae039({ neighborCount: neighborCount = 6 } = {}) {
    const boundedNeighborCount = Math.max(0, Math.min(8, neighborCount));
    const neighborCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(boundedNeighborCount);
    neighborCountRef.current = boundedNeighborCount;
    // The last value included in hello or acknowledged by a welcome. This
    // prevents the post-welcome render from redundantly setting the count.
    const sentNeighborCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [myGameId, setMyGameId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Move history the server has for our own game, as of the latest
    // welcome/rejection. PlayableSolitaire reads this once in its lazy
    // state init to resume after a refresh, then owns state from there —
    // later changes to this value are ignored by design.
    const [myGameMoves, setMyGameMoves] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Whether undo is armed for the resumed history (the server's view;
    // snapshots are self-contained so a refresh mid-game keeps its undo).
    const [myGameCanUndo, setMyGameCanUndo] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [activeGameIds, setActiveGameIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // The server's ordered watched set is deliberately separate from all
    // loaded machines. Browse snapshots must not quietly rearrange the
    // desktop behind the containing window.
    const [watchedGameIds, setWatchedGameIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // One entry per watched seat: gameId -> phase. Key membership IS the
    // watched set (insertion order mirrors the server's ordered list);
    // the phase tracks a seat's ending ceremony:
    //   "live"     — normal spectated window.
    //   "ended"    — game_ended arrived; the live subscription is closed
    //                and the window is playing its departure (close
    //                ritual / cascade).
    //   "departed" — the ceremony finished: the window is gone from the
    //                desktop, but the id stays here (and in reconnect
    //                re-asserts) until the server's reseat welcome swaps
    //                a fresh game into the slot — the gap is the
    //                deliberate "someone left the table" beat.
    const seatPhasesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    // True once any welcome has landed: distinguishes the first-ever hello
    // (server seeds the room) from a reconnect (client re-asserts its room).
    const hadWelcomeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    // All Active Games is a cheap ordered roster plus a bounded subset of
    // live machines. Ended IDs remain in the roster as stable stubs until
    // the containing window closes.
    const [browseGameIds, setBrowseGameIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [browseEndedIds, setBrowseEndedIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    // Published mirror of the seats whose phase is "departed" (App hides
    // those windows while their seat waits for the reseat).
    const [departedWatchedIds, setDepartedWatchedIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    // Ended browse stubs get their final board over HTTP (the Past Games
    // endpoint) — in-flight ids so a stub isn't fetched twice, and a ref
    // into the socket effect's rememberBrowseFinal.
    const finalFetchesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set());
    const rememberFinalRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(()=>{});
    // Set on socket open, consumed by the first welcome: distinguishes a
    // reconnect welcome (rebuild the browse roster, quiet arrivals) from
    // mid-session welcomes.
    const freshSocketRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    // Ids whose windows arrived via a RECONNECT welcome: they open with
    // no animation — waking from the screensaver (or a laptop lid)
    // presents the settled room, not a parade of arrivals. Entries clear
    // when the machine dies. The session's very first welcome is NOT a
    // reconnect — it's the seeding, and seeding gets the arrival
    // choreography.
    const everWelcomedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const quietArrivalIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set());
    const [quietArrivalIds, setQuietArrivalIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    // Machine identity generation per game id: bumped whenever a snapshot
    // creates a machine from scratch (vs. replacing a live one). Windows key
    // their subscription on it so a rebuilt id gets a fresh, un-frozen view.
    const machineGenRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const [gameGenerations, setGameGenerations] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Map());
    // A cached machine is not necessarily current after it left the
    // viewport. Only a fresh game_present for the current browse_set makes
    // a preview ready; until then the UI keeps its dim empty board.
    const [browseReadyIds, setBrowseReadyIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    // Final boards for games that ended while in the bounded browse range —
    // captured from the live machine before it's released. Capped
    // independently and cleared with the browse roster.
    const [browseFinalStates, setBrowseFinalStates] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Map());
    const browseWantedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const browseRequestedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set());
    // Ended stubs leave the browse grid after a short linger — mobile
    // keeps its window open indefinitely, so dead boards must not
    // accumulate. id → removal timer; cancelled when a ghost replay
    // re-adds the id, cleared wholesale with the roster.
    const browsePruneTimersRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    // Monotonic range generation: a snapshot from an earlier scroll must
    // never make a newly revisited slot look current.
    const browseSeqRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const pruneBrowseRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(()=>{});
    // Browse slots whose win cascade is playing: id → {timer, wonAt}.
    // Destructive bookkeeping (ended stub, cached final board, machine
    // teardown) is deferred via `timer` so the show isn't cut mid-air.
    // `wonAt` is the win epoch (Date.now domain) — since the cascade is a
    // deterministic function of (game id, elapsed time), a slot mounting
    // mid-show fast-forwards to the exact frame every other viewer is on;
    // a late joiner derives it from the server's won_elapsed_ms. Read by
    // subscribeGame's handle.
    const celebrationsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    // Set inside the connection effect; SpectatedSolitaire reports its
    // cascade finished through the subscribe handle → this.
    const settleCelebrationRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(()=>{});
    const browseRetryTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // How many games are live in the whole room right now (yours included).
    const [roomActive, setRoomActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // Bumped when the server tells us our optimistic local state is wrong
    // (move_rejected, or a welcome-time consistency failure). App keys
    // PlayableSolitaire on this so the game remounts and rebuilds from the
    // server's history.
    const [myGameResyncNonce, setMyGameResyncNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // --- presence / lifecycle ---
    // Idle model: the server sweeps games with no productive move for
    // SERVER_IDLE_MS (X; mirrors idleTimeout in server/hub.go — change
    // together); the screensaver takes over at screensaverIdleMs() (Y) of
    // total input silence, Y < X. Exactly one prompt exists — the "you
    // haven't made a move" warning — shown shortly before the sweep ONLY
    // while the player is awake (input newer than Y). A player under the
    // screensaver gets no prompt; the game dies behind the pipes and they
    // meet the timed-out notice on wake. Dev knob: `?idle=SECONDS` shrinks
    // the window (pair with the server's -idle-seconds / IDLE_SECONDS,
    // and `?ss=SECONDS` for the saver).
    const idleWindowMs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (typeof window === "undefined") return 480000;
        const raw = new URLSearchParams(window.location.search).get("idle");
        const n = raw ? parseInt(raw, 10) : NaN;
        return Number.isFinite(n) && n >= 10 ? n * 1000 : 480000;
    }, []);
    const SERVER_IDLE_MS = idleWindowMs;
    const LAST_CHANCE_LEAD_MS = Math.round(idleWindowMs * (1.5 / 8));
    const IDLE_CHECK_MS = Math.max(1000, Math.min(15000, idleWindowMs / 20));
    const AWAKE_MS = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $8fbbc52a9bb39ab3$export$7dc2e43efa060a76)(), []);
    // null | { kind: "no-move", minutes }
    const [idlePrompt, setIdlePrompt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // True when the server abandoned OUR game out from under us (idle
    // timeout). We keep the board mounted and let the UI say so instead
    // of silently dealing a fresh game.
    const [myGameTimedOut, setMyGameTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const myGameTimedOutRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const updateTimedOut = (v)=>{
        myGameTimedOutRef.current = v;
        setMyGameTimedOut(v);
    };
    // True after our own win echoes back. The game is over but stays
    // mounted for the cascade — over means no idle prompt, no still_here,
    // and nothing to abandon when the player eventually re-deals (the
    // state copy lets the UI skip the "Abandon this game?" confirm).
    const [myGameWon, setMyGameWon] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const myGameWonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const updateWon = (v)=>{
        myGameWonRef.current = v;
        setMyGameWon(v);
    };
    // True after the socket has been down long enough that this stopped
    // being a blip (~15s). Reconnection keeps being attempted regardless;
    // this only gates whether the UI mentions it.
    const [netTrouble, setNetTrouble] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const netTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const lastActivityRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(Date.now());
    // Any input at all — pointer motion, clicks, keys, touch. Cheap ref
    // writes; this is what distinguishes "away" from "around but not
    // moving cards" for the two prompt flavors above.
    const lastInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(Date.now());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const mark = ()=>{
            lastInputRef.current = Date.now();
        };
        const opts = {
            capture: true,
            passive: true
        };
        const events = [
            "pointermove",
            "pointerdown",
            "keydown",
            "wheel",
            "touchstart"
        ];
        for (const e of events)window.addEventListener(e, mark, opts);
        return ()=>{
            for (const e of events)window.removeEventListener(e, mark, opts);
        };
    }, []);
    const wsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // One-shot latch for the ?devwin verification knob.
    const devWinSentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const pendingGameIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // True from sendHello until its welcome/error lands — guards against
    // firing a second automatic hello while one is already in flight.
    const helloInFlightRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    // Set inside the connection effect so UI callbacks (dealNewGame) can
    // trigger a fresh hello without owning the socket internals.
    const sendHelloRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Mirror of myGameId for reading inside message handlers without stale
    // closures. Updated anywhere we set myGameId.
    const myGameIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Our optimistic history length for our own game — the seq every
    // outbound move/undo is minted at. The server accepts an op only at
    // the exact position it was minted for (seq == len(server history)),
    // so a stale op is rejected with the authoritative history instead of
    // being silently reinterpreted. null until the first welcome.
    const ownSeqRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Own-game ops composed while the socket was down. Each entry is
    // {gameId, payload} (payload carries its minted seq); flushed on the
    // next welcome IF the server's history lines up exactly underneath
    // them, dropped otherwise (see the welcome consistency check).
    const outboxRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    // Spectated-game ordering. seqRef: gameId -> next expected seq (== number
    // of moves reduced so far). The wire guarantees per-client FIFO with
    // no holes (PROTOCOL.md §1-3), so a gap is a violation, not a race —
    // there is deliberately no out-of-order buffer.
    const seqRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    // Pure state machine per non-own active game: { board, prevBoard }.
    // Self-contained — snapshots carry can_undo, so a machine built at
    // connect time behaves identically to one that watched every move
    // (this killed the old one-deep prevState cache and its "connected
    // mid-undo-window" corruption hole). The player's own game is owned by
    // PlayableSolitaire (which applies moves optimistically); we
    // deliberately don't duplicate it here to avoid two sources of truth.
    const machinesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    // gameId -> Set<(event) => void>. Events:
    //   { prevState, curState, move, terminal }
    // - Fired on each applied spectated move (move is the engine move object).
    // - Fired once on game end with terminal: true, move: null; the subscriber
    //   is then automatically unsubscribed.
    // - Fired on reconnect-welcome/refreshed snapshots for games still
    //   present with move: null, terminal: false — a "resync to curState"
    //   signal.
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const publishActiveGameIds = ()=>{
        setActiveGameIds(Array.from(machinesRef.current.keys()));
        setWatchedGameIds(Array.from(seatPhasesRef.current.keys()));
        const departed = new Set();
        for (const [id, phase] of seatPhasesRef.current)if (phase === "departed") departed.add(id);
        setDepartedWatchedIds(departed);
        setQuietArrivalIds(new Set(quietArrivalIdsRef.current));
        setGameGenerations(new Map(machineGenRef.current));
    };
    const updateMyGameId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((nextId)=>{
        myGameIdRef.current = nextId;
        setMyGameId(nextId);
        $1638376c337d7afc$var$storeGameId(nextId);
    }, []);
    // Dev-knob state (see readSpectateKnob): fire at most once per load.
    const knobFiredRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const uuid = $1638376c337d7afc$var$getOrCreateUuid();
        const spectateKnob = $1638376c337d7afc$var$readSpectateKnob();
        const ws = new (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039)((0, $bebe1cbb5a309c8c$export$e1d22fd22e60a13d));
        wsRef.current = ws;
        const sendHello = (gameId, { fresh: fresh = false } = {})=>{
            const msg = {
                type: "hello",
                user_uuid: uuid,
                neighbor_count: neighborCountRef.current
            };
            // Reconnect re-asserts the room verbatim (ordered, including frozen
            // ended windows and deliberate vacancies) instead of letting the
            // server deal a fresh seed — a wifi blip must not replace the
            // player's chosen neighbors. Absent on the first-ever hello so the
            // server's one-time seed still happens.
            if (hadWelcomeRef.current) msg.watched_game_ids = Array.from(seatPhasesRef.current.keys());
            if (gameId != null) msg.game_id = gameId;
            // fresh: abandon whatever game this session owns and deal a new
            // one, in ONE op — replaces the old abandon-then-hello pair, which
            // could race/interleave across a reconnect.
            if (fresh) msg.fresh = true;
            pendingGameIdRef.current = gameId ?? null;
            helloInFlightRef.current = true;
            sentNeighborCountRef.current = neighborCountRef.current;
            ws.send(JSON.stringify(msg));
        };
        sendHelloRef.current = sendHello;
        const onOpen = ()=>{
            if (netTimerRef.current) {
                clearTimeout(netTimerRef.current);
                netTimerRef.current = null;
            }
            // The next welcome answers a fresh socket: the server-side Client
            // is new, so the browse roster (if open) must be re-established.
            // Ordinary mid-session welcomes (watch/unwatch/reseat) must NOT
            // rebuild it — that would evict ended stubs and drop scroll state.
            freshSocketRef.current = true;
            setNetTrouble(false);
            const override = $1638376c337d7afc$var$readSeedOverride();
            sendHello(override ?? $1638376c337d7afc$var$getStoredGameId());
        };
        const onClose = ()=>{
            if (browseRetryTimerRef.current != null) {
                clearTimeout(browseRetryTimerRef.current);
                browseRetryTimerRef.current = null;
            }
            // Blips stay silent; only sustained failure gets a dialog. Null
            // the ref when the timer fires so the NEXT close can re-arm it —
            // otherwise dismissing the notice mid-outage silences it for good.
            if (!netTimerRef.current) netTimerRef.current = setTimeout(()=>{
                netTimerRef.current = null;
                setNetTrouble(true);
            }, 15000);
        };
        const notifySubscribers = (gameId, event)=>{
            const subs = subscribersRef.current.get(gameId);
            if (!subs) return;
            for (const cb of subs)cb(event);
        };
        rememberFinalRef.current = (gameId, board)=>rememberBrowseFinal(gameId, board);
        const rememberBrowseFinal = (gameId, board)=>{
            const finalBoard = board ?? machinesRef.current.get(gameId)?.board;
            if (!finalBoard) return;
            setBrowseFinalStates((prev)=>{
                const next = new Map(prev);
                next.delete(gameId);
                next.set(gameId, finalBoard);
                while(next.size > $1638376c337d7afc$var$MAX_BROWSE_FINAL_STATES)next.delete(next.keys().next().value);
                return next;
            });
        };
        // An ended stub lingers long enough to read the ending, then its
        // slot leaves the grid entirely (wins spend their whole cascade
        // live first — browse_ended is deferred past the celebration).
        // Removing the id shrinks renderedIds, so the visible-range effect
        // follows with a browse_set that drops the subscription too.
        const BROWSE_ENDED_LINGER_MS = 10000;
        const scheduleBrowsePrune = (gameId)=>{
            const timers = browsePruneTimersRef.current;
            clearTimeout(timers.get(gameId));
            timers.set(gameId, setTimeout(()=>{
                timers.delete(gameId);
                setBrowseGameIds((prev)=>prev.filter((id)=>id !== gameId));
                setBrowseEndedIds((prev)=>{
                    if (!prev.has(gameId)) return prev;
                    const next = new Set(prev);
                    next.delete(gameId);
                    return next;
                });
                setBrowseFinalStates((prev)=>{
                    if (!prev.has(gameId)) return prev;
                    const next = new Map(prev);
                    next.delete(gameId);
                    return next;
                });
            }, BROWSE_ENDED_LINGER_MS));
        };
        // A protocol violation (bad move index, impossible undo, seq gap)
        // means this machine's stream can no longer be trusted. The
        // seq-guarded, no-holes wire makes these unreachable in theory, so
        // recovery is deliberately blunt: cycle the socket and rebuild
        // EVERYTHING from the reconnect welcome — the one resync path that
        // is exercised constantly and tested.
        const forceResync = (why)=>{
            console.error(`useSolitaireServer: ${why}; cycling the socket`);
            ws.reconnect();
        };
        const endGame = (gameId, reason)=>{
            const m = machinesRef.current.get(gameId);
            if (m) notifySubscribers(gameId, {
                prevState: m.board,
                curState: m.board,
                move: null,
                terminal: true,
                reason: reason ?? null
            });
            subscribersRef.current.delete(gameId);
            machinesRef.current.delete(gameId);
            seqRef.current.delete(gameId);
            seatPhasesRef.current.delete(gameId);
            quietArrivalIdsRef.current.delete(gameId);
        };
        // A watched game ending starts its departure: the live subscription
        // is finished, and the machine + watched-set membership stay while
        // the window plays the close ritual (or the cascade). The window
        // reports departWatchedGame when the ceremony ends; the id then
        // waits invisibly for the server's reseat welcome to clear it.
        const finishWatchedGame = (gameId, reason)=>{
            const m = machinesRef.current.get(gameId);
            if (!m) return;
            notifySubscribers(gameId, {
                prevState: m.board,
                curState: m.board,
                move: null,
                terminal: true,
                reason: reason ?? null
            });
            subscribersRef.current.delete(gameId);
            if (seatPhasesRef.current.has(gameId)) seatPhasesRef.current.set(gameId, "ended");
        };
        // A browse-grid neighbor WON while on screen (the server sends the
        // reasoned game_ended to browse-subscribed clients): play their
        // cascade in the slot instead of snapping to a frozen board — the
        // piece's one gift, witnessed from the chaos window too. The live
        // stream is over, but the machine and the slot's ready state stay
        // so the SpectatedSolitaire instance survives to run the show. The
        // deferred bookkeeping lands when the window reports its cascade
        // done, when the fallback timer fires, or when a scroll-away prune
        // unmounts the slot — whichever comes first.
        const CASCADE_GRACE_MS = 240000; // a full 52-card run is minutes
        const settleBrowseCelebration = (gameId)=>{
            const show = celebrationsRef.current.get(gameId);
            if (show == null) return;
            clearTimeout(show.timer);
            celebrationsRef.current.delete(gameId);
            // Final board first — endGame deletes the machine it reads.
            setBrowseEndedIds((prev)=>new Set(prev).add(gameId));
            rememberBrowseFinal(gameId);
            setBrowseReadyIds((prev)=>{
                const next = new Set(prev);
                next.delete(gameId);
                return next;
            });
            // A watched winner keeps its machine — the frozen desktop window
            // owns it until X/replacement. Only browse-only machines tear down.
            if (!seatPhasesRef.current.has(gameId)) endGame(gameId);
            scheduleBrowsePrune(gameId);
            publishActiveGameIds();
        };
        settleCelebrationRef.current = settleBrowseCelebration;
        // notify: false when finishWatchedGame delivers the terminal event
        // itself (a second one would be ignored, but one is cleaner).
        // wonElapsedMs > 0 means we JOINED a show already in flight (the
        // server's celebrating-stub snapshot said how far in) — the win
        // epoch and the settle fallback both shift back by that much.
        const beginBrowseCelebration = (gameId, { notify: notify, wonElapsedMs: wonElapsedMs = 0 })=>{
            const m = machinesRef.current.get(gameId);
            if (!m) return;
            // The same server beat ships browse_ended BEFORE this reasoned
            // game_ended (one coalesced frame), so the ended-stub bookkeeping
            // has already landed by the time we know it's a win. Reverse it
            // in the same React batch: the slot stays live for the show, and
            // the settle re-stamps everything when the cascade ends.
            setBrowseEndedIds((prev)=>{
                if (!prev.has(gameId)) return prev;
                const next = new Set(prev);
                next.delete(gameId);
                return next;
            });
            setBrowseFinalStates((prev)=>{
                if (!prev.has(gameId)) return prev;
                const next = new Map(prev);
                next.delete(gameId);
                return next;
            });
            setBrowseReadyIds((prev)=>new Set(prev).add(gameId));
            if (notify) notifySubscribers(gameId, {
                prevState: m.board,
                curState: m.board,
                move: null,
                terminal: true,
                reason: "won",
                wonElapsedMs: wonElapsedMs
            });
            // Floor of a few seconds: even a joiner arriving at the very end
            // of the window gets the final-board settle, never a stuck slot.
            const remaining = Math.max(5000, CASCADE_GRACE_MS - wonElapsedMs);
            celebrationsRef.current.set(gameId, {
                timer: setTimeout(()=>settleBrowseCelebration(gameId), remaining),
                wonAt: Date.now() - wonElapsedMs
            });
        };
        // Scrolling away silently drops browse-only machines. This is the
        // client-memory half of the bounded protocol; watched desktop games
        // survive even when they leave the browser viewport.
        pruneBrowseRef.current = (gameIds)=>{
            for (const gameId of gameIds){
                if (seatPhasesRef.current.has(gameId)) continue;
                if (celebrationsRef.current.has(gameId)) settleBrowseCelebration(gameId);
                else endGame(gameId);
            }
            publishActiveGameIds();
        };
        // Apply one spectated move by wire index. Returns false on a bad
        // index — which the seq-guarded protocol makes a genuine violation,
        // so we ask for a fresh snapshot rather than freezing forever.
        const applySpectatedMove = (gameId, moveIndex)=>{
            const m = machinesRef.current.get(gameId);
            const applied = (0, $2ed1e96d131fed28$export$37e14c2bfa1ddb86)(m, moveIndex);
            if (!applied) {
                forceResync(`bad move index ${moveIndex} for game ${gameId}`);
                return false;
            }
            machinesRef.current.set(gameId, applied.machine);
            notifySubscribers(gameId, {
                prevState: m.board,
                curState: applied.machine.board,
                move: applied.move,
                terminal: false
            });
            return true;
        };
        // Register a freshly (re)built game machine from a self-contained
        // server snapshot: history + whether undo is armed. Callers notify
        // subscribers as appropriate.
        const setGameSnapshot = (gameId, moves, canUndo)=>{
            // A snapshot for an id with no current machine is a NEW identity —
            // either first sight or a rebuild after endGame (e.g. Watch on a
            // ghost replay reusing a frozen window's number). The generation
            // feeds SpectatedSolitaire's re-arm effect: a frozen (terminal)
            // window instance must never silently adopt a different game.
            if (!machinesRef.current.has(gameId)) machineGenRef.current.set(gameId, (machineGenRef.current.get(gameId) ?? 0) + 1);
            machinesRef.current.set(gameId, (0, $2ed1e96d131fed28$export$a452cc4c8630e0ff)(gameId, moves ?? [], !!canUndo, {
                label: "useSolitaireServer"
            }));
            seqRef.current.set(gameId, (moves ?? []).length);
        };
        const onMessage = (evt)=>{
            let parsed;
            try {
                parsed = JSON.parse(evt.data);
            } catch  {
                return;
            }
            // The write pump coalesces queued frames into one message (a JSON
            // array in queue order). Unwrapping here keeps the FIFO guarantee:
            // a batch [a,b] is exactly "a then b" (see server/PROTOCOL.md).
            if (Array.isArray(parsed)) for (const m of parsed)handleServerMsg(m);
            else handleServerMsg(parsed);
        };
        const handleServerMsg = (msg)=>{
            // Compact cursor relay ({"t":"c","g":id,"c":[x,y,down01]}) —
            // presence only, display-only, never engine state.
            if (msg.t === "c") {
                if (msg.g !== myGameIdRef.current && Array.isArray(msg.c)) notifySubscribers(msg.g, {
                    cursor: {
                        x: msg.c[0],
                        y: msg.c[1],
                        down: msg.c[2] === 1
                    }
                });
                return;
            }
            switch(msg.type){
                case "welcome":
                    {
                        // The hello this answers is no longer pending — without this,
                        // the error handler below would treat any later "ended" error
                        // as a response to a request we never made.
                        pendingGameIdRef.current = null;
                        helloInFlightRef.current = false;
                        hadWelcomeRef.current = true;
                        // Dev knob: `?devwin=ID` asks the server (dev-create gate) to
                        // force-end that live game as won, once, so its cascade can
                        // be verified from this tab's neighbor windows / browse grid.
                        if (!devWinSentRef.current) {
                            devWinSentRef.current = true;
                            const raw = new URLSearchParams(window.location.search).get("devwin");
                            const target = raw ? parseInt(raw, 10) : NaN;
                            if (Number.isFinite(target) && target > 0) ws.send(JSON.stringify({
                                type: "dev_win",
                                game_id: target
                            }));
                        }
                        const wasSameGame = myGameIdRef.current === msg.your_game_id;
                        updateMyGameId(msg.your_game_id);
                        updateTimedOut(false);
                        updateWon(false);
                        setIdlePrompt(null);
                        // Mirror the server's idle clock instead of resetting our own:
                        // a reconnect blip must not suppress the "still there?" prompt
                        // while the server's sweep marches on regardless.
                        lastActivityRef.current = Date.now() - (typeof msg.idle_ms === "number" ? msg.idle_ms : 0);
                        if (typeof msg.room_active === "number") setRoomActive(msg.room_active);
                        if (typeof msg.neighbor_count === "number") sentNeighborCountRef.current = msg.neighbor_count;
                        const freshSocket = freshSocketRef.current;
                        freshSocketRef.current = false;
                        // Reconnect = a fresh socket AFTER the session's first
                        // welcome. Only reconnect arrivals open quietly.
                        const reconnectWelcome = freshSocket && everWelcomedRef.current;
                        everWelcomedRef.current = true;
                        let serverMoves = [];
                        let serverCanUndo = false;
                        const incoming = new Map();
                        for (const g of msg.active_games || [])if (g.game_id === msg.your_game_id) {
                            serverMoves = g.moves || [];
                            serverCanUndo = !!g.can_undo;
                        } else incoming.set(g.game_id, g);
                        // Always present (sendWelcome unconditionally includes it);
                        // the ordered list is the authoritative desktop-set diff.
                        const watchedIds = (msg.watched_game_ids ?? []).filter(Number.isInteger);
                        // Rebuild the seat map on the server's ordered list. Seats
                        // already mid-ceremony keep their phase: a welcome for one
                        // seat's reseat must not reanimate another seat's departure.
                        const prevSeats = seatPhasesRef.current;
                        seatPhasesRef.current = new Map(watchedIds.map((id)=>[
                                id,
                                prevSeats.get(id) ?? "live"
                            ]));
                        // The watched ID list is authoritative and includes ended games,
                        // whose final machines remain local even though active_games no
                        // longer carries a live snapshot for them.
                        for (const oldId of Array.from(machinesRef.current.keys())){
                            const stillBrowsed = browseWantedRef.current && browseRequestedRef.current.has(oldId);
                            if (!seatPhasesRef.current.has(oldId) && !stillBrowsed) endGame(oldId);
                        }
                        // Games still/newly present: rebuild from the snapshot, and
                        // resync existing subscribers by firing a non-terminal event
                        // with the new state. Windows first seen on a RECONNECT
                        // welcome open with zero animation — waking must present the
                        // already-settled room, so arrivals get no theater either.
                        for (const [gid, g] of incoming){
                            const prev = machinesRef.current.get(gid);
                            if (reconnectWelcome && !prev) quietArrivalIdsRef.current.add(gid);
                            setGameSnapshot(gid, g.moves, g.can_undo);
                            if (prev) notifySubscribers(gid, {
                                prevState: prev.board,
                                curState: machinesRef.current.get(gid).board,
                                move: null,
                                terminal: false
                            });
                        }
                        publishActiveGameIds();
                        // A reconnect creates a fresh server-side Client, so restore
                        // the lightweight browser roster if its window stayed open.
                        // Its visible-range effect follows with the bounded browse_set.
                        // Gated on a genuinely fresh socket: reseat and watch welcomes
                        // arrive mid-session and must leave the roster (ended stubs,
                        // scroll position) alone.
                        if (freshSocket && browseWantedRef.current && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) {
                            setBrowseGameIds([]);
                            setBrowseReadyIds(new Set());
                            browseRequestedRef.current = new Set();
                            ws.send(JSON.stringify({
                                type: "browse_open"
                            }));
                        }
                        // Dev knobs: stage a fake neighbor ending once per page load.
                        if (spectateKnob && !knobFiredRef.current && machinesRef.current.size > 0) {
                            knobFiredRef.current = true;
                            // Pick a game somebody is actually WATCHING (a machine
                            // without subscribers has no window — its ending would play
                            // to an empty room). Windows mount over several seconds
                            // (staggered reveal), so retry until one is subscribed.
                            const tryFire = (attemptsLeft)=>{
                                const id = [
                                    ...subscribersRef.current.keys()
                                ].find((g)=>machinesRef.current.has(g));
                                if (id != null) finishWatchedGame(id, spectateKnob);
                                else if (attemptsLeft > 0) setTimeout(()=>tryFire(attemptsLeft - 1), 1000);
                            };
                            setTimeout(()=>tryFire(20), 6000);
                        }
                        // Welcome-time consistency check: the server's history plus our
                        // queued outbox must land exactly on our optimistic length, with
                        // each queued op minted at the position it will arrive at. Then
                        // (and only then) the outbox flushes. Anything else — including
                        // an outbox containing an undo — drops the queue and rebuilds
                        // from the server's history. (A queued move+undo pair nets out
                        // to the server's history anyway, so rebuilding loses nothing.)
                        const outbox = outboxRef.current;
                        outboxRef.current = [];
                        const queued = outbox.filter((e)=>e.gameId === msg.your_game_id);
                        const local = ownSeqRef.current;
                        const contiguous = queued.every((e, i)=>e.payload.type === "move" && e.payload.seq === serverMoves.length + i);
                        const adopt = (rebuild)=>{
                            setMyGameMoves(serverMoves);
                            setMyGameCanUndo(serverCanUndo);
                            ownSeqRef.current = serverMoves.length;
                            if (rebuild) setMyGameResyncNonce((n)=>n + 1);
                        };
                        if (!wasSameGame || local == null) adopt(false);
                        else if (local === serverMoves.length + queued.length && contiguous) for (const e of queued)ws.send(JSON.stringify(e.payload));
                        else {
                            console.warn(`own-game divergence at welcome (local ${local}, server ` + `${serverMoves.length}, queued ${queued.length}); rebuilding`);
                            adopt(true);
                        }
                        break;
                    }
                case "browse_roster":
                    {
                        if (!browseWantedRef.current) break;
                        if (browseRetryTimerRef.current != null) {
                            clearTimeout(browseRetryTimerRef.current);
                            browseRetryTimerRef.current = null;
                        }
                        const seen = new Set();
                        const ids = [];
                        for (const raw of msg.game_ids || []){
                            const id = Number(raw);
                            if (!Number.isInteger(id) || seen.has(id)) continue;
                            seen.add(id);
                            ids.push(id);
                        }
                        setBrowseGameIds(ids);
                        setBrowseEndedIds(new Set());
                        setBrowseReadyIds(new Set());
                        setBrowseFinalStates(new Map());
                        browseRequestedRef.current = new Set();
                        // Stale prune timers must not fire into the fresh roster —
                        // an id present again here is a new live incarnation.
                        for (const t of browsePruneTimersRef.current.values())clearTimeout(t);
                        browsePruneTimersRef.current.clear();
                        break;
                    }
                case "browse_retry":
                    {
                        if (!browseWantedRef.current) break;
                        const operation = msg.operation;
                        const seq = Number(msg.browse_seq);
                        if (operation === "set" && (!Number.isInteger(seq) || seq !== browseSeqRef.current)) break;
                        if (operation !== "open" && operation !== "set") break;
                        if (browseRetryTimerRef.current != null) clearTimeout(browseRetryTimerRef.current);
                        const retryMs = Math.max(250, Math.min(1000, Number(msg.retry_ms) || 300));
                        browseRetryTimerRef.current = setTimeout(()=>{
                            browseRetryTimerRef.current = null;
                            if (!browseWantedRef.current || ws.readyState !== (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) return;
                            if (operation === "open") ws.send(JSON.stringify({
                                type: "browse_open"
                            }));
                            else if (seq === browseSeqRef.current) ws.send(JSON.stringify({
                                type: "browse_set",
                                game_ids: Array.from(browseRequestedRef.current),
                                browse_seq: seq
                            }));
                        }, retryMs);
                        break;
                    }
                case "browse_added":
                    {
                        if (!browseWantedRef.current) break;
                        const id = Number(msg.game_id);
                        if (!Number.isInteger(id)) break;
                        setBrowseGameIds((prev)=>prev.includes(id) ? prev : [
                                ...prev,
                                id
                            ]);
                        // A re-added ID means a ghost replay reused a historical number:
                        // the old instance's ended stub and cached final board are stale
                        // for the new one — clear them so the slot reads live again
                        // (including any pending prune of the dead incarnation).
                        {
                            const timers = browsePruneTimersRef.current;
                            clearTimeout(timers.get(id));
                            timers.delete(id);
                        }
                        setBrowseEndedIds((prev)=>{
                            if (!prev.has(id)) return prev;
                            const next = new Set(prev);
                            next.delete(id);
                            return next;
                        });
                        setBrowseFinalStates((prev)=>{
                            if (!prev.has(id)) return prev;
                            const next = new Map(prev);
                            next.delete(id);
                            return next;
                        });
                        break;
                    }
                case "browse_ended":
                    {
                        if (!browseWantedRef.current) break;
                        const id = Number(msg.game_id);
                        if (!Number.isInteger(id)) break;
                        // Mid-cascade: the reasoned game_ended arrived in the same
                        // server beat and deferred this bookkeeping to the settle.
                        if (celebrationsRef.current.has(id)) break;
                        setBrowseEndedIds((prev)=>new Set(prev).add(id));
                        rememberBrowseFinal(id);
                        setBrowseReadyIds((prev)=>{
                            const next = new Set(prev);
                            next.delete(id);
                            return next;
                        });
                        scheduleBrowsePrune(id);
                        break;
                    }
                case "game_present":
                    {
                        if (msg.game_id === myGameIdRef.current) break;
                        // A scroll may have moved again while this snapshot was in
                        // flight. Only the exact current generation may make a browse
                        // slot live; ordinary watched-game snapshots have no marker.
                        if (msg.browse && (msg.browse_seq !== browseSeqRef.current || !browseRequestedRef.current.has(msg.game_id))) break;
                        // A game that WON inside its celebration window is still a
                        // roster entry (server/PROTOCOL.md §6): the ended stub carries
                        // won_elapsed_ms, and the cascade is deterministic per game id,
                        // so this slot can join the show in progress — build the (won)
                        // machine, keep the slot live, and let SpectatedSolitaire
                        // fast-forward the sim by the elapsed time.
                        if (msg.browse && msg.ended && msg.reason === "won" && typeof msg.won_elapsed_ms === "number") {
                            if (celebrationsRef.current.has(msg.game_id)) {
                                // Already celebrating here (range churn re-requests the id
                                // because the slot never reads ended mid-show): keep the
                                // running show, just re-mark the slot ready.
                                setBrowseReadyIds((prev)=>new Set(prev).add(msg.game_id));
                                break;
                            }
                            setGameSnapshot(msg.game_id, msg.moves, false);
                            beginBrowseCelebration(msg.game_id, {
                                notify: true,
                                wonElapsedMs: Math.max(0, msg.won_elapsed_ms)
                            });
                            publishActiveGameIds();
                            break;
                        }
                        // The celebration join above is the ONLY ended snapshot the
                        // wire carries; plain ended stubs fetch their final board over
                        // HTTP (loadBrowseFinal). Anything else ended here is stray.
                        if (msg.ended) break;
                        // Server snapshots are authoritative: always adopt, replacing
                        // any machine we already had (this is also the resync path).
                        const prev = machinesRef.current.get(msg.game_id);
                        setGameSnapshot(msg.game_id, msg.moves, msg.can_undo);
                        if (prev) notifySubscribers(msg.game_id, {
                            prevState: prev.board,
                            curState: machinesRef.current.get(msg.game_id).board,
                            move: null,
                            terminal: false
                        });
                        if (!msg.browse && !seatPhasesRef.current.has(msg.game_id)) seatPhasesRef.current.set(msg.game_id, "live");
                        publishActiveGameIds();
                        if (browseRequestedRef.current.has(msg.game_id)) setBrowseReadyIds((prev)=>new Set(prev).add(msg.game_id));
                        break;
                    }
                case "move":
                    {
                        if (msg.game_id === myGameIdRef.current) break;
                        // A move that completed a drag carries its cursor release
                        // edge (c:[x,y,0]). Dispatch the release FIRST, in the same
                        // task as the move below — the spectated window restores its
                        // drag ghost and applies the board change in one React
                        // commit, which is exactly what makes the drop flicker-free.
                        if (Array.isArray(msg.c) && msg.c.length === 3) notifySubscribers(msg.game_id, {
                            cursor: {
                                x: msg.c[0],
                                y: msg.c[1],
                                down: msg.c[2] === 1
                            }
                        });
                        if (!machinesRef.current.has(msg.game_id)) break;
                        const nextSeq = seqRef.current.get(msg.game_id) ?? 0;
                        if (msg.seq < nextSeq) break; // duplicate/stale — already reduced
                        if (msg.seq > nextSeq) {
                            // A hole in a FIFO no-holes stream: protocol violation.
                            forceResync(`seq gap for game ${msg.game_id} (${msg.seq} > ${nextSeq})`);
                            break;
                        }
                        if (applySpectatedMove(msg.game_id, msg.move)) seqRef.current.set(msg.game_id, nextSeq + 1);
                        break;
                    }
                case "room":
                    if (typeof msg.active === "number") setRoomActive(msg.active);
                    break;
                // A neighbor took back their last move. Machines are built from
                // self-contained snapshots (can_undo included), so a machine that
                // exists can always honor a server-approved undo — a null here is
                // a protocol violation, answered loudly with a resync request.
                case "undo":
                    {
                        if (msg.game_id === myGameIdRef.current) break; // own undo is local
                        const m = machinesRef.current.get(msg.game_id);
                        if (!m) break;
                        const undone = (0, $2ed1e96d131fed28$export$45cb8543509a58f0)(m);
                        if (!undone) {
                            forceResync(`undo with no armed prevBoard for game ${msg.game_id}`);
                            break;
                        }
                        if (typeof msg.seq === "number") seqRef.current.set(msg.game_id, msg.seq);
                        machinesRef.current.set(msg.game_id, undone);
                        notifySubscribers(msg.game_id, {
                            prevState: m.board,
                            curState: undone.board,
                            move: null,
                            terminal: false
                        });
                        break;
                    }
                case "game_ended":
                    if (msg.game_id !== myGameIdRef.current) {
                        const watched = seatPhasesRef.current.has(msg.game_id);
                        // A visible winner (watched or browse-only): defer the
                        // browse bookkeeping so the grid slot plays the cascade
                        // instead of snapping to a frozen "Ended" board. Watched
                        // desktops still finish normally — their instance runs the
                        // same show and keeps the final board after.
                        const celebrate = msg.reason === "won" && browseWantedRef.current && machinesRef.current.has(msg.game_id);
                        if (celebrate) beginBrowseCelebration(msg.game_id, {
                            notify: !watched
                        });
                        else if (browseWantedRef.current) {
                            setBrowseEndedIds((prev)=>new Set(prev).add(msg.game_id));
                            rememberBrowseFinal(msg.game_id);
                        }
                        if (watched) finishWatchedGame(msg.game_id, msg.reason);
                        else if (!celebrate) endGame(msg.game_id, msg.reason);
                        publishActiveGameIds();
                        break;
                    }
                    endGame(msg.game_id, msg.reason);
                    publishActiveGameIds();
                    if (myGameIdRef.current === msg.game_id) {
                        outboxRef.current = [];
                        if (msg.reason === "won") {
                            // Our own win claim echoing back. Keep the won board mounted
                            // — nulling the ID here would unmount the app mid-cascade.
                            // A fresh deal comes later via dealNewGame().
                            updateWon(true);
                            setIdlePrompt(null); // never ask "Still there?" over a win
                            $1638376c337d7afc$var$storeGameId(null); // but a refresh should start fresh
                        } else if (!helloInFlightRef.current) {
                            // Abandoned/timed out under us (idle sweep). Don't silently
                            // deal a new game — keep the dead board mounted and let the
                            // UI say what happened; the player chooses to re-deal. The
                            // stored id is dead too: a refresh must not resurrect it.
                            $1638376c337d7afc$var$storeGameId(null);
                            setIdlePrompt(null);
                            updateTimedOut(true);
                        }
                    }
                    break;
                // Our optimistic local state diverged from the server's (stale
                // seq, illegal index, rate limit). Adopt the server's history and
                // force PlayableSolitaire to rebuild from it.
                case "move_rejected":
                    if (msg.game_id !== myGameIdRef.current) break;
                    console.warn("server rejected a move; resyncing own game");
                    outboxRef.current = [];
                    setMyGameMoves(msg.moves || []);
                    setMyGameCanUndo(!!msg.can_undo);
                    ownSeqRef.current = (msg.moves || []).length;
                    setMyGameResyncNonce((n)=>n + 1);
                    break;
                case "error":
                    // Structured codes, not prose: the error text is for humans.
                    if (msg.code === "game_unavailable" && pendingGameIdRef.current != null) {
                        // Our stored game_id names a game that's gone (ended, timed
                        // out during an outage, or not ours). Drop it and hello
                        // fresh for a new deal.
                        $1638376c337d7afc$var$storeGameId(null);
                        pendingGameIdRef.current = null;
                        outboxRef.current = [];
                        sendHello(null);
                    } else if (msg.code === "hello_throttled") {
                        // The hello bucket is empty (reconnect storm). Retry the
                        // SAME hello after the bucket refills — without this a
                        // throttled resume stranded the client gameless forever.
                        helloInFlightRef.current = false;
                        const retryId = pendingGameIdRef.current;
                        setTimeout(()=>{
                            if (myGameIdRef.current == null && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) sendHello(retryId);
                        }, 4500);
                    } else {
                        helloInFlightRef.current = false;
                        console.warn("server error:", msg.error);
                    }
                    break;
                default:
                    break;
            }
        };
        ws.addEventListener("open", onOpen);
        ws.addEventListener("close", onClose);
        ws.addEventListener("message", onMessage);
        // Wake-from-suspend nudge. Safari (especially iOS) aggressively
        // bfcaches and freezes tabs; a restored page can hold a zombie
        // socket — readyState still OPEN but the NAT/proxy path long dead,
        // and no close event ever fires, so partysocket never retries on
        // its own. Cycling the socket is the sanctioned recovery path: the
        // welcome flow re-asserts the room, and a live seat rebinds by id.
        let hiddenAt = null;
        const onPageShow = (e)=>{
            if (e.persisted) ws.reconnect();
        };
        const onVisibility = ()=>{
            if (document.visibilityState === "hidden") hiddenAt = Date.now();
            else if (hiddenAt != null) {
                // Long enough hidden that intermediaries may have dropped the
                // idle connection (Cloudflare cuts at ~100s; keepalive pings
                // are throttled in background tabs). Short blur/refocus flips
                // stay untouched.
                if (Date.now() - hiddenAt > 90000) ws.reconnect();
                hiddenAt = null;
            }
        };
        window.addEventListener("pageshow", onPageShow);
        document.addEventListener("visibilitychange", onVisibility);
        return ()=>{
            window.removeEventListener("pageshow", onPageShow);
            document.removeEventListener("visibilitychange", onVisibility);
            ws.removeEventListener("open", onOpen);
            ws.removeEventListener("close", onClose);
            ws.removeEventListener("message", onMessage);
            ws.close();
            if (browseRetryTimerRef.current != null) {
                clearTimeout(browseRetryTimerRef.current);
                browseRetryTimerRef.current = null;
            }
            if (netTimerRef.current != null) {
                clearTimeout(netTimerRef.current);
                netTimerRef.current = null;
            }
            pruneBrowseRef.current = ()=>{};
            settleCelebrationRef.current = ()=>{};
            for (const t of browsePruneTimersRef.current.values())clearTimeout(t);
            browsePruneTimersRef.current.clear();
            for (const show of celebrationsRef.current.values())clearTimeout(show.timer);
            celebrationsRef.current.clear();
        };
    }, [
        updateMyGameId
    ]);
    // The room layout is selected before the socket hook runs, so the first
    // hello already carries the right count (mobile sends zero). If compact
    // mode changes later, resize the watched-set ceiling without reconnecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (myGameId == null || sentNeighborCountRef.current === boundedNeighborCount) return;
        const ws = wsRef.current;
        if (ws && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) {
            ws.send(JSON.stringify({
                type: "set_neighbor_count",
                neighbor_count: boundedNeighborCount
            }));
            sentNeighborCountRef.current = boundedNeighborCount;
        }
    }, [
        boundedNeighborCount,
        myGameId
    ]);
    // Send now if the socket is open; otherwise queue against the current
    // game so a reconnect blip doesn't silently lose moves. The queue is
    // flushed after the reconnect welcome confirms the server's history
    // sits exactly underneath it (and dropped if it doesn't — see the
    // welcome handler's consistency check).
    const send = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((payload)=>{
        const ws = wsRef.current;
        if (ws && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) ws.send(JSON.stringify(payload));
        else if (myGameIdRef.current != null) outboxRef.current.push({
            gameId: myGameIdRef.current,
            payload: payload
        });
    }, []);
    // Volatile send for presence traffic: if the socket is down, drop it —
    // stale cursor positions must never queue behind real moves. Compact
    // form ({"t":"c","c":[x,y,down01]}) — the chattiest message on the
    // wire earns the short keys. `down` mirrors the held button so
    // watchers see clicks and drags.
    const sendCursor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((x, y, down = false)=>{
        const ws = wsRef.current;
        if (ws && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) ws.send(JSON.stringify({
            t: "c",
            c: [
                x,
                y,
                down ? 1 : 0
            ]
        }));
    }, []);
    // Every own-game op is minted at our current optimistic history length
    // (seq); the server accepts it only at exactly that position. See
    // ownSeqRef above.
    const sendMove = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(// releaseAt: [x,y] when this move completed a drag — the cursor
    // release edge rides ON the move message so watchers get
    // release+move as one atomic frame (PROTOCOL.md §4).
    // `draw` mirrors the server's idle clock, which draws never feed: a
    // pure stock-cycler used to sail past the "no move" warning (client
    // counted draws, server didn't) straight into a timed-out notice.
    (moveIndex, releaseAt = null, { draw: draw = false } = {})=>{
        if (!draw) lastActivityRef.current = Date.now();
        const seq = ownSeqRef.current ?? 0;
        ownSeqRef.current = seq + 1;
        // Mirror the op into the published own-history optimistically, so
        // initialMoves is NEVER stale: a PlayableSolitaire remount from
        // any cause rebuilds today's position instead of silently
        // rewinding to welcome-time state. A rejection overwrites this
        // with the server's truth.
        setMyGameMoves((prev)=>prev == null ? prev : [
                ...prev,
                moveIndex
            ]);
        setMyGameCanUndo(true);
        const msg = {
            type: "move",
            move: moveIndex,
            seq: seq
        };
        if (releaseAt) msg.c = [
            Math.round(releaseAt[0]),
            Math.round(releaseAt[1]),
            0
        ];
        send(msg);
    }, [
        send
    ]);
    // Shut Down's honest exit: powering off gives the game up immediately
    // — you can't resume a computer you turned off. Best-effort
    // fire-and-forget on the live socket only; if the socket is down the
    // idle sweep ends the game soon anyway, and queuing an abandon behind
    // a reconnect could kill a game the player believes they resumed.
    const abandonGame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const ws = wsRef.current;
        if (ws && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) ws.send(JSON.stringify({
            type: "abandon"
        }));
    }, []);
    // Undoing a draw is still stock-cycling — the server's idle clock
    // ignores it, so ours must too (same mirror as sendMove).
    const sendUndo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ draw: draw = false } = {})=>{
        if (!draw) lastActivityRef.current = Date.now();
        const seq = ownSeqRef.current ?? 0;
        ownSeqRef.current = Math.max(0, seq - 1);
        // Single-step undo: pop the mirrored op; the undo slot is spent.
        setMyGameMoves((prev)=>prev == null || prev.length === 0 ? prev : prev.slice(0, -1));
        setMyGameCanUndo(false);
        send({
            type: "undo",
            seq: seq
        });
    }, [
        send
    ]);
    // The one warning. Note the client counts draws as activity but the
    // server doesn't — a pure-stock-cycler can still be swept, and then
    // the timed-out notice covers it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const t = setInterval(()=>{
            if (myGameIdRef.current == null) return;
            if (myGameTimedOutRef.current) return;
            // A won game is over — sitting with the cascade (or the finished
            // board) is not idling; there is nothing for the server to sweep.
            if (myGameWonRef.current) return;
            const gameIdle = Date.now() - lastActivityRef.current;
            const inputQuiet = Date.now() - lastInputRef.current;
            // Under the screensaver (or headed there): no prompt. The game
            // dies behind the pipes and the timed-out notice waits for wake.
            if (inputQuiet >= AWAKE_MS) return;
            if (gameIdle > SERVER_IDLE_MS - LAST_CHANCE_LEAD_MS) {
                // Sweep imminent and they're demonstrably present: warn, and
                // say why ("no move", not "no sign of you").
                const next = {
                    kind: "no-move",
                    minutes: Math.max(1, Math.round(gameIdle / 60000))
                };
                setIdlePrompt((prev)=>prev && prev.kind === next.kind && prev.minutes === next.minutes ? prev : next);
            }
        // An already-raised prompt never auto-dismisses (a mouse wiggle
        // silently swallowing a modal would be spookier than the modal).
        }, IDLE_CHECK_MS);
        return ()=>clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const confirmStillHere = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        // The server may have swept the game while the prompt sat on
        // screen (its idle clock ignores draws; ours doesn't). If so, the
        // timed-out notice has already replaced the prompt — a late OK
        // must not send still_here for a dead game.
        if (myGameTimedOutRef.current || myGameWonRef.current) return;
        lastActivityRef.current = Date.now();
        setIdlePrompt(null);
        // Volatile, like cursor traffic: presence must never queue in the
        // outbox (a stale still_here delivered after reconnect would lie
        // about the idle clock; the welcome's idle_ms re-derives the honest
        // state, and the prompt re-raises if it's still true).
        const ws = wsRef.current;
        if (ws && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) ws.send(JSON.stringify({
            type: "still_here"
        }));
    }, []);
    const dismissNetTrouble = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setNetTrouble(false), []);
    // Browser control is volatile UI state, never part of the own-game
    // outbox. Reconnect restoration happens from browseWantedRef in the
    // welcome handler above.
    const sendBrowse = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((payload)=>{
        const ws = wsRef.current;
        if (ws && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) ws.send(JSON.stringify(payload));
    }, []);
    const openGameBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (browseRetryTimerRef.current != null) {
            clearTimeout(browseRetryTimerRef.current);
            browseRetryTimerRef.current = null;
        }
        browseWantedRef.current = true;
        setBrowseGameIds([]);
        setBrowseEndedIds(new Set());
        setBrowseReadyIds(new Set());
        setBrowseFinalStates(new Map());
        browseRequestedRef.current = new Set();
        for (const t of browsePruneTimersRef.current.values())clearTimeout(t);
        browsePruneTimersRef.current.clear();
        sendBrowse({
            type: "browse_open"
        });
    }, [
        sendBrowse
    ]);
    const setBrowsedGames = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((gameIds)=>{
        if (browseRetryTimerRef.current != null) {
            clearTimeout(browseRetryTimerRef.current);
            browseRetryTimerRef.current = null;
        }
        const next = new Set(gameIds);
        const previous = browseRequestedRef.current;
        browseRequestedRef.current = next;
        const leaving = [];
        for (const id of previous)if (!next.has(id)) leaving.push(id);
        if (leaving.length > 0) pruneBrowseRef.current(leaving);
        setBrowseReadyIds((ready)=>{
            const kept = new Set();
            for (const id of ready)if (next.has(id) && previous.has(id)) kept.add(id);
            return kept;
        });
        browseSeqRef.current += 1;
        sendBrowse({
            type: "browse_set",
            game_ids: gameIds,
            browse_seq: browseSeqRef.current
        });
    }, [
        sendBrowse
    ]);
    // Fetch an ended stub's final board from the Past Games endpoint.
    // A just-ended game persists asynchronously, so a 404 retries a few
    // times before giving up (the stub simply stays a labeled empty board
    // and a later scroll retries). Celebrating wins never come through
    // here — their wire snapshot carries won_elapsed_ms.
    const loadBrowseFinal = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((gameId)=>{
        if (finalFetchesRef.current.has(gameId)) return;
        finalFetchesRef.current.add(gameId);
        const attempt = (triesLeft)=>{
            (0, $bc6426009fe17cee$export$7cace6c5bbcb0712)(gameId).then((board)=>{
                finalFetchesRef.current.delete(gameId);
                if (board) rememberFinalRef.current(gameId, board);
            }).catch(()=>{
                if (triesLeft > 0) setTimeout(()=>attempt(triesLeft - 1), 900);
                else finalFetchesRef.current.delete(gameId);
            });
        };
        attempt(3);
    }, []);
    const closeGameBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (browseRetryTimerRef.current != null) {
            clearTimeout(browseRetryTimerRef.current);
            browseRetryTimerRef.current = null;
        }
        browseWantedRef.current = false;
        setBrowseGameIds([]);
        setBrowseEndedIds(new Set());
        setBrowseReadyIds(new Set());
        setBrowseFinalStates(new Map());
        browseRequestedRef.current = new Set();
        for (const t of browsePruneTimersRef.current.values())clearTimeout(t);
        browsePruneTimersRef.current.clear();
        sendBrowse({
            type: "browse_close"
        });
    }, [
        sendBrowse
    ]);
    // Put one specific live game into the watched desktop set. The server
    // answers with a welcome containing the complete ordered set.
    const watchGame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((gameId)=>{
        const ws = wsRef.current;
        if (ws && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) ws.send(JSON.stringify({
            type: "watch",
            game_id: gameId
        }));
    }, []);
    const unwatchGame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((gameId)=>{
        // Optimistic local removal: X must stick even across a socket blip.
        // If the unwatch frame is lost, the reconnect hello simply re-asserts
        // a watched set without this id — no haunted seat either way.
        seatPhasesRef.current.delete(gameId);
        setWatchedGameIds(Array.from(seatPhasesRef.current.keys()));
        const ws = wsRef.current;
        if (ws && ws.readyState === (0, $e62ef20f585cc2b1$export$2e2bcd8739ae039).OPEN) ws.send(JSON.stringify({
            type: "unwatch",
            game_id: gameId
        }));
    }, []);
    // Give up the current game (recorded as an abandon — losses are part of
    // the piece) and ask for a fresh one, as a single server-side op:
    // hello {fresh} abandons whatever this session owns and deals anew.
    // Used by the Start menu's "Deal New Game".
    const dealNewGame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        outboxRef.current = [];
        updateTimedOut(false);
        setIdlePrompt(null);
        lastActivityRef.current = Date.now();
        $1638376c337d7afc$var$storeGameId(null);
        if (sendHelloRef.current) sendHelloRef.current(null, {
            fresh: true
        });
    }, []);
    // A watched window finished its departure ceremony (close ritual /
    // cascade). Hide it from the desktop; the id stays in the watched set
    // so a reconnect re-assert keeps the seat until the server's reseat
    // welcome swaps in the replacement (which clears everything via the
    // normal welcome diff).
    const departWatchedGame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((gameId)=>{
        const phase = seatPhasesRef.current.get(gameId);
        if (phase !== "ended" && phase !== "departed") return;
        seatPhasesRef.current.set(gameId, "departed");
        setDepartedWatchedIds((prev)=>new Set(prev).add(gameId));
    }, []);
    // Subscribe to a spectated game's move stream. Returns a handle whose
    // `state` is the current board (use it for immediate render);
    // subsequent moves arrive via onEvent. On terminal the subscriber is
    // auto-unsubscribed. Stable across renders.
    const subscribeGame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((gameId, onEvent)=>{
        const machine = machinesRef.current.get(gameId);
        let set = subscribersRef.current.get(gameId);
        if (!set) {
            set = new Set();
            subscribersRef.current.set(gameId, set);
        }
        set.add(onEvent);
        const wonAt = celebrationsRef.current.get(gameId)?.wonAt;
        return {
            state: machine ? machine.board : undefined,
            // Non-null when this game's win cascade is mid-flight: how far
            // the show has run. A window mounting now (a browse slot opened
            // mid-show) starts its celebration fast-forwarded by this much
            // instead of waiting for a terminal event that already fired.
            celebrationElapsedMs: wonAt != null ? Math.max(0, Date.now() - wonAt) : null,
            unsubscribe: ()=>{
                const s = subscribersRef.current.get(gameId);
                if (!s) return;
                s.delete(onEvent);
                if (s.size === 0) subscribersRef.current.delete(gameId);
            },
            // The window's win cascade finished playing. Only meaningful for
            // browse-grid celebrations (deferred teardown lands now); no-op
            // for everything else.
            cascadeDone: ()=>settleCelebrationRef.current(gameId)
        };
    }, []);
    return {
        myGameId: myGameId,
        myGameMoves: myGameMoves,
        myGameCanUndo: myGameCanUndo,
        myGameResyncNonce: myGameResyncNonce,
        idlePrompt: idlePrompt,
        confirmStillHere: confirmStillHere,
        myGameTimedOut: myGameTimedOut,
        myGameWon: myGameWon,
        netTrouble: netTrouble,
        dismissNetTrouble: dismissNetTrouble,
        activeGameIds: activeGameIds,
        watchedGameIds: watchedGameIds,
        departedWatchedIds: departedWatchedIds,
        departWatchedGame: departWatchedGame,
        quietArrivalIds: quietArrivalIds,
        gameGenerations: gameGenerations,
        browseGameIds: browseGameIds,
        browseEndedIds: browseEndedIds,
        browseReadyIds: browseReadyIds,
        browseFinalStates: browseFinalStates,
        roomActive: roomActive,
        openGameBrowser: openGameBrowser,
        setBrowsedGames: setBrowsedGames,
        loadBrowseFinal: loadBrowseFinal,
        closeGameBrowser: closeGameBrowser,
        watchGame: watchGame,
        unwatchGame: unwatchGame,
        sendMove: sendMove,
        sendUndo: sendUndo,
        sendCursor: sendCursor,
        dealNewGame: dealNewGame,
        abandonGame: abandonGame,
        subscribeGame: subscribeGame
    };
}



// The player's card back: `?back=7` dev override wins, then the deck
// chosen via the Game → Deck… dialog (localStorage), then the same
// per-game hash back that SPECTATORS see — so by default your deck
// matches what everyone else watching your game sees. (A custom choice
// still diverges for watchers until the protocol carries it.)
function $4d8b6aef94a206ca$var$readPlayerCardBack(gameId) {
    if (typeof window === "undefined") return "back-3";
    const raw = new URLSearchParams(window.location.search).get("back");
    if (raw) {
        const n = parseInt(raw, 10);
        if (Number.isFinite(n) && n >= 0 && n <= 18) return `back-${n}`;
    }
    try {
        return localStorage.getItem("saat.cardBack") || (0, $ec53346e7fcdea16$export$5a8a79c6ad2fc273)(gameId);
    } catch  {
        return (0, $ec53346e7fcdea16$export$5a8a79c6ad2fc273)(gameId); // storage denied — hashed default
    }
}
function $4d8b6aef94a206ca$var$App() {
    const compact = (0, $f8c2256ec504592b$export$2e2bcd8739ae039)();
    const roomLayout = (0, $1116e8cea5385e22$export$2e2bcd8739ae039)(compact);
    const neighborCount = compact ? 0 : roomLayout?.neighbors.length ?? (0, $1116e8cea5385e22$export$2873c030859a950d);
    const { myGameId: myGameId, myGameMoves: myGameMoves, myGameCanUndo: myGameCanUndo, myGameResyncNonce: myGameResyncNonce, sendMove: sendMove, sendUndo: sendUndo, sendCursor: sendCursor, dealNewGame: dealNewGame, abandonGame: abandonGame, activeGameIds: activeGameIds, watchedGameIds: watchedGameIds, departedWatchedIds: departedWatchedIds, departWatchedGame: departWatchedGame, quietArrivalIds: quietArrivalIds, gameGenerations: gameGenerations, browseGameIds: browseGameIds, browseEndedIds: browseEndedIds, browseReadyIds: browseReadyIds, browseFinalStates: browseFinalStates, roomActive: roomActive, openGameBrowser: openGameBrowser, setBrowsedGames: setBrowsedGames, loadBrowseFinal: loadBrowseFinal, closeGameBrowser: closeGameBrowser, watchGame: watchGame, unwatchGame: unwatchGame, subscribeGame: subscribeGame, idlePrompt: idlePrompt, confirmStillHere: confirmStillHere, myGameTimedOut: myGameTimedOut, myGameWon: myGameWon, netTrouble: netTrouble, dismissNetTrouble: dismissNetTrouble } = (0, $1638376c337d7afc$export$2e2bcd8739ae039)({
        neighborCount: neighborCount
    });
    // Wallpaper choice survives reloads.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $079dae0934e9e4c7$export$d983cfe63325de39)();
    }, []);
    // Gate on having a game, not on live socket status: once we're seated,
    // reconnect blips shouldn't unmount the Stage (that would replay the
    // whole opening choreography).
    if (myGameId == null) // The POST screen doubles as the loading screen — the machine is
    // "booting" while the socket finds you a game.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($4d8b6aef94a206ca$var$Main, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85c1cff5a23469e0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc26afc7f31cd267$export$2e2bcd8739ae039), {
                waiting: true
            })
        ]
    });
    // The one ambient notice, chosen by priority; first match wins. Add
    // new notices HERE, never as a separately-rendered dialog — Stage
    // renders this through the same modal slot as every other dialog.
    // Order: timed-out > net-trouble > still-there — when the connection
    // is down, "still there?" is a question whose answer we can't
    // deliver, so the network notice replaces it; on reconnect the
    // welcome's idle_ms mirror re-raises the prompt if it's still true.
    const systemNotice = myGameTimedOut ? {
        key: "timed-out",
        priority: (0, $26590d9c4cc3e906$export$bb34f3538ba26c7e).TIMED_OUT,
        title: "Solitaire Alone Together",
        icon: "question",
        message: "Timed out. Start a new game?",
        buttons: [
            {
                label: "OK",
                onClick: dealNewGame
            }
        ]
    } : netTrouble ? {
        key: "net-trouble",
        priority: (0, $26590d9c4cc3e906$export$bb34f3538ba26c7e).NET_TROUBLE,
        title: "Network Error",
        icon: "warning",
        message: "A network error has occurred. Trying to reconnect\u2026",
        buttons: [
            {
                label: "OK",
                onClick: dismissNetTrouble
            }
        ],
        onCancel: dismissNetTrouble
    } : idlePrompt ? {
        key: "still-there",
        priority: (0, $26590d9c4cc3e906$export$bb34f3538ba26c7e).STILL_THERE,
        title: "Solitaire Alone Together",
        icon: "question",
        // The one idle prompt: they're demonstrably present but
        // haven't moved a card in almost the whole window — say why
        // we're asking. Fully-idle players get the screensaver
        // instead, never a prompt.
        // Nolen's copy (2026-09-21): vague on purpose — no minute count.
        message: "You haven't made a move in a while, are you still there?",
        buttons: [
            {
                label: "OK",
                onClick: confirmStillHere
            }
        ]
    } : null;
    const title = `(You) Game #${myGameId} \u{2014} Solitaire Alone Together`;
    const playerSlot = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f6c13e68f433d1b$export$2e2bcd8739ae039), {
        title: title,
        gameId: myGameId,
        cardBack: $4d8b6aef94a206ca$var$readPlayerCardBack(myGameId),
        sendMove: sendMove,
        sendUndo: sendUndo,
        sendCursor: sendCursor,
        dealNewGame: dealNewGame,
        initialMoves: myGameMoves,
        initialCanUndo: myGameCanUndo
    }, `${myGameId}:${myGameResyncNonce}`);
    const allSpectatedSlots = activeGameIds.map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec53346e7fcdea16$export$2e2bcd8739ae039), {
            gameId: id,
            // Bumped when this id's machine is rebuilt from scratch (ghost
            // replays reuse historical numbers) — re-arms a frozen window.
            generation: gameGenerations.get(id) ?? 0,
            subscribeGame: subscribeGame,
            title: `Game #${id} \u{2014} Solitaire Alone Together`
        }, id));
    const watchedIds = new Set(watchedGameIds);
    // Departed seats (their close ritual / cascade has fully played) hold
    // their place in the watched set for reconnect integrity, but their
    // windows are gone until the server redeals the slot.
    const neighborSlots = allSpectatedSlots.filter((slot)=>watchedIds.has(Number(slot.key)) && !departedWatchedIds.has(Number(slot.key)));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($4d8b6aef94a206ca$var$Main, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85c1cff5a23469e0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fbbc52a9bb39ab3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $210cc6c367e16937$export$2e2bcd8739ae039), {
                playerSlot: playerSlot,
                neighborSlots: neighborSlots,
                browserGameSlots: allSpectatedSlots,
                playerGameId: myGameId,
                playerGameOver: myGameTimedOut,
                playerGameWon: myGameWon,
                dealNewGame: dealNewGame,
                abandonGame: abandonGame,
                roomActive: roomActive,
                browseGameIds: browseGameIds,
                browseEndedIds: browseEndedIds,
                browseReadyIds: browseReadyIds,
                browseFinalStates: browseFinalStates,
                openGameBrowser: openGameBrowser,
                setBrowsedGames: setBrowsedGames,
                loadBrowseFinal: loadBrowseFinal,
                closeGameBrowser: closeGameBrowser,
                watchGame: watchGame,
                unwatchGame: unwatchGame,
                departGame: departWatchedGame,
                // Reconnect reseats of seats that died offline open silently:
                // waking shows a settled room, never a parade of arrivals.
                quietArrivalIds: quietArrivalIds,
                roomLayout: roomLayout,
                systemNotice: systemNotice
            })
        ]
    });
}
const $4d8b6aef94a206ca$var$Main = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).main``;
var $4d8b6aef94a206ca$export$2e2bcd8739ae039 = $4d8b6aef94a206ca$var$App;






var $acw62 = parcelRequire("acw62");







// The Layout Studio (`?layout`): a standalone bench for making window
// arrangements. No server, no boot, no bots — pick a target
// resolution, see a to-scale simulation of SAT at exactly that size,
// add dummy windows, drag them into a room, save the JSON, paste into
// Stage/layouts.js. Several saves at one resolution = variants (a
// session picks one at random).
// The resolutions worth caring about (desktop only — compact/mobile
// has its own fixed arrangement). Viewport sizes, i.e. AFTER browser
// chrome, which is why they're shorter than the marketing numbers:
// "1080p" screens hand the page ~950px. "Short" covers half-height
// windows and toolbar-heavy browsers; below/beside these, the loader
// stretches the nearest room (applyLayout), so the buckets can stay few.
const $f5e2c1b11cbc6771$var$RESOLUTIONS = [
    {
        label: "Small laptop \u2014 1280\xd7660",
        w: 1280,
        h: 660
    },
    {
        label: "MacBook \u2014 1512\xd7830",
        w: 1512,
        h: 830
    },
    {
        label: "1080p \u2014 1920\xd7950",
        w: 1920,
        h: 950
    },
    {
        label: "Big display \u2014 2560\xd71300",
        w: 2560,
        h: 1300
    },
    {
        label: "Short window \u2014 1600\xd7520",
        w: 1600,
        h: 520
    }
];
const $f5e2c1b11cbc6771$var$GAME_W = 620;
const $f5e2c1b11cbc6771$var$GAME_H = 435;
// Same clamp PositionedWindow applies to live drags: title bar on
// screen and above the taskbar, a hand's width grabbable horizontally.
function $f5e2c1b11cbc6771$var$clampCenter(x, y, W, H) {
    const GRAB_X = 60;
    let cx = W / 2 + x;
    let cy = H / 2 + y;
    cx = Math.max(GRAB_X - $f5e2c1b11cbc6771$var$GAME_W / 2, Math.min(W - GRAB_X + $f5e2c1b11cbc6771$var$GAME_W / 2, cx));
    cy = Math.max($f5e2c1b11cbc6771$var$GAME_H / 2, Math.min(H - (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef) - 24 + $f5e2c1b11cbc6771$var$GAME_H / 2, cy));
    return {
        x: cx - W / 2,
        y: cy - H / 2
    };
}
// A plausibly mid-game board for a dummy window (same trick as the
// All Active Games' ?fakechaos knob).
function $f5e2c1b11cbc6771$var$dummyState(i) {
    let st = (0, $73d8f6063558c0ab$export$4021de1c0df2c0bd)(1000000 + i);
    let seed = (i + 1) * 2654435761;
    const rand = ()=>{
        seed = seed * 1664525 + 1013904223 >>> 0;
        return seed / 2 ** 32;
    };
    const moves = 10 + Math.floor(rand() * 40);
    for(let m = 0; m < moves; m++){
        const legal = (0, $73d8f6063558c0ab$export$36208696e3534245)(st);
        if (legal.length === 0) break;
        st = (0, $73d8f6063558c0ab$export$ccb438d1838ccb16)(st, Math.floor(rand() * legal.length));
    }
    return st;
}
const $f5e2c1b11cbc6771$var$SELF_STATE = (0, $73d8f6063558c0ab$export$4021de1c0df2c0bd)(1137);
function $f5e2c1b11cbc6771$var$LayoutStudio() {
    const [resIdx, setResIdx] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // Per-resolution working state, kept across switches so several
    // rooms can be tweaked in one sitting. { self: {x,y},
    // dummies: [{id, x, y}], nextId }
    const [rooms, setRooms] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$f5e2c1b11cbc6771$var$RESOLUTIONS.map(()=>({
                self: {
                    x: 0,
                    y: 0
                },
                dummies: [],
                nextId: 0
            })));
    const [copied, setCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [viewport, setViewport] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        w: window.innerWidth,
        h: window.innerHeight
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onResize = ()=>setViewport({
                w: window.innerWidth,
                h: window.innerHeight
            });
        window.addEventListener("resize", onResize);
        return ()=>window.removeEventListener("resize", onResize);
    }, []);
    const res = $f5e2c1b11cbc6771$var$RESOLUTIONS[resIdx];
    const room = rooms[resIdx];
    // Boards are keyed by dummy id (not render index) so closing one
    // window never reshuffles the others' cards.
    const boardsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const dummyBoard = (id)=>{
        if (!boardsRef.current.has(id)) boardsRef.current.set(id, $f5e2c1b11cbc6771$var$dummyState(id));
        return boardsRef.current.get(id);
    };
    const TOOLBAR_H = 46;
    const scale = Math.min((viewport.w - 24) / res.w, (viewport.h - TOOLBAR_H - 24) / res.h);
    const patchRoom = (fn)=>setRooms((prev)=>prev.map((r, i)=>i === resIdx ? fn(r) : r));
    const addWindow = ()=>patchRoom((r)=>{
            const n = r.dummies.length;
            const spot = $f5e2c1b11cbc6771$var$clampCenter(-140 + n % 3 * 130, -90 + n * 52, res.w, res.h);
            return {
                ...r,
                dummies: [
                    ...r.dummies,
                    {
                        id: r.nextId,
                        ...spot
                    }
                ],
                nextId: r.nextId + 1
            };
        });
    const removeWindow = (id)=>patchRoom((r)=>({
                ...r,
                dummies: r.dummies.filter((d)=>d.id !== id)
            }));
    // Drag: plain pointer capture with scale compensation (screen px →
    // frame px). PositionedWindow isn't reused because its clamps are
    // viewport-based — here the FRAME is the world.
    const dragWindow = (e, get, set)=>{
        if (e.button !== 0) return;
        if (e.target.closest("button, input")) return;
        if (!e.target.closest("[data-drag-handle]")) return;
        e.preventDefault();
        const startX = e.clientX;
        const startY = e.clientY;
        const base = get();
        const onMove = (ev)=>{
            const next = $f5e2c1b11cbc6771$var$clampCenter(base.x + (ev.clientX - startX) / scale, base.y + (ev.clientY - startY) / scale, res.w, res.h);
            set(next);
        };
        const onUp = ()=>{
            window.removeEventListener("pointermove", onMove);
            window.removeEventListener("pointerup", onUp);
        };
        window.addEventListener("pointermove", onMove);
        window.addEventListener("pointerup", onUp);
    };
    const save = async ()=>{
        const layout = {
            width: res.w,
            height: res.h,
            self: {
                x: Math.round(room.self.x),
                y: Math.round(room.self.y)
            },
            neighbors: room.dummies.map((d)=>({
                    x: Math.round(d.x),
                    y: Math.round(d.y)
                }))
        };
        const json = JSON.stringify(layout);
        // eslint-disable-next-line no-console
        console.log("[layout]", json);
        try {
            await navigator.clipboard.writeText(json + ",");
        } catch  {
        /* console has it */ }
        setCopied(true);
        setTimeout(()=>setCopied(false), 1600);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5e2c1b11cbc6771$var$Studio, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$Toolbar, {
                className: "window",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5e2c1b11cbc6771$var$ToolbarRow, {
                    className: "window-body",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            value: resIdx,
                            onChange: (e)=>setResIdx(Number(e.target.value)),
                            "aria-label": "Target resolution",
                            children: $f5e2c1b11cbc6771$var$RESOLUTIONS.map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: i,
                                    children: r.label
                                }, r.label))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: addWindow,
                            children: "Add window"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: save,
                            children: copied ? "Copied!" : "Save layout JSON"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5e2c1b11cbc6771$var$Meta, {
                            children: [
                                room.dummies.length,
                                " neighbors \xb7 shown at ",
                                Math.round(scale * 100),
                                "% \xb7 paste into Stage/layouts.js"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$FrameArea, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5e2c1b11cbc6771$var$Frame, {
                    style: {
                        "--w": res.w + "px",
                        "--h": res.h + "px",
                        "--scale": scale
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f5e2c1b11cbc6771$var$IconLayer, {
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$IconSlot, {
                                    style: {
                                        "--top": "12px"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                            name: "solitaire",
                                            size: 32
                                        }),
                                        label: "Solitaire Alone Together"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$IconSlot, {
                                    style: {
                                        "--top": "116px"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                            name: "folder",
                                            size: 32
                                        }),
                                        label: "Past Games"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$IconSlot, {
                                    style: {
                                        "--top": "220px"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                            name: "all-games",
                                            size: 32
                                        }),
                                        label: "All Active Games"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$IconSlot, {
                                    style: {
                                        "--top": "324px"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44bdb76f21627302$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9b9905cc1d7b9d6$export$2e2bcd8739ae039), {
                                            name: "text-file",
                                            size: 32
                                        }),
                                        label: "stats.txt"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$IconSlot, {
                                    style: {
                                        "--top": "auto",
                                        "--bottom": (0, $d2026809cde12e7e$export$e7ce2d3fe3294aef) + 10 + "px"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d97721bde78e9860$export$3f06a51bda79210f), {})
                                })
                            ]
                        }),
                        room.dummies.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$Slot, {
                                style: {
                                    "--x": d.x + "px",
                                    "--y": d.y + "px"
                                },
                                onPointerDown: (e)=>dragWindow(e, ()=>d, (next)=>patchRoom((r)=>({
                                                ...r,
                                                dummies: r.dummies.map((w)=>w.id === d.id ? {
                                                        ...w,
                                                        ...next
                                                    } : w)
                                            }))),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $523f633b3aed431a$export$2e2bcd8739ae039), {
                                    title: `Game #${1200 + d.id} \u{2014} Solitaire Alone Together`,
                                    state: dummyBoard(d.id),
                                    titleIcon: "solitaire",
                                    interactive: false,
                                    inactive: true,
                                    disabledControls: [
                                        "minimize",
                                        "maximize"
                                    ],
                                    onControlClick: (control)=>{
                                        if (control === "close") removeWindow(d.id);
                                    }
                                })
                            }, d.id)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$Slot, {
                            style: {
                                "--x": room.self.x + "px",
                                "--y": room.self.y + "px"
                            },
                            onPointerDown: (e)=>dragWindow(e, ()=>room.self, (next)=>patchRoom((r)=>({
                                            ...r,
                                            self: next
                                        }))),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $523f633b3aed431a$export$2e2bcd8739ae039), {
                                title: "(You) Game #1137 \u2014 Solitaire Alone Together",
                                state: $f5e2c1b11cbc6771$var$SELF_STATE,
                                interactive: false,
                                disabledControls: [
                                    "minimize",
                                    "maximize",
                                    "close"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f5e2c1b11cbc6771$var$FakeTaskbar, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                disabled: true,
                                children: "Start"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
const $f5e2c1b11cbc6771$var$Studio = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: fixed;
  inset: 0;
  background: #1a1a2a;
  display: flex;
  flex-direction: column;
`;
const $f5e2c1b11cbc6771$var$Toolbar = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: none;
  margin: 4px;
`;
const $f5e2c1b11cbc6771$var$ToolbarRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
`;
const $f5e2c1b11cbc6771$var$Meta = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  font-size: 11px;
  color: #444;
`;
const $f5e2c1b11cbc6771$var$FrameArea = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1;
  position: relative;
  overflow: hidden;
`;
// The simulated viewport: exactly the target resolution, scaled to
// fit. Absolutely centered — grid/flex centering goes start-aligned
// once the UNSCALED box overflows the area. Same felt-teal as the
// real desktop so the vibe reads true.
const $f5e2c1b11cbc6771$var$Frame = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: var(--w);
  height: var(--h);
  transform: translate(-50%, -50%) scale(var(--scale));
  background: #027f7f;
  overflow: hidden;
  outline: 2px solid #000;
`;
// A window in the frame: centered at (frame center + x, y), the same
// coordinate system PositionedWindow uses at runtime.
const $f5e2c1b11cbc6771$var$Slot = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) translate(var(--x), var(--y));
`;
// Inert furniture: visible for judging occlusion, never interactive
// and never in the way of window drags.
const $f5e2c1b11cbc6771$var$IconLayer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;
const $f5e2c1b11cbc6771$var$IconSlot = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 10px;
  top: var(--top);
  bottom: var(--bottom, auto);
`;
const $f5e2c1b11cbc6771$var$FakeTaskbar = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: ${(0, $d2026809cde12e7e$export$e7ce2d3fe3294aef)}px;
  background: #c0c0c0;
  box-shadow: inset 0 1px #fff;
  display: flex;
  align-items: center;
  padding: 3px 4px;

  & button {
    min-width: 54px;
    font-weight: bold;
  }
`;
var $f5e2c1b11cbc6771$export$2e2bcd8739ae039 = $f5e2c1b11cbc6771$var$LayoutStudio;






// `?layout` boots the Layout Studio INSTEAD of the site: no websocket,
// no game consumed, no login/boot choreography — a layout arrangement
// bench, not a player surface. Dev builds only: a shared ?layout link
// in prod must show the piece, not the workbench.
const $35da740d59af89ba$var$layoutMode = false;
// Nothing in the piece uses native HTML drag-and-drop (cards, windows
// and icons all drag via pointer events), so no OS drag session may ever
// start: on Linux Firefox a drag of selected text (stats.txt) dropped on
// a non-accepting page can leave the browser stuck mid-drag — pointer
// moves, every click ignored, no recovery without a keyboard (Bugzilla
// 736811 and friends). Capture phase so nothing can opt back in.
document.addEventListener("dragstart", (e)=>e.preventDefault(), true);
// `?kiosk` / `?kiosk=off`: sticky per-machine flag, see kiosk.js.
(0, $b9747e1bfffdb7e5$export$85001a6be391bd58)();
// Everything on screen is the pixel font; painting even one frame in a
// fallback font looks broken in a way this piece can't afford. Block the
// first render until both weights are in (they're self-hosted woff2s, a
// few KB), with a timeout so a busted font never blanks the site.
const $35da740d59af89ba$var$fontsReady = Promise.race([
    Promise.all([
        document.fonts.load('11px "Pixelated MS Sans Serif"'),
        document.fonts.load('bold 11px "Pixelated MS Sans Serif"')
    ]),
    new Promise((resolve)=>setTimeout(resolve, 2500))
]);
$35da740d59af89ba$var$fontsReady.then(()=>{
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
    root.render($35da740d59af89ba$var$layoutMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5e2c1b11cbc6771$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d8b6aef94a206ca$export$2e2bcd8739ae039), {}));
});


//# sourceMappingURL=public.34543697.js.map
